import { defineComponent as X, computed as i, openBlock as n, createElementBlock as c, normalizeClass as r, toDisplayString as C, createCommentVNode as v, useSlots as We, unref as l, createElementVNode as m, renderSlot as T, Fragment as re, createTextVNode as ie, createBlock as F, withCtx as M, createVNode as L, useCssVars as hn, normalizeStyle as Ee, useAttrs as gn, useId as Ga, mergeProps as Oe, ref as A, onBeforeUnmount as Mt, watch as Se, withModifiers as Te, useTemplateRef as mn, renderList as xe, Transition as _t, toValue as Ne, onScopeDispose as vn, withDirectives as _a, vModelText as Tl, nextTick as Fe, Teleport as Wa, onMounted as Vt, shallowRef as Al, createSlots as tt, createStaticVNode as yn, reactive as il, resolveDynamicComponent as kt, withKeys as Tt, onUnmounted as Ka, normalizeProps as ca, guardReactiveProps as ua, vShow as xn, inject as fa, provide as ba, onUpdated as wn, useModel as Ya, mergeModels as ia } from "vue";
import { TooltipProvider as Ln, TooltipRoot as Cn, TooltipTrigger as kn, TooltipPortal as $n, TooltipContent as Mn, TooltipArrow as Vn, ProgressRoot as Sn, ProgressIndicator as Bn, CheckboxRoot as Ol, CheckboxIndicator as zl, RadioGroupItem as Hl, RadioGroupIndicator as En, SwitchRoot as Zl, SwitchThumb as Pl, SelectRoot as Dn, SelectTrigger as Fn, SelectIcon as Rn, SelectPortal as In, SelectContent as Tn, SelectViewport as An, SelectItem as On, SelectItemText as zn, SelectItemIndicator as Hn, ComboboxRoot as jl, ComboboxAnchor as Nl, ComboboxInput as ql, ComboboxCancel as Zn, ComboboxTrigger as Ul, ComboboxPortal as Gl, ComboboxContent as _l, ComboboxViewport as Wl, ComboboxItem as Kl, ComboboxItemIndicator as Yl, ComboboxEmpty as Pn, DatePickerRoot as jn, DatePickerTrigger as Nn, DatePickerContent as qn, DatePickerCalendar as Un, DatePickerPrev as Gn, DatePickerNext as _n, DatePickerGrid as Wn, DatePickerGridHead as Kn, DatePickerGridRow as dl, DatePickerHeadCell as Yn, DatePickerGridBody as Xn, DatePickerCell as Jn, DatePickerCellTrigger as Qn, DateRangePickerRoot as eo, DateRangePickerTrigger as to, DateRangePickerContent as ao, DateRangePickerCalendar as lo, DateRangePickerPrev as so, DateRangePickerNext as no, DateRangePickerGrid as oo, DateRangePickerGridHead as ro, DateRangePickerGridRow as cl, DateRangePickerHeadCell as io, DateRangePickerGridBody as co, DateRangePickerCell as uo, DateRangePickerCellTrigger as fo, DropdownMenuRoot as bo, DropdownMenuTrigger as po, DropdownMenuPortal as ul, DropdownMenuContent as ho, DropdownMenuArrow as go, DropdownMenuSeparator as mo, DropdownMenuSub as vo, DropdownMenuSubTrigger as yo, DropdownMenuSubContent as xo, DropdownMenuItem as fl, AccordionRoot as wo, AccordionItem as Lo, AccordionHeader as Co, AccordionTrigger as ko, AccordionContent as $o, RadioGroupRoot as Xl, ListboxRoot as Mo, ListboxContent as Vo, ListboxGroup as So, ListboxGroupLabel as Bo, ListboxItem as Eo, PopoverRoot as Jl, PopoverTrigger as Ql, PopoverPortal as es, PopoverContent as ts, PopoverAnchor as Do, DialogRoot as Fo, DialogTrigger as Ro, DialogPortal as Io, DialogOverlay as To, DialogContent as Ao, DialogTitle as Oo, DialogClose as zo, DialogDescription as Ho } from "reka-ui";
const Zo = (e, a) => {
  const t = new Array(e.length + a.length);
  for (let s = 0; s < e.length; s++)
    t[s] = e[s];
  for (let s = 0; s < a.length; s++)
    t[e.length + s] = a[s];
  return t;
}, Po = (e, a) => ({
  classGroupId: e,
  validator: a
}), as = (e = /* @__PURE__ */ new Map(), a = null, t) => ({
  nextPart: e,
  validators: a,
  classGroupId: t
}), Ca = "-", bl = [], jo = "arbitrary..", No = (e) => {
  const a = Uo(e), {
    conflictingClassGroups: t,
    conflictingClassGroupModifiers: s
  } = e;
  return {
    getClassGroupId: (u) => {
      if (u.startsWith("[") && u.endsWith("]"))
        return qo(u);
      const b = u.split(Ca), g = b[0] === "" && b.length > 1 ? 1 : 0;
      return ls(b, g, a);
    },
    getConflictingClassGroupIds: (u, b) => {
      if (b) {
        const g = s[u], h = t[u];
        return g ? h ? Zo(h, g) : g : h || bl;
      }
      return t[u] || bl;
    }
  };
}, ls = (e, a, t) => {
  if (e.length - a === 0)
    return t.classGroupId;
  const o = e[a], d = t.nextPart.get(o);
  if (d) {
    const h = ls(e, a + 1, d);
    if (h) return h;
  }
  const u = t.validators;
  if (u === null)
    return;
  const b = a === 0 ? e.join(Ca) : e.slice(a).join(Ca), g = u.length;
  for (let h = 0; h < g; h++) {
    const p = u[h];
    if (p.validator(b))
      return p.classGroupId;
  }
}, qo = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const a = e.slice(1, -1), t = a.indexOf(":"), s = a.slice(0, t);
  return s ? jo + s : void 0;
})(), Uo = (e) => {
  const {
    theme: a,
    classGroups: t
  } = e;
  return Go(t, a);
}, Go = (e, a) => {
  const t = as();
  for (const s in e) {
    const o = e[s];
    Xa(o, t, s, a);
  }
  return t;
}, Xa = (e, a, t, s) => {
  const o = e.length;
  for (let d = 0; d < o; d++) {
    const u = e[d];
    _o(u, a, t, s);
  }
}, _o = (e, a, t, s) => {
  if (typeof e == "string") {
    Wo(e, a, t);
    return;
  }
  if (typeof e == "function") {
    Ko(e, a, t, s);
    return;
  }
  Yo(e, a, t, s);
}, Wo = (e, a, t) => {
  const s = e === "" ? a : ss(a, e);
  s.classGroupId = t;
}, Ko = (e, a, t, s) => {
  if (Xo(e)) {
    Xa(e(s), a, t, s);
    return;
  }
  a.validators === null && (a.validators = []), a.validators.push(Po(t, e));
}, Yo = (e, a, t, s) => {
  const o = Object.entries(e), d = o.length;
  for (let u = 0; u < d; u++) {
    const [b, g] = o[u];
    Xa(g, ss(a, b), t, s);
  }
}, ss = (e, a) => {
  let t = e;
  const s = a.split(Ca), o = s.length;
  for (let d = 0; d < o; d++) {
    const u = s[d];
    let b = t.nextPart.get(u);
    b || (b = as(), t.nextPart.set(u, b)), t = b;
  }
  return t;
}, Xo = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, Jo = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let a = 0, t = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null);
  const o = (d, u) => {
    t[d] = u, a++, a > e && (a = 0, s = t, t = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(d) {
      let u = t[d];
      if (u !== void 0)
        return u;
      if ((u = s[d]) !== void 0)
        return o(d, u), u;
    },
    set(d, u) {
      d in t ? t[d] = u : o(d, u);
    }
  };
}, Pa = "!", pl = ":", Qo = [], hl = (e, a, t, s, o) => ({
  modifiers: e,
  hasImportantModifier: a,
  baseClassName: t,
  maybePostfixModifierPosition: s,
  isExternal: o
}), er = (e) => {
  const {
    prefix: a,
    experimentalParseClassName: t
  } = e;
  let s = (o) => {
    const d = [];
    let u = 0, b = 0, g = 0, h;
    const p = o.length;
    for (let k = 0; k < p; k++) {
      const x = o[k];
      if (u === 0 && b === 0) {
        if (x === pl) {
          d.push(o.slice(g, k)), g = k + 1;
          continue;
        }
        if (x === "/") {
          h = k;
          continue;
        }
      }
      x === "[" ? u++ : x === "]" ? u-- : x === "(" ? b++ : x === ")" && b--;
    }
    const f = d.length === 0 ? o : o.slice(g);
    let y = f, w = !1;
    f.endsWith(Pa) ? (y = f.slice(0, -1), w = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      f.startsWith(Pa) && (y = f.slice(1), w = !0)
    );
    const S = h && h > g ? h - g : void 0;
    return hl(d, w, y, S);
  };
  if (a) {
    const o = a + pl, d = s;
    s = (u) => u.startsWith(o) ? d(u.slice(o.length)) : hl(Qo, !1, u, void 0, !0);
  }
  if (t) {
    const o = s;
    s = (d) => t({
      className: d,
      parseClassName: o
    });
  }
  return s;
}, tr = (e) => {
  const a = /* @__PURE__ */ new Map();
  return e.orderSensitiveModifiers.forEach((t, s) => {
    a.set(t, 1e6 + s);
  }), (t) => {
    const s = [];
    let o = [];
    for (let d = 0; d < t.length; d++) {
      const u = t[d], b = u[0] === "[", g = a.has(u);
      b || g ? (o.length > 0 && (o.sort(), s.push(...o), o = []), s.push(u)) : o.push(u);
    }
    return o.length > 0 && (o.sort(), s.push(...o)), s;
  };
}, ar = (e) => ({
  cache: Jo(e.cacheSize),
  parseClassName: er(e),
  sortModifiers: tr(e),
  postfixLookupClassGroupIds: lr(e),
  ...No(e)
}), lr = (e) => {
  const a = /* @__PURE__ */ Object.create(null), t = e.postfixLookupClassGroups;
  if (t)
    for (let s = 0; s < t.length; s++)
      a[t[s]] = !0;
  return a;
}, sr = /\s+/, nr = (e, a) => {
  const {
    parseClassName: t,
    getClassGroupId: s,
    getConflictingClassGroupIds: o,
    sortModifiers: d,
    postfixLookupClassGroupIds: u
  } = a, b = [], g = e.trim().split(sr);
  let h = "";
  for (let p = g.length - 1; p >= 0; p -= 1) {
    const f = g[p], {
      isExternal: y,
      modifiers: w,
      hasImportantModifier: S,
      baseClassName: k,
      maybePostfixModifierPosition: x
    } = t(f);
    if (y) {
      h = f + (h.length > 0 ? " " + h : h);
      continue;
    }
    let $ = !!x, D;
    if ($) {
      const G = k.substring(0, x);
      D = s(G);
      const z = D && u[D] ? s(k) : void 0;
      z && z !== D && (D = z, $ = !1);
    } else
      D = s(k);
    if (!D) {
      if (!$) {
        h = f + (h.length > 0 ? " " + h : h);
        continue;
      }
      if (D = s(k), !D) {
        h = f + (h.length > 0 ? " " + h : h);
        continue;
      }
      $ = !1;
    }
    const E = w.length === 0 ? "" : w.length === 1 ? w[0] : d(w).join(":"), R = S ? E + Pa : E, V = R + D;
    if (b.indexOf(V) > -1)
      continue;
    b.push(V);
    const Z = o(D, $);
    for (let G = 0; G < Z.length; ++G) {
      const z = Z[G];
      b.push(R + z);
    }
    h = f + (h.length > 0 ? " " + h : h);
  }
  return h;
}, or = (...e) => {
  let a = 0, t, s, o = "";
  for (; a < e.length; )
    (t = e[a++]) && (s = ns(t)) && (o && (o += " "), o += s);
  return o;
}, ns = (e) => {
  if (typeof e == "string")
    return e;
  let a, t = "";
  for (let s = 0; s < e.length; s++)
    e[s] && (a = ns(e[s])) && (t && (t += " "), t += a);
  return t;
}, gl = (e, ...a) => {
  let t, s, o, d;
  const u = (g) => {
    const h = a.reduce((p, f) => f(p), e());
    return t = ar(h), s = t.cache.get, o = t.cache.set, d = b, b(g);
  }, b = (g) => {
    const h = s(g);
    if (h)
      return h;
    const p = nr(g, t);
    return o(g, p), p;
  };
  return d = u, (...g) => d(or(...g));
}, rr = [], He = (e) => {
  const a = (t) => t[e] || rr;
  return a.isThemeGetter = !0, a.themeKey = e, a;
}, os = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, rs = /^\((?:(\w[\w-]*):)?(.+)\)$/i, ir = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, dr = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, cr = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, ur = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix|color|light-dark)\(.+\)$/, fr = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, br = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Lt = (e) => ir.test(e), Ce = (e) => !!e && !Number.isNaN(Number(e)), st = (e) => !!e && Number.isInteger(Number(e)), Fa = (e) => e.endsWith("%") && Ce(e.slice(0, -1)), ut = (e) => dr.test(e), is = () => !0, pr = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  cr.test(e) && !ur.test(e)
), Ja = () => !1, hr = (e) => fr.test(e), gr = (e) => br.test(e), mr = (e) => !se(e) && !oe(e), vr = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), yr = (e) => St(e, us, Ja), se = (e) => os.test(e), It = (e) => St(e, fs, pr), ml = (e) => St(e, Vr, Ce), xr = (e) => St(e, ps, is), wr = (e) => St(e, bs, Ja), vl = (e) => St(e, ds, Ja), Lr = (e) => St(e, cs, gr), ga = (e) => St(e, hs, hr), oe = (e) => rs.test(e), la = (e) => Ht(e, fs), Cr = (e) => Ht(e, bs), yl = (e) => Ht(e, ds), kr = (e) => Ht(e, us), $r = (e) => Ht(e, cs), ma = (e) => Ht(e, hs, !0), Mr = (e) => Ht(e, ps, !0), St = (e, a, t) => {
  const s = os.exec(e);
  return s ? s[1] ? a(s[1]) : t(s[2]) : !1;
}, Ht = (e, a, t = !1) => {
  const s = rs.exec(e);
  return s ? s[1] ? a(s[1]) : t : !1;
}, ds = (e) => e === "position" || e === "percentage", cs = (e) => e === "image" || e === "url", us = (e) => e === "length" || e === "size" || e === "bg-size", fs = (e) => e === "length", Vr = (e) => e === "number", bs = (e) => e === "family-name", ps = (e) => e === "number" || e === "weight", hs = (e) => e === "shadow", xl = () => {
  const e = He("color"), a = He("font"), t = He("text"), s = He("font-weight"), o = He("tracking"), d = He("leading"), u = He("breakpoint"), b = He("container"), g = He("spacing"), h = He("radius"), p = He("shadow"), f = He("inset-shadow"), y = He("text-shadow"), w = He("drop-shadow"), S = He("blur"), k = He("perspective"), x = He("aspect"), $ = He("ease"), D = He("animate"), E = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], R = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], V = () => [...R(), oe, se], Z = () => ["auto", "hidden", "clip", "visible", "scroll"], G = () => ["auto", "contain", "none"], z = () => [oe, se, g], U = () => [Lt, "full", "auto", ...z()], ae = () => [st, "none", "subgrid", oe, se], B = () => ["auto", {
    span: ["full", st, oe, se]
  }, st, oe, se], le = () => [st, "auto", oe, se], O = () => ["auto", "min", "max", "fr", oe, se], j = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], _ = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], ne = () => ["auto", ...z()], P = () => [Lt, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...z()], ce = () => [b, Lt, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...z()], W = () => [Lt, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...z()], H = () => [e, oe, se], fe = () => [...R(), yl, vl, {
    position: [oe, se]
  }], $e = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], te = () => ["auto", "cover", "contain", kr, yr, {
    size: [oe, se]
  }], we = () => [Fa, la, It], I = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    h,
    oe,
    se
  ], Y = () => ["", Ce, la, It], be = () => ["solid", "dashed", "dotted", "double"], J = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], Q = () => [Ce, Fa, yl, vl], ue = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    S,
    oe,
    se
  ], K = () => ["none", Ce, oe, se], ee = () => ["none", Ce, oe, se], he = () => [Ce, oe, se], ge = () => [Lt, "full", ...z()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [ut],
      breakpoint: [ut],
      color: [is],
      container: [ut],
      "drop-shadow": [ut],
      ease: ["in", "out", "in-out"],
      font: [mr],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [ut],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [ut],
      shadow: [ut],
      spacing: ["px", Ce],
      text: [ut],
      "text-shadow": [ut],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", Lt, se, oe, x]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Container Type
       * @see https://tailwindcss.com/docs/responsive-design#container-queries
       */
      "container-type": [{
        "@container": ["", "normal", "size", oe, se]
      }],
      /**
       * Container Name
       * @see https://tailwindcss.com/docs/responsive-design#named-containers
       */
      "container-named": [vr],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Ce, "auto", se, oe, b]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": E()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": E()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: V()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: Z()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": Z()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": Z()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: G()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": G()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": G()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: U()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": U()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": U()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": U(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: U()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": U(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: U()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": U()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": U()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: U()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: U()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: U()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: U()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [st, "auto", oe, se]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [Lt, "full", "auto", b, ...z()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [Ce, Lt, "auto", "initial", "none", se]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", Ce, oe, se]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", Ce, oe, se]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [st, "first", "last", "none", oe, se]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": ae()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: B()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": le()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": le()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": ae()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: B()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": le()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": le()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": O()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": O()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: z()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": z()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": z()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...j(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [..._(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ..._()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...j()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [..._(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ..._(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": j()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [..._(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ..._()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: z()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: z()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: z()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: z()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: z()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: z()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: z()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: z()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: z()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: z()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: z()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: ne()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: ne()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: ne()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: ne()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: ne()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: ne()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: ne()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: ne()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: ne()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: ne()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: ne()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": z()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": z()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: P()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/inline-size
       */
      "inline-size": [{
        inline: ["auto", ...ce()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-inline-size
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...ce()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-inline-size
       */
      "max-inline-size": [{
        "max-inline": ["none", ...ce()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/block-size
       */
      "block-size": [{
        block: ["auto", ...W()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-block-size
       */
      "min-block-size": [{
        "min-block": ["auto", ...W()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-block-size
       */
      "max-block-size": [{
        "max-block": ["none", ...W()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [b, "screen", ...P()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          b,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...P()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          b,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [u]
          },
          ...P()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...P()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...P()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", "none", ...P()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", t, la, It]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [s, Mr, xr]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Fa, se]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Cr, wr, a]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [se]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [o, oe, se]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [Ce, "none", oe, ml]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          d,
          ...z()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", oe, se]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", oe, se]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: H()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: H()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...be(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [Ce, "from-font", "auto", oe, It]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: H()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [Ce, "auto", oe, se]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: z()
      }],
      /**
       * Tab Size
       * @see https://tailwindcss.com/docs/tab-size
       */
      "tab-size": [{
        tab: [st, oe, se]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", oe, se]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", oe, se]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: fe()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: $e()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: te()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, st, oe, se],
          radial: ["", oe, se],
          conic: ["", st, oe, se]
        }, $r, Lr]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: H()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: we()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: we()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: we()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: H()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: H()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: H()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: I()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": I()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": I()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": I()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": I()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": I()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": I()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": I()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": I()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": I()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": I()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": I()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": I()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": I()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": I()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: Y()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": Y()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": Y()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": Y()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": Y()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": Y()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": Y()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": Y()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": Y()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": Y()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": Y()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": Y()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": Y()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...be(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...be(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: H()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": H()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": H()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": H()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": H()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": H()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": H()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": H()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": H()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": H()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": H()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: H()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...be(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Ce, oe, se]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", Ce, la, It]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: H()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          // Deprecated since Tailwind CSS v4.0.0
          "inner",
          "none",
          p,
          ma,
          ga
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: H()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", f, ma, ga]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": H()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: Y()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: H()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [Ce, It]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": H()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": Y()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": H()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", y, ma, ga]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": H()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [Ce, oe, se]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...J(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": J()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [Ce]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": Q()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": Q()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": H()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": H()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": Q()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": Q()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": H()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": H()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": Q()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": Q()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": H()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": H()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": Q()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": Q()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": H()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": H()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": Q()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": Q()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": H()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": H()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": Q()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": Q()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": H()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": H()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": Q()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": Q()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": H()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": H()
      }],
      "mask-image-radial": [{
        "mask-radial": [oe, se]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": Q()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": Q()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": H()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": H()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": R()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [Ce]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": Q()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": Q()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": H()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": H()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: fe()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: $e()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: te()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", oe, se]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          oe,
          se
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: ue()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [Ce, oe, se]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [Ce, oe, se]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          w,
          ma,
          ga
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": H()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", Ce, oe, se]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [Ce, oe, se]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", Ce, oe, se]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [Ce, oe, se]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", Ce, oe, se]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          oe,
          se
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": ue()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [Ce, oe, se]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [Ce, oe, se]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", Ce, oe, se]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [Ce, oe, se]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", Ce, oe, se]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [Ce, oe, se]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [Ce, oe, se]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", Ce, oe, se]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": z()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": z()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": z()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", oe, se]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [Ce, "initial", oe, se]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", $, oe, se]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [Ce, oe, se]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", D, oe, se]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [k, oe, se]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": V()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: K()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": K()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": K()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": K()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: ee()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": ee()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": ee()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": ee()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: he()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": he()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": he()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [oe, se, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: V()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: ge()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": ge()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": ge()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": ge()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      /**
       * Zoom
       * @see https://tailwindcss.com/docs/zoom
       */
      zoom: [{
        zoom: [st, oe, se]
      }],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: H()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: H()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", oe, se]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scrollbar Thumb Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-thumb-color": [{
        "scrollbar-thumb": H()
      }],
      /**
       * Scrollbar Track Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-track-color": [{
        "scrollbar-track": H()
      }],
      /**
       * Scrollbar Gutter
       * @see https://tailwindcss.com/docs/scrollbar-gutter
       */
      "scrollbar-gutter": [{
        "scrollbar-gutter": ["auto", "stable", "both"]
      }],
      /**
       * Scrollbar Width
       * @see https://tailwindcss.com/docs/scrollbar-width
       */
      "scrollbar-w": [{
        scrollbar: ["auto", "thin", "none"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": z()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": z()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": z()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": z()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": z()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": z()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": z()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": z()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": z()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": z()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": z()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": z()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": z()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": z()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": z()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": z()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": z()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": z()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": z()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": z()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": z()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": z()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", oe, se]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...H()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Ce, la, It, ml]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...H()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      "container-named": ["container-type"],
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["start", "end", "right", "left"],
      "inset-y": ["inset-bs", "inset-be", "top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["ps", "pe", "pr", "pl"],
      py: ["pbs", "pbe", "pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["ms", "me", "mr", "ml"],
      my: ["mbs", "mbe", "mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-s", "border-w-e", "border-w-r", "border-w-l"],
      "border-w-y": ["border-w-bs", "border-w-be", "border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-s", "border-color-e", "border-color-r", "border-color-l"],
      "border-color-y": ["border-color-bs", "border-color-be", "border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-ms", "scroll-me", "scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-ps", "scroll-pe", "scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    postfixLookupClassGroups: ["container-type"],
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, Sr = (e, {
  cacheSize: a,
  prefix: t,
  experimentalParseClassName: s,
  extend: o = {},
  override: d = {}
}) => (Ut(e, "cacheSize", a), Ut(e, "prefix", t), Ut(e, "experimentalParseClassName", s), va(e.theme, d.theme), va(e.classGroups, d.classGroups), va(e.conflictingClassGroups, d.conflictingClassGroups), va(e.conflictingClassGroupModifiers, d.conflictingClassGroupModifiers), Ut(e, "postfixLookupClassGroups", d.postfixLookupClassGroups), Ut(e, "orderSensitiveModifiers", d.orderSensitiveModifiers), ya(e.theme, o.theme), ya(e.classGroups, o.classGroups), ya(e.conflictingClassGroups, o.conflictingClassGroups), ya(e.conflictingClassGroupModifiers, o.conflictingClassGroupModifiers), ja(e, o, "postfixLookupClassGroups"), ja(e, o, "orderSensitiveModifiers"), e), Ut = (e, a, t) => {
  t !== void 0 && (e[a] = t);
}, va = (e, a) => {
  if (a)
    for (const t in a)
      Ut(e, t, a[t]);
}, ya = (e, a) => {
  if (a)
    for (const t in a)
      ja(e, a, t);
}, ja = (e, a, t) => {
  const s = a[t];
  s !== void 0 && (e[t] = e[t] ? e[t].concat(s) : s);
}, Br = (e, ...a) => typeof e == "function" ? gl(xl, e, ...a) : gl(() => Sr(xl(), e), ...a);
function gs(e) {
  var a, t, s = "";
  if (typeof e == "string" || typeof e == "number") s += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (a = 0; a < o; a++) e[a] && (t = gs(e[a])) && (s && (s += " "), s += t);
  } else for (t in e) e[t] && (s && (s += " "), s += t);
  return s;
}
function Er() {
  for (var e, a, t = 0, s = "", o = arguments.length; t < o; t++) (e = arguments[t]) && (a = gs(e)) && (s && (s += " "), s += a);
  return s;
}
const Dr = Br({
  extend: {
    classGroups: {
      "boqnet-type": [
        {
          type: [
            "display",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "body-1",
            "body-1-strong",
            "body-2",
            "body-2-strong",
            "caption",
            "cell",
            "column-header",
            "form-sub-header",
            "field-label",
            "field-help"
          ]
        }
      ]
    }
  }
}), q = (...e) => Dr(Er(e)), Fr = (e) => {
  if (!e) throw new Error("Nothing to copy");
  return new Blob([e], { type: "text/plain" });
}, Qa = async (e) => {
  const a = globalThis.navigator?.clipboard;
  if (typeof e != "string" && a?.write && typeof globalThis.ClipboardItem == "function")
    try {
      return await a.write([new ClipboardItem({ "text/plain": e.then(Fr) })]), !0;
    } catch {
      return !1;
    }
  try {
    const t = await e;
    return !t || !a?.writeText ? !1 : (await a.writeText(t), !0);
  } catch {
    return !1;
  }
}, ms = (e, a, t) => {
  if (!e && !a) return;
  const s = e ? `transparent 0, #000 ${t}` : "#000 0", o = a ? `#000 calc(100% - ${t}), transparent 100%` : "#000 100%", d = `linear-gradient(to right, ${s}, ${o})`;
  return { maskImage: d, WebkitMaskImage: d };
}, Rr = /* @__PURE__ */ X({
  __name: "Badge",
  props: {
    value: { default: void 0 },
    tone: { default: "neutral" },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e, t = i(
      () => a.value !== void 0 && a.value !== null && a.value !== 0 && a.value !== ""
    ), s = {
      neutral: "bg-gray-100",
      info: "bg-blue-700 text-white",
      // orange-700, a rung darker than the design's 600: white on 600 is 3.6:1, under AA for the
      // 14px number, and on 700 it is 5.2:1.
      warn: "bg-orange-700 text-white"
    }, o = i(
      () => q(
        "inline-flex items-center justify-center min-w-6 h-6 px-1 type-body-2 rounded-full",
        s[a.tone],
        a.class
      )
    );
    return (d, u) => t.value ? (n(), c("span", {
      key: 0,
      class: r(o.value),
      "data-testid": "badge"
    }, C(e.value), 3)) : v("", !0);
  }
}), Sa = /* @__PURE__ */ X({
  __name: "Tag",
  props: {
    color: { default: "gray" },
    size: { default: "md" },
    label: {},
    isTruncated: { type: Boolean, default: !0 },
    hasOutline: { type: Boolean, default: !1 },
    isTransparent: { type: Boolean, default: !1 },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e, t = We();
    return (s, o) => (n(), c("div", {
      "data-testid": "tag-wrapper",
      class: r(
        l(q)(
          // Base styles
          "inline-flex items-center rounded-sm",
          {
            // --- Sizes & Truncation ---
            "type-body-2-strong px-3 py-0.5": a.size === "sm",
            "type-body-2-strong px-3 py-1.5": a.size === "md",
            "type-body-2-strong px-4 py-3": a.size === "lg",
            "overflow-hidden text-ellipsis whitespace-nowrap": a.isTruncated,
            //  --- Text, Background and Border color  ---
            // Gray
            "border-gray-200 bg-gray-200 text-gray-700": a.color === "gray",
            // Blue
            "border-blue-100 bg-blue-100 text-blue-700": a.color === "blue",
            // Green
            "border-green-100 bg-green-100 text-green-700": a.color === "green",
            // Orange
            "border-orange-100 bg-orange-100 text-orange-700": a.color === "orange",
            // Red
            "border-red-100 bg-red-100 text-red-700": a.color === "red",
            "border-gray-300 bg-white text-gray-700": a.color === "white",
            // Violet
            "border-violet-200 bg-violet-100 text-violet-700": a.color === "violet",
            // Pink
            "border-pink-200 bg-pink-100 text-pink-700": a.color === "pink",
            //  --- Outline  ---
            border: a.hasOutline,
            //  --- Transparent background  ---
            "bg-transparent": a.isTransparent
          },
          a.class
        )
      )
    }, [
      m("p", {
        "data-testid": "tag-text",
        class: r({ "overflow-hidden text-ellipsis whitespace-nowrap": a.isTruncated })
      }, [
        l(t).label ? T(s.$slots, "label", {}, void 0, void 0, 0) : (n(), c(re, { key: 1 }, [
          ie(C(a.label), 1)
        ], 64))
      ], 2),
      m("div", {
        "data-testid": "tag-icon",
        class: r({ "pl-2": l(t).icon })
      }, [
        T(s.$slots, "icon")
      ], 2)
    ], 2));
  }
}), Ir = ["aria-label"], Tr = ["viewBox"], Ar = ["cx", "cy", "r"], Or = ["width", "height"], zr = ["src", "alt"], Ot = /* @__PURE__ */ X({
  __name: "Avatar",
  props: {
    src: {},
    label: {},
    isPending: { type: Boolean, default: !1 },
    size: { default: "md" },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e, t = i(() => {
      if (!a.label) return "";
      const u = a.label.trim().split(/\s+/).filter((b) => b.length > 0);
      return u.length === 0 ? "" : u.length === 1 ? u[0].charAt(0).toUpperCase() : u.slice(0, 2).map((b) => b.charAt(0).toUpperCase()).join("");
    }), s = {
      sm: { size: 24, center: 12, radius: 10.5, iconSize: 14 },
      md: { size: 32, center: 16, radius: 14.5, iconSize: 18 },
      lg: { size: 40, center: 20, radius: 18.5, iconSize: 20 }
    }, o = i(() => s[a.size]), d = i(() => a.size === "sm" ? "type-caption" : "type-body-2");
    return (u, b) => (n(), c("div", {
      "data-testid": "avatar-wrapper",
      role: "img",
      "aria-label": a.label || "Avatar",
      class: r(
        l(q)(
          // Base Layout
          "relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full",
          // --- Sizes ---
          {
            "h-6 w-6": a.size === "sm",
            "h-8 w-8": a.size === "md",
            "h-10 w-10": a.size === "lg"
          },
          // --- Styles ---
          // If Pending or (No Label AND No Src) -> Transparent
          // Otherwise (Initials or Valid Image) -> Blue Background + White Border
          {
            "border border-white bg-blue-800": !a.isPending && (a.src || a.label),
            "bg-transparent": a.isPending || !a.src && !a.label
          },
          a.class
        )
      )
    }, [
      a.isPending || !a.src && !a.label ? (n(), c(re, { key: 0 }, [
        (n(), c("svg", {
          "data-testid": "avatar-pending-bg",
          viewBox: `0 0 ${o.value.size} ${o.value.size}`,
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          class: "absolute inset-0 h-full w-full"
        }, [
          m("circle", {
            cx: o.value.center,
            cy: o.value.center,
            r: o.value.radius,
            fill: "#FAFAFA",
            stroke: "#737373",
            "stroke-width": "1",
            "stroke-dasharray": "3 3"
          }, null, 8, Ar)
        ], 8, Tr)),
        (n(), c("svg", {
          "data-testid": "avatar-pending-icon",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          "stroke-width": "1.5",
          stroke: "currentColor",
          width: o.value.iconSize,
          height: o.value.iconSize,
          class: "relative z-10 text-gray-700"
        }, [...b[0] || (b[0] = [
          m("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
          }, null, -1)
        ])], 8, Or))
      ], 64)) : a.src ? (n(), c("img", {
        key: 1,
        "data-testid": "avatar-image",
        src: a.src,
        alt: a.label || "Avatar",
        class: "h-full w-full object-cover"
      }, null, 8, zr)) : (n(), c("span", {
        key: 2,
        "data-testid": "avatar-initials",
        class: r([
          "text-center font-sans leading-none tracking-[-0.135px] text-white",
          d.value
        ])
      }, C(t.value), 3))
    ], 10, Ir));
  }
}), ht = /* @__PURE__ */ X({
  __name: "Tooltip",
  props: {
    label: {},
    position: { default: "top" },
    delay: { default: 200 },
    isDisabled: { type: Boolean, default: !1 },
    maxWidth: { default: "max-w-64" },
    isOpen: { type: Boolean, default: void 0 }
  },
  setup(e) {
    const a = e, t = We();
    return (s, o) => (n(), F(l(Ln), null, {
      default: M(() => [
        L(l(Cn), {
          "delay-duration": a.delay,
          disabled: a.isDisabled || !l(t).label && !a.label,
          open: a.isOpen
        }, {
          default: M(() => [
            L(l(kn), { "as-child": "" }, {
              default: M(() => [
                T(s.$slots, "default")
              ]),
              _: 3
            }),
            L(l($n), null, {
              default: M(() => [
                L(l(Mn), {
                  side: a.position,
                  "side-offset": 5,
                  class: r(
                    l(q)(
                      // Default classes
                      "type-body-2 z-1200 rounded-md border border-gray-200 bg-white px-3 py-1.5 text-gray-700 will-change-[transform,opacity] select-none",
                      // Shadow
                      "shadow-[0_15px_30px_0_rgba(0,0,0,0.12)]",
                      // Animation classes
                      "data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade",
                      "data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade",
                      "data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade",
                      "data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade",
                      // Max-width
                      a.maxWidth
                    )
                  )
                }, {
                  default: M(() => [
                    l(t).label ? T(s.$slots, "label", {}, void 0, void 0, 0) : (n(), c(re, { key: 1 }, [
                      ie(C(a.label), 1)
                    ], 64)),
                    L(l(Vn), {
                      class: "fill-white stroke-gray-200",
                      width: 12,
                      height: 6
                    })
                  ]),
                  _: 3
                }, 8, ["side", "class"])
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["delay-duration", "disabled", "open"])
      ]),
      _: 3
    }));
  }
}), Hr = ["href", "target", "rel", "aria-disabled", "tabindex", "data-testid"], Zr = ["disabled", "data-testid"], sb = /* @__PURE__ */ X({
  __name: "TextLink",
  props: {
    href: {},
    target: {},
    rel: { default: "noopener noreferrer" },
    label: {},
    disabled: { type: Boolean, default: !1 },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e, t = i(() => {
      if (!a.href) return;
      if (a.target !== "_blank") return a.rel;
      const o = a.rel ? a.rel.split(/\s+/) : [];
      for (const d of ["noopener", "noreferrer"])
        o.includes(d) || o.push(d);
      return o.join(" ");
    }), s = i(
      () => q(
        "cursor-pointer border-0 bg-transparent p-0 text-left align-baseline",
        "text-blue-600 underline-offset-2 hover:underline",
        "focus-visible:underline focus-visible:outline-none",
        a.disabled && "pointer-events-none cursor-not-allowed text-gray-300 no-underline",
        a.class
      )
    );
    return (o, d) => e.href ? (n(), c("a", {
      key: 0,
      href: e.disabled ? void 0 : e.href,
      target: e.target,
      rel: t.value,
      "aria-disabled": e.disabled || void 0,
      tabindex: e.disabled ? -1 : void 0,
      class: r(s.value),
      "data-testid": o.$attrs["data-testid"] || "text-link"
    }, [
      T(o.$slots, "default", {}, () => [
        ie(C(e.label), 1)
      ])
    ], 10, Hr)) : (n(), c("button", {
      key: 1,
      type: "button",
      disabled: e.disabled,
      class: r(s.value),
      "data-testid": o.$attrs["data-testid"] || "text-link"
    }, [
      T(o.$slots, "default", {}, () => [
        ie(C(e.label), 1)
      ])
    ], 10, Zr));
  }
}), Pr = { class: "flex flex-col gap-1" }, jr = ["for"], Nr = {
  key: 0,
  class: "text-txt-800 type-body-1"
}, qr = {
  key: 1,
  class: "text-txt-600 type-field-help"
}, nb = /* @__PURE__ */ X({
  __name: "Label",
  props: {
    for: {},
    title: {},
    description: {},
    isRequired: { type: Boolean, default: !0 }
  },
  setup(e) {
    const a = e;
    return (t, s) => (n(), c("div", Pr, [
      e.title || t.$slots.default ? (n(), c("label", {
        key: 0,
        for: a.for,
        class: "text-txt-800 type-body-1 flex items-center gap-1"
      }, [
        T(t.$slots, "default", {}, () => [
          ie(C(e.title), 1)
        ]),
        e.isRequired ? v("", !0) : (n(), c("span", Nr, " (Optional) "))
      ], 8, jr)) : v("", !0),
      e.description || t.$slots.description ? (n(), c("p", qr, [
        T(t.$slots, "description", {}, () => [
          ie(C(e.description), 1)
        ])
      ])) : v("", !0)
    ]));
  }
});
function Ur(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
    })
  ]);
}
function Gr(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
    })
  ]);
}
function _r(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
    })
  ]);
}
function vs(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"
    })
  ]);
}
function Wr(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
    })
  ]);
}
function ys(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
    })
  ]);
}
function Kr(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function $t(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 12.75 6 6 9-13.5"
    })
  ]);
}
function pa(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m19.5 8.25-7.5 7.5-7.5-7.5"
    })
  ]);
}
function Wt(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 19.5 8.25 12l7.5-7.5"
    })
  ]);
}
function ot(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m8.25 4.5 7.5 7.5-7.5 7.5"
    })
  ]);
}
function Yr(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
    })
  ]);
}
function Xr(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 15.75 7.5-7.5 7.5 7.5"
    })
  ]);
}
function xs(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75"
    })
  ]);
}
function ws(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
    })
  ]);
}
function Jr(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
    })
  ]);
}
function Qr(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
    })
  ]);
}
function Ls(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
    })
  ]);
}
function ei(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
    })
  ]);
}
function Cs(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
    }),
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    })
  ]);
}
function el(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
    })
  ]);
}
function ti(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
    })
  ]);
}
function ks(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
    })
  ]);
}
function $s(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5 12h14"
    })
  ]);
}
function ai(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13"
    })
  ]);
}
function li(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
    })
  ]);
}
function si(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 4.5v15m7.5-7.5h-15"
    })
  ]);
}
function Ms(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
    })
  ]);
}
function ni(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.5 3.75H6A2.25 2.25 0 0 0 3.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0 1 20.25 6v1.5m0 9V18A2.25 2.25 0 0 1 18 20.25h-1.5m-9 0H6A2.25 2.25 0 0 1 3.75 18v-1.5M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    })
  ]);
}
function rt(e, a) {
  return n(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 18 18 6M6 6l12 12"
    })
  ]);
}
const oi = /* @__PURE__ */ X({
  __name: "Spinner",
  props: {
    size: { default: "md" },
    color: { default: "currentColor" }
  },
  setup(e) {
    hn((b) => ({
      v0bd0ca39: o.value,
      v3ea00cc4: u.value,
      v603f42fe: d.value
    }));
    const a = e, t = {
      xs: "16px",
      sm: "20px",
      md: "24px",
      lg: "28px"
    }, s = {
      xs: "2px",
      sm: "2px",
      md: "3px",
      lg: "3.5px"
    }, o = i(() => t[a.size]), d = i(() => s[a.size]), u = i(() => a.color === "currentColor" ? "currentColor" : a.color.startsWith("#") || a.color.startsWith("rgb") ? a.color : `var(--color-${a.color})`);
    return (b, g) => (n(), c("span", {
      class: "ui-spinner",
      role: "status",
      "aria-label": "loading",
      "aria-live": "polite",
      "data-testid": "ui-spinner",
      style: Ee({
        "--spinner-size": o.value,
        "--spinner-color": u.value,
        "--spinner-width": d.value
      })
    }, null, 4));
  }
}), Ye = (e, a) => {
  const t = e.__vccOpts || e;
  for (const [s, o] of a)
    t[s] = o;
  return t;
}, et = /* @__PURE__ */ Ye(oi, [["__scopeId", "data-v-d40b58e7"]]);
function Vs(e) {
  const a = [
    "inline-flex items-center justify-center transition-all duration-200 ease-in-out",
    "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1",
    "no-underline",
    e.isIconOnly ? "" : "h-fit"
  ], t = i(() => {
    switch (e.size) {
      case "xxs":
        return "type-caption";
      case "xs":
        return "type-body-2-strong";
      case "sm":
        return "type-body-1-strong";
      case "md":
        return "type-h4";
      case "lg":
        return "type-body-1-strong";
      default:
        return "type-h4";
    }
  }), s = {
    danger: {
      solidBg: "bg-red-600 border border-red-600",
      solidHover: "hover:bg-red-700 hover:border-red-700",
      solidActive: "active:bg-red-800",
      text: "text-red-600",
      textHover: "hover:text-red-700",
      border: "border-red-600",
      ring: "focus-visible:ring-red-600",
      softBg: "bg-red-50",
      softHover: "hover:bg-red-100"
    },
    success: {
      solidBg: "bg-green-600 border border-green-600",
      solidHover: "hover:bg-green-700 hover:border-green-700",
      solidActive: "active:bg-green-800",
      text: "text-green-600",
      textHover: "hover:text-green-700",
      border: "border-green-600",
      ring: "focus-visible:ring-green-600",
      softBg: "bg-green-50",
      softHover: "hover:bg-green-100"
    },
    warn: {
      solidBg: "bg-orange-500 border border-orange-500",
      solidHover: "hover:bg-orange-600 hover:border-orange-600",
      solidActive: "active:bg-orange-700",
      text: "text-orange-600",
      textHover: "hover:text-orange-700",
      border: "border-orange-500",
      ring: "focus-visible:ring-orange-500",
      softBg: "bg-orange-50",
      softHover: "hover:bg-orange-100"
    },
    neutral: {
      solidBg: "bg-white border border-white",
      solidHover: "hover:bg-gray-50 hover:border-gray-300",
      solidActive: "active:bg-gray-50",
      text: "text-gray-800",
      textHover: "hover:text-black",
      border: "border-gray-200",
      ring: "focus-visible:ring-gray-200",
      softBg: "bg-gray-50",
      softHover: "hover:bg-gray-50"
    },
    default: {
      solidBg: "bg-blue-700 border border-blue-700",
      solidHover: "hover:bg-blue-800 hover:border-blue-800",
      solidActive: "active:bg-blue-800",
      text: "text-blue-700",
      textHover: "hover:text-blue-800",
      border: "border-blue-700",
      ring: "focus-visible:ring-blue-700",
      softBg: "bg-gray-50",
      softHover: "hover:bg-gray-50"
    }
  }, o = () => s[e.severity] || s.default, d = {
    danger: "hover:border-red-600",
    success: "hover:border-green-600",
    warn: "hover:border-orange-500",
    default: "hover:border-blue-600"
  }, u = i(() => {
    const x = (...D) => e.isDisabled || e.isLoading ? [] : D, $ = o();
    switch (e.variant) {
      case "primary":
        return [
          e.severity === "neutral" ? $.text : "text-white",
          $.solidBg,
          ...x($.solidHover, $.solidActive),
          $.ring
        ].join(" ");
      case "secondary":
        return [
          "bg-transparent border",
          $.border,
          $.text,
          ...x(
            $.solidHover,
            // Neutral's hover fill is near-white, so its text darkens instead of turning white.
            e.severity === "neutral" ? $.textHover : "hover:text-white"
          ),
          $.ring
        ].join(" ");
      case "tertiary":
        return [
          "border border-gray-200 bg-white",
          $.text,
          ...x(
            $.softHover,
            d[e.severity] ?? d.default
          ),
          $.ring
        ].join(" ");
      case "text":
        return [
          "bg-transparent border-0",
          ...x("decoration-1 hover:underline underline-offset-3", $.textHover),
          $.text,
          $.ring
        ].join(" ");
      case "brand":
        return [
          "text-white",
          "border border-transparent",
          "ui-btn-brand",
          // `ui-btn-brand` sets its shadow outside Tailwind's layers, so only `!important` removes it.
          e.isDisabled ? "!shadow-none" : "hover:text-white shadow-md",
          "focus-visible:ring-blue-500"
        ].join(" ");
      default:
        return "";
    }
  }), b = {
    xxs: "pl-1",
    xs: "pl-1",
    sm: "pl-1.5",
    md: "pl-2",
    lg: "pl-2"
  }, g = i(() => {
    if (e.variant === "text") return "p-0 gap-2 rounded-lg";
    if (e.isIconOnly) {
      const x = {
        xxs: "w-5 h-5 p-0 rounded",
        xs: "w-6 h-6 p-0 rounded-md",
        sm: "w-8 h-8 p-0 rounded-md",
        md: "w-10 h-10 p-0 rounded-lg",
        lg: "w-12 h-12 p-0 rounded-lg"
      };
      return `${x[e.size] ?? x.md} justify-center items-center shrink-0`;
    }
    switch (e.size) {
      case "xxs":
        return "px-1.5 py-0.5 gap-1 rounded";
      case "xs":
        return "px-2 py-1 gap-1 rounded";
      case "sm":
        return "px-2 py-1 gap-1.5 rounded-md";
      case "md":
        return "px-4 py-1.5 gap-2 rounded-lg";
      case "lg":
        return "px-4 py-3 gap-2 rounded-lg";
      default:
        return "px-4 py-2 gap-2 rounded-lg";
    }
  }), h = [
    "grid grid-cols-[0fr] transition-[grid-template-columns] duration-200 ease-out motion-reduce:transition-none",
    "group-hover/reveal:grid-cols-[1fr] group-focus-visible/reveal:grid-cols-[1fr] [@media(hover:none)]:grid-cols-[1fr]"
  ].join(" "), p = i(
    () => `block whitespace-nowrap ${b[e.size] ?? b.md}`
  ), f = i(() => e.isLoading ? "cursor-wait" : e.isDisabled ? "cursor-not-allowed opacity-50 shadow-none" : "cursor-pointer"), y = i(() => [
    ...a,
    e.isLabelRevealedOnHover ? `group/reveal ${g.value.replace(/\bgap-\S+/, "gap-0")}` : g.value,
    u.value,
    e.isIconOnly ? "" : t.value,
    f.value,
    // The loading spinner and a floating badge both position against the button.
    e.isLoading || e.isFloatingBadge ? "relative" : ""
  ].join(" ")), w = i(() => {
    if (e.isFloatingBadge)
      return "text-[10px] px-1.5 min-w-[18px] h-4.5";
    switch (e.size) {
      case "xxs":
        return "text-[10px] px-1 min-w-[14px] h-3.5";
      case "xs":
        return "text-[10px] px-1 min-w-[14px] h-3.5";
      case "sm":
        return "text-[10px] px-1.5 min-w-[16px] h-4";
      case "lg":
        return "text-xs px-2 min-w-[20px] h-5";
      default:
        return "text-xs px-1.5 min-w-[18px] h-4.5";
    }
  }), S = {
    default: "bg-blue-700 text-white",
    danger: "bg-red-600 text-white",
    success: "bg-green-600 text-white",
    warn: "bg-orange-500 text-white",
    neutral: "bg-gray-600 text-white"
  }, k = i(() => {
    const x = e.variant === "text" ? "-top-2 left-full -ml-1" : "-top-2 -right-2", $ = e.isFloatingBadge ? `absolute z-10 ${x}` : `inline-flex shrink-0 ${e.isLoading ? "opacity-0" : ""}`, D = /* @__PURE__ */ new Set(["primary", "brand"]), R = e.isFloatingBadge && D.has(e.variant) ? "ring-2 ring-white" : "", V = `${$} flex items-center justify-center rounded-full font-semibold leading-none tabular-nums ${R}`;
    if (D.has(e.variant) && !e.isFloatingBadge) {
      const G = {
        default: "bg-white text-blue-700",
        danger: "bg-white text-red-600",
        success: "bg-white text-green-600",
        warn: "bg-white text-orange-500",
        neutral: "bg-white text-gray-700"
      }, z = G[e.severity] ?? G.default;
      return `${V} ${w.value} ${z}`;
    }
    const Z = S[e.severity] ?? S.default;
    return `${V} ${w.value} ${Z}`;
  });
  return { buttonClasses: y, badgeClasses: k, revealTrackClasses: h, revealLabelClasses: p };
}
const ri = { class: "min-w-0 overflow-hidden" }, ii = {
  key: 5,
  class: "absolute inset-0 flex items-center justify-center"
}, di = { class: "min-w-0 overflow-hidden" }, ci = {
  key: 5,
  class: "absolute inset-0 flex items-center justify-center"
}, ui = ["id"], fi = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "Button",
  props: {
    variant: { default: "primary" },
    size: { default: "md" },
    severity: { default: "default" },
    type: { default: "button" },
    isLoading: { type: Boolean, default: !1 },
    isDisabled: { type: Boolean, default: !1 },
    isIconOnly: { type: Boolean, default: !1 },
    isLabelRevealedOnHover: { type: Boolean, default: !1 },
    count: { default: void 0 },
    isFloatingBadge: { type: Boolean, default: !1 },
    tooltip: { default: void 0 },
    tooltipPosition: { default: void 0 }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = We(), d = gn(), { buttonClasses: u, badgeClasses: b, revealTrackClasses: g, revealLabelClasses: h } = Vs(t), p = i(() => t.size === "xxs" || t.size === "xs" ? "xs" : "sm"), f = i(() => t.isIconOnly || !!o["left-icon"]), y = i(() => !t.isIconOnly && !!o["right-icon"]), w = i(() => t.isLoading ? "opacity-0" : ""), S = i(() => t.isDisabled && !!t.tooltip), k = Ga(), x = () => ({
      type: t.type,
      disabled: t.isLoading || t.isDisabled,
      "data-testid": "ui-button",
      "aria-busy": t.isLoading || void 0
    }), $ = () => S.value ? {
      disabled: t.isLoading,
      "aria-disabled": !0,
      // Joined, not replaced: a caller may already point at its own description.
      "aria-describedby": [d["aria-describedby"], k].filter(Boolean).join(" ")
    } : {}, D = (E) => {
      if (t.isDisabled || t.isLoading) {
        E.preventDefault(), E.stopPropagation();
        return;
      }
      s("click", E);
    };
    return (E, R) => e.tooltip ? (n(), c(re, { key: 1 }, [
      L(ht, {
        label: e.tooltip,
        position: e.tooltipPosition
      }, {
        default: M(() => [
          m("button", Oe({ ...x(), ...E.$attrs, ...$() }, {
            class: l(u),
            onClick: D
          }), [
            f.value ? (n(), c("span", {
              key: 0,
              class: r(["inline-flex shrink-0 items-center justify-center", w.value])
            }, [
              T(E.$slots, "left-icon", {}, void 0, !0)
            ], 2)) : v("", !0),
            e.isLabelRevealedOnHover ? (n(), c("span", {
              key: 1,
              class: r([l(g), w.value])
            }, [
              m("span", di, [
                m("span", {
                  class: r(l(h)),
                  "data-testid": "ui-button-revealed-label"
                }, [
                  T(E.$slots, "default", {}, void 0, !0)
                ], 2)
              ])
            ], 2)) : (n(), c("span", {
              key: 2,
              class: r(["block truncate", w.value])
            }, [
              T(E.$slots, "default", {}, void 0, !0)
            ], 2)),
            e.count !== void 0 && (!e.isIconOnly || e.isFloatingBadge) ? (n(), c("span", {
              key: 3,
              class: r(l(b))
            }, C(e.count), 3)) : v("", !0),
            y.value ? (n(), c("span", {
              key: 4,
              class: r(["inline-flex shrink-0 items-center justify-center", w.value])
            }, [
              T(E.$slots, "right-icon", {}, void 0, !0)
            ], 2)) : v("", !0),
            e.isLoading ? (n(), c("span", ci, [
              L(et, { size: p.value }, null, 8, ["size"])
            ])) : v("", !0)
          ], 16)
        ]),
        _: 3
      }, 8, ["label", "position"]),
      S.value ? (n(), c("span", {
        key: 0,
        id: l(k),
        class: "sr-only"
      }, C(e.tooltip), 9, ui)) : v("", !0)
    ], 64)) : (n(), c("button", Oe({ key: 0 }, { ...x(), ...E.$attrs, ...$() }, {
      class: l(u),
      onClick: D
    }), [
      f.value ? (n(), c("span", {
        key: 0,
        class: r(["inline-flex shrink-0 items-center justify-center", w.value])
      }, [
        T(E.$slots, "left-icon", {}, void 0, !0)
      ], 2)) : v("", !0),
      e.isLabelRevealedOnHover ? (n(), c("span", {
        key: 1,
        class: r([l(g), w.value])
      }, [
        m("span", ri, [
          m("span", {
            class: r(l(h)),
            "data-testid": "ui-button-revealed-label"
          }, [
            T(E.$slots, "default", {}, void 0, !0)
          ], 2)
        ])
      ], 2)) : (n(), c("span", {
        key: 2,
        class: r(["block truncate", w.value])
      }, [
        T(E.$slots, "default", {}, void 0, !0)
      ], 2)),
      e.count !== void 0 && (!e.isIconOnly || e.isFloatingBadge) ? (n(), c("span", {
        key: 3,
        class: r(l(b))
      }, C(e.count), 3)) : v("", !0),
      y.value ? (n(), c("span", {
        key: 4,
        class: r(["inline-flex shrink-0 items-center justify-center", w.value])
      }, [
        T(E.$slots, "right-icon", {}, void 0, !0)
      ], 2)) : v("", !0),
      e.isLoading ? (n(), c("span", ii, [
        L(et, { size: p.value }, null, 8, ["size"])
      ])) : v("", !0)
    ], 16));
  }
}), Ze = /* @__PURE__ */ Ye(fi, [["__scopeId", "data-v-7c15a8ab"]]), tl = "cursor-pointer inline-flex items-center justify-center rounded p-0.5 text-gray-400 hover:bg-blue-50 hover:text-blue-700";
function bi(e, a = () => !1) {
  const t = i(() => {
    const d = [
      "group flex items-center w-full transition-all duration-200 border rounded-lg overflow-hidden"
    ], u = {
      filled: "bg-background-light-300",
      outlined: "bg-white"
    }, b = [
      "border-border-border-200",
      // Read-only omits the focus blue rather than overriding it with a transparent variant.
      // Both are the same specificity on the same property, so pairing them leaves the winner
      // up to Tailwind's generated utility order instead of intent — it happened to resolve
      // correctly, but nothing held it there. Mirrors `useAutoCompleteStyles`.
      e.isReadOnly ? "" : "has-[:focus]:border-blue-600",
      {
        "border-red-600 has-[:focus]:border-red-600": e.isInvalid,
        "border-transparent": e.isReadOnly,
        "opacity-70 select-none border-gray-300 cursor-not-allowed !bg-blue-50": e.isDisabled
      }
    ];
    return [...d, u[e.variant ?? "filled"], ...b];
  }), s = {
    xs: "py-0.5",
    sm: "py-1",
    md: "py-2",
    lg: "py-3"
  }, o = i(() => {
    const u = [
      "border-none outline-none type-body-1 transition-colors focus:outline-none focus:ring-0 ring-0",
      e.isReadOnly && a() ? "w-auto max-w-full field-sizing-content" : "flex-1 w-full",
      s[e.size ?? "md"],
      // Read-only drops the horizontal padding so the value lines up flush left with
      // its label (which loses its own border-notch inset). The padding only exists to
      // hold the text off the border, and read-only has no visible border.
      e.isReadOnly ? "px-0" : "px-2",
      { "cursor-not-allowed": e.isDisabled }
    ], b = {
      filled: ["bg-transparent", "text-txt-700"],
      outlined: ["bg-transparent", "text-black disabled:text-txt-200"]
    }, g = e.isReadOnly ? "placeholder:text-gray-400" : (e.variant ?? "filled") === "filled" ? "placeholder:text-txt-500" : "placeholder:text-gray-300";
    return [...u, ...b[e.variant ?? "filled"], g];
  });
  return { containerClasses: t, inputClasses: o, clearButtonClasses: tl };
}
const ka = "—", Bt = (e, a) => i(
  () => e.isReadOnly && !a() ? ka : e.placeholder?.trim() || void 0
), gt = "left-px px-0", mt = "text-gray-400", Et = (e, a, t) => ({
  isLabelHidden: i(
    () => !e.isReadOnly && !!e.floatLabel && !a() && !t()
  )
}), pi = ["for"], hi = ["id", "value", "type", "inputmode", "maxlength", "placeholder", "disabled", "readonly", "required", "aria-describedby", "aria-label", "aria-busy"], gi = ["data-testid"], mi = /* @__PURE__ */ X({
  __name: "TextInput",
  props: {
    id: {},
    modelValue: { default: "" },
    class: { type: [Boolean, null, String, Object, Array] },
    placeholder: {},
    label: {},
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: {},
    ariaLabel: {},
    isDisabled: { type: Boolean, default: !1 },
    isReadOnly: { type: Boolean, default: !1 },
    isClearable: { type: Boolean, default: !1 },
    isCopyable: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    variant: { default: "outlined" },
    isInvalid: { type: Boolean, default: !1 },
    isRequired: { type: Boolean, default: !1 },
    type: { default: "text" },
    inputMode: {},
    maxLength: {},
    size: { default: "lg" }
  },
  emits: ["update:modelValue", "blur", "focus", "clear"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = We(), { containerClasses: d, inputClasses: u, clearButtonClasses: b } = bi(
      t,
      () => !!o.suffix
    ), g = Bt(t, () => h.value), h = i(
      () => t.modelValue !== "" && t.modelValue !== null && t.modelValue !== void 0
    ), p = i(() => t.isClearable && h.value && !t.isDisabled && !t.isReadOnly), f = i(() => t.isCopyable && h.value), y = A(!1);
    let w;
    const S = async () => {
      await Qa(String(t.modelValue ?? "")) && (y.value = !0, clearTimeout(w), w = setTimeout(() => {
        y.value = !1;
      }, 1500));
    };
    Mt(() => clearTimeout(w));
    const k = A(!1), x = A(!1);
    Se(
      () => t.isInvalid,
      (ae, B) => {
        ae && !B && (x.value = !0);
      }
    );
    const $ = (ae) => {
      ae.animationName.includes("shake") && (x.value = !1);
    }, D = i(() => `${t.label ?? ""}${t.isRequired ? " (Required)" : ""}`), E = i(() => t.isDisabled ? "text-txt-500" : t.isInvalid ? "text-red-600" : t.isReadOnly ? mt : k.value ? "text-blue-600" : h.value ? "text-gray-400" : "text-txt-700"), { isLabelHidden: R } = Et(
      t,
      () => k.value,
      () => h.value
    ), V = i(() => [
      "pointer-events-none absolute -top-2 z-10 rounded type-body-2 transition duration-200",
      // Read-only has no border to notch, so the label drops the inset + backing colour and
      // sits flush left, aligned with the (also unpadded) value beneath it. `left-px`, not
      // `left-0`: the label is positioned against the outer wrapper while the value sits inside
      // the container, so the container's 1px border insets the value by exactly that much. The
      // border stays (transparent) so toggling read-only doesn't resize the box, so the label
      // matches it instead.
      t.isReadOnly ? gt : [
        "left-2 px-1",
        // Background matches the field so the label cleanly notches the top border.
        t.variant === "outlined" ? "bg-white" : "bg-background-light-300"
      ],
      R.value ? "opacity-0 translate-y-1" : "opacity-100 translate-y-0",
      E.value
    ]), Z = (ae) => {
      const B = ae.target;
      s("update:modelValue", B.value);
    }, G = (ae) => {
      k.value = !0, s("focus", ae);
    }, z = (ae) => {
      k.value = !1, s("blur", ae);
    }, U = () => {
      s("update:modelValue", ""), s("clear");
    };
    return (ae, B) => (n(), c("div", {
      class: r(l(q)("relative w-full", t.class))
    }, [
      e.label ? (n(), c("label", {
        key: 0,
        for: e.id,
        class: r(V.value)
      }, C(D.value), 11, pi)) : v("", !0),
      m("div", {
        class: r([l(d), { "ti-shake": x.value }]),
        onAnimationend: $
      }, [
        l(o).prefix ? (n(), c("div", {
          key: 0,
          class: r(["pointer-events-none flex items-center justify-center", e.isReadOnly ? "pr-2 pl-0" : "pl-2"])
        }, [
          T(ae.$slots, "prefix", {}, void 0, !0)
        ], 2)) : v("", !0),
        m("input", {
          id: e.id,
          value: e.modelValue,
          type: e.type,
          inputmode: e.inputMode,
          maxlength: e.maxLength,
          placeholder: l(g),
          disabled: e.isDisabled,
          readonly: e.isReadOnly,
          required: e.isRequired,
          "aria-describedby": e.ariaDescribedby,
          "aria-label": e.label ? void 0 : e.ariaLabel,
          "aria-busy": e.isLoading || void 0,
          class: r(l(u)),
          onInput: Z,
          onBlur: z,
          onFocus: G
        }, null, 42, hi),
        e.isLoading || f.value || p.value || l(o).suffix ? (n(), c("div", {
          key: 1,
          class: r(["pointer-events-auto flex items-center justify-center gap-1 pr-2", { "pl-2": e.isReadOnly }])
        }, [
          e.isLoading ? (n(), F(et, {
            key: 0,
            size: "xs",
            color: "blue-600",
            class: "shrink-0"
          })) : v("", !0),
          f.value ? (n(), F(Ze, {
            key: 1,
            variant: "primary",
            severity: "neutral",
            size: "xs",
            "is-icon-only": "",
            class: "opacity-0 transition-opacity duration-200 group-focus-within:opacity-100 group-hover:opacity-100",
            "aria-label": y.value ? "Copied to clipboard" : "Copy value",
            "data-testid": e.id ? `textinput-${e.id}-copy` : void 0,
            onClick: Te(S, ["stop"])
          }, {
            "left-icon": M(() => [
              y.value ? (n(), F(l($t), {
                key: 0,
                class: "h-4 w-4 text-green-600"
              })) : (n(), F(l(Jr), {
                key: 1,
                class: "h-4 w-4"
              }))
            ]),
            _: 1
          }, 8, ["aria-label", "data-testid"])) : v("", !0),
          p.value ? (n(), c("button", {
            key: 2,
            type: "button",
            class: r(l(b)),
            "aria-label": "Clear input",
            "data-testid": e.id ? `textinput-${e.id}-clear` : void 0,
            onClick: Te(U, ["stop"])
          }, [
            L(l(rt), { class: "h-4 w-4" })
          ], 10, gi)) : l(o).suffix ? T(ae.$slots, "suffix", {}, void 0, !0, 3) : v("", !0)
        ], 2)) : v("", !0)
      ], 34)
    ], 2));
  }
}), Ba = /* @__PURE__ */ Ye(mi, [["__scopeId", "data-v-5b985c2d"]]), vi = {
  sm: "h-1",
  md: "h-2"
}, Ss = {
  default: "bg-blue-600",
  complete: "bg-green-600",
  warn: "bg-orange-500",
  danger: "bg-red-600"
}, yi = {
  default: "bg-[repeating-linear-gradient(135deg,var(--color-blue-600)_0_4px,var(--color-white)_4px_8px)]",
  complete: "bg-[repeating-linear-gradient(135deg,var(--color-green-600)_0_4px,var(--color-white)_4px_8px)]",
  warn: "bg-[repeating-linear-gradient(135deg,var(--color-orange-600)_0_4px,var(--color-white)_4px_8px)]",
  danger: "bg-[repeating-linear-gradient(135deg,var(--color-red-600)_0_4px,var(--color-white)_4px_8px)]"
}, xi = ({
  tone: e = "default",
  pattern: a = "solid"
}) => (a === "hatched" ? yi : Ss)[e], wi = {
  key: 0,
  class: "flex h-full w-full"
}, ob = /* @__PURE__ */ X({
  __name: "ProgressBar",
  props: {
    value: { default: void 0 },
    segments: { default: void 0 },
    max: { default: 100 },
    tone: { default: "default" },
    size: { default: "md" },
    class: { type: [Boolean, null, String, Object, Array], default: void 0 }
  },
  setup(e) {
    const a = e, t = i(() => (a.segments?.length ?? 0) > 0), s = i(() => a.max > 0 ? a.max : 1), o = i(() => (a.segments ?? []).map((k) => Math.max(k.value, 0))), d = i(() => o.value.reduce((k, x) => k + x, 0)), u = i(
      () => t.value ? Math.max(s.value, d.value) : s.value
    ), b = i(() => Math.min(Math.max(a.value ?? 0, 0), s.value)), g = i(() => t.value ? d.value : b.value), h = (k) => `${k / u.value * 100}%`, p = i(() => {
      if (!(!t.value || a.max <= 0))
        return `${Math.round(d.value / a.max * 100)}%`;
    }), f = mn("root"), y = i(
      () => q(
        "relative w-full overflow-hidden rounded-full bg-gray-200",
        vi[a.size],
        a.class
      )
    ), w = i(
      () => q("h-full rounded-full transition-[width] duration-300 ease-out", Ss[a.tone])
    ), S = (k) => q("h-full transition-[width] duration-300 ease-out", xi(k));
    return (k, x) => (n(), F(l(Sn), {
      ref_key: "root",
      ref: f,
      "model-value": g.value,
      max: u.value,
      "aria-valuetext": p.value,
      class: r(y.value),
      "data-testid": "progress-bar"
    }, {
      default: M(() => [
        t.value ? (n(), c("span", wi, [
          (n(!0), c(re, null, xe(a.segments, ($, D) => (n(), c("span", {
            key: D,
            class: r(S($)),
            style: Ee({ width: h(o.value[D] ?? 0) }),
            "data-testid": "progress-bar-segment"
          }, null, 6))), 128))
        ])) : (n(), F(l(Bn), {
          key: 1,
          class: r(w.value),
          style: Ee({ width: h(b.value) }),
          "data-testid": "progress-bar-indicator"
        }, null, 8, ["class", "style"]))
      ]),
      _: 1
    }, 8, ["model-value", "max", "aria-valuetext", "class"]));
  }
}), Li = ["id", "role"], Be = /* @__PURE__ */ X({
  __name: "InputMessage",
  props: {
    message: { default: "" },
    type: { default: "error" },
    id: {},
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e, t = {
      info: "text-txt-600",
      warn: "text-orange-700",
      error: "text-red-600"
    }, s = {
      info: "status",
      warn: "status",
      error: "alert"
    }, o = i(() => t[a.type]), d = i(() => s[a.type]);
    return (u, b) => (n(), F(_t, {
      "enter-active-class": "transition duration-200 ease-out",
      "enter-from-class": "transform -translate-y-1 opacity-0",
      "enter-to-class": "transform translate-y-0 opacity-100",
      "leave-active-class": "transition duration-150 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: M(() => [
        e.message || u.$slots.default ? (n(), c("p", {
          key: 0,
          id: e.id,
          role: d.value,
          class: r(l(q)("type-body-2 mt-1", o.value, a.class))
        }, [
          T(u.$slots, "default", {}, () => [
            ie(C(e.message), 1)
          ])
        ], 10, Li)) : v("", !0)
      ]),
      _: 3
    }));
  }
}), Bs = /* @__PURE__ */ X({
  __name: "Checkbox",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    modelValue: { type: Boolean, default: !1 },
    name: { default: void 0 },
    required: { type: Boolean, default: !1 },
    value: { default: "on" },
    disabled: { type: Boolean, default: !1 },
    id: { default: void 0 },
    variant: { default: "blue" },
    "aria-describedby": { default: void 0 },
    "aria-invalid": { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = i({
      get: () => t.modelValue,
      set: (d) => s("update:modelValue", d)
    });
    return (d, u) => (n(), F(l(Ol), {
      id: t.id,
      modelValue: o.value,
      "onUpdate:modelValue": u[0] || (u[0] = (b) => o.value = b),
      "data-testid": "checkbox-root",
      disabled: t.disabled,
      required: t.required,
      name: t.name,
      value: t.value,
      "aria-describedby": t["aria-describedby"],
      "aria-invalid": t["aria-invalid"],
      class: r(
        l(q)(
          "peer flex h-5 w-5 shrink-0 items-center justify-center rounded-sm border-2 transition-all",
          "focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 focus-visible:outline-none",
          // --- Disabled State ---
          "disabled:cursor-not-allowed disabled:border-gray-100 disabled:bg-transparent disabled:opacity-80",
          // --- Variant: Blue ---
          !t.disabled && t.variant === "blue" && [
            "border-blue-100 bg-blue-100",
            "data-[state=checked]:border-blue-100 data-[state=checked]:bg-blue-100",
            "cursor-pointer hover:border-blue-200"
          ],
          // --- Variant: White ---
          !t.disabled && t.variant === "white" && [
            "border-white bg-white",
            "data-[state=checked]:border-white data-[state=checked]:bg-white",
            "cursor-pointer"
          ],
          t.class
        )
      )
    }, {
      default: M(() => [
        L(l(zl), { class: "flex h-full w-full items-center justify-center text-current" }, {
          default: M(() => [
            L(l($t), {
              class: r(l(q)("h-3.5 w-3.5 stroke-3", t.disabled ? "text-gray-400" : "text-blue-800"))
            }, null, 8, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["id", "modelValue", "disabled", "required", "name", "value", "aria-describedby", "aria-invalid", "class"]));
  }
}), Ci = /* @__PURE__ */ X({
  __name: "Radio",
  props: {
    value: {},
    id: { default: void 0 },
    name: { default: void 0 },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    variant: { default: "blue" },
    "aria-describedby": { default: void 0 },
    "aria-invalid": { type: Boolean, default: !1 }
  },
  setup(e) {
    const a = e;
    return (t, s) => (n(), F(l(Hl), {
      id: a.id,
      value: a.value,
      "data-testid": "radio-item",
      disabled: a.disabled,
      required: a.required,
      name: a.name,
      "aria-describedby": a["aria-describedby"],
      "aria-invalid": a["aria-invalid"],
      class: r(
        l(q)(
          "peer flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 transition-all",
          "focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 focus-visible:outline-none",
          // --- Disabled State ---
          "disabled:cursor-not-allowed disabled:border-gray-100 disabled:bg-transparent disabled:opacity-80",
          // --- Variant: Blue ---
          !a.disabled && a.variant === "blue" && [
            "border-blue-100 bg-blue-100",
            "data-[state=checked]:border-blue-100 data-[state=checked]:bg-blue-100",
            "cursor-pointer hover:border-blue-200"
          ],
          // --- Variant: White ---
          !a.disabled && a.variant === "white" && [
            "border-white bg-white",
            "data-[state=checked]:border-white data-[state=checked]:bg-white",
            "cursor-pointer"
          ]
        )
      )
    }, {
      default: M(() => [
        L(l(En), { class: "flex h-full w-full items-center justify-center" }, {
          default: M(() => [
            m("span", {
              class: r(l(q)("h-2 w-2 rounded-full", a.disabled ? "bg-gray-400" : "bg-blue-800")),
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["id", "value", "disabled", "required", "name", "aria-describedby", "aria-invalid", "class"]));
  }
}), ki = {
  sm: { track: "h-5 w-9", thumb: "h-4 w-4", translate: "data-[state=checked]:translate-x-4" },
  md: { track: "h-7 w-12", thumb: "h-6 w-6", translate: "data-[state=checked]:translate-x-5" }
}, $i = (e) => {
  const a = i(() => ki[Ne(e.size)]), t = i(() => [
    "inline-flex shrink-0 items-center rounded-2xl border transition-colors",
    "focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 focus-visible:outline-none",
    a.value.track,
    Ne(e.isDisabled) ? "cursor-default opacity-60" : "cursor-pointer data-[state=unchecked]:hover:bg-brand-greyscale-neutral-700",
    // The two track colours the app's PrimeVue switch has always used, so a migrated consumer
    // looks unchanged next to one that hasn't moved yet.
    "data-[state=unchecked]:bg-brand-greyscale-neutral-600 data-[state=checked]:bg-blue-600",
    Ne(e.isInvalid) ? "border-red-500" : "border-transparent"
  ]), s = i(() => [
    "pointer-events-none block translate-x-px rounded-full bg-white shadow transition-transform",
    a.value.thumb,
    a.value.translate
  ]);
  return { trackClasses: t, thumbClasses: s };
}, rb = /* @__PURE__ */ X({
  __name: "Switch",
  props: {
    id: {},
    modelValue: { type: Boolean, default: !1 },
    size: { default: "md" },
    isDisabled: { type: Boolean, default: !1 },
    isRequired: { type: Boolean, default: !1 },
    isInvalid: { type: Boolean, default: !1 },
    name: { default: void 0 },
    ariaLabel: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    class: { type: [Boolean, null, String, Object, Array], default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = a, { trackClasses: o, thumbClasses: d } = $i({
      size: () => t.size,
      isDisabled: () => t.isDisabled,
      isInvalid: () => t.isInvalid
    }), u = i({
      get: () => t.modelValue,
      set: (b) => s("update:modelValue", b)
    });
    return (b, g) => (n(), F(l(Zl), {
      id: t.id,
      modelValue: u.value,
      "onUpdate:modelValue": g[0] || (g[0] = (h) => u.value = h),
      disabled: t.isDisabled,
      required: t.isRequired,
      name: t.name,
      "aria-label": t.ariaLabel,
      "aria-describedby": t.ariaDescribedby,
      "aria-invalid": t.isInvalid || void 0,
      class: r(l(q)(l(o), t.class)),
      "data-testid": "switch-root"
    }, {
      default: M(() => [
        L(l(Pl), {
          class: r(l(d)),
          "data-testid": "switch-thumb"
        }, null, 8, ["class"])
      ]),
      _: 1
    }, 8, ["id", "modelValue", "disabled", "required", "name", "aria-label", "aria-describedby", "aria-invalid", "class"]));
  }
}), Mi = {
  xs: "py-0.5",
  sm: "py-1",
  md: "py-2",
  lg: "py-3"
};
function Vi(e, a) {
  const t = i(() => e.variant === "accent" && a()), s = i(() => e.isDisabled ? "border-gray-300" : e.isInvalid ? "border-red-600" : e.isReadOnly ? "border-transparent" : t.value ? "border-blue-600" : "border-border-border-200"), o = i(() => {
    const ae = [
      "group flex w-full items-center gap-2 rounded-lg border type-body-1 outline-none transition-all duration-200 focus:outline-none focus:ring-0",
      Mi[e.size ?? "md"],
      // Read-only drops the horizontal padding so the value lines up flush left with its
      // label (which loses its own border-notch inset). The padding only holds content off
      // the border, and read-only has no visible border.
      e.isReadOnly ? "px-0" : "px-2"
    ], B = {
      filled: "bg-background-light-300",
      outlined: "bg-white",
      accent: t.value ? "bg-blue-50" : "bg-white"
    }, le = [
      s.value,
      // Read-only never lights up blue: reka's `disabled` keeps it unfocusable and unopenable,
      // so these would be dead classes — but they're withheld explicitly so the intent is
      // readable and a future focusable read-only variant can't accidentally flash a border.
      e.isReadOnly ? "" : "focus:border-blue-600 data-[state=open]:border-blue-600",
      {
        "focus:border-red-600 data-[state=open]:border-red-600": e.isInvalid && !e.isReadOnly,
        "cursor-not-allowed opacity-70 select-none !bg-blue-50": e.isDisabled,
        // Read-only gets a plain cursor rather than disabled's `not-allowed`: nothing is being
        // withheld, there is just nothing to click.
        "cursor-default": e.isReadOnly && !e.isDisabled,
        "cursor-pointer": !e.isDisabled && !e.isReadOnly
      }
    ];
    return [...ae, B[e.variant ?? "outlined"], ...le];
  }), d = i(() => e.isDisabled ? "text-txt-200" : t.value ? "text-blue-700" : "text-black"), u = i(() => ["flex-1 truncate text-left", d.value]), b = i(() => [
    "flex-1 truncate text-left",
    // In read-only this span holds the em-dash stand-in for a missing value rather than a
    // prompt, so it gets a legible muted tone instead of the faint prompt grey.
    e.isReadOnly ? "text-gray-400" : "text-gray-300"
  ]), g = i(() => [
    "h-4 w-4 transition-transform duration-200 group-data-[state=open]:rotate-180",
    t.value ? "text-blue-800" : "text-gray-400"
  ]), h = i(() => [
    "absolute cursor-pointer top-1/2 right-8 hover:text-blue-700 inline-flex -translate-y-1/2 items-center justify-center rounded p-0.5",
    t.value ? "text-blue-800 hover:bg-blue-100" : "text-gray-400 hover:bg-blue-50"
  ]), p = "z-50 max-h-[var(--reka-select-content-available-height)] overflow-hidden rounded-lg border border-border-border-200 bg-white shadow-lg", f = {
    trigger: "w-[var(--reka-select-trigger-width)] min-w-[var(--reka-select-trigger-width)] max-w-[var(--reka-select-trigger-width)]",
    auto: "w-max min-w-[var(--reka-select-trigger-width)] max-w-[min(28rem,var(--reka-select-content-available-width))]"
  }, y = i(
    () => q(p, f[e.menuWidth ?? "trigger"])
  ), w = i(
    () => (
      // Only a finite positive integer caps the list. `0` and `NaN` are falsy, so they used to
      // remove the cap silently, and a negative emitted a negative `max-height` the browser drops —
      // in both cases an open-ended menu quietly went back to filling the viewport.
      Number.isInteger(e.menuMaxRows) && (e.menuMaxRows ?? 0) > 0 ? { maxHeight: `calc(${e.menuMaxRows} * 2.25rem + 0.5rem)`, overflowY: "auto" } : void 0
    )
  );
  return {
    triggerClasses: o,
    valueClasses: u,
    placeholderClasses: b,
    chevronClasses: g,
    clearButtonClasses: h,
    contentClasses: y,
    viewportClasses: "p-1",
    viewportStyle: w,
    menuHeaderClasses: "border-b border-border-border-200 px-3 py-2",
    menuTitleClasses: "type-h5 text-black",
    menuDescriptionClasses: "mt-0.5 type-body-2 text-gray-500",
    itemClasses: "relative flex w-full cursor-pointer items-center rounded-md py-2 pr-8 pl-2 type-body-1 text-txt-700 outline-none select-none data-[highlighted]:bg-gray-50 data-[highlighted]:text-black data-[state=checked]:font-medium data-[disabled]:pointer-events-none data-[disabled]:text-gray-300",
    optionTextClasses: "flex min-w-0 flex-1 flex-col break-words",
    optionDescriptionClasses: "mt-0.5 type-body-2 text-gray-500",
    indicatorClasses: "absolute top-1/2 right-2 inline-flex -translate-y-1/2 items-center",
    searchRowClasses: "flex items-center gap-2 border-b border-border-border-200 px-3 py-2",
    searchIconClasses: "h-4 w-4 shrink-0 text-gray-400",
    searchInputClasses: "w-full min-w-0 border-none bg-transparent p-0 type-body-1 text-txt-700 outline-none ring-0 placeholder:text-gray-400 focus:ring-0 focus:outline-none",
    emptyClasses: "px-2 py-2 type-body-1 text-gray-400"
  };
}
let Gt = null;
const Si = (e) => {
  Gt && Gt !== e && Gt(), Gt = e;
}, wl = (e) => {
  Gt === e && (Gt = null);
}, Bi = ["for"], Ei = {
  key: 3,
  class: "w-5 shrink-0",
  "aria-hidden": "true"
}, Di = ["data-testid"], Fi = ["placeholder", "aria-label", "data-testid"], Ri = ["data-testid"], Ii = ["data-testid"], Ti = /* @__PURE__ */ X({
  __name: "Select",
  props: {
    id: {},
    modelValue: { default: void 0 },
    options: {},
    class: { type: [Boolean, null, String, Object, Array] },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: { default: void 0 },
    ariaLabel: { default: void 0 },
    name: { default: void 0 },
    isDisabled: { type: Boolean, default: !1 },
    isReadOnly: { type: Boolean, default: !1 },
    isClearable: { type: Boolean, default: !1 },
    isInvalid: { type: Boolean, default: !1 },
    isRequired: { type: Boolean, default: !1 },
    variant: { default: "outlined" },
    size: { default: "lg" },
    showSelectedAvatar: { type: Boolean, default: !0 },
    menuMaxRows: {},
    menuTitle: {},
    menuDescription: {},
    isSearchable: { type: Boolean, default: !1 },
    searchPlaceholder: { default: "Search" },
    menuWidth: { default: "trigger" },
    noMatchesText: { default: "No matches" }
  },
  emits: ["update:modelValue", "change", "blur", "focus", "clear"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = A(!1), d = A(!1), u = () => {
      o.value = !1;
    }, b = (N) => {
      o.value = N, N ? Si(u) : wl(u);
    };
    vn(() => wl(u));
    const g = A(!1);
    Se(
      () => t.isInvalid,
      (N, Le) => {
        N && !Le && (g.value = !0);
      }
    );
    const h = (N) => {
      N.animationName.includes("shake") && (g.value = !1);
    }, p = A(""), f = A(null), y = i(() => {
      const N = t.isSearchable ? p.value.trim().toLowerCase() : "";
      return N ? t.options.filter((Le) => Le.label.toLowerCase().includes(N)) : t.options;
    }), w = i(() => t.options.length > 0 && y.value.length === 0);
    Se(o, (N) => {
      t.isSearchable && !N && (p.value = "");
    }), Se(f, (N) => {
      N && requestAnimationFrame(() => N.focus());
    });
    const S = /* @__PURE__ */ new Set([
      "ArrowDown",
      "ArrowUp",
      "Home",
      "End",
      "Enter",
      "Escape",
      "Tab"
    ]), k = (N) => {
      S.has(N.key) || N.stopPropagation();
    }, x = i(
      () => t.options.find((N) => N.value === t.modelValue)
    ), $ = i(() => x.value !== void 0), D = i(() => t.size === "lg" ? "md" : "sm"), E = i(
      () => D.value === "md" ? "-my-1.5" : "-my-0.5"
    ), {
      triggerClasses: R,
      valueClasses: V,
      placeholderClasses: Z,
      chevronClasses: G,
      clearButtonClasses: z,
      contentClasses: U,
      viewportClasses: ae,
      viewportStyle: B,
      menuHeaderClasses: le,
      menuTitleClasses: O,
      menuDescriptionClasses: j,
      itemClasses: _,
      optionTextClasses: ne,
      optionDescriptionClasses: P,
      indicatorClasses: ce,
      searchRowClasses: W,
      searchIconClasses: H,
      searchInputClasses: fe,
      emptyClasses: $e
    } = Vi(t, () => $.value), te = Bt(t, () => $.value), we = i(() => {
      if (!t.label)
        return t.ariaLabel ? t.ariaLabel : t.placeholder?.trim() || "Select an option";
    }), I = i(() => `${t.label ?? ""}${t.isRequired ? " (Required)" : ""}`), Y = i(
      () => t.isClearable && $.value && !t.isDisabled && !t.isReadOnly
    ), be = i(() => t.isDisabled ? "text-txt-500" : t.isInvalid ? "text-red-600" : t.isReadOnly ? mt : d.value || o.value || t.variant === "accent" && $.value ? "text-blue-600" : $.value ? "text-gray-400" : "text-txt-700"), J = i(() => t.variant === "filled" ? "bg-background-light-300" : t.variant === "accent" && $.value ? "bg-blue-50" : "bg-white"), { isLabelHidden: Q } = Et(
      t,
      () => d.value || o.value,
      () => $.value
    ), ue = i(() => [
      "pointer-events-none absolute -top-2 z-10 rounded type-body-2 transition duration-200",
      // Read-only has no border to notch, so the label drops the inset + backing colour and sits
      // flush left. `left-px`, not `left-0`: the label is positioned against the outer wrapper
      // while the value sits inside the trigger, so the trigger's 1px (transparent) border insets
      // it by exactly that much.
      t.isReadOnly ? gt : ["left-2 px-1", J.value],
      Q.value ? "opacity-0 translate-y-1" : "opacity-100 translate-y-0",
      be.value
    ]), K = (N) => {
      s("update:modelValue", N), s("change", N);
    }, ee = () => {
      s("update:modelValue", void 0), s("change", void 0), s("clear"), Fe(() => document.getElementById(t.id)?.focus());
    }, he = (N) => {
      d.value = !0, s("focus", N);
    }, ge = (N) => {
      d.value = !1, s("blur", N);
    };
    return (N, Le) => (n(), c("div", {
      class: r(l(q)("relative w-full", t.class)),
      onAnimationend: h
    }, [
      e.label ? (n(), c("label", {
        key: 0,
        for: e.id,
        class: r(ue.value)
      }, C(I.value), 11, Bi)) : v("", !0),
      L(l(Dn), {
        "model-value": e.modelValue,
        open: o.value,
        name: e.name,
        disabled: e.isDisabled || e.isReadOnly,
        required: e.isRequired,
        "onUpdate:modelValue": K,
        "onUpdate:open": b
      }, {
        default: M(() => [
          L(l(Fn), {
            id: e.id,
            class: r([l(R), { "ti-shake": g.value }]),
            "aria-label": we.value,
            "aria-describedby": e.ariaDescribedby,
            "aria-invalid": e.isInvalid || void 0,
            "data-testid": `select-${e.id}`,
            onFocus: he,
            onBlur: ge
          }, {
            default: M(() => [
              e.showSelectedAvatar && $.value && x.value?.avatar && !N.$slots.value ? (n(), F(Ot, Oe({ key: 0 }, x.value.avatar, {
                size: D.value,
                class: ["shrink-0", E.value]
              }), null, 16, ["size", "class"])) : v("", !0),
              $.value && x.value ? (n(), c("span", {
                key: 1,
                class: r(l(V))
              }, [
                T(N.$slots, "value", { option: x.value }, () => [
                  ie(C(x.value.label), 1)
                ], !0)
              ], 2)) : (n(), c("span", {
                key: 2,
                class: r(l(Z))
              }, C(l(te)), 3)),
              Y.value ? (n(), c("span", Ei)) : v("", !0),
              e.isReadOnly ? v("", !0) : (n(), F(l(Rn), {
                key: 4,
                class: "ml-auto inline-flex shrink-0 items-center"
              }, {
                default: M(() => [
                  L(l(pa), {
                    class: r(l(G))
                  }, null, 8, ["class"])
                ]),
                _: 1
              }))
            ]),
            _: 3
          }, 8, ["id", "class", "aria-label", "aria-describedby", "aria-invalid", "data-testid"]),
          L(l(In), null, {
            default: M(() => [
              L(l(Tn), {
                position: "popper",
                "side-offset": 6,
                class: r(l(U)),
                "data-testid": `select-${e.id}-content`
              }, {
                default: M(() => [
                  N.$slots.header || e.menuTitle || e.menuDescription ? (n(), c("div", {
                    key: 0,
                    class: r(l(le)),
                    "data-testid": `select-${e.id}-header`
                  }, [
                    T(N.$slots, "header", {}, () => [
                      e.menuTitle ? (n(), c("p", {
                        key: 0,
                        class: r(l(O))
                      }, C(e.menuTitle), 3)) : v("", !0),
                      e.menuDescription ? (n(), c("p", {
                        key: 1,
                        class: r(l(j))
                      }, C(e.menuDescription), 3)) : v("", !0)
                    ], !0)
                  ], 10, Di)) : v("", !0),
                  t.isSearchable ? (n(), c("div", {
                    key: 1,
                    class: r(l(W))
                  }, [
                    L(l(ks), {
                      class: r(l(H))
                    }, null, 8, ["class"]),
                    _a(m("input", {
                      ref_key: "searchInput",
                      ref: f,
                      "onUpdate:modelValue": Le[0] || (Le[0] = (Me) => p.value = Me),
                      type: "text",
                      autocomplete: "off",
                      class: r(l(fe)),
                      placeholder: t.searchPlaceholder,
                      "aria-label": t.searchPlaceholder,
                      "data-testid": `select-${e.id}-search`,
                      onKeydown: k
                    }, null, 42, Fi), [
                      [Tl, p.value]
                    ])
                  ], 2)) : v("", !0),
                  L(l(An), {
                    class: r(l(ae)),
                    style: Ee(l(B))
                  }, {
                    default: M(() => [
                      y.value.length > 0 ? (n(!0), c(re, { key: 0 }, xe(y.value, (Me) => (n(), F(l(On), {
                        key: String(Me.value),
                        value: Me.value,
                        disabled: Me.disabled,
                        class: r(l(_)),
                        "data-testid": `select-${e.id}-option-${Me.value}`
                      }, {
                        default: M(() => [
                          Me.avatar && !N.$slots.option ? (n(), F(Ot, Oe({
                            key: 0,
                            ref_for: !0
                          }, Me.avatar, {
                            size: "md",
                            class: "mr-2 shrink-0"
                          }), null, 16)) : v("", !0),
                          m("span", {
                            class: r(l(ne))
                          }, [
                            L(l(zn), null, {
                              default: M(() => [
                                T(N.$slots, "option", { option: Me }, () => [
                                  ie(C(Me.label), 1)
                                ], !0)
                              ]),
                              _: 2
                            }, 1024),
                            Me.description && !N.$slots.option ? (n(), c("span", {
                              key: 0,
                              class: r(l(P))
                            }, C(Me.description), 3)) : v("", !0)
                          ], 2),
                          L(l(Hn), {
                            class: r(l(ce))
                          }, {
                            default: M(() => [
                              L(l($t), { class: "h-4 w-4 text-blue-600" })
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ]),
                        _: 2
                      }, 1032, ["value", "disabled", "class", "data-testid"]))), 128)) : w.value ? (n(), c("div", {
                        key: 1,
                        class: r(l($e)),
                        "data-testid": `select-${e.id}-no-matches`
                      }, C(t.noMatchesText), 11, Ri)) : (n(), c("div", {
                        key: 2,
                        class: r(l($e))
                      }, [
                        T(N.$slots, "empty", {}, () => [
                          Le[1] || (Le[1] = ie("No options available", -1))
                        ], !0)
                      ], 2))
                    ]),
                    _: 3
                  }, 8, ["class", "style"])
                ]),
                _: 3
              }, 8, ["class", "data-testid"])
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["model-value", "open", "name", "disabled", "required"]),
      Y.value ? (n(), c("button", {
        key: 1,
        type: "button",
        "aria-label": "Clear selection",
        "data-testid": `select-${e.id}-clear`,
        class: r(l(z)),
        onClick: Te(ee, ["stop"])
      }, [
        L(l(rt), { class: "h-4 w-4" })
      ], 10, Ii)) : v("", !0)
    ], 34));
  }
}), Ai = /* @__PURE__ */ Ye(Ti, [["__scopeId", "data-v-cd715a22"]]), Oi = {
  xs: "py-0.5",
  sm: "py-1",
  md: "py-2",
  lg: "py-3"
};
function zi(e, a) {
  const t = i(() => e.variant === "accent" && a()), s = i(() => e.isDisabled ? "border-gray-300" : e.isInvalid ? "border-red-600" : e.isReadOnly ? "border-transparent" : t.value ? "border-blue-600" : "border-border-border-200"), o = {
    filled: "bg-background-light-300",
    outlined: "bg-white",
    accent: "bg-white"
  }, d = i(
    () => t.value ? "bg-blue-50" : o[e.variant ?? "outlined"]
  ), u = i(() => [
    "group flex w-full items-center gap-1 rounded-lg border type-body-1 transition-all duration-200",
    Oi[e.size ?? "md"],
    d.value,
    // Read-only drops the horizontal padding so the value lines up flush left with its label
    // (which loses its own border-notch inset). The padding only holds content off the
    // border, and read-only has no visible border.
    e.isReadOnly ? "px-0" : "px-2",
    s.value,
    // Read-only stays focusable (native `readonly`, not `disabled`), so unlike the pickers
    // this genuinely has to be withheld — otherwise tabbing into a read-only field would
    // light up a blue border on a control that can't be changed.
    e.isReadOnly ? "" : "focus-within:border-blue-600",
    {
      "focus-within:border-red-600": e.isInvalid && !e.isReadOnly,
      "cursor-not-allowed opacity-70 select-none !bg-blue-50": e.isDisabled
    }
  ]), b = i(() => e.isDisabled ? "text-txt-200" : t.value ? "text-blue-700" : "text-black"), g = i(() => [
    "min-w-0 flex-1 border-0 bg-transparent p-0 type-body-1 outline-none focus:ring-0 disabled:cursor-not-allowed",
    // In read-only the placeholder is the em-dash stand-in for a missing value rather than a
    // prompt, so it gets a legible muted tone instead of the faint prompt grey. `accent`
    // deliberately leaves the prompt alone — see the note in `useSelectStyles`.
    e.isReadOnly ? "placeholder:text-gray-400" : "placeholder:text-gray-300",
    b.value
  ]), h = i(() => [
    "h-4 w-4 transition-transform duration-200 group-data-[state=open]:rotate-180",
    t.value ? "text-blue-800" : "text-gray-400"
  ]), p = i(() => [
    "inline-flex cursor-pointer items-center justify-center rounded p-0.5",
    t.value ? "text-blue-800 hover:bg-blue-100" : "text-gray-400 hover:bg-blue-50"
  ]);
  return {
    isAccentFilled: t,
    anchorClasses: u,
    inputClasses: g,
    chevronClasses: h,
    clearButtonClasses: p,
    triggerClasses: "group inline-flex shrink-0 cursor-pointer items-center justify-center",
    contentClasses: "z-50 max-h-[var(--reka-combobox-content-available-height)] min-w-[var(--reka-combobox-trigger-width)] overflow-hidden rounded-lg border border-border-border-200 bg-white shadow-lg",
    viewportClasses: "max-h-96 overflow-y-auto p-1",
    actionRowClasses: "border-t border-gray-200 p-1",
    itemClasses: "relative flex w-full cursor-pointer items-center rounded-md py-2 pr-8 pl-2 type-body-1 text-txt-700 outline-none select-none data-[highlighted]:bg-gray-50 data-[highlighted]:text-black data-[state=checked]:font-medium data-[disabled]:pointer-events-none data-[disabled]:text-gray-300",
    optionTextClasses: "flex min-w-0 flex-1 flex-col",
    optionDescriptionClasses: "mt-0.5 type-body-2 text-gray-500",
    indicatorClasses: "absolute top-1/2 right-2 inline-flex -translate-y-1/2 items-center",
    messageRowClasses: "flex items-center gap-2 px-2 py-2 type-body-1 text-gray-400"
  };
}
const Hi = ["for"], Zi = /* @__PURE__ */ X({
  __name: "AutoComplete",
  props: {
    id: {},
    modelValue: { default: void 0 },
    options: {},
    class: { type: [Boolean, null, String, Object, Array] },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: { default: void 0 },
    ariaLabel: { default: void 0 },
    name: { default: void 0 },
    isDisabled: { type: Boolean, default: !1 },
    isReadOnly: { type: Boolean, default: !1 },
    isClearable: { type: Boolean, default: !0 },
    isInvalid: { type: Boolean, default: !1 },
    isRequired: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    ignoreFilter: { type: Boolean, default: !1 },
    emptyMessage: { default: "No results" },
    loadingMessage: { default: "Loading…" },
    size: { default: "lg" },
    variant: { default: "outlined" }
  },
  emits: ["update:modelValue", "change", "update:query", "blur", "focus", "clear"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = A(!1), d = A(!1), u = A(!1);
    Se(
      () => t.isInvalid,
      (te, we) => {
        te && !we && (u.value = !0);
      }
    );
    const b = (te) => {
      te.animationName.includes("shake") && (u.value = !1);
    }, g = A();
    Se(
      [() => t.modelValue, () => t.options],
      ([te, we]) => {
        if (te === void 0) {
          g.value = void 0;
          return;
        }
        const I = we.find((Y) => Y.value === te);
        I && (g.value = I);
      },
      { immediate: !0 }
    );
    const h = i(() => {
      const te = t.options.find((we) => we.value === t.modelValue);
      if (te) return te;
      if (t.modelValue !== void 0 && g.value?.value === t.modelValue)
        return g.value;
    }), p = i(() => h.value !== void 0), {
      isAccentFilled: f,
      anchorClasses: y,
      inputClasses: w,
      chevronClasses: S,
      clearButtonClasses: k,
      triggerClasses: x,
      contentClasses: $,
      viewportClasses: D,
      actionRowClasses: E,
      itemClasses: R,
      optionTextClasses: V,
      optionDescriptionClasses: Z,
      indicatorClasses: G,
      messageRowClasses: z
    } = zi(t, () => p.value), U = Bt(t, () => p.value), ae = i(() => `${t.label ?? ""}${t.isRequired ? " (Required)" : ""}`), B = i(
      () => t.isClearable && p.value && !t.isDisabled && !t.isReadOnly
    ), le = (te) => {
      if (te == null || te === "") return "";
      const we = t.options.find((I) => I.value === te);
      return we ? we.label : g.value?.value === te ? g.value.label : "";
    }, O = i(() => t.isDisabled ? "text-txt-500" : t.isInvalid ? "text-red-600" : t.isReadOnly ? mt : d.value || o.value || f.value ? "text-blue-600" : p.value ? "text-gray-400" : "text-txt-700"), { isLabelHidden: j } = Et(
      t,
      () => d.value || o.value,
      () => p.value
    ), _ = i(
      () => f.value ? "bg-blue-50" : t.variant === "filled" ? "bg-background-light-300" : "bg-white"
    ), ne = i(() => [
      "pointer-events-none absolute -top-2 z-10 rounded type-field-label transition duration-200",
      // Read-only has no border to notch, so the label drops the inset + backing colour and sits
      // flush left. `left-px`, not `left-0`: the label is positioned against the outer wrapper
      // while the value sits inside the anchor, so the anchor's 1px (transparent) border insets
      // it by exactly that much.
      t.isReadOnly ? gt : ["left-2 px-1", _.value],
      j.value ? "opacity-0 translate-y-1" : "opacity-100 translate-y-0",
      O.value
    ]), P = (te) => {
      const we = te ?? void 0;
      s("update:modelValue", we), s("change", we);
    }, ce = A(""), W = (te) => {
      ce.value = te, s("update:query", te);
    };
    Se(
      () => le(t.modelValue),
      (te) => {
        d.value || ce.value || te && (ce.value = te);
      }
    );
    const H = async () => {
      const te = t.modelValue;
      ce.value = "", s("clear"), await Fe(), t.modelValue === te && (ce.value = le(t.modelValue));
    }, fe = (te) => {
      d.value = !0, s("focus", te);
    }, $e = (te) => {
      d.value = !1, s("blur", te);
    };
    return (te, we) => (n(), c("div", {
      class: r(l(q)("relative w-full", t.class)),
      onAnimationend: b
    }, [
      e.label ? (n(), c("label", {
        key: 0,
        for: e.id,
        class: r(ne.value)
      }, C(ae.value), 11, Hi)) : v("", !0),
      L(l(jl), {
        "model-value": e.modelValue,
        name: e.name,
        disabled: e.isDisabled,
        "ignore-filter": e.ignoreFilter,
        "open-on-click": !e.isReadOnly,
        "reset-model-value-on-clear": "",
        "onUpdate:modelValue": P,
        "onUpdate:open": we[0] || (we[0] = (I) => o.value = I)
      }, {
        default: M(() => [
          L(l(Nl), {
            class: r([l(y), { "ti-shake": u.value }])
          }, {
            default: M(() => [
              L(l(ql), {
                id: e.id,
                class: r(l(w)),
                placeholder: l(U),
                "model-value": ce.value,
                "display-value": le,
                disabled: e.isDisabled,
                readonly: e.isReadOnly,
                required: e.isRequired || void 0,
                "aria-describedby": e.ariaDescribedby,
                "aria-label": e.label ? void 0 : e.ariaLabel,
                "aria-invalid": e.isInvalid || void 0,
                "data-testid": `autocomplete-${e.id}`,
                "onUpdate:modelValue": W,
                onFocus: fe,
                onBlur: $e
              }, null, 8, ["id", "class", "placeholder", "model-value", "disabled", "readonly", "required", "aria-describedby", "aria-label", "aria-invalid", "data-testid"]),
              B.value ? (n(), F(l(Zn), {
                key: 0,
                "aria-label": "Clear selection",
                class: r(l(k)),
                "data-testid": `autocomplete-${e.id}-clear`,
                onClick: H
              }, {
                default: M(() => [
                  L(l(rt), { class: "h-4 w-4" })
                ]),
                _: 1
              }, 8, ["class", "data-testid"])) : v("", !0),
              e.isLoading ? (n(), F(et, {
                key: 1,
                size: "xs",
                color: "blue-600",
                class: "shrink-0"
              })) : e.isReadOnly ? v("", !0) : (n(), F(l(Ul), {
                key: 2,
                class: r(l(x)),
                "data-testid": `autocomplete-${e.id}-trigger`
              }, {
                default: M(() => [
                  L(l(pa), {
                    class: r(l(S))
                  }, null, 8, ["class"])
                ]),
                _: 1
              }, 8, ["class", "data-testid"]))
            ]),
            _: 1
          }, 8, ["class"]),
          L(l(Gl), null, {
            default: M(() => [
              L(l(_l), {
                position: "popper",
                "side-offset": 6,
                class: r(l($))
              }, {
                default: M(() => [
                  L(l(Wl), {
                    class: r(l(D))
                  }, {
                    default: M(() => [
                      e.isLoading ? (n(), c("div", {
                        key: 0,
                        class: r(l(z))
                      }, [
                        L(et, {
                          size: "xs",
                          color: "blue-600"
                        }),
                        m("span", null, C(e.loadingMessage), 1)
                      ], 2)) : (n(), c(re, { key: 1 }, [
                        (n(!0), c(re, null, xe(e.options, (I) => (n(), F(l(Kl), {
                          key: String(I.value),
                          value: I.value,
                          "text-value": I.label,
                          disabled: I.disabled,
                          class: r(l(R)),
                          "data-testid": `autocomplete-${e.id}-option-${I.value}`
                        }, {
                          default: M(() => [
                            m("span", {
                              class: r(l(V))
                            }, [
                              T(te.$slots, "option", { option: I }, () => [
                                ie(C(I.label), 1)
                              ], !0),
                              I.description && !te.$slots.option ? (n(), c("span", {
                                key: 0,
                                class: r(l(Z))
                              }, C(I.description), 3)) : v("", !0)
                            ], 2),
                            L(l(Yl), {
                              class: r(l(G))
                            }, {
                              default: M(() => [
                                L(l($t), { class: "h-4 w-4 text-blue-600" })
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ]),
                          _: 2
                        }, 1032, ["value", "text-value", "disabled", "class", "data-testid"]))), 128)),
                        L(l(Pn), {
                          class: r(l(z))
                        }, {
                          default: M(() => [
                            T(te.$slots, "empty", {}, () => [
                              ie(C(e.emptyMessage), 1)
                            ], !0)
                          ]),
                          _: 3
                        }, 8, ["class"])
                      ], 64))
                    ]),
                    _: 3
                  }, 8, ["class"]),
                  te.$slots.action ? (n(), c("div", {
                    key: 0,
                    class: r(l(E))
                  }, [
                    T(te.$slots, "action", { query: ce.value }, void 0, !0)
                  ], 2)) : v("", !0)
                ]),
                _: 3
              }, 8, ["class"])
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["model-value", "name", "disabled", "ignore-filter", "open-on-click"])
    ], 34));
  }
}), Pi = /* @__PURE__ */ Ye(Zi, [["__scopeId", "data-v-ac4b4b56"]]), ji = {
  xs: "py-0.5",
  sm: "py-1",
  md: "py-2",
  lg: "py-3"
};
function Ni(e) {
  const a = i(() => {
    const f = [
      "group flex items-center w-full transition-all duration-200 border rounded-lg overflow-hidden"
    ], y = {
      filled: "bg-background-light-300",
      outlined: "bg-white"
    }, w = [
      "border-border-border-200",
      // Read-only omits the focus blue rather than overriding it with a transparent variant.
      // Both are the same specificity on the same property, so pairing them leaves the winner
      // up to Tailwind's generated utility order instead of intent. Mirrors `useTextInputStyles`.
      e.isReadOnly ? "" : "has-[:focus]:border-blue-600",
      {
        "border-red-600 has-[:focus]:border-red-600": e.isInvalid,
        "border-transparent": e.isReadOnly,
        "opacity-70 select-none border-gray-300 cursor-not-allowed !bg-blue-50": e.isDisabled
      }
    ];
    return [...f, y[e.variant ?? "outlined"], ...w];
  }), t = i(() => {
    const f = [
      "flex-1 w-full border-none outline-none type-body-1 transition-colors focus:outline-none focus:ring-0 ring-0",
      ji[e.size ?? "md"],
      // Read-only drops the horizontal padding so the value lines up flush left with its
      // label (which loses its own border-notch inset).
      e.isReadOnly ? "px-0" : "px-2",
      { "cursor-not-allowed": e.isDisabled }
    ], y = {
      filled: ["bg-transparent", "text-txt-700"],
      outlined: ["bg-transparent", "text-black disabled:text-txt-200"]
    }, w = e.isReadOnly ? "placeholder:text-gray-400" : (e.variant ?? "outlined") === "filled" ? "placeholder:text-txt-500" : "placeholder:text-gray-300";
    return [...f, ...y[e.variant ?? "outlined"], w];
  });
  return {
    containerClasses: a,
    inputClasses: t,
    panelClasses: "overflow-hidden rounded-lg border border-border-border-200 bg-white shadow-lg",
    viewportClasses: "max-h-72 overflow-y-auto p-1",
    itemClasses: "flex w-full items-center rounded-md px-2 py-2 text-left type-body-1 text-txt-700 outline-none select-none",
    itemInteractiveClasses: "cursor-pointer hover:bg-gray-50 hover:text-black",
    itemActiveClasses: "bg-gray-50 text-black",
    itemDisabledClasses: "!cursor-not-allowed text-gray-300",
    optionTextClasses: "flex min-w-0 flex-1 flex-col",
    optionDescriptionClasses: "mt-0.5 type-body-2 text-gray-500",
    clearButtonClasses: tl
  };
}
const qi = ["for"], Ui = ["id", "value", "type", "inputmode", "name", "placeholder", "disabled", "readonly", "required", "aria-describedby", "aria-label", "aria-invalid", "aria-expanded", "aria-controls", "aria-activedescendant", "data-testid"], Gi = ["data-testid"], _i = ["id", "aria-label"], Wi = ["id", "aria-selected", "aria-disabled", "tabindex", "data-testid", "onClick"], Ll = 8, Ki = 288, Yi = 1e4, Xi = /* @__PURE__ */ X({
  __name: "ComboboxInput",
  props: {
    id: {},
    modelValue: { default: "" },
    suggestions: { default: () => [] },
    filter: { type: [Boolean, Function], default: !0 },
    class: { type: [Boolean, null, String, Object, Array] },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: { default: void 0 },
    ariaLabel: { default: void 0 },
    name: { default: void 0 },
    type: { default: "text" },
    inputMode: { default: void 0 },
    isDisabled: { type: Boolean, default: !1 },
    isReadOnly: { type: Boolean, default: !1 },
    isClearable: { type: Boolean, default: !1 },
    isInvalid: { type: Boolean, default: !1 },
    isRequired: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    variant: { default: "outlined" },
    size: { default: "lg" },
    showSelectedAvatar: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "select", "blur", "focus", "clear"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = We(), {
      containerClasses: d,
      inputClasses: u,
      panelClasses: b,
      viewportClasses: g,
      itemClasses: h,
      itemInteractiveClasses: p,
      itemActiveClasses: f,
      itemDisabledClasses: y,
      optionTextClasses: w,
      optionDescriptionClasses: S,
      clearButtonClasses: k
    } = Ni(t), x = A(), $ = A(), D = A(!1), E = A(!1), R = A(-1), V = i(() => `${t.id}-listbox`), Z = (K) => `${t.id}-option-${K}`, G = i(() => {
      const { filter: K } = t;
      if (K === !1) return t.suggestions;
      if (typeof K == "function") {
        const he = String(t.modelValue ?? "");
        return t.suggestions.filter((ge) => K(ge, he));
      }
      const ee = String(t.modelValue ?? "").trim().toLowerCase();
      return ee ? t.suggestions.filter(
        (he) => he.label.toLowerCase().includes(ee) || (he.description ?? "").toLowerCase().includes(ee)
      ) : t.suggestions;
    }), z = i(
      () => D.value && !t.isDisabled && !t.isReadOnly && G.value.length > 0
    ), U = i(
      () => z.value && R.value >= 0 ? Z(R.value) : void 0
    );
    Se(G, () => {
      R.value = -1;
    });
    const ae = A({}), B = () => {
      const K = $.value;
      if (!K) return;
      const ee = K.getBoundingClientRect(), he = window.innerHeight - ee.bottom, ge = he < Ki && ee.top > he;
      ae.value = {
        position: "fixed",
        zIndex: Yi,
        // reka's modal Dialog sets `body { pointer-events: none }` while open. The panel
        // is a body child, so without opting back in the suggestions render but can't be
        // clicked (and don't even show their hover state).
        pointerEvents: "auto",
        left: `${ee.left}px`,
        width: `${ee.width}px`,
        ...ge ? { bottom: `${window.innerHeight - ee.top + Ll}px` } : { top: `${ee.bottom + Ll}px` }
      };
    };
    Se(z, (K) => {
      K ? (Fe(B), window.addEventListener("scroll", B, !0), window.addEventListener("resize", B)) : (window.removeEventListener("scroll", B, !0), window.removeEventListener("resize", B));
    }), Mt(() => {
      window.removeEventListener("scroll", B, !0), window.removeEventListener("resize", B);
    });
    const le = Bt(t, () => O.value), O = i(() => !!t.modelValue), j = A(), _ = i(() => {
      if (t.showSelectedAvatar)
        return j.value && j.value.label === t.modelValue ? j.value.avatar : t.suggestions.find((K) => K.label === t.modelValue)?.avatar;
    }), ne = i(() => t.size === "lg" ? "md" : "sm"), P = i(
      () => t.isClearable && O.value && !t.isDisabled && !t.isReadOnly
    ), ce = A(!1);
    Se(
      () => t.isInvalid,
      (K, ee) => {
        K && !ee && (ce.value = !0);
      }
    );
    const W = (K) => {
      K.animationName.includes("shake") && (ce.value = !1);
    }, H = i(() => `${t.label ?? ""}${t.isRequired ? " (Required)" : ""}`), fe = i(() => t.isDisabled ? "text-txt-500" : t.isInvalid ? "text-red-600" : t.isReadOnly ? mt : E.value ? "text-blue-600" : O.value ? "text-gray-400" : "text-txt-700"), { isLabelHidden: $e } = Et(
      t,
      () => E.value,
      () => O.value
    ), te = i(() => [
      "pointer-events-none absolute -top-2 z-10 rounded type-body-2 transition duration-200",
      // Read-only has no border to notch, so the label drops the inset + backing colour and
      // sits flush left, aligned with the (also unpadded) value beneath it. `left-px`, not
      // `left-0`: the label is positioned against the outer wrapper while the value sits inside
      // the container, so the container's 1px (transparent) border insets it by that much.
      t.isReadOnly ? gt : ["left-2 px-1", t.variant === "outlined" ? "bg-white" : "bg-background-light-300"],
      $e.value ? "opacity-0 translate-y-1" : "opacity-100 translate-y-0",
      fe.value
    ]), we = (K) => {
      const ee = K.target;
      s("update:modelValue", ee.value), D.value = !0, R.value = -1;
    }, I = (K) => {
      E.value = !0, D.value = !0, s("focus", K);
    }, Y = (K) => {
      E.value = !1, D.value = !1, R.value = -1, s("blur", K);
    }, be = (K) => {
      K.disabled || (j.value = K, s("update:modelValue", K.label), s("select", K), D.value = !1, R.value = -1, x.value?.focus());
    }, J = (K) => {
      const ee = G.value, he = ee.length;
      if (he === 0) return;
      let ge = R.value;
      for (let N = 0; N < he; N += 1)
        if (ge = (ge + K + he) % he, !ee[ge]?.disabled) {
          R.value = ge;
          return;
        }
    }, Q = (K) => {
      if (!(t.isDisabled || t.isReadOnly))
        switch (K.key) {
          case "ArrowDown": {
            K.preventDefault(), D.value || (D.value = !0), J(1);
            break;
          }
          case "ArrowUp": {
            K.preventDefault(), D.value || (D.value = !0), J(-1);
            break;
          }
          case "Enter": {
            if (z.value && R.value >= 0) {
              const ee = G.value[R.value];
              ee && !ee.disabled && (K.preventDefault(), be(ee));
            }
            break;
          }
          case "Escape": {
            D.value && (K.preventDefault(), D.value = !1, R.value = -1);
            break;
          }
        }
    }, ue = () => {
      s("update:modelValue", ""), s("clear"), R.value = -1, x.value?.focus();
    };
    return (K, ee) => (n(), c("div", {
      ref_key: "rootRef",
      ref: $,
      class: r(l(q)("relative w-full", t.class))
    }, [
      e.label ? (n(), c("label", {
        key: 0,
        for: e.id,
        class: r(te.value)
      }, C(H.value), 11, qi)) : v("", !0),
      m("div", {
        class: r([l(d), { "ti-shake": ce.value }]),
        onAnimationend: W
      }, [
        l(o).prefix || _.value ? (n(), c("div", {
          key: 0,
          class: r(["pointer-events-none flex items-center justify-center", e.isReadOnly ? "pr-2 pl-0" : "pl-2"])
        }, [
          l(o).prefix ? T(K.$slots, "prefix", {}, void 0, !0, 0) : _.value ? (n(), F(Ot, Oe({ key: 1 }, _.value, { size: ne.value }), null, 16, ["size"])) : v("", !0)
        ], 2)) : v("", !0),
        m("input", {
          id: e.id,
          ref_key: "inputRef",
          ref: x,
          value: e.modelValue,
          type: e.type,
          inputmode: e.inputMode,
          name: e.name,
          placeholder: l(le),
          disabled: e.isDisabled,
          readonly: e.isReadOnly,
          required: e.isRequired,
          "aria-describedby": e.ariaDescribedby,
          "aria-label": e.label ? void 0 : e.ariaLabel,
          "aria-invalid": e.isInvalid || void 0,
          role: "combobox",
          "aria-autocomplete": "list",
          "aria-expanded": z.value,
          "aria-controls": V.value,
          "aria-activedescendant": U.value,
          class: r(l(u)),
          "data-testid": `combobox-${e.id}`,
          onInput: we,
          onKeydown: Q,
          onFocus: I,
          onBlur: Y
        }, null, 42, Ui),
        e.isLoading || P.value || l(o).suffix ? (n(), c("div", {
          key: 1,
          class: r(["pointer-events-auto flex items-center justify-center gap-1 pr-2", { "pl-2": e.isReadOnly }])
        }, [
          e.isLoading ? (n(), F(et, {
            key: 0,
            size: "xs",
            color: "blue-600",
            class: "shrink-0"
          })) : v("", !0),
          P.value ? (n(), c("button", {
            key: 1,
            type: "button",
            class: r(l(k)),
            "aria-label": "Clear input",
            "data-testid": `combobox-${e.id}-clear`,
            onClick: Te(ue, ["stop"])
          }, [
            L(l(rt), { class: "h-4 w-4" })
          ], 10, Gi)) : l(o).suffix ? T(K.$slots, "suffix", {}, void 0, !0, 2) : v("", !0)
        ], 2)) : v("", !0)
      ], 34),
      (n(), F(Wa, { to: "body" }, [
        z.value ? (n(), c("div", {
          key: 0,
          id: V.value,
          role: "listbox",
          "aria-label": e.label || e.ariaLabel || e.placeholder || "Suggestions",
          class: r(l(b)),
          style: Ee(ae.value),
          onPointerdown: ee[1] || (ee[1] = Te(() => {
          }, ["stop"]))
        }, [
          m("div", {
            class: r(l(g))
          }, [
            (n(!0), c(re, null, xe(G.value, (he, ge) => (n(), c("button", {
              id: Z(ge),
              key: String(he.value),
              type: "button",
              role: "option",
              "aria-selected": ge === R.value,
              "aria-disabled": he.disabled || void 0,
              tabindex: he.disabled ? -1 : void 0,
              class: r([
                l(h),
                he.disabled ? l(y) : l(p),
                ge === R.value && l(f)
              ]),
              "data-testid": `combobox-${e.id}-option-${he.value}`,
              onMousedown: ee[0] || (ee[0] = Te(() => {
              }, ["prevent"])),
              onClick: (N) => be(he)
            }, [
              he.avatar && !K.$slots.suggestion ? (n(), F(Ot, Oe({
                key: 0,
                ref_for: !0
              }, he.avatar, {
                size: "md",
                class: "mr-2 shrink-0"
              }), null, 16)) : v("", !0),
              m("span", {
                class: r(l(w))
              }, [
                T(K.$slots, "suggestion", { suggestion: he }, () => [
                  ie(C(he.label), 1)
                ], !0),
                he.description && !K.$slots.suggestion ? (n(), c("span", {
                  key: 0,
                  class: r(l(S))
                }, C(he.description), 3)) : v("", !0)
              ], 2)
            ], 42, Wi))), 128))
          ], 2)
        ], 46, _i)) : v("", !0)
      ]))
    ], 2));
  }
}), Ji = /* @__PURE__ */ Ye(Xi, [["__scopeId", "data-v-ac1dbd41"]]);
function Qi(e) {
  const a = {
    xs: "py-0.5",
    sm: "py-1",
    md: "py-2",
    lg: "py-3"
  }, t = i(() => e.autoResize ? "resize-none overflow-hidden" : e.isResizable ? "resize-y" : "resize-none");
  return { textareaClasses: i(() => {
    const o = [
      "block w-full border rounded-lg type-body-1 outline-none transition-colors focus:outline-none focus:ring-0 ring-0",
      a[e.size ?? "md"],
      t.value,
      // Read-only drops the horizontal padding so the value lines up flush left with its
      // label (which loses its own border-notch inset). The padding only holds the text
      // off the border, and read-only has no visible border.
      e.isReadOnly ? "px-0" : "px-2",
      { "cursor-not-allowed": e.isDisabled }
    ], d = [
      "border-border-border-200",
      // Read-only omits the focus blue rather than overriding it with a transparent variant.
      // Both are the same specificity on the same property, so pairing them leaves the winner
      // up to Tailwind's generated utility order instead of intent. Mirrors `useTextInputStyles`.
      e.isReadOnly ? "" : "focus:border-blue-600",
      {
        "border-red-600 focus:border-red-600": e.isInvalid,
        "border-transparent": e.isReadOnly,
        "opacity-70 select-none border-gray-300 cursor-not-allowed !bg-blue-50": e.isDisabled
      }
    ], u = [
      "bg-white",
      "text-black disabled:text-txt-200",
      // In read-only the placeholder is the em-dash stand-in for a missing value rather
      // than a prompt, so it gets a legible muted tone instead of the faint prompt grey.
      e.isReadOnly ? "placeholder:text-gray-400" : "placeholder:text-gray-300"
    ];
    return [...o, ...d, ...u];
  }) };
}
const ed = ["for"], td = ["id", "value", "rows", "placeholder", "disabled", "readonly", "required", "maxlength", "aria-invalid", "aria-describedby"], ad = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "TextArea",
  props: {
    id: {},
    modelValue: { default: "" },
    class: { type: [Boolean, null, String, Object, Array] },
    placeholder: {},
    label: {},
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: {},
    isDisabled: { type: Boolean, default: !1 },
    isReadOnly: { type: Boolean, default: !1 },
    isInvalid: { type: Boolean, default: !1 },
    isRequired: { type: Boolean, default: !1 },
    size: { default: "lg" },
    rows: { default: 4 },
    autoResize: { type: Boolean, default: !1 },
    isResizable: { type: Boolean, default: !1 },
    maxlength: {}
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(e, { emit: a }) {
    const t = e, s = a, { textareaClasses: o } = Qi(t), d = Bt(t, () => u.value), u = i(() => !!t.modelValue), b = A(!1), g = A(!1);
    Se(
      () => t.isInvalid,
      (V, Z) => {
        V && !Z && (g.value = !0);
      }
    );
    const h = (V) => {
      V.animationName.includes("shake") && (g.value = !1);
    }, p = i(() => `${t.label ?? ""}${t.isRequired ? " (Required)" : ""}`), f = i(() => t.isDisabled ? "text-txt-500" : t.isInvalid ? "text-red-600" : t.isReadOnly ? mt : b.value ? "text-blue-600" : u.value ? "text-gray-400" : "text-txt-700"), { isLabelHidden: y } = Et(
      t,
      () => b.value,
      () => u.value
    ), w = i(() => [
      "pointer-events-none absolute -top-2 z-10 rounded type-field-label transition duration-200",
      // Read-only has no border to notch, so the label drops the inset + backing colour and
      // sits flush left, aligned with the (also unpadded) value beneath it. `left-px`, not
      // `left-0`: the label is positioned against the outer wrapper while the border lives on
      // the textarea itself, insetting its text by exactly 1px. The border stays (transparent)
      // so toggling read-only doesn't resize the box, so the label matches it instead.
      t.isReadOnly ? gt : (
        // White background matches the field so the label cleanly notches the top border.
        "left-2 px-1 bg-white"
      ),
      y.value ? "opacity-0 translate-y-1" : "opacity-100 translate-y-0",
      f.value
    ]), S = A(null), k = i(() => t.autoResize || t.isReadOnly), x = i(() => t.isReadOnly ? 1 : t.rows), $ = () => {
      const V = S.value;
      !k.value || !V || (V.style.height = "auto", V.style.height = `${V.scrollHeight}px`);
    }, D = (V) => {
      const Z = V.target;
      s("update:modelValue", Z.value), Fe($);
    }, E = (V) => {
      b.value = !0, s("focus", V);
    }, R = (V) => {
      b.value = !1, s("blur", V);
    };
    return Se([() => t.modelValue, () => t.isReadOnly], () => {
      Fe($);
    }), Vt(() => {
      Fe($);
    }), (V, Z) => (n(), c("div", {
      class: r(l(q)("relative w-full", t.class))
    }, [
      e.label ? (n(), c("label", {
        key: 0,
        for: e.id,
        class: r(w.value)
      }, C(p.value), 11, ed)) : v("", !0),
      m("textarea", Oe({
        id: e.id,
        ref_key: "textareaRef",
        ref: S,
        value: e.modelValue,
        rows: x.value,
        placeholder: l(d),
        disabled: e.isDisabled,
        readonly: e.isReadOnly,
        required: e.isRequired,
        maxlength: e.maxlength,
        "aria-invalid": e.isInvalid || void 0,
        "aria-describedby": e.ariaDescribedby
      }, V.$attrs, {
        class: [l(o), { "ta-shake": g.value }],
        onInput: D,
        onFocus: E,
        onBlur: R,
        onAnimationend: h
      }), null, 16, td)
    ], 2));
  }
}), ld = /* @__PURE__ */ Ye(ad, [["__scopeId", "data-v-9537dcef"]]);
function Ra(e, a) {
  return e - a * Math.floor(e / a);
}
const Es = 1721426;
function xa(e, a, t, s) {
  a = al(e, a);
  let o = a - 1, d = -2;
  return t <= 2 ? d = 0 : La(a) && (d = -1), Es - 1 + 365 * o + Math.floor(o / 4) - Math.floor(o / 100) + Math.floor(o / 400) + Math.floor((367 * t - 362) / 12 + d + s);
}
function La(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function al(e, a) {
  return e === "BC" ? 1 - a : a;
}
function sd(e) {
  let a = "AD";
  return e <= 0 && (a = "BC", e = 1 - e), [
    a,
    e
  ];
}
const nd = {
  standard: [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ],
  leapyear: [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
};
class Kt {
  fromJulianDay(a) {
    let t = a, s = t - Es, o = Math.floor(s / 146097), d = Ra(s, 146097), u = Math.floor(d / 36524), b = Ra(d, 36524), g = Math.floor(b / 1461), h = Ra(b, 1461), p = Math.floor(h / 365), f = o * 400 + u * 100 + g * 4 + p + (u !== 4 && p !== 4 ? 1 : 0), [y, w] = sd(f), S = t - xa(y, w, 1, 1), k = 2;
    t < xa(y, w, 3, 1) ? k = 0 : La(w) && (k = 1);
    let x = Math.floor(((S + k) * 12 + 373) / 367), $ = t - xa(y, w, x, 1) + 1;
    return new _e(y, w, x, $);
  }
  toJulianDay(a) {
    return xa(a.era, a.year, a.month, a.day);
  }
  getDaysInMonth(a) {
    return nd[La(a.year) ? "leapyear" : "standard"][a.month - 1];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMonthsInYear(a) {
    return 12;
  }
  getDaysInYear(a) {
    return La(a.year) ? 366 : 365;
  }
  getMaximumMonthsInYear() {
    return 12;
  }
  getMaximumDaysInMonth() {
    return 31;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getYearsInEra(a) {
    return 9999;
  }
  getEras() {
    return [
      "BC",
      "AD"
    ];
  }
  isInverseEra(a) {
    return a.era === "BC";
  }
  balanceDate(a) {
    a.year <= 0 && (a.era = a.era === "BC" ? "AD" : "BC", a.year = 1 - a.year);
  }
  constructor() {
    this.identifier = "gregory";
  }
}
function od(e, a) {
  return e.isEqual?.(a) ?? a.isEqual?.(e) ?? e.identifier === a.identifier;
}
function rd(e) {
  return bt(Date.now(), e);
}
function $a(e) {
  return fd(rd(e));
}
function Ds(e, a) {
  return e.calendar.toJulianDay(e) - a.calendar.toJulianDay(a);
}
function id(e, a) {
  return Cl(e) - Cl(a);
}
function Cl(e) {
  return e.hour * 36e5 + e.minute * 6e4 + e.second * 1e3 + e.millisecond;
}
let Ia = null, dd = !1;
function At() {
  return Ia == null && (Ia = new Intl.DateTimeFormat().resolvedOptions().timeZone), Ia;
}
function Fs() {
  return dd;
}
function Yt(e) {
  e = nt(e, new Kt());
  let a = al(e.era, e.year);
  return Rs(a, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
}
function Rs(e, a, t, s, o, d, u) {
  let b = /* @__PURE__ */ new Date();
  return b.setUTCHours(s, o, d, u), b.setUTCFullYear(e, a - 1, t), b.getTime();
}
function Na(e, a) {
  if (a === "UTC") return 0;
  if (e > 0 && a === At() && !Fs()) return new Date(e).getTimezoneOffset() * -6e4;
  let { year: t, month: s, day: o, hour: d, minute: u, second: b } = Is(e, a);
  return Rs(t, s, o, d, u, b, 0) - Math.floor(e / 1e3) * 1e3;
}
const kl = /* @__PURE__ */ new Map();
function Is(e, a) {
  let t = kl.get(a);
  t || (t = new Intl.DateTimeFormat("en-US", {
    timeZone: a,
    hour12: !1,
    era: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), kl.set(a, t));
  let s = t.formatToParts(new Date(e)), o = {};
  for (let d of s) d.type !== "literal" && (o[d.type] = d.value);
  return {
    // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
    year: o.era === "BC" || o.era === "B" ? -o.year + 1 : +o.year,
    month: +o.month,
    day: +o.day,
    hour: o.hour === "24" ? 0 : +o.hour,
    minute: +o.minute,
    second: +o.second
  };
}
const $l = 864e5;
function cd(e, a, t, s) {
  return (t === s ? [
    t
  ] : [
    t,
    s
  ]).filter((d) => ud(e, a, d));
}
function ud(e, a, t) {
  let s = Is(t, a);
  return e.year === s.year && e.month === s.month && e.day === s.day && e.hour === s.hour && e.minute === s.minute && e.second === s.second;
}
function ft(e, a, t = "compatible") {
  let s = Xt(e);
  if (a === "UTC") return Yt(s);
  if (a === At() && t === "compatible" && !Fs()) {
    s = nt(s, new Kt());
    let g = /* @__PURE__ */ new Date(), h = al(s.era, s.year);
    return g.setFullYear(h, s.month - 1, s.day), g.setHours(s.hour, s.minute, s.second, s.millisecond), g.getTime();
  }
  let o = Yt(s), d = Na(o - $l, a), u = Na(o + $l, a), b = cd(s, a, o - d, o - u);
  if (b.length === 1) return b[0];
  if (b.length > 1) switch (t) {
    // 'compatible' means 'earlier' for "fall back" transitions
    case "compatible":
    case "earlier":
      return b[0];
    case "later":
      return b[b.length - 1];
    case "reject":
      throw new RangeError("Multiple possible absolute times found");
  }
  switch (t) {
    case "earlier":
      return Math.min(o - d, o - u);
    // 'compatible' means 'later' for "spring forward" transitions
    case "compatible":
    case "later":
      return Math.max(o - d, o - u);
    case "reject":
      throw new RangeError("No such absolute time found");
  }
}
function Ts(e, a, t = "compatible") {
  return new Date(ft(e, a, t));
}
function bt(e, a) {
  let t = Na(e, a), s = new Date(e + t), o = s.getUTCFullYear(), d = s.getUTCMonth() + 1, u = s.getUTCDate(), b = s.getUTCHours(), g = s.getUTCMinutes(), h = s.getUTCSeconds(), p = s.getUTCMilliseconds();
  return new da(o < 1 ? "BC" : "AD", o < 1 ? -o + 1 : o, d, u, a, t, b, g, h, p);
}
function fd(e) {
  return new _e(e.calendar, e.era, e.year, e.month, e.day);
}
function Xt(e, a) {
  let t = 0, s = 0, o = 0, d = 0;
  if ("timeZone" in e) ({ hour: t, minute: s, second: o, millisecond: d } = e);
  else if ("hour" in e && !a) return e;
  return a && ({ hour: t, minute: s, second: o, millisecond: d } = a), new Va(e.calendar, e.era, e.year, e.month, e.day, t, s, o, d);
}
function nt(e, a) {
  if (od(e.calendar, a)) return e;
  let t = a.fromJulianDay(e.calendar.toJulianDay(e)), s = e.copy();
  return s.calendar = a, s.era = t.era, s.year = t.year, s.month = t.month, s.day = t.day, zt(s), s;
}
function bd(e, a, t) {
  if (e instanceof da)
    return e.timeZone === a ? e : hd(e, a);
  let s = ft(e, a, t);
  return bt(s, a);
}
function pd(e) {
  let a = Yt(e) - e.offset;
  return new Date(a);
}
function hd(e, a) {
  let t = Yt(e) - e.offset;
  return nt(bt(t, a), e.calendar);
}
const sa = 36e5;
function Ea(e, a) {
  let t = e.copy(), s = "hour" in t ? yd(t, a) : 0;
  qa(t, a.years || 0), t.calendar.balanceYearMonth && t.calendar.balanceYearMonth(t, e), t.month += a.months || 0, Ua(t), As(t), t.day += (a.weeks || 0) * 7, t.day += a.days || 0, t.day += s, gd(t), t.calendar.balanceDate && t.calendar.balanceDate(t), t.year < 1 && (t.year = 1, t.month = 1, t.day = 1);
  let o = t.calendar.getYearsInEra(t);
  if (t.year > o) {
    let u = t.calendar.isInverseEra?.(t);
    t.year = o, t.month = u ? 1 : t.calendar.getMonthsInYear(t), t.day = u ? 1 : t.calendar.getDaysInMonth(t);
  }
  t.month < 1 && (t.month = 1, t.day = 1);
  let d = t.calendar.getMonthsInYear(t);
  return t.month > d && (t.month = d, t.day = t.calendar.getDaysInMonth(t)), t.day = Math.max(1, Math.min(t.calendar.getDaysInMonth(t), t.day)), t;
}
function qa(e, a) {
  e.calendar.isInverseEra?.(e) && (a = -a), e.year += a;
}
function Ua(e) {
  for (; e.month < 1; )
    qa(e, -1), e.month += e.calendar.getMonthsInYear(e);
  let a = 0;
  for (; e.month > (a = e.calendar.getMonthsInYear(e)); )
    e.month -= a, qa(e, 1);
}
function gd(e) {
  for (; e.day < 1; )
    e.month--, Ua(e), e.day += e.calendar.getDaysInMonth(e);
  for (; e.day > e.calendar.getDaysInMonth(e); )
    e.day -= e.calendar.getDaysInMonth(e), e.month++, Ua(e);
}
function As(e) {
  e.month = Math.max(1, Math.min(e.calendar.getMonthsInYear(e), e.month)), e.day = Math.max(1, Math.min(e.calendar.getDaysInMonth(e), e.day));
}
function zt(e) {
  e.calendar.constrainDate && e.calendar.constrainDate(e), e.year = Math.max(1, Math.min(e.calendar.getYearsInEra(e), e.year)), As(e);
}
function Os(e) {
  let a = {};
  for (let t in e) typeof e[t] == "number" && (a[t] = -e[t]);
  return a;
}
function zs(e, a) {
  return Ea(e, Os(a));
}
function ll(e, a) {
  let t = e.copy();
  return a.era != null && (t.era = a.era), a.year != null && (t.year = a.year), a.month != null && (t.month = a.month), a.day != null && (t.day = a.day), zt(t), t;
}
function Ma(e, a) {
  let t = e.copy();
  return a.hour != null && (t.hour = a.hour), a.minute != null && (t.minute = a.minute), a.second != null && (t.second = a.second), a.millisecond != null && (t.millisecond = a.millisecond), vd(t), t;
}
function md(e) {
  e.second += Math.floor(e.millisecond / 1e3), e.millisecond = wa(e.millisecond, 1e3), e.minute += Math.floor(e.second / 60), e.second = wa(e.second, 60), e.hour += Math.floor(e.minute / 60), e.minute = wa(e.minute, 60);
  let a = Math.floor(e.hour / 24);
  return e.hour = wa(e.hour, 24), a;
}
function vd(e) {
  e.millisecond = Math.max(0, Math.min(e.millisecond, 999)), e.second = Math.max(0, Math.min(e.second, 59)), e.minute = Math.max(0, Math.min(e.minute, 59)), e.hour = Math.max(0, Math.min(e.hour, 23));
}
function wa(e, a) {
  let t = e % a;
  return t < 0 && (t += a), t;
}
function yd(e, a) {
  return e.hour += a.hours || 0, e.minute += a.minutes || 0, e.second += a.seconds || 0, e.millisecond += a.milliseconds || 0, md(e);
}
function sl(e, a, t, s) {
  let o = e.copy();
  switch (a) {
    case "era": {
      let d = e.calendar.getEras(), u = d.indexOf(e.era);
      if (u < 0) throw new Error("Invalid era: " + e.era);
      u = pt(u, t, 0, d.length - 1, s?.round), o.era = d[u], zt(o);
      break;
    }
    case "year":
      o.calendar.isInverseEra?.(o) && (t = -t), o.year = pt(e.year, t, -1 / 0, 9999, s?.round), o.year === -1 / 0 && (o.year = 1), o.calendar.balanceYearMonth && o.calendar.balanceYearMonth(o, e);
      break;
    case "month":
      o.month = pt(e.month, t, 1, e.calendar.getMonthsInYear(e), s?.round);
      break;
    case "day":
      o.day = pt(e.day, t, 1, e.calendar.getDaysInMonth(e), s?.round);
      break;
    default:
      throw new Error("Unsupported field " + a);
  }
  return e.calendar.balanceDate && e.calendar.balanceDate(o), zt(o), o;
}
function Hs(e, a, t, s) {
  let o = e.copy();
  switch (a) {
    case "hour": {
      let d = e.hour, u = 0, b = 23;
      if (s?.hourCycle === 12) {
        let g = d >= 12;
        u = g ? 12 : 0, b = g ? 23 : 11;
      }
      o.hour = pt(d, t, u, b, s?.round);
      break;
    }
    case "minute":
      o.minute = pt(e.minute, t, 0, 59, s?.round);
      break;
    case "second":
      o.second = pt(e.second, t, 0, 59, s?.round);
      break;
    case "millisecond":
      o.millisecond = pt(e.millisecond, t, 0, 999, s?.round);
      break;
    default:
      throw new Error("Unsupported field " + a);
  }
  return o;
}
function pt(e, a, t, s, o = !1) {
  if (o) {
    e += Math.sign(a), e < t && (e = s);
    let d = Math.abs(a);
    a > 0 ? e = Math.ceil(e / d) * d : e = Math.floor(e / d) * d, e > s && (e = t);
  } else
    e += a, e < t ? e = s - (t - e - 1) : e > s && (e = t + (e - s - 1));
  return e;
}
function Zs(e, a) {
  let t;
  if (a.years != null && a.years !== 0 || a.months != null && a.months !== 0 || a.weeks != null && a.weeks !== 0 || a.days != null && a.days !== 0) {
    let o = Ea(Xt(e), {
      years: a.years,
      months: a.months,
      weeks: a.weeks,
      days: a.days
    });
    t = ft(o, e.timeZone);
  } else
    t = Yt(e) - e.offset;
  t += a.milliseconds || 0, t += (a.seconds || 0) * 1e3, t += (a.minutes || 0) * 6e4, t += (a.hours || 0) * 36e5;
  let s = bt(t, e.timeZone);
  return nt(s, e.calendar);
}
function xd(e, a) {
  return Zs(e, Os(a));
}
function wd(e, a, t, s) {
  switch (a) {
    case "hour": {
      let o = 0, d = 23;
      if (s?.hourCycle === 12) {
        let S = e.hour >= 12;
        o = S ? 12 : 0, d = S ? 23 : 11;
      }
      let u = Xt(e), b = nt(Ma(u, {
        hour: o
      }), new Kt()), g = [
        ft(b, e.timeZone, "earlier"),
        ft(b, e.timeZone, "later")
      ].filter((S) => bt(S, e.timeZone).day === b.day)[0], h = nt(Ma(u, {
        hour: d
      }), new Kt()), p = [
        ft(h, e.timeZone, "earlier"),
        ft(h, e.timeZone, "later")
      ].filter((S) => bt(S, e.timeZone).day === h.day).pop(), f = Yt(e) - e.offset, y = Math.floor(f / sa), w = f % sa;
      return f = pt(y, t, Math.floor(g / sa), Math.floor(p / sa), s?.round) * sa + w, nt(bt(f, e.timeZone), e.calendar);
    }
    case "minute":
    case "second":
    case "millisecond":
      return Hs(e, a, t, s);
    case "era":
    case "year":
    case "month":
    case "day": {
      let o = sl(Xt(e), a, t, s), d = ft(o, e.timeZone);
      return nt(bt(d, e.timeZone), e.calendar);
    }
    default:
      throw new Error("Unsupported field " + a);
  }
}
function Ld(e, a, t) {
  let s = Xt(e), o = Ma(ll(s, a), a);
  if (o.compare(s) === 0) return e;
  let d = ft(o, e.timeZone, t);
  return nt(bt(d, e.timeZone), e.calendar);
}
function Cd(e) {
  return `${String(e.hour).padStart(2, "0")}:${String(e.minute).padStart(2, "0")}:${String(e.second).padStart(2, "0")}${e.millisecond ? String(e.millisecond / 1e3).slice(1) : ""}`;
}
function Ps(e) {
  let a = nt(e, new Kt()), t;
  return a.era === "BC" ? t = a.year === 1 ? "0000" : "-" + String(Math.abs(1 - a.year)).padStart(6, "00") : t = String(a.year).padStart(4, "0"), `${t}-${String(a.month).padStart(2, "0")}-${String(a.day).padStart(2, "0")}`;
}
function js(e) {
  return `${Ps(e)}T${Cd(e)}`;
}
function kd(e) {
  let a = Math.sign(e) < 0 ? "-" : "+";
  e = Math.abs(e);
  let t = Math.floor(e / 36e5), s = Math.floor(e % 36e5 / 6e4), o = Math.floor(e % 36e5 % 6e4 / 1e3), d = `${a}${String(t).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  return o !== 0 && (d += `:${String(o).padStart(2, "0")}`), d;
}
function $d(e) {
  return `${js(e)}${kd(e.offset)}[${e.timeZone}]`;
}
function nl(e) {
  let a = typeof e[0] == "object" ? e.shift() : new Kt(), t;
  if (typeof e[0] == "string") t = e.shift();
  else {
    let u = a.getEras();
    t = u[u.length - 1];
  }
  let s = e.shift(), o = e.shift(), d = e.shift();
  return [
    a,
    t,
    s,
    o,
    d
  ];
}
class _e {
  // This prevents TypeScript from allowing other types with the same fields to match.
  // i.e. a ZonedDateTime should not be be passable to a parameter that expects CalendarDate.
  // If that behavior is desired, use the AnyCalendarDate interface instead.
  // @ts-ignore
  #e;
  constructor(...a) {
    let [t, s, o, d, u] = nl(a);
    this.calendar = t, this.era = s, this.year = o, this.month = d, this.day = u, zt(this);
  }
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new _e(this.calendar, this.era, this.year, this.month, this.day) : new _e(this.calendar, this.year, this.month, this.day);
  }
  /** Returns a new `CalendarDate` with the given duration added to it. */
  add(a) {
    return Ea(this, a);
  }
  /** Returns a new `CalendarDate` with the given duration subtracted from it. */
  subtract(a) {
    return zs(this, a);
  }
  /**
  * Returns a new `CalendarDate` with the given fields set to the provided values. Other fields
  * will be constrained accordingly.
  */
  set(a) {
    return ll(this, a);
  }
  /**
  * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(a, t, s) {
    return sl(this, a, t, s);
  }
  /**
  * Converts the date to a native JavaScript Date object, with the time set to midnight in the
  * given time zone.
  */
  toDate(a) {
    return Ts(this, a);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return Ps(this);
  }
  /**
  * Compares this date with another. A negative result indicates that this date is before the given
  * one, and a positive date indicates that it is after.
  */
  compare(a) {
    return Ds(this, a);
  }
}
class Va {
  // This prevents TypeScript from allowing other types with the same fields to match.
  // @ts-ignore
  #e;
  constructor(...a) {
    let [t, s, o, d, u] = nl(a);
    this.calendar = t, this.era = s, this.year = o, this.month = d, this.day = u, this.hour = a.shift() || 0, this.minute = a.shift() || 0, this.second = a.shift() || 0, this.millisecond = a.shift() || 0, zt(this);
  }
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Va(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new Va(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `CalendarDateTime` with the given duration added to it. */
  add(a) {
    return Ea(this, a);
  }
  /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */
  subtract(a) {
    return zs(this, a);
  }
  /**
  * Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields
  * will be constrained accordingly.
  */
  set(a) {
    return ll(Ma(this, a), a);
  }
  /**
  * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(a, t, s) {
    switch (a) {
      case "era":
      case "year":
      case "month":
      case "day":
        return sl(this, a, t, s);
      default:
        return Hs(this, a, t, s);
    }
  }
  /** Converts the date to a native JavaScript Date object in the given time zone. */
  toDate(a, t) {
    return Ts(this, a, t);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return js(this);
  }
  /**
  * Compares this date with another. A negative result indicates that this date is before the given
  * one, and a positive date indicates that it is after.
  */
  compare(a) {
    let t = Ds(this, a);
    return t === 0 ? id(this, Xt(a)) : t;
  }
}
class da {
  // This prevents TypeScript from allowing other types with the same fields to match.
  // @ts-ignore
  #e;
  constructor(...a) {
    let [t, s, o, d, u] = nl(a), b = a.shift(), g = a.shift();
    this.calendar = t, this.era = s, this.year = o, this.month = d, this.day = u, this.timeZone = b, this.offset = g, this.hour = a.shift() || 0, this.minute = a.shift() || 0, this.second = a.shift() || 0, this.millisecond = a.shift() || 0, zt(this);
  }
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new da(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond) : new da(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `ZonedDateTime` with the given duration added to it. */
  add(a) {
    return Zs(this, a);
  }
  /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */
  subtract(a) {
    return xd(this, a);
  }
  /**
  * Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields
  * will be constrained accordingly.
  */
  set(a, t) {
    return Ld(this, a, t);
  }
  /**
  * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(a, t, s) {
    return wd(this, a, t, s);
  }
  /** Converts the date to a native JavaScript Date object. */
  toDate() {
    return pd(this);
  }
  /**
  * Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone
  * identifier.
  */
  toString() {
    return $d(this);
  }
  /** Converts the date to an ISO 8601 formatted string in UTC. */
  toAbsoluteString() {
    return this.toDate().toISOString();
  }
  /**
  * Compares this date with another. A negative result indicates that this date is before the given
  * one, and a positive date indicates that it is after.
  */
  compare(a) {
    return this.toDate().getTime() - bd(a, this.timeZone).toDate().getTime();
  }
}
const Ml = "data-[selected]:data-[today]:text-white data-[disabled]:data-[today]:text-gray-300 data-[unavailable]:data-[today]:text-gray-300", Md = {
  xs: "py-0.5",
  sm: "py-1",
  md: "py-2",
  lg: "py-3"
};
function Vd(e, a) {
  const t = i(() => e.variant === "accent" && a()), s = i(() => e.isDisabled ? "border-gray-300" : e.isInvalid ? "border-red-600" : e.isReadOnly ? "border-transparent" : t.value ? "border-blue-600" : "border-border-border-200"), o = i(() => {
    const G = [
      "group flex w-full items-center gap-2 rounded-lg border type-body-1 outline-none transition-all duration-200 focus:outline-none focus:ring-0",
      Md[e.size ?? "md"],
      // Read-only drops the horizontal padding so the value lines up flush left with its
      // label (which loses its own border-notch inset). The padding only holds content off
      // the border, and read-only has no visible border.
      e.isReadOnly ? "px-0" : "px-2"
    ], z = t.value ? "bg-blue-50" : "bg-white", U = [
      s.value,
      // Read-only never lights up blue: reka's `disabled` keeps it unfocusable and unopenable,
      // so these would be dead classes — but they're withheld explicitly so the intent is
      // readable and a future focusable read-only variant can't accidentally flash a border.
      e.isReadOnly ? "" : "focus:border-blue-600 data-[state=open]:border-blue-600",
      {
        "focus:border-red-600 data-[state=open]:border-red-600": e.isInvalid && !e.isReadOnly,
        "cursor-not-allowed opacity-70 select-none !bg-blue-50": e.isDisabled,
        // Read-only gets a plain cursor rather than disabled's `not-allowed`: nothing is being
        // withheld, there is just nothing to click.
        "cursor-default": e.isReadOnly && !e.isDisabled,
        "cursor-pointer": !e.isDisabled && !e.isReadOnly
      }
    ];
    return [...G, z, ...U];
  }), d = i(() => e.isDisabled ? "text-txt-200" : t.value ? "text-blue-700" : "text-black"), u = i(() => ["flex-1 truncate text-left", d.value]), b = i(() => [
    "flex-1 truncate text-left",
    // In read-only this span holds the em-dash stand-in for a missing value rather than a
    // prompt, so it gets a legible muted tone instead of the faint prompt grey.
    e.isReadOnly ? "text-gray-400" : "text-gray-300"
  ]), g = i(() => [
    "h-4 w-4 shrink-0",
    t.value ? "text-blue-800" : "text-gray-400"
  ]), h = i(() => [
    "absolute cursor-pointer top-1/2 right-8 hover:text-blue-700 inline-flex -translate-y-1/2 items-center justify-center rounded p-0.5",
    t.value ? "text-blue-800 hover:bg-blue-100" : "text-gray-400 hover:bg-blue-50"
  ]), p = "z-50 w-64 rounded-lg border border-border-border-200 bg-white p-3 shadow-lg", f = "flex items-center justify-between pb-2", y = "inline-flex h-7 w-7 items-center justify-center rounded-md text-gray-500 outline-none hover:bg-gray-50 hover:text-black focus:ring-2 focus:ring-blue-600 disabled:pointer-events-none disabled:text-gray-300", w = "type-body-1-strong text-txt-700", S = "inline-flex items-center rounded-md px-1.5 py-0.5 type-body-1-strong text-txt-700 outline-none hover:bg-gray-50 hover:text-black focus:ring-2 focus:ring-blue-600", k = "grid w-full gap-1 pt-1", x = [
    "inline-flex h-9 w-full items-center justify-center rounded-md type-body-1 text-txt-700 outline-none hover:bg-gray-50 focus:ring-2 focus:ring-blue-600 data-[today]:font-semibold data-[today]:text-blue-700 data-[selected]:bg-blue-600 data-[selected]:font-medium data-[selected]:text-white data-[selected]:hover:bg-blue-600 data-[disabled]:pointer-events-none data-[disabled]:text-gray-300",
    Ml
  ].join(" "), $ = "mt-2 flex justify-start border-t border-border-border-200 pt-2", D = "rounded-md px-2 py-1 type-body-1-strong text-blue-600 outline-none hover:bg-blue-50 focus:ring-2 focus:ring-blue-600 disabled:pointer-events-none disabled:text-gray-300", E = "w-full border-collapse select-none", R = "pb-1 type-body-2 text-gray-400", V = "p-0 text-center", Z = [
    "relative inline-flex h-8 w-8 items-center justify-center rounded-md type-body-1 text-txt-700 outline-none hover:bg-gray-50 focus:ring-2 focus:ring-blue-600 data-[today]:font-semibold data-[today]:text-blue-700 data-[selected]:bg-blue-600 data-[selected]:font-medium data-[selected]:text-white data-[selected]:hover:bg-blue-600 data-[outside-view]:text-gray-300 data-[disabled]:pointer-events-none data-[disabled]:text-gray-300 data-[unavailable]:pointer-events-none data-[unavailable]:text-gray-300 data-[unavailable]:line-through",
    Ml
  ].join(" ");
  return {
    triggerClasses: o,
    valueClasses: u,
    placeholderClasses: b,
    calendarIconClasses: g,
    clearButtonClasses: h,
    contentClasses: p,
    headerClasses: f,
    navButtonClasses: y,
    headingClasses: w,
    headingButtonClasses: S,
    panelGridClasses: k,
    panelCellClasses: x,
    footerClasses: $,
    todayButtonClasses: D,
    gridClasses: E,
    headCellClasses: R,
    cellClasses: V,
    cellTriggerClasses: Z
  };
}
const oa = 12, Ta = (e) => e - e % oa, Aa = (e, a, t) => t.compare(e) >= 0 && t.compare(a) <= 0;
function Ns(e) {
  const a = At(), t = () => e.selection().start ?? $a(a), s = t(), o = Al(s), d = A("day"), u = A(Ta(s.year)), b = A(0), g = i(
    () => new Intl.DateTimeFormat(e.locale(), { month: "long", timeZone: a })
  ), h = i(
    () => new Intl.DateTimeFormat(e.locale(), { month: "short", timeZone: a })
  ), p = (P, ce) => P.format(ce.toDate(a)), f = i(
    () => new _e(o.value.year, o.value.month, 1)
  ), y = i(() => f.value.add({ months: b.value })), w = (P) => p(g.value, new _e(P.year, P.month, 1)), S = i(() => p(g.value, y.value)), k = i(() => String(y.value.year)), x = i(
    () => `${u.value} – ${u.value + oa - 1}`
  ), $ = (P, ce) => {
    const W = e.minValue(), H = e.maxValue();
    return !!(W && ce.compare(W) < 0 || H && P.compare(H) > 0);
  }, D = i(() => $a(a)), E = i(() => {
    const { start: P, end: ce } = e.selection(), W = P ?? ce, H = ce ?? P;
    return W && H ? { from: W, to: H } : void 0;
  }), R = (P, ce, W) => {
    const H = E.value;
    return {
      ...W,
      isDisabled: $(P, ce),
      isSelected: !!(H && H.from.compare(ce) <= 0 && H.to.compare(P) >= 0),
      isRangeStart: !!(H && Aa(P, ce, H.from)),
      isRangeEnd: !!(H && Aa(P, ce, H.to)),
      isToday: Aa(P, ce, D.value)
    };
  }, V = i(() => {
    const P = y.value.year;
    return Array.from({ length: 12 }, (ce, W) => {
      const H = W + 1, fe = new _e(P, H, 1), $e = fe.add({ months: 1 }).subtract({ days: 1 });
      return R(fe, $e, {
        year: P,
        month: H,
        label: p(h.value, fe)
      });
    });
  }), Z = i(
    () => Array.from({ length: oa }, (P, ce) => {
      const W = u.value + ce;
      return R(new _e(W, 1, 1), new _e(W, 12, 31), {
        year: W,
        label: String(W)
      });
    })
  ), G = i(() => {
    const P = e.minValue();
    return P ? d.value === "month" ? y.value.year - 1 < P.year : u.value - 1 < P.year : !1;
  }), z = i(() => {
    const P = e.maxValue();
    return P ? d.value === "month" ? y.value.year + 1 > P.year : u.value + oa > P.year : !1;
  });
  return {
    placeholder: o,
    view: d,
    monthLabel: S,
    yearLabel: k,
    yearPageLabel: x,
    monthLabelFor: w,
    months: V,
    years: Z,
    isPrevPageDisabled: G,
    isNextPageDisabled: z,
    setPlaceholder: (P) => {
      o.value = P;
    },
    showMonthView: (P = b.value) => {
      b.value = P, d.value = "month";
    },
    showYearView: (P = b.value) => {
      b.value = P, u.value = Ta(y.value.year), d.value = "year";
    },
    showDayView: () => {
      d.value = "day";
    },
    selectMonth: (P) => {
      o.value = new _e(P.year, P.month ?? 1, 1).subtract({
        months: b.value
      }), d.value = "day";
    },
    selectYear: (P) => {
      o.value = new _e(P.year, y.value.month, 1).subtract({
        months: b.value
      }), d.value = "month";
    },
    stepPage: (P) => {
      if (d.value === "month") {
        o.value = new _e(
          o.value.year + P,
          o.value.month,
          1
        );
        return;
      }
      u.value += P * oa;
    },
    resetToSelection: () => {
      const P = t();
      o.value = P, u.value = Ta(P.year), b.value = 0, d.value = "day";
    }
  };
}
const Sd = ["for"], Bd = ["id", "aria-label", "aria-describedby", "aria-invalid", "data-testid"], Ed = {
  key: 2,
  class: "sr-only"
}, Dd = {
  key: 3,
  class: "w-5 shrink-0",
  "aria-hidden": "true"
}, Fd = { class: "flex items-center gap-0.5" }, Rd = ["data-testid", "aria-label"], Id = ["data-testid", "aria-label"], Td = ["disabled", "aria-label"], Ad = ["data-testid", "aria-label"], Od = ["disabled", "aria-label"], zd = ["aria-label"], Hd = ["disabled", "data-disabled", "data-selected", "data-today", "data-testid", "onClick"], Zd = ["aria-label"], Pd = ["disabled", "data-disabled", "data-selected", "data-today", "data-testid", "onClick"], jd = ["disabled", "data-testid"], Nd = ["data-testid"], qd = /* @__PURE__ */ X({
  __name: "DatePicker",
  props: {
    id: {},
    modelValue: { default: void 0 },
    class: { type: [Boolean, null, String, Object, Array], default: void 0 },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: { default: void 0 },
    ariaLabel: { default: void 0 },
    name: { default: void 0 },
    isDisabled: { type: Boolean, default: !1 },
    isReadOnly: { type: Boolean, default: !1 },
    isClearable: { type: Boolean, default: !1 },
    showTodayButton: { type: Boolean, default: !1 },
    isInvalid: { type: Boolean, default: !1 },
    isRequired: { type: Boolean, default: !1 },
    variant: { default: "default" },
    size: { default: "lg" },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    locale: { default: void 0 },
    formatOptions: { default: void 0 },
    weekStartsOn: { default: 0 }
  },
  emits: ["update:modelValue", "change", "blur", "focus", "clear"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = A(null), d = A(!1), u = A(!1), b = A(!1);
    Se(
      () => t.isInvalid,
      (Ve, qe) => {
        Ve && !qe && (b.value = !0);
      }
    );
    const g = (Ve) => {
      Ve.animationName.includes("shake") && (b.value = !1);
    }, h = (Ve) => new _e(Ve.getFullYear(), Ve.getMonth() + 1, Ve.getDate()), p = (Ve) => Ve.toDate(At()), f = i(
      () => t.modelValue ? h(t.modelValue) : null
    ), y = i(() => t.minDate ? h(t.minDate) : void 0), w = i(() => t.maxDate ? h(t.maxDate) : void 0), S = i(() => !!t.modelValue), k = i(() => {
      const Ve = $a(At());
      return !!(y.value && Ve.compare(y.value) < 0 || w.value && Ve.compare(w.value) > 0);
    }), x = i(
      () => new Intl.DateTimeFormat(t.locale, t.formatOptions ?? { dateStyle: "medium" })
    ), $ = i(
      () => t.modelValue ? x.value.format(t.modelValue) : ""
    ), D = Bt(t, () => S.value), E = i(() => `${t.label ?? ""}${t.isRequired ? " (Required)" : ""}`), R = i(() => {
      if (!t.label) {
        if (t.ariaLabel) return `${t.ariaLabel}${t.isRequired ? " (Required)" : ""}`;
        if (!S.value && !(!t.isReadOnly && t.placeholder?.trim()))
          return `Select a date${t.isRequired ? " (Required)" : ""}`;
      }
    }), V = i(
      () => t.isClearable && S.value && !t.isDisabled && !t.isReadOnly
    ), {
      triggerClasses: Z,
      valueClasses: G,
      placeholderClasses: z,
      calendarIconClasses: U,
      clearButtonClasses: ae,
      contentClasses: B,
      headerClasses: le,
      navButtonClasses: O,
      headingClasses: j,
      headingButtonClasses: _,
      panelGridClasses: ne,
      panelCellClasses: P,
      footerClasses: ce,
      todayButtonClasses: W,
      gridClasses: H,
      headCellClasses: fe,
      cellClasses: $e,
      cellTriggerClasses: te
    } = Vd(t, () => S.value), {
      placeholder: we,
      view: I,
      monthLabel: Y,
      yearLabel: be,
      yearPageLabel: J,
      months: Q,
      years: ue,
      isPrevPageDisabled: K,
      isNextPageDisabled: ee,
      setPlaceholder: he,
      showMonthView: ge,
      showYearView: N,
      showDayView: Le,
      selectMonth: Me,
      selectYear: ye,
      stepPage: Re,
      resetToSelection: Zt
    } = Ns({
      locale: () => t.locale,
      // A single date is a one-day span, so both endpoints are the same date.
      selection: () => ({ start: f.value, end: f.value }),
      minValue: () => y.value,
      maxValue: () => w.value
    }), ze = A(null), at = A(null), Xe = (Ve) => {
      Fe(() => Ve()?.focus());
    }, lt = () => ze.value?.querySelector("[data-selected]:not([disabled])") ?? ze.value?.querySelector("button:not([disabled])"), Pe = () => {
      ge(), Xe(lt);
    }, vt = () => {
      N(), Xe(lt);
    }, Jt = (Ve) => {
      Me(Ve), Xe(() => at.value);
    }, yt = (Ve) => {
      ye(Ve), Xe(lt);
    }, it = (Ve) => {
      Ve && Zt(), d.value = Ve;
    }, Pt = (Ve) => {
      I.value !== "day" && (Ve.preventDefault(), Le(), Xe(() => at.value));
    }, jt = i(() => t.variant === "accent" && S.value), xt = i(() => t.isDisabled ? "text-txt-500" : t.isInvalid ? "text-red-600" : t.isReadOnly ? mt : u.value || d.value || jt.value ? "text-blue-600" : S.value ? "text-gray-400" : "text-txt-700"), Nt = i(() => jt.value ? "bg-blue-50" : "bg-white"), { isLabelHidden: Qt } = Et(
      t,
      () => u.value || d.value,
      () => S.value
    ), Dt = i(() => [
      "pointer-events-none absolute -top-2 z-10 rounded type-body-2 transition duration-200",
      // Read-only has no border to notch, so the label drops the inset + backing colour and sits
      // flush left. `left-px`, not `left-0`: the label is positioned against the outer wrapper
      // while the value sits inside the trigger, so the trigger's 1px (transparent) border insets
      // it by exactly that much.
      t.isReadOnly ? gt : ["left-2 px-1", Nt.value],
      Qt.value ? "opacity-0 translate-y-1" : "opacity-100 translate-y-0",
      xt.value
    ]), dt = (Ve) => {
      d.value = !1;
      const qe = Ve ? p(Ve) : null;
      s("update:modelValue", qe), s("change", qe);
    }, Ft = () => dt($a(At())), wt = () => {
      s("update:modelValue", null), s("change", null), s("clear"), Fe(() => document.getElementById(t.id)?.focus());
    }, Rt = (Ve) => {
      u.value = !0, s("focus", Ve);
    }, qt = (Ve) => {
      const qe = Ve.relatedTarget;
      d.value || qe && o.value?.contains(qe) || (u.value = !1, s("blur", Ve));
    };
    return (Ve, qe) => (n(), c("div", {
      ref_key: "rootRef",
      ref: o,
      class: r(l(q)("relative w-full", t.class)),
      onAnimationend: g
    }, [
      e.label ? (n(), c("label", {
        key: 0,
        for: e.id,
        class: r(Dt.value)
      }, C(E.value), 11, Sd)) : v("", !0),
      L(l(jn), {
        "model-value": f.value,
        open: d.value,
        name: e.name,
        required: e.isRequired,
        disabled: e.isDisabled || e.isReadOnly,
        "min-value": y.value,
        "max-value": w.value,
        locale: e.locale,
        "week-starts-on": e.weekStartsOn,
        placeholder: l(we),
        "onUpdate:modelValue": dt,
        "onUpdate:open": it,
        "onUpdate:placeholder": l(he)
      }, {
        default: M(() => [
          L(l(Nn), { "as-child": "" }, {
            default: M(() => [
              m("button", {
                id: e.id,
                type: "button",
                class: r([l(Z), { "ti-shake": b.value }]),
                "aria-label": R.value,
                "aria-describedby": e.ariaDescribedby,
                "aria-invalid": e.isInvalid || void 0,
                "data-testid": `datepicker-${e.id}`,
                onFocus: Rt,
                onBlur: qt
              }, [
                S.value ? (n(), c("span", {
                  key: 0,
                  class: r(l(G))
                }, C($.value), 3)) : (n(), c("span", {
                  key: 1,
                  class: r(l(z))
                }, C(l(D)), 3)),
                e.isRequired && !e.label && !e.ariaLabel ? (n(), c("span", Ed, " (Required)")) : v("", !0),
                V.value ? (n(), c("span", Dd)) : v("", !0),
                e.isReadOnly ? v("", !0) : (n(), F(l(ys), {
                  key: 4,
                  class: r(["ml-auto", l(U)])
                }, null, 8, ["class"]))
              ], 42, Bd)
            ]),
            _: 1
          }),
          L(l(qn), {
            class: r(l(B)),
            "aria-label": "Choose a date",
            "side-offset": 6,
            align: "start",
            onEscapeKeyDown: Pt
          }, {
            default: M(() => [
              L(l(Un), null, {
                default: M(({ weekDays: ea, grid: me }) => [
                  m("div", {
                    class: r(l(le))
                  }, [
                    l(I) === "day" ? (n(), c(re, { key: 0 }, [
                      L(l(Gn), {
                        class: r(l(O)),
                        "aria-label": "Previous month"
                      }, {
                        default: M(() => [
                          L(l(Wt), { class: "h-4 w-4" })
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      m("div", Fd, [
                        m("button", {
                          ref_key: "monthViewButtonRef",
                          ref: at,
                          type: "button",
                          class: r(l(_)),
                          "data-testid": `datepicker-${e.id}-month-view`,
                          "aria-label": `Change month, currently ${l(Y)}`,
                          onClick: Pe
                        }, C(l(Y)), 11, Rd),
                        m("button", {
                          type: "button",
                          class: r(l(_)),
                          "data-testid": `datepicker-${e.id}-year-view`,
                          "aria-label": `Change year, currently ${l(be)}`,
                          onClick: vt
                        }, C(l(be)), 11, Id)
                      ]),
                      L(l(_n), {
                        class: r(l(O)),
                        "aria-label": "Next month"
                      }, {
                        default: M(() => [
                          L(l(ot), { class: "h-4 w-4" })
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ], 64)) : (n(), c(re, { key: 1 }, [
                      m("button", {
                        type: "button",
                        class: r(l(O)),
                        disabled: l(K),
                        "aria-label": l(I) === "month" ? "Previous year" : "Previous years",
                        onClick: qe[0] || (qe[0] = (ve) => l(Re)(-1))
                      }, [
                        L(l(Wt), { class: "h-4 w-4" })
                      ], 10, Td),
                      l(I) === "month" ? (n(), c("button", {
                        key: 0,
                        type: "button",
                        class: r(l(_)),
                        "data-testid": `datepicker-${e.id}-year-view`,
                        "aria-label": `Change year, currently ${l(be)}`,
                        onClick: vt
                      }, C(l(be)), 11, Ad)) : (n(), c("span", {
                        key: 1,
                        class: r(l(j))
                      }, C(l(J)), 3)),
                      m("button", {
                        type: "button",
                        class: r(l(O)),
                        disabled: l(ee),
                        "aria-label": l(I) === "month" ? "Next year" : "Next years",
                        onClick: qe[1] || (qe[1] = (ve) => l(Re)(1))
                      }, [
                        L(l(ot), { class: "h-4 w-4" })
                      ], 10, Od)
                    ], 64))
                  ], 2),
                  l(I) === "month" ? (n(), c("div", {
                    key: 0,
                    ref_key: "panelRef",
                    ref: ze,
                    class: r([l(ne), "grid-cols-3"]),
                    role: "group",
                    "aria-label": `Select a month in ${l(be)}`
                  }, [
                    (n(!0), c(re, null, xe(l(Q), (ve) => (n(), c("button", {
                      key: ve.month,
                      type: "button",
                      class: r(l(P)),
                      disabled: ve.isDisabled,
                      "data-disabled": ve.isDisabled || void 0,
                      "data-selected": ve.isSelected || void 0,
                      "data-today": ve.isToday || void 0,
                      "data-testid": `datepicker-${e.id}-month-${ve.month}`,
                      onClick: (Ue) => Jt(ve)
                    }, C(ve.label), 11, Hd))), 128))
                  ], 10, zd)) : l(I) === "year" ? (n(), c("div", {
                    key: 1,
                    ref_key: "panelRef",
                    ref: ze,
                    class: r([l(ne), "grid-cols-4"]),
                    role: "group",
                    "aria-label": `Select a year between ${l(J)}`
                  }, [
                    (n(!0), c(re, null, xe(l(ue), (ve) => (n(), c("button", {
                      key: ve.year,
                      type: "button",
                      class: r(l(P)),
                      disabled: ve.isDisabled,
                      "data-disabled": ve.isDisabled || void 0,
                      "data-selected": ve.isSelected || void 0,
                      "data-today": ve.isToday || void 0,
                      "data-testid": `datepicker-${e.id}-year-${ve.year}`,
                      onClick: (Ue) => yt(ve)
                    }, C(ve.label), 11, Pd))), 128))
                  ], 10, Zd)) : (n(!0), c(re, { key: 2 }, xe(me, (ve) => (n(), F(l(Wn), {
                    key: ve.value.toString(),
                    class: r(l(H))
                  }, {
                    default: M(() => [
                      L(l(Kn), null, {
                        default: M(() => [
                          L(l(dl), null, {
                            default: M(() => [
                              (n(!0), c(re, null, xe(ea, (Ue) => (n(), F(l(Yn), {
                                key: Ue,
                                class: r(l(fe))
                              }, {
                                default: M(() => [
                                  ie(C(Ue), 1)
                                ]),
                                _: 2
                              }, 1032, ["class"]))), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      L(l(Xn), null, {
                        default: M(() => [
                          (n(!0), c(re, null, xe(ve.rows, (Ue, ct) => (n(), F(l(dl), {
                            key: `week-${ct}`
                          }, {
                            default: M(() => [
                              (n(!0), c(re, null, xe(Ue, (ke) => (n(), F(l(Jn), {
                                key: ke.toString(),
                                date: ke,
                                class: r(l($e))
                              }, {
                                default: M(() => [
                                  L(l(Qn), {
                                    day: ke,
                                    month: ve.value,
                                    class: r(l(te))
                                  }, null, 8, ["day", "month", "class"])
                                ]),
                                _: 2
                              }, 1032, ["date", "class"]))), 128))
                            ]),
                            _: 2
                          }, 1024))), 128))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["class"]))), 128))
                ]),
                _: 1
              }),
              e.showTodayButton ? (n(), c("div", {
                key: 0,
                class: r(l(ce))
              }, [
                m("button", {
                  type: "button",
                  class: r(l(W)),
                  disabled: k.value,
                  "data-testid": `datepicker-${e.id}-today`,
                  onClick: Ft
                }, " Today ", 10, jd)
              ], 2)) : v("", !0)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }, 8, ["model-value", "open", "name", "required", "disabled", "min-value", "max-value", "locale", "week-starts-on", "placeholder", "onUpdate:placeholder"]),
      V.value ? (n(), c("button", {
        key: 1,
        type: "button",
        "aria-label": "Clear date",
        "data-testid": `datepicker-${e.id}-clear`,
        class: r(l(ae)),
        onClick: Te(wt, ["stop"])
      }, [
        L(l(rt), { class: "h-4 w-4" })
      ], 10, Nd)) : v("", !0)
    ], 34));
  }
}), Ud = /* @__PURE__ */ Ye(qd, [["__scopeId", "data-v-6f306283"]]), Vl = "data-[selection-start]:data-[today]:text-white data-[selection-end]:data-[today]:text-white data-[disabled]:data-[today]:text-gray-300 data-[unavailable]:data-[today]:text-gray-300", Gd = {
  xs: "py-0.5",
  sm: "py-1",
  md: "py-2",
  lg: "py-3"
};
function _d(e, a) {
  const t = i(() => e.variant === "accent" && a()), s = i(() => e.isDisabled ? "border-gray-300" : e.isInvalid ? "border-red-600" : e.isReadOnly ? "border-transparent" : t.value ? "border-blue-600" : "border-border-border-200"), o = i(() => {
    const Z = [
      "group flex w-full items-center gap-2 rounded-lg border type-body-1 outline-none transition-all duration-200 focus:outline-none focus:ring-0",
      Gd[e.size ?? "md"],
      // Read-only drops the horizontal padding so the value lines up flush left with its
      // label (which loses its own border-notch inset). The padding only holds content off
      // the border, and read-only has no visible border.
      e.isReadOnly ? "px-0" : "px-2"
    ], G = t.value ? "bg-blue-50" : "bg-white", z = [
      s.value,
      // Read-only never lights up blue: reka's `disabled` keeps it unfocusable and unopenable,
      // so these would be dead classes — but they're withheld explicitly so the intent is
      // readable and a future focusable read-only variant can't accidentally flash a border.
      e.isReadOnly ? "" : "focus:border-blue-600 data-[state=open]:border-blue-600",
      {
        "focus:border-red-600 data-[state=open]:border-red-600": e.isInvalid && !e.isReadOnly,
        "cursor-not-allowed opacity-70 select-none !bg-blue-50": e.isDisabled,
        // Read-only gets a plain cursor rather than disabled's `not-allowed`: nothing is being
        // withheld, there is just nothing to click.
        "cursor-default": e.isReadOnly && !e.isDisabled,
        "cursor-pointer": !e.isDisabled && !e.isReadOnly
      }
    ];
    return [...Z, G, ...z];
  }), d = i(() => e.isDisabled ? "text-txt-200" : t.value ? "text-blue-700" : "text-black"), u = i(() => ["flex-1 truncate text-left", d.value]), b = i(() => [
    "flex-1 truncate text-left",
    // In read-only this span holds the em-dash stand-in for a missing value rather than a
    // prompt, so it gets a legible muted tone instead of the faint prompt grey.
    e.isReadOnly ? "text-gray-400" : "text-gray-300"
  ]), g = i(() => [
    "h-4 w-4 shrink-0",
    t.value ? "text-blue-800" : "text-gray-400"
  ]), h = i(() => [
    "absolute cursor-pointer top-1/2 right-8 hover:text-blue-700 inline-flex -translate-y-1/2 items-center justify-center rounded p-0.5",
    t.value ? "text-blue-800 hover:bg-blue-100" : "text-gray-400 hover:bg-blue-50"
  ]), p = "z-50 rounded-lg border border-border-border-200 bg-white p-3 shadow-lg", f = "flex items-center justify-between pb-2", y = "inline-flex h-7 w-7 items-center justify-center rounded-md text-gray-500 outline-none hover:bg-gray-50 hover:text-black focus:ring-2 focus:ring-blue-600 disabled:pointer-events-none disabled:text-gray-300", w = "type-body-1-strong text-txt-700", S = "inline-flex items-center rounded-md px-1.5 py-0.5 type-body-1-strong text-txt-700 outline-none hover:bg-gray-50 hover:text-black focus:ring-2 focus:ring-blue-600", k = "flex flex-col gap-4 sm:flex-row", x = "mx-auto grid w-56 gap-1 pt-1", $ = [
    "inline-flex h-9 w-full items-center justify-center rounded-md type-body-1 text-txt-700 outline-none hover:bg-gray-50 focus:ring-2 focus:ring-blue-600 data-[today]:font-semibold data-[today]:text-blue-700 data-[selected]:bg-blue-100 data-[selected]:text-blue-700 data-[selected]:rounded-none data-[selection-start]:rounded-md data-[selection-start]:bg-blue-600 data-[selection-start]:font-medium data-[selection-start]:text-white data-[selection-start]:hover:bg-blue-600 data-[selection-end]:rounded-md data-[selection-end]:bg-blue-600 data-[selection-end]:font-medium data-[selection-end]:text-white data-[selection-end]:hover:bg-blue-600 data-[disabled]:pointer-events-none data-[disabled]:text-gray-300",
    Vl
  ].join(" "), D = "w-full border-collapse select-none", E = "pb-1 type-body-2 text-gray-400", R = "p-0 text-center", V = [
    "relative inline-flex h-8 w-8 items-center justify-center rounded-md type-body-1 text-txt-700 outline-none hover:bg-gray-50 focus:ring-2 focus:ring-blue-600 data-[today]:font-semibold data-[today]:text-blue-700 data-[highlighted]:bg-blue-50 data-[selected]:bg-blue-100 data-[selected]:text-blue-700 data-[selected]:rounded-none data-[selection-start]:rounded-md data-[selection-start]:bg-blue-600 data-[selection-start]:font-medium data-[selection-start]:text-white data-[selection-start]:hover:bg-blue-600 data-[selection-end]:rounded-md data-[selection-end]:bg-blue-600 data-[selection-end]:font-medium data-[selection-end]:text-white data-[selection-end]:hover:bg-blue-600 data-[outside-view]:text-gray-300 data-[disabled]:pointer-events-none data-[disabled]:text-gray-300 data-[unavailable]:pointer-events-none data-[unavailable]:text-gray-300 data-[unavailable]:line-through",
    Vl
  ].join(" ");
  return {
    triggerClasses: o,
    valueClasses: u,
    placeholderClasses: b,
    calendarIconClasses: g,
    clearButtonClasses: h,
    contentClasses: p,
    headerClasses: f,
    navButtonClasses: y,
    headingClasses: w,
    headingButtonClasses: S,
    calendarsClasses: k,
    panelGridClasses: x,
    panelCellClasses: $,
    gridClasses: D,
    headCellClasses: E,
    cellClasses: R,
    cellTriggerClasses: V
  };
}
const Wd = ["for"], Kd = ["id", "aria-label", "aria-describedby", "aria-invalid", "data-testid"], Yd = {
  key: 2,
  class: "sr-only"
}, Xd = {
  key: 3,
  class: "w-5 shrink-0",
  "aria-hidden": "true"
}, Jd = ["disabled", "aria-label"], Qd = ["data-testid", "aria-label"], ec = ["disabled", "aria-label"], tc = ["aria-label"], ac = ["disabled", "data-disabled", "data-selected", "data-selection-start", "data-selection-end", "data-today", "data-testid", "onClick"], lc = ["aria-label"], sc = ["disabled", "data-disabled", "data-selected", "data-selection-start", "data-selection-end", "data-today", "data-testid", "onClick"], nc = {
  key: 1,
  class: "h-7 w-7",
  "aria-hidden": "true"
}, oc = { class: "flex items-center gap-0.5" }, rc = ["data-testid", "aria-label", "onClick"], ic = ["data-testid", "aria-label", "onClick"], dc = {
  key: 3,
  class: "h-7 w-7",
  "aria-hidden": "true"
}, cc = ["data-testid"], uc = /* @__PURE__ */ X({
  __name: "DateRangePicker",
  props: {
    id: {},
    modelValue: { default: void 0 },
    class: { type: [Boolean, null, String, Object, Array], default: void 0 },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: { default: void 0 },
    ariaLabel: { default: void 0 },
    name: { default: void 0 },
    isDisabled: { type: Boolean, default: !1 },
    isReadOnly: { type: Boolean, default: !1 },
    isClearable: { type: Boolean, default: !1 },
    isInvalid: { type: Boolean, default: !1 },
    isRequired: { type: Boolean, default: !1 },
    variant: { default: "default" },
    size: { default: "lg" },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    locale: { default: void 0 },
    formatOptions: { default: void 0 },
    weekStartsOn: { default: 0 },
    numberOfMonths: { default: 1 }
  },
  emits: ["update:modelValue", "change", "blur", "focus", "clear"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = A(null), d = A(!1), u = A(!1), b = A(!1);
    Se(
      () => t.isInvalid,
      (me, ve) => {
        me && !ve && (b.value = !0);
      }
    );
    const g = (me) => {
      me.animationName.includes("shake") && (b.value = !1);
    }, h = (me) => new _e(me.getFullYear(), me.getMonth() + 1, me.getDate()), p = (me) => me.toDate(At()), f = i(() => {
      const me = t.modelValue;
      return {
        start: me?.start ? h(me.start) : void 0,
        end: me?.end ? h(me.end) : void 0
      };
    }), y = i(() => ({
      start: t.modelValue?.start ? h(t.modelValue.start) : null,
      end: t.modelValue?.end ? h(t.modelValue.end) : null
    })), w = i(() => t.minDate ? h(t.minDate) : void 0), S = i(() => t.maxDate ? h(t.maxDate) : void 0), k = i(() => !!(t.modelValue?.start || t.modelValue?.end)), x = i(
      () => new Intl.DateTimeFormat(t.locale, t.formatOptions ?? { dateStyle: "medium" })
    ), $ = i(() => {
      const me = t.modelValue?.start, ve = t.modelValue?.end;
      return me && ve ? x.value.formatRange(me, ve) : me ? x.value.format(me) : ve ? x.value.format(ve) : "";
    }), D = Bt(t, () => k.value), E = i(() => `${t.label ?? ""}${t.isRequired ? " (Required)" : ""}`), R = i(() => {
      if (!t.label) {
        if (t.ariaLabel) return `${t.ariaLabel}${t.isRequired ? " (Required)" : ""}`;
        if (!k.value && !(!t.isReadOnly && t.placeholder?.trim()))
          return `Select a date range${t.isRequired ? " (Required)" : ""}`;
      }
    }), V = i(
      () => t.isClearable && k.value && !t.isDisabled && !t.isReadOnly
    ), {
      triggerClasses: Z,
      valueClasses: G,
      placeholderClasses: z,
      calendarIconClasses: U,
      clearButtonClasses: ae,
      contentClasses: B,
      headerClasses: le,
      navButtonClasses: O,
      headingClasses: j,
      headingButtonClasses: _,
      calendarsClasses: ne,
      panelGridClasses: P,
      panelCellClasses: ce,
      gridClasses: W,
      headCellClasses: H,
      cellClasses: fe,
      cellTriggerClasses: $e
    } = _d(t, () => k.value), {
      placeholder: te,
      view: we,
      yearLabel: I,
      yearPageLabel: Y,
      monthLabelFor: be,
      months: J,
      years: Q,
      isPrevPageDisabled: ue,
      isNextPageDisabled: K,
      setPlaceholder: ee,
      showMonthView: he,
      showYearView: ge,
      showDayView: N,
      selectMonth: Le,
      selectYear: Me,
      stepPage: ye,
      resetToSelection: Re
    } = Ns({
      locale: () => t.locale,
      selection: () => y.value,
      minValue: () => w.value,
      maxValue: () => S.value
    }), Zt = A(null), ze = A(), at = (me, ve) => {
      const Ue = Zt.value?.offsetWidth;
      Ue && (ze.value = `${Ue}px`), vt.value = me, ve(), yt(it);
    }, Xe = i(() => ze.value ? { width: ze.value } : void 0), lt = A(null), Pe = A([]), vt = A(0), Jt = (me, ve) => {
      Pe.value[me] = ve ?? null;
    }, yt = (me) => {
      Fe(() => me()?.focus());
    }, it = () => lt.value?.querySelector("[data-selected]:not([disabled])") ?? lt.value?.querySelector("button:not([disabled])"), Pt = () => Pe.value[vt.value] ?? Pe.value[0], jt = (me) => {
      Le(me), yt(Pt);
    }, xt = (me) => {
      Me(me), yt(it);
    }, Nt = (me) => {
      me && Re(), d.value = me;
    }, Qt = (me) => {
      we.value !== "day" && (me.preventDefault(), N(), yt(Pt));
    }, Dt = i(() => t.variant === "accent" && k.value), dt = i(() => t.isDisabled ? "text-txt-500" : t.isInvalid ? "text-red-600" : t.isReadOnly ? mt : u.value || d.value || Dt.value ? "text-blue-600" : k.value ? "text-gray-400" : "text-txt-700"), Ft = i(() => Dt.value ? "bg-blue-50" : "bg-white"), { isLabelHidden: wt } = Et(
      t,
      () => u.value || d.value,
      () => k.value
    ), Rt = i(() => [
      "pointer-events-none absolute -top-2 z-10 rounded type-field-label transition duration-200",
      // Read-only has no border to notch, so the label drops the inset + backing colour and sits
      // flush left. `left-px`, not `left-0`: the label is positioned against the outer wrapper
      // while the value sits inside the trigger, so the trigger's 1px (transparent) border insets
      // it by exactly that much.
      t.isReadOnly ? gt : ["left-2 px-1", Ft.value],
      wt.value ? "opacity-0 translate-y-1" : "opacity-100 translate-y-0",
      dt.value
    ]), qt = (me) => {
      const ve = me?.start ? p(me.start) : null, Ue = me?.end ? p(me.end) : null, ct = ve || Ue ? { start: ve, end: Ue } : null;
      s("update:modelValue", ct), s("change", ct);
    }, Ve = () => {
      s("update:modelValue", null), s("change", null), s("clear"), Fe(() => document.getElementById(t.id)?.focus());
    }, qe = (me) => {
      u.value = !0, s("focus", me);
    }, ea = (me) => {
      const ve = me.relatedTarget;
      d.value || ve && o.value?.contains(ve) || (u.value = !1, s("blur", me));
    };
    return (me, ve) => (n(), c("div", {
      ref_key: "rootRef",
      ref: o,
      class: r(l(q)("relative w-full", t.class)),
      onAnimationend: g
    }, [
      e.label ? (n(), c("label", {
        key: 0,
        for: e.id,
        class: r(Rt.value)
      }, C(E.value), 11, Wd)) : v("", !0),
      L(l(eo), {
        "model-value": f.value,
        name: e.name,
        required: e.isRequired,
        disabled: e.isDisabled || e.isReadOnly,
        "min-value": w.value,
        "max-value": S.value,
        locale: e.locale,
        "week-starts-on": e.weekStartsOn,
        "number-of-months": e.numberOfMonths,
        placeholder: l(te),
        "close-on-select": "",
        "onUpdate:modelValue": qt,
        "onUpdate:open": Nt,
        "onUpdate:placeholder": l(ee)
      }, {
        default: M(() => [
          L(l(to), { "as-child": "" }, {
            default: M(() => [
              m("button", {
                id: e.id,
                type: "button",
                class: r([l(Z), { "ti-shake": b.value }]),
                "aria-label": R.value,
                "aria-describedby": e.ariaDescribedby,
                "aria-invalid": e.isInvalid || void 0,
                "data-testid": `daterangepicker-${e.id}`,
                onFocus: qe,
                onBlur: ea
              }, [
                k.value ? (n(), c("span", {
                  key: 0,
                  class: r(l(G))
                }, C($.value), 3)) : (n(), c("span", {
                  key: 1,
                  class: r(l(z))
                }, C(l(D)), 3)),
                e.isRequired && !e.label && !e.ariaLabel ? (n(), c("span", Yd, " (Required)")) : v("", !0),
                V.value ? (n(), c("span", Xd)) : v("", !0),
                e.isReadOnly ? v("", !0) : (n(), F(l(ys), {
                  key: 4,
                  class: r(["ml-auto", l(U)])
                }, null, 8, ["class"]))
              ], 42, Kd)
            ]),
            _: 1
          }),
          L(l(ao), {
            class: r(l(B)),
            "aria-label": "Choose a date range",
            "side-offset": 6,
            align: "start",
            onEscapeKeyDown: Qt
          }, {
            default: M(() => [
              L(l(lo), null, {
                default: M(({ weekDays: Ue, grid: ct }) => [
                  l(we) !== "day" ? (n(), c("div", {
                    key: 0,
                    class: r(l(le))
                  }, [
                    m("button", {
                      type: "button",
                      class: r(l(O)),
                      disabled: l(ue),
                      "aria-label": l(we) === "month" ? "Previous year" : "Previous years",
                      onClick: ve[0] || (ve[0] = (ke) => l(ye)(-1))
                    }, [
                      L(l(Wt), { class: "h-4 w-4" })
                    ], 10, Jd),
                    l(we) === "month" ? (n(), c("button", {
                      key: 0,
                      type: "button",
                      class: r(l(_)),
                      "data-testid": `daterangepicker-${e.id}-year-view`,
                      "aria-label": `Change year, currently ${l(I)}`,
                      onClick: ve[1] || (ve[1] = (ke) => at(vt.value, () => l(ge)()))
                    }, C(l(I)), 11, Qd)) : (n(), c("span", {
                      key: 1,
                      class: r(l(j))
                    }, C(l(Y)), 3)),
                    m("button", {
                      type: "button",
                      class: r(l(O)),
                      disabled: l(K),
                      "aria-label": l(we) === "month" ? "Next year" : "Next years",
                      onClick: ve[2] || (ve[2] = (ke) => l(ye)(1))
                    }, [
                      L(l(ot), { class: "h-4 w-4" })
                    ], 10, ec)
                  ], 2)) : v("", !0),
                  l(we) === "month" ? (n(), c("div", {
                    key: 1,
                    style: Ee(Xe.value)
                  }, [
                    m("div", {
                      ref_key: "panelRef",
                      ref: lt,
                      class: r([l(P), "grid-cols-3"]),
                      role: "group",
                      "aria-label": `Select a month in ${l(I)}`
                    }, [
                      (n(!0), c(re, null, xe(l(J), (ke) => (n(), c("button", {
                        key: ke.month,
                        type: "button",
                        class: r(l(ce)),
                        disabled: ke.isDisabled,
                        "data-disabled": ke.isDisabled || void 0,
                        "data-selected": ke.isSelected || void 0,
                        "data-selection-start": ke.isRangeStart || void 0,
                        "data-selection-end": ke.isRangeEnd || void 0,
                        "data-today": ke.isToday || void 0,
                        "data-testid": `daterangepicker-${e.id}-month-${ke.month}`,
                        onClick: (Ke) => jt(ke)
                      }, C(ke.label), 11, ac))), 128))
                    ], 10, tc)
                  ], 4)) : l(we) === "year" ? (n(), c("div", {
                    key: 2,
                    style: Ee(Xe.value)
                  }, [
                    m("div", {
                      ref_key: "panelRef",
                      ref: lt,
                      class: r([l(P), "grid-cols-4"]),
                      role: "group",
                      "aria-label": `Select a year between ${l(Y)}`
                    }, [
                      (n(!0), c(re, null, xe(l(Q), (ke) => (n(), c("button", {
                        key: ke.year,
                        type: "button",
                        class: r(l(ce)),
                        disabled: ke.isDisabled,
                        "data-disabled": ke.isDisabled || void 0,
                        "data-selected": ke.isSelected || void 0,
                        "data-selection-start": ke.isRangeStart || void 0,
                        "data-selection-end": ke.isRangeEnd || void 0,
                        "data-today": ke.isToday || void 0,
                        "data-testid": `daterangepicker-${e.id}-year-${ke.year}`,
                        onClick: (Ke) => xt(ke)
                      }, C(ke.label), 11, sc))), 128))
                    ], 10, lc)
                  ], 4)) : (n(), c("div", {
                    key: 3,
                    ref_key: "calendarsRef",
                    ref: Zt,
                    class: r(l(ne))
                  }, [
                    (n(!0), c(re, null, xe(ct, (ke, Ke) => (n(), c("div", {
                      key: ke.value.toString()
                    }, [
                      m("div", {
                        class: r(l(le))
                      }, [
                        Ke === 0 ? (n(), F(l(so), {
                          key: 0,
                          class: r(l(O)),
                          "aria-label": "Previous month"
                        }, {
                          default: M(() => [
                            L(l(Wt), { class: "h-4 w-4" })
                          ]),
                          _: 1
                        }, 8, ["class"])) : (n(), c("span", nc)),
                        m("div", oc, [
                          m("button", {
                            ref_for: !0,
                            ref: (Je) => Jt(Ke, Je),
                            type: "button",
                            class: r(l(_)),
                            "data-testid": `daterangepicker-${e.id}-month-view-${Ke}`,
                            "aria-label": `Change month, currently ${l(be)(ke.value)}`,
                            onClick: (Je) => at(Ke, () => l(he)(Ke))
                          }, C(l(be)(ke.value)), 11, rc),
                          m("button", {
                            type: "button",
                            class: r(l(_)),
                            "data-testid": `daterangepicker-${e.id}-year-view-${Ke}`,
                            "aria-label": `Change year, currently ${ke.value.year}`,
                            onClick: (Je) => at(Ke, () => l(ge)(Ke))
                          }, C(ke.value.year), 11, ic)
                        ]),
                        Ke === ct.length - 1 ? (n(), F(l(no), {
                          key: 2,
                          class: r(l(O)),
                          "aria-label": "Next month"
                        }, {
                          default: M(() => [
                            L(l(ot), { class: "h-4 w-4" })
                          ]),
                          _: 1
                        }, 8, ["class"])) : (n(), c("span", dc))
                      ], 2),
                      L(l(oo), {
                        class: r(l(W))
                      }, {
                        default: M(() => [
                          L(l(ro), null, {
                            default: M(() => [
                              L(l(cl), null, {
                                default: M(() => [
                                  (n(!0), c(re, null, xe(Ue, (Je) => (n(), F(l(io), {
                                    key: Je,
                                    class: r(l(H))
                                  }, {
                                    default: M(() => [
                                      ie(C(Je), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]))), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          L(l(co), null, {
                            default: M(() => [
                              (n(!0), c(re, null, xe(ke.rows, (Je, ta) => (n(), F(l(cl), {
                                key: `week-${ta}`
                              }, {
                                default: M(() => [
                                  (n(!0), c(re, null, xe(Je, (aa) => (n(), F(l(uo), {
                                    key: aa.toString(),
                                    date: aa,
                                    class: r(l(fe))
                                  }, {
                                    default: M(() => [
                                      L(l(fo), {
                                        day: aa,
                                        month: ke.value,
                                        class: r(l($e))
                                      }, null, 8, ["day", "month", "class"])
                                    ]),
                                    _: 2
                                  }, 1032, ["date", "class"]))), 128))
                                ]),
                                _: 2
                              }, 1024))), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    ]))), 128))
                  ], 2))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }, 8, ["model-value", "name", "required", "disabled", "min-value", "max-value", "locale", "week-starts-on", "number-of-months", "placeholder", "onUpdate:placeholder"]),
      V.value ? (n(), c("button", {
        key: 1,
        type: "button",
        "aria-label": "Clear date range",
        "data-testid": `daterangepicker-${e.id}-clear`,
        class: r(l(ae)),
        onClick: Te(Ve, ["stop"])
      }, [
        L(l(rt), { class: "h-4 w-4" })
      ], 10, cc)) : v("", !0)
    ], 34));
  }
}), fc = /* @__PURE__ */ Ye(uc, [["__scopeId", "data-v-5587e85e"]]), bc = /* @__PURE__ */ X({
  __name: "NumberInput",
  props: {
    id: {},
    modelValue: { default: null },
    label: {},
    floatLabel: { type: Boolean, default: !0 },
    placeholder: {},
    class: { type: [Boolean, null, String, Object, Array] },
    ariaDescribedby: {},
    ariaLabel: {},
    variant: { default: "outlined" },
    size: { default: "lg" },
    isDisabled: { type: Boolean, default: !1 },
    isReadOnly: { type: Boolean, default: !1 },
    isInvalid: { type: Boolean, default: !1 },
    isRequired: { type: Boolean, default: !1 },
    isClearable: { type: Boolean, default: !1 },
    mode: { default: "decimal" },
    locale: { default: "en-ZA" },
    currency: {},
    min: {},
    max: {},
    minFractionDigits: {},
    maxFractionDigits: {},
    useGrouping: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "blur", "focus", "clear"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = A(null), d = () => o.value?.querySelector("input") ?? null, u = A(""), b = A(t.modelValue ?? null), g = A(!1), h = /(^|[-_])za($|[-_])/i, p = () => h.test(t.locale), f = i(() => {
      if (p()) return " ";
      try {
        return new Intl.NumberFormat(t.locale).formatToParts(11111).find((le) => le.type === "group")?.value ?? ",";
      } catch {
        return ",";
      }
    }), y = (B) => {
      if (B == null || Number.isNaN(B)) return "";
      const le = t.minFractionDigits !== void 0, O = t.maxFractionDigits !== void 0;
      let j = t.minFractionDigits ?? 2, _ = t.maxFractionDigits ?? j;
      j = Math.max(0, Math.min(20, j)), _ = Math.max(j, Math.min(20, _)), !le && !O && B % 1 === 0 && (j = 0);
      const ne = {
        minimumFractionDigits: j,
        maximumFractionDigits: _,
        useGrouping: t.useGrouping
      };
      t.mode === "currency" && t.currency && (ne.style = "currency", ne.currency = t.currency);
      try {
        const P = p(), ce = P ? "en-US" : t.locale, W = new Intl.NumberFormat(ce, ne).format(B);
        return P ? W.replaceAll(",", " ") : W;
      } catch (P) {
        return console.error("NumberInput formatNumber error", P, { val: B, options: ne }), String(B);
      }
    }, w = (B) => t.min !== void 0 && B < t.min ? t.min : t.max !== void 0 && B > t.max ? t.max : B, S = (B) => {
      const le = B.replaceAll(/[^\d.,-]/g, "");
      let O = le.replaceAll("-", "");
      le.startsWith("-") && (O = "-" + O);
      const j = f.value;
      (j === "." || j === ",") && (O = O.replaceAll(j, ""));
      const _ = O.lastIndexOf("."), P = O.lastIndexOf(",") > _ ? (
        // Comma is the decimal separator -> drop dot thousands, comma -> dot.
        O.replaceAll(".", "").replace(",", ".")
      ) : (
        // Dot is the decimal separator -> drop comma thousands.
        O.replaceAll(",", "")
      ), ce = Number.parseFloat(P);
      return Number.isNaN(ce) ? null : w(ce);
    }, k = (B, le, O) => {
      if (O <= 0) {
        const ne = le.startsWith("-") ? 1 : 0;
        B.setSelectionRange(ne, ne);
        return;
      }
      let j = 0, _ = le.length;
      for (const [ne, P] of [...le].entries())
        if (/\d/.test(P) && (j++, j === O)) {
          _ = ne + 1;
          break;
        }
      B.setSelectionRange(_, _);
    }, x = (B, le) => {
      let O = 0;
      for (let j = 0; j < le && j < B.length; j++)
        /\d/.test(B[j] ?? "") && O++;
      return O;
    }, $ = A(!1), D = A(!1), E = (B) => {
      $.value = B.key === "." || B.key === ",", D.value = B.key === "Backspace" || B.key === "Delete";
    }, R = /^[\d.,-]+$/, V = (B) => {
      if (B.inputType === "insertText" && B.data != null) {
        if (!R.test(B.data)) {
          B.preventDefault();
          return;
        }
        (B.data === "." || B.data === ",") && ($.value = !0);
      } else B.inputType.startsWith("delete") && (D.value = !0);
    }, Z = (B) => {
      B !== b.value && (b.value = B, s("update:modelValue", B));
    }, G = (B) => {
      const le = d(), O = B, j = le?.selectionStart ?? O.length, _ = $.value, ne = D.value;
      $.value = !1, D.value = !1;
      const P = S(O), ce = x(O, j);
      if (ne && /^[.,]00$/.test(O)) {
        u.value = "", Z(null);
        return;
      }
      if (["", "-", ".", ",", "-.", "-,"].includes(O)) {
        u.value = O, Z(P);
        return;
      }
      if (_) {
        const H = P === null ? "" : y(P), fe = H.includes(".") ? H : H + ".";
        u.value = fe, Fe(() => {
          const $e = d();
          if (!$e) return;
          const te = fe.indexOf(".") + 1;
          $e.setSelectionRange(te, te);
        }), Z(P);
        return;
      }
      const W = P === null ? "" : y(P);
      u.value = W, Fe(() => {
        const H = d();
        H && k(H, W, ce);
      }), Z(P);
    }, z = (B) => {
      g.value = !0, b.value === 0 && Fe(() => d()?.select()), s("focus", B);
    }, U = (B) => {
      g.value = !1;
      const le = S(u.value);
      u.value = le === null ? "" : y(le), Z(le), s("blur", B);
    }, ae = () => {
      u.value = "", Z(null), Fe(() => d()?.focus()), s("clear");
    };
    return Se(
      () => t.modelValue,
      (B) => {
        B !== b.value && (b.value = B, g.value || (u.value = y(B)));
      }
    ), Se(
      [
        () => t.locale,
        () => t.currency,
        () => t.mode,
        () => t.useGrouping,
        () => t.minFractionDigits,
        () => t.maxFractionDigits
      ],
      () => {
        g.value || (u.value = y(b.value));
      }
    ), Vt(() => {
      u.value = y(t.modelValue);
    }), (B, le) => (n(), c("div", {
      ref_key: "rootRef",
      ref: o,
      class: r(l(q)("w-full", t.class))
    }, [
      L(Ba, {
        id: e.id,
        "model-value": u.value,
        "input-mode": "decimal",
        label: e.label,
        "float-label": e.floatLabel,
        placeholder: e.placeholder,
        "aria-describedby": e.ariaDescribedby,
        "aria-label": e.ariaLabel,
        variant: e.variant,
        size: e.size,
        "is-disabled": e.isDisabled,
        "is-read-only": e.isReadOnly,
        "is-invalid": e.isInvalid,
        "is-required": e.isRequired,
        "is-clearable": e.isClearable,
        onKeydown: E,
        onBeforeinput: V,
        "onUpdate:modelValue": G,
        onFocus: z,
        onBlur: U,
        onClear: ae
      }, tt({ _: 2 }, [
        B.$slots.prefix ? {
          name: "prefix",
          fn: M(() => [
            T(B.$slots, "prefix")
          ]),
          key: "0"
        } : void 0,
        B.$slots.suffix ? {
          name: "suffix",
          fn: M(() => [
            T(B.$slots, "suffix")
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["id", "model-value", "label", "float-label", "placeholder", "aria-describedby", "aria-label", "variant", "size", "is-disabled", "is-read-only", "is-invalid", "is-required", "is-clearable"])
    ], 2));
  }
}), Sl = {
  xs: "py-0.5",
  sm: "py-1",
  md: "py-2",
  lg: "py-3"
};
function pc(e, a) {
  const t = i(() => {
    let $ = "border-border-border-200";
    return e.isDisabled ? $ = "border-gray-300" : e.isInvalid ? $ = "border-red-600" : e.isReadOnly ? $ = "border-transparent" : a() && ($ = "border-blue-600"), [
      "group flex w-full items-stretch overflow-hidden rounded-lg border bg-white transition-all duration-200",
      $,
      {
        "cursor-not-allowed opacity-70 select-none !bg-blue-50": e.isDisabled
      }
    ];
  }), s = i(() => e.isDisabled ? "cursor-not-allowed" : e.isReadOnly ? "cursor-default" : "cursor-pointer"), o = i(() => [
    "group flex shrink-0 items-center gap-1 border-0 bg-transparent pr-2 type-body-1 text-black outline-none transition-colors focus:outline-none",
    Sl[e.size ?? "md"],
    // Read-only is the leftmost content (chevron + divider are hidden), so it loses its
    // left inset to sit flush with the label above it. `pr-2` stays as the gap before
    // the number, standing in for the hidden divider.
    e.isReadOnly ? "pl-0" : "pl-2",
    s.value
  ]), d = "my-1.5 w-px shrink-0 self-stretch bg-border-border-200", u = "h-4 w-4 shrink-0 text-gray-400 transition-transform duration-200 group-data-[state=open]:rotate-180", b = i(() => [
    "min-w-0 flex-1 border-0 bg-transparent type-body-1 outline-none focus:ring-0 disabled:cursor-not-allowed",
    // In read-only the placeholder is the em-dash stand-in for a missing value rather than a
    // prompt, so it gets a legible muted tone instead of the faint prompt grey.
    e.isReadOnly ? "placeholder:text-gray-400" : "placeholder:text-gray-300",
    Sl[e.size ?? "md"],
    // Read-only drops the padding so the value reads as plain text; with `noCountryCode`
    // it's the leftmost content and lines up flush with the label.
    e.isReadOnly ? "px-0" : "px-2",
    e.isDisabled ? "text-txt-200" : "text-black"
  ]);
  return {
    containerClasses: t,
    countryTriggerClasses: o,
    dividerClasses: d,
    chevronClasses: u,
    inputClasses: b,
    contentClasses: "z-50 w-72 max-w-[calc(100vw-2rem)] overflow-hidden rounded-lg border border-border-border-200 bg-white shadow-lg",
    searchRowClasses: "border-b border-border-border-200 p-1",
    searchInputClasses: "w-full rounded-md border-0 bg-transparent px-2 py-1.5 type-body-1 text-black outline-none focus:ring-0 placeholder:text-gray-300",
    viewportClasses: "max-h-72 overflow-y-auto p-1",
    itemClasses: "relative flex w-full cursor-pointer items-center gap-2 rounded-md py-2 pr-8 pl-2 type-body-1 text-txt-700 outline-none select-none data-[highlighted]:bg-gray-50 data-[highlighted]:text-black data-[state=checked]:font-medium data-[disabled]:pointer-events-none data-[disabled]:text-gray-300",
    itemNameClasses: "min-w-0 flex-1 truncate",
    itemDialClasses: "shrink-0 type-body-2 text-gray-500",
    indicatorClasses: "absolute top-1/2 right-2 inline-flex -translate-y-1/2 items-center",
    emptyClasses: "px-2 py-3 text-center type-body-1 text-gray-400"
  };
}
const hc = [
  { code: "AF", dialingCode: "93", name: "Afghanistan" },
  { code: "AL", dialingCode: "355", name: "Albania" },
  { code: "DZ", dialingCode: "213", name: "Algeria" },
  { code: "AS", dialingCode: "1684", name: "American Samoa" },
  { code: "AD", dialingCode: "376", name: "Andorra" },
  { code: "AO", dialingCode: "244", name: "Angola" },
  { code: "AI", dialingCode: "1264", name: "Anguilla" },
  { code: "AQ", dialingCode: "672", name: "Antarctica" },
  { code: "AG", dialingCode: "1268", name: "Antigua and Barbuda" },
  { code: "AR", dialingCode: "54", name: "Argentina" },
  { code: "AM", dialingCode: "374", name: "Armenia" },
  { code: "AW", dialingCode: "297", name: "Aruba" },
  { code: "AU", dialingCode: "61", name: "Australia" },
  { code: "AT", dialingCode: "43", name: "Austria" },
  { code: "AZ", dialingCode: "994", name: "Azerbaijan" },
  { code: "BS", dialingCode: "1242", name: "Bahamas" },
  { code: "BH", dialingCode: "973", name: "Bahrain" },
  { code: "BD", dialingCode: "880", name: "Bangladesh" },
  { code: "BB", dialingCode: "1246", name: "Barbados" },
  { code: "BY", dialingCode: "375", name: "Belarus" },
  { code: "BE", dialingCode: "32", name: "Belgium" },
  { code: "BZ", dialingCode: "501", name: "Belize" },
  { code: "BJ", dialingCode: "229", name: "Benin" },
  { code: "BM", dialingCode: "1441", name: "Bermuda" },
  { code: "BT", dialingCode: "975", name: "Bhutan" },
  { code: "BO", dialingCode: "591", name: "Bolivia" },
  { code: "BA", dialingCode: "387", name: "Bosnia and Herzegovina" },
  { code: "BW", dialingCode: "267", name: "Botswana" },
  { code: "BR", dialingCode: "55", name: "Brazil" },
  { code: "IO", dialingCode: "246", name: "British Indian Ocean Territory" },
  { code: "VG", dialingCode: "1284", name: "British Virgin Islands" },
  { code: "BN", dialingCode: "673", name: "Brunei" },
  { code: "BG", dialingCode: "359", name: "Bulgaria" },
  { code: "BF", dialingCode: "226", name: "Burkina Faso" },
  { code: "BI", dialingCode: "257", name: "Burundi" },
  { code: "KH", dialingCode: "855", name: "Cambodia" },
  { code: "CM", dialingCode: "237", name: "Cameroon" },
  { code: "CA", dialingCode: "1", name: "Canada" },
  { code: "CV", dialingCode: "238", name: "Cape Verde" },
  { code: "KY", dialingCode: "1345", name: "Cayman Islands" },
  { code: "CF", dialingCode: "236", name: "Central African Republic" },
  { code: "TD", dialingCode: "235", name: "Chad" },
  { code: "CL", dialingCode: "56", name: "Chile" },
  { code: "CN", dialingCode: "86", name: "China" },
  { code: "CX", dialingCode: "61", name: "Christmas Island" },
  { code: "CC", dialingCode: "61", name: "Cocos Islands" },
  { code: "CO", dialingCode: "57", name: "Colombia" },
  { code: "KM", dialingCode: "269", name: "Comoros" },
  { code: "CK", dialingCode: "682", name: "Cook Islands" },
  { code: "CR", dialingCode: "506", name: "Costa Rica" },
  { code: "HR", dialingCode: "385", name: "Croatia" },
  { code: "CU", dialingCode: "53", name: "Cuba" },
  { code: "CW", dialingCode: "599", name: "Curacao" },
  { code: "CY", dialingCode: "357", name: "Cyprus" },
  { code: "CZ", dialingCode: "420", name: "Czech Republic" },
  { code: "CD", dialingCode: "243", name: "Democratic Republic of the Congo" },
  { code: "DK", dialingCode: "45", name: "Denmark" },
  { code: "DJ", dialingCode: "253", name: "Djibouti" },
  { code: "DM", dialingCode: "1767", name: "Dominica" },
  { code: "DO", dialingCode: "1809", name: "Dominican Republic" },
  { code: "TL", dialingCode: "670", name: "East Timor" },
  { code: "EC", dialingCode: "593", name: "Ecuador" },
  { code: "EG", dialingCode: "20", name: "Egypt" },
  { code: "SV", dialingCode: "503", name: "El Salvador" },
  { code: "GQ", dialingCode: "240", name: "Equatorial Guinea" },
  { code: "ER", dialingCode: "291", name: "Eritrea" },
  { code: "EE", dialingCode: "372", name: "Estonia" },
  { code: "ET", dialingCode: "251", name: "Ethiopia" },
  { code: "FK", dialingCode: "500", name: "Falkland Islands" },
  { code: "FO", dialingCode: "298", name: "Faroe Islands" },
  { code: "FJ", dialingCode: "679", name: "Fiji" },
  { code: "FI", dialingCode: "358", name: "Finland" },
  { code: "FR", dialingCode: "33", name: "France" },
  { code: "PF", dialingCode: "689", name: "French Polynesia" },
  { code: "GA", dialingCode: "241", name: "Gabon" },
  { code: "GM", dialingCode: "220", name: "Gambia" },
  { code: "GE", dialingCode: "995", name: "Georgia" },
  { code: "DE", dialingCode: "49", name: "Germany" },
  { code: "GH", dialingCode: "233", name: "Ghana" },
  { code: "GI", dialingCode: "350", name: "Gibraltar" },
  { code: "GR", dialingCode: "30", name: "Greece" },
  { code: "GL", dialingCode: "299", name: "Greenland" },
  { code: "GD", dialingCode: "1473", name: "Grenada" },
  { code: "GU", dialingCode: "1671", name: "Guam" },
  { code: "GT", dialingCode: "502", name: "Guatemala" },
  { code: "GG", dialingCode: "441481", name: "Guernsey" },
  { code: "GW", dialingCode: "245", name: "Guinea - Bissau" },
  { code: "GN", dialingCode: "224", name: "Guinea" },
  { code: "GY", dialingCode: "592", name: "Guyana" },
  { code: "HT", dialingCode: "509", name: "Haiti" },
  { code: "HN", dialingCode: "504", name: "Honduras" },
  { code: "HK", dialingCode: "852", name: "Hong Kong" },
  { code: "HU", dialingCode: "36", name: "Hungary" },
  { code: "IS", dialingCode: "354", name: "Iceland" },
  { code: "IN", dialingCode: "91", name: "India" },
  { code: "ID", dialingCode: "62", name: "Indonesia" },
  { code: "IR", dialingCode: "98", name: "Iran" },
  { code: "IQ", dialingCode: "964", name: "Iraq" },
  { code: "IE", dialingCode: "353", name: "Ireland" },
  { code: "IM", dialingCode: "441624", name: "Isle of Man" },
  { code: "IL", dialingCode: "972", name: "Israel" },
  { code: "IT", dialingCode: "39", name: "Italy" },
  { code: "CI", dialingCode: "225", name: "Ivory Coast" },
  { code: "JM", dialingCode: "1876", name: "Jamaica" },
  { code: "JP", dialingCode: "81", name: "Japan" },
  { code: "JE", dialingCode: "441534", name: "Jersey" },
  { code: "JO", dialingCode: "962", name: "Jordan" },
  { code: "KZ", dialingCode: "7", name: "Kazakhstan" },
  { code: "KE", dialingCode: "254", name: "Kenya" },
  { code: "KI", dialingCode: "686", name: "Kiribati" },
  { code: "XK", dialingCode: "383", name: "Kosovo" },
  { code: "KW", dialingCode: "965", name: "Kuwait" },
  { code: "KG", dialingCode: "996", name: "Kyrgyzstan" },
  { code: "LA", dialingCode: "856", name: "Laos" },
  { code: "LV", dialingCode: "371", name: "Latvia" },
  { code: "LB", dialingCode: "961", name: "Lebanon" },
  { code: "LS", dialingCode: "266", name: "Lesotho" },
  { code: "LR", dialingCode: "231", name: "Liberia" },
  { code: "LY", dialingCode: "218", name: "Libya" },
  { code: "LI", dialingCode: "423", name: "Liechtenstein" },
  { code: "LT", dialingCode: "370", name: "Lithuania" },
  { code: "LU", dialingCode: "352", name: "Luxembourg" },
  { code: "MO", dialingCode: "853", name: "Macau" },
  { code: "MK", dialingCode: "389", name: "Macedonia" },
  { code: "MG", dialingCode: "261", name: "Madagascar" },
  { code: "MW", dialingCode: "265", name: "Malawi" },
  { code: "MY", dialingCode: "60", name: "Malaysia" },
  { code: "MV", dialingCode: "960", name: "Maldives" },
  { code: "ML", dialingCode: "223", name: "Mali" },
  { code: "MT", dialingCode: "356", name: "Malta" },
  { code: "MH", dialingCode: "692", name: "Marshall Islands" },
  { code: "MR", dialingCode: "222", name: "Mauritania" },
  { code: "MU", dialingCode: "230", name: "Mauritius" },
  { code: "YT", dialingCode: "262", name: "Mayotte" },
  { code: "MX", dialingCode: "52", name: "Mexico" },
  { code: "FM", dialingCode: "691", name: "Micronesia" },
  { code: "MD", dialingCode: "373", name: "Moldova" },
  { code: "MC", dialingCode: "377", name: "Monaco" },
  { code: "MN", dialingCode: "976", name: "Mongolia" },
  { code: "ME", dialingCode: "382", name: "Montenegro" },
  { code: "MS", dialingCode: "1664", name: "Montserrat" },
  { code: "MA", dialingCode: "212", name: "Morocco" },
  { code: "MZ", dialingCode: "258", name: "Mozambique" },
  { code: "MM", dialingCode: "95", name: "Myanmar" },
  { code: "NA", dialingCode: "264", name: "Namibia" },
  { code: "NR", dialingCode: "674", name: "Nauru" },
  { code: "NP", dialingCode: "977", name: "Nepal" },
  { code: "AN", dialingCode: "599", name: "Netherlands Antilles" },
  { code: "NL", dialingCode: "31", name: "Netherlands" },
  { code: "NC", dialingCode: "687", name: "New Caledonia" },
  { code: "NZ", dialingCode: "64", name: "New Zealand" },
  { code: "NI", dialingCode: "505", name: "Nicaragua" },
  { code: "NE", dialingCode: "227", name: "Niger" },
  { code: "NG", dialingCode: "234", name: "Nigeria" },
  { code: "NU", dialingCode: "683", name: "Niue" },
  { code: "KP", dialingCode: "850", name: "North Korea" },
  { code: "MP", dialingCode: "1670", name: "Northern Mariana Islands" },
  { code: "NO", dialingCode: "47", name: "Norway" },
  { code: "OM", dialingCode: "968", name: "Oman" },
  { code: "PK", dialingCode: "92", name: "Pakistan" },
  { code: "PW", dialingCode: "680", name: "Palau" },
  { code: "PS", dialingCode: "970", name: "Palestine" },
  { code: "PA", dialingCode: "507", name: "Panama" },
  { code: "PG", dialingCode: "675", name: "Papua New Guinea" },
  { code: "PY", dialingCode: "595", name: "Paraguay" },
  { code: "PE", dialingCode: "51", name: "Peru" },
  { code: "PH", dialingCode: "63", name: "Philippines" },
  { code: "PN", dialingCode: "64", name: "Pitcairn" },
  { code: "PL", dialingCode: "48", name: "Poland" },
  { code: "PT", dialingCode: "351", name: "Portugal" },
  { code: "PR", dialingCode: "1787", name: "Puerto Rico" },
  { code: "QA", dialingCode: "974", name: "Qatar" },
  { code: "RE", dialingCode: "262", name: "Reunion" },
  { code: "RO", dialingCode: "40", name: "Romania" },
  { code: "RU", dialingCode: "7", name: "Russia" },
  { code: "RW", dialingCode: "250", name: "Rwanda" },
  { code: "BL", dialingCode: "590", name: "Saint Barthelemy" },
  { code: "SH", dialingCode: "290", name: "Saint Helena" },
  { code: "KN", dialingCode: "1869", name: "Saint Kitts and Nevis" },
  { code: "LC", dialingCode: "1758", name: "Saint Lucia" },
  { code: "MF", dialingCode: "590", name: "Saint Martin" },
  { code: "PM", dialingCode: "508", name: "Saint Pierre and Miquelon" },
  { code: "VC", dialingCode: "1784", name: "Saint Vincent and the Grenadines" },
  { code: "WS", dialingCode: "685", name: "Samoa" },
  { code: "SM", dialingCode: "378", name: "San Marino" },
  { code: "ST", dialingCode: "239", name: "Sao Tome and Principe" },
  { code: "SA", dialingCode: "966", name: "Saudi Arabia" },
  { code: "SN", dialingCode: "221", name: "Senegal" },
  { code: "RS", dialingCode: "381", name: "Serbia" },
  { code: "SC", dialingCode: "248", name: "Seychelles" },
  { code: "SL", dialingCode: "232", name: "Sierra Leone" },
  { code: "SG", dialingCode: "65", name: "Singapore" },
  { code: "SX", dialingCode: "1721", name: "Sint Maarten" },
  { code: "SK", dialingCode: "421", name: "Slovakia" },
  { code: "SI", dialingCode: "386", name: "Slovenia" },
  { code: "SB", dialingCode: "677", name: "Solomon Islands" },
  { code: "SO", dialingCode: "252", name: "Somalia" },
  { code: "ZA", dialingCode: "27", name: "South Africa" },
  { code: "KR", dialingCode: "82", name: "South Korea" },
  { code: "SS", dialingCode: "211", name: "South Sudan" },
  { code: "ES", dialingCode: "34", name: "Spain" },
  { code: "LK", dialingCode: "94", name: "Sri Lanka" },
  { code: "SD", dialingCode: "249", name: "Sudan" },
  { code: "SR", dialingCode: "597", name: "Suriname" },
  { code: "SJ", dialingCode: "47", name: "Svalbard and Jan Mayen" },
  { code: "SZ", dialingCode: "268", name: "Swaziland" },
  { code: "SE", dialingCode: "46", name: "Sweden" },
  { code: "CH", dialingCode: "41", name: "Switzerland" },
  { code: "SY", dialingCode: "963", name: "Syria" },
  { code: "TW", dialingCode: "886", name: "Taiwan" },
  { code: "TJ", dialingCode: "992", name: "Tajikistan" },
  { code: "TZ", dialingCode: "255", name: "Tanzania" },
  { code: "TH", dialingCode: "66", name: "Thailand" },
  { code: "TG", dialingCode: "228", name: "Togo" },
  { code: "TK", dialingCode: "690", name: "Tokelau" },
  { code: "TO", dialingCode: "676", name: "Tonga" },
  { code: "TT", dialingCode: "1868", name: "Trinidad and Tobago" },
  { code: "TN", dialingCode: "216", name: "Tunisia" },
  { code: "TR", dialingCode: "90", name: "Turkey" },
  { code: "TM", dialingCode: "993", name: "Turkmenistan" },
  { code: "TC", dialingCode: "1649", name: "Turks and Caicos Islands" },
  { code: "TV", dialingCode: "688", name: "Tuvalu" },
  { code: "VI", dialingCode: "1340", name: "U.S.Virgin Islands" },
  { code: "UG", dialingCode: "256", name: "Uganda" },
  { code: "UA", dialingCode: "380", name: "Ukraine" },
  { code: "AE", dialingCode: "971", name: "United Arab Emirates" },
  { code: "GB", dialingCode: "44", name: "United Kingdom" },
  { code: "US", dialingCode: "1", name: "United States" },
  { code: "UY", dialingCode: "598", name: "Uruguay" },
  { code: "UZ", dialingCode: "998", name: "Uzbekistan" },
  { code: "VU", dialingCode: "678", name: "Vanuatu" },
  { code: "VA", dialingCode: "379", name: "Vatican" },
  { code: "VE", dialingCode: "58", name: "Venezuela" },
  { code: "VN", dialingCode: "84", name: "Vietnam" },
  { code: "WF", dialingCode: "681", name: "Wallis and Futuna" },
  { code: "EH", dialingCode: "212", name: "Western Sahara" },
  { code: "YE", dialingCode: "967", name: "Yemen" },
  { code: "ZM", dialingCode: "260", name: "Zambia" },
  { code: "ZW", dialingCode: "263", name: "Zimbabwe" }
], Bl = "27", gc = ["for"], mc = ["id", "value", "name", "placeholder", "disabled", "readonly", "required", "aria-describedby", "aria-label", "aria-invalid", "data-testid"], vc = /* @__PURE__ */ X({
  __name: "PhoneNumberInput",
  props: {
    id: {},
    modelValue: { default: "" },
    countryCode: { default: Bl },
    countries: { default: () => hc },
    class: { type: [Boolean, null, String, Object, Array] },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: { default: void 0 },
    ariaLabel: { default: void 0 },
    name: { default: void 0 },
    isDisabled: { type: Boolean, default: !1 },
    isReadOnly: { type: Boolean, default: !1 },
    isInvalid: { type: Boolean, default: !1 },
    isRequired: { type: Boolean, default: !1 },
    noCountryCode: { type: Boolean, default: !1 },
    maxLength: { default: 15 },
    stripLeadingZero: { type: Boolean, default: !1 },
    groupSizes: { default: () => [3, 3, 4] },
    size: { default: "lg" },
    searchPlaceholder: { default: "Search country or code" },
    emptyMessage: { default: "No countries found" }
  },
  emits: ["update:modelValue", "update:countryCode", "blur", "focus"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = A(!1), d = A(!1), u = A(""), b = A(!1);
    Se(
      () => t.isInvalid,
      (J, Q) => {
        J && !Q && (b.value = !0);
      }
    );
    const g = (J) => {
      J.animationName.includes("shake") && (b.value = !1);
    }, h = (J) => {
      const Q = t.countries.find((K) => K.dialingCode === J);
      return Q ? Q.code : (t.countries.find((K) => K.dialingCode === Bl) ?? t.countries[0])?.code;
    }, p = A();
    Se(
      [() => t.countryCode, () => t.countries],
      ([J]) => {
        const Q = t.countries.find((ee) => ee.code === p.value);
        if (Q && Q.dialingCode === J) return;
        const ue = h(J);
        p.value = ue;
        const K = t.countries.find(
          (ee) => ee.code === ue
        )?.dialingCode;
        !t.noCountryCode && K && K !== J && s("update:countryCode", K);
      },
      { immediate: !0 }
    );
    const f = i(
      () => t.countries.find((J) => J.code === p.value)
    ), y = i(() => f.value?.dialingCode ?? t.countryCode), w = i(() => d.value || o.value), {
      containerClasses: S,
      countryTriggerClasses: k,
      dividerClasses: x,
      chevronClasses: $,
      inputClasses: D,
      contentClasses: E,
      searchRowClasses: R,
      searchInputClasses: V,
      viewportClasses: Z,
      itemClasses: G,
      itemNameClasses: z,
      itemDialClasses: U,
      indicatorClasses: ae,
      emptyClasses: B
    } = pc(t, () => w.value), le = i(() => t.modelValue !== "" && t.modelValue != null), O = i(
      () => !t.noCountryCode && !(t.isReadOnly && !le.value)
    ), j = Bt(t, () => le.value), _ = i(() => `${t.label ?? ""}${t.isRequired ? " (Required)" : ""}`), ne = i(() => t.isDisabled ? "text-txt-500" : t.isInvalid ? "text-red-600" : t.isReadOnly ? mt : w.value ? "text-blue-600" : le.value ? "text-gray-400" : "text-txt-700"), { isLabelHidden: P } = Et(
      t,
      () => w.value,
      () => le.value
    ), ce = i(() => [
      "pointer-events-none absolute -top-2 z-10 rounded type-body-2 transition duration-200",
      // Read-only has no border to notch, so the label drops the inset + backing colour and
      // sits flush left, aligned with the dialing code beneath it. `left-px`, not `left-0`: the
      // label is positioned against the outer wrapper while the code sits inside the container,
      // so the container's 1px (transparent) border insets it by that much.
      t.isReadOnly ? gt : "left-2 bg-white px-1",
      P.value ? "opacity-0 translate-y-1" : "opacity-100 translate-y-0",
      ne.value
    ]), W = i(() => {
      const J = u.value.trim().toLowerCase();
      if (!J) return t.countries;
      const Q = J.replaceAll(/\D/g, "");
      return t.countries.filter(
        (ue) => ue.name.toLowerCase().includes(J) || ue.code.toLowerCase().includes(J) || Q.length > 0 && ue.dialingCode.includes(Q)
      );
    }), H = (J) => {
      o.value = J, J || (u.value = "");
    }, fe = (J) => {
      const Q = J;
      if (!Q) return;
      p.value = Q;
      const ue = t.countries.find((K) => K.code === Q)?.dialingCode;
      ue && s("update:countryCode", ue);
    }, $e = (J, Q) => {
      const ue = Q.filter((ge) => Number.isInteger(ge) && ge > 0);
      if (!J || ue.length === 0) return J;
      const K = [];
      let ee = 0;
      for (const ge of ue) {
        if (ee >= J.length) break;
        K.push(J.slice(ee, ee + ge)), ee += ge;
      }
      const he = ue.at(-1) ?? 3;
      for (; ee < J.length; )
        K.push(J.slice(ee, ee + he)), ee += he;
      return K.join(" ");
    }, te = i(() => $e(t.modelValue ?? "", t.groupSizes)), we = (J, Q) => {
      if (Q <= 0) return 0;
      let ue = 0;
      for (const [K, ee] of [...J].entries())
        if (/\d/.test(ee) && (ue += 1, ue === Q))
          return K + 1;
      return J.length;
    }, I = (J) => {
      const Q = J.target, ue = Q.selectionStart ?? Q.value.length;
      let K = Q.value.slice(0, ue).replaceAll(/\D/g, "").length, ee = Q.value.replaceAll(/\D/g, "");
      t.stripLeadingZero && ee.startsWith("0") && (ee = ee.slice(1), K > 0 && (K -= 1)), t.maxLength && ee.length > t.maxLength && (ee = ee.slice(0, t.maxLength));
      const he = $e(ee, t.groupSizes);
      Q.value = he;
      const ge = we(he, K);
      Q.setSelectionRange(ge, ge), s("update:modelValue", ee);
    }, Y = (J) => {
      d.value = !0, s("focus", J);
    }, be = (J) => {
      d.value = !1, s("blur", J);
    };
    return (J, Q) => (n(), c("div", {
      class: r(l(q)("relative w-full", t.class)),
      onAnimationend: g
    }, [
      e.label ? (n(), c("label", {
        key: 0,
        for: e.id,
        class: r(ce.value)
      }, C(_.value), 11, gc)) : v("", !0),
      L(l(jl), {
        "model-value": p.value,
        disabled: e.isDisabled || e.isReadOnly,
        "ignore-filter": "",
        "onUpdate:modelValue": fe,
        "onUpdate:open": H
      }, {
        default: M(() => [
          L(l(Nl), {
            class: r([l(S), { "ti-shake": b.value }])
          }, {
            default: M(() => [
              O.value ? (n(), c(re, { key: 0 }, [
                L(l(Ul), {
                  class: r(l(k)),
                  disabled: e.isDisabled || e.isReadOnly,
                  "aria-label": `Country dialing code, currently +${y.value}`,
                  "data-testid": `phone-${e.id}-country`
                }, {
                  default: M(() => [
                    m("span", null, "+" + C(y.value), 1),
                    e.isReadOnly ? v("", !0) : (n(), F(l(pa), {
                      key: 0,
                      class: r(l($))
                    }, null, 8, ["class"]))
                  ]),
                  _: 1
                }, 8, ["class", "disabled", "aria-label", "data-testid"]),
                e.isReadOnly ? v("", !0) : (n(), c("span", {
                  key: 0,
                  class: r(l(x)),
                  "aria-hidden": "true"
                }, null, 2))
              ], 64)) : v("", !0),
              m("input", {
                id: e.id,
                type: "tel",
                inputmode: "tel",
                value: te.value,
                name: e.name,
                placeholder: l(j),
                disabled: e.isDisabled,
                readonly: e.isReadOnly,
                required: e.isRequired,
                "aria-describedby": e.ariaDescribedby,
                "aria-label": e.label ? void 0 : e.ariaLabel,
                "aria-invalid": e.isInvalid || void 0,
                class: r(l(D)),
                "data-testid": `phone-${e.id}`,
                onInput: I,
                onFocus: Y,
                onBlur: be
              }, null, 42, mc)
            ]),
            _: 1
          }, 8, ["class"]),
          e.noCountryCode ? v("", !0) : (n(), F(l(Gl), { key: 0 }, {
            default: M(() => [
              L(l(_l), {
                position: "popper",
                align: "start",
                "side-offset": 6,
                class: r(l(E))
              }, {
                default: M(() => [
                  m("div", {
                    class: r(l(R))
                  }, [
                    L(l(ql), {
                      placeholder: e.searchPlaceholder,
                      "display-value": () => "",
                      class: r(l(V)),
                      "data-testid": `phone-${e.id}-search`,
                      "onUpdate:modelValue": Q[0] || (Q[0] = (ue) => u.value = String(ue ?? ""))
                    }, null, 8, ["placeholder", "class", "data-testid"])
                  ], 2),
                  L(l(Wl), {
                    class: r(l(Z))
                  }, {
                    default: M(() => [
                      (n(!0), c(re, null, xe(W.value, (ue) => (n(), F(l(Kl), {
                        key: ue.code,
                        value: ue.code,
                        "text-value": ue.name,
                        class: r(l(G)),
                        "data-testid": `phone-${e.id}-country-option-${ue.code}`
                      }, {
                        default: M(() => [
                          m("span", {
                            class: r(l(z))
                          }, C(ue.name), 3),
                          m("span", {
                            class: r(l(U))
                          }, "+" + C(ue.dialingCode), 3),
                          L(l(Yl), {
                            class: r(l(ae))
                          }, {
                            default: M(() => [
                              L(l($t), { class: "h-4 w-4 text-blue-600" })
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ]),
                        _: 2
                      }, 1032, ["value", "text-value", "class", "data-testid"]))), 128)),
                      W.value.length === 0 ? (n(), c("div", {
                        key: 0,
                        class: r(l(B))
                      }, C(e.emptyMessage), 3)) : v("", !0)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }))
        ]),
        _: 1
      }, 8, ["model-value", "disabled"])
    ], 34));
  }
}), yc = /* @__PURE__ */ Ye(vc, [["__scopeId", "data-v-3376151c"]]), qs = /* @__PURE__ */ X({
  __name: "IconWrapper",
  props: {
    color: { default: "gray" },
    size: { default: "md" },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e;
    return (t, s) => (n(), c("div", {
      "data-testid": "icon-wrapper",
      class: r(
        l(q)(
          "inline-flex shrink-0 items-center justify-center rounded-lg",
          {
            // --- Sizes ---
            "h-7 w-7 rounded-md": a.size === "2xs",
            "h-8 w-8": a.size === "xs",
            "h-10 w-10": a.size === "sm",
            "h-12 w-12": a.size === "md",
            "h-16 w-16": a.size === "lg",
            // --- Colors (Background + Text) ---
            "bg-gray-100 text-gray-600": a.color === "gray",
            "bg-blue-50 text-blue-600": a.color === "blue",
            "bg-green-50 text-green-600": a.color === "green",
            "bg-orange-50 text-orange-600": a.color === "orange",
            "bg-red-50 text-red-600": a.color === "red",
            "bg-purple-50 text-purple-600": a.color === "purple"
          },
          a.class
        )
      )
    }, [
      T(t.$slots, "default")
    ], 2));
  }
}), xc = { class: "type-h3 mt-6 text-gray-900" }, wc = {
  key: 1,
  class: "type-body-1 mt-2 max-w-sm text-gray-500"
}, Lc = {
  key: 2,
  class: "mt-6"
}, ib = /* @__PURE__ */ X({
  __name: "EmptyState",
  props: {
    title: {},
    description: {},
    iconColor: { default: "gray" },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e;
    return (t, s) => (n(), c("div", {
      "data-testid": "empty-state",
      class: r(
        l(q)(
          "flex h-full w-full flex-col items-center justify-center px-6 py-12 text-center",
          a.class
        )
      )
    }, [
      t.$slots.icon ? (n(), F(qs, {
        key: 0,
        color: a.iconColor,
        size: "lg",
        class: "rounded-full"
      }, {
        default: M(() => [
          T(t.$slots, "icon")
        ]),
        _: 3
      }, 8, ["color"])) : v("", !0),
      m("h3", xc, C(a.title), 1),
      a.description ? (n(), c("p", wc, C(a.description), 1)) : v("", !0),
      t.$slots.action ? (n(), c("div", Lc, [
        T(t.$slots, "action")
      ])) : v("", !0)
    ], 2));
  }
}), Cc = {}, kc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 183 140",
  fill: "none",
  role: "img",
  "aria-label": "Image placeholder"
};
function $c(e, a) {
  return n(), c("svg", kc, [...a[0] || (a[0] = [
    yn('<path d="M144.877 137.353L144.873 137.521L148.219 137.604L148.224 137.437L144.877 137.353Z" fill="#625F6E"></path><path d="M152.629 136.043L148.347 135.85V138.31H148.18V135.763V135.675L148.268 135.679L152.636 135.876L152.629 136.043Z" fill="#625F6E"></path><path d="M164.548 136.427L165.772 136.483L165.857 136.486V136.57V139.746H165.681V136.653L164.541 136.602L164.548 136.427Z" fill="#625F6E"></path><path d="M170.356 129.521L170.864 129.594L170.939 129.606V129.682V139.746H170.764V129.758L170.332 129.694L170.356 129.521Z" fill="#625F6E"></path><path d="M137.978 139.004L140.521 139.021V139.171L137.978 139.154V139.004Z" fill="#625F6E"></path><path d="M137.983 138.551L140.553 138.58L140.552 138.73L137.981 138.702L137.983 138.551Z" fill="#625F6E"></path><path d="M109.116 134.61H108.965V139.75H109.116V134.61Z" fill="#625F6E"></path><path d="M117.65 135.177H117.499V139.75H117.65V135.177Z" fill="#625F6E"></path><path d="M109.802 135.415H109.651V139.75H109.802V135.415Z" fill="#625F6E"></path><path d="M110.463 137.688H110.312V139.75H110.463V137.688Z" fill="#625F6E"></path><path d="M123.762 121.825H123.594V139.749H123.762V121.825Z" fill="#625F6E"></path><path d="M161.552 120.814H161.385V139.749H161.552V120.814Z" fill="#625F6E"></path><path d="M152.055 118.405H151.887V139.749H152.055V118.405Z" fill="#625F6E"></path><path d="M144.96 134.522H144.792V139.749H144.96V134.522Z" fill="#625F6E"></path><path d="M147.864 134.435H147.697V137.523H147.864V134.435Z" fill="#625F6E"></path><path d="M139.981 120.294H139.83V137.434H139.981V120.294Z" fill="#625F6E"></path><path d="M78.457 138.743L89.4053 138.767V138.933L78.457 138.909V138.743Z" fill="#625F6E"></path><path d="M78.4846 138.145L89.383 138.211L89.3818 138.377L78.4834 138.311L78.4846 138.145Z" fill="#625F6E"></path><path d="M78.7786 94.6309H78.6279V139.722H78.7786V94.6309Z" fill="#625F6E"></path><path d="M94.9842 134.166H94.8335V139.749H94.9842V134.166Z" fill="#625F6E"></path><path d="M26.5666 137.787L17.3665 137.985V139.665H17.2158V137.912V137.838L17.2894 137.837L26.5631 137.638L26.5666 137.787Z" fill="#625F6E"></path><path d="M26.575 127.734L24.9491 127.942V137.752H24.7983V127.875V127.809L24.8636 127.8L26.556 127.584L26.575 127.734Z" fill="#625F6E"></path><path d="M45.6645 138.733L44.4113 138.744L44.3223 138.746V138.658V128.836V128.756L44.4018 128.748L45.6539 128.627L45.6705 128.801L44.4979 128.915V138.569L45.6634 138.558L45.6645 138.733Z" fill="#625F6E"></path><path d="M48.7229 138.895L48.7222 139.062L53.9595 139.084L53.9602 138.917L48.7229 138.895Z" fill="#625F6E"></path><path d="M48.7194 138.292L53.9639 138.33V138.498L48.7183 138.46L48.7194 138.292Z" fill="#625F6E"></path><path d="M71.8929 1.13135H71.7422V139.75H71.8929V1.13135Z" fill="#625F6E"></path><path d="M56.2269 119.674H56.0762V139.751H56.2269V119.674Z" fill="#625F6E"></path><path d="M15.5863 127.292H15.4355V139.751H15.5863V127.292Z" fill="#625F6E"></path><path d="M45.6779 125.92L42.7821 126.275L42.7857 139.75H42.61L42.6064 126.196V126.118L42.6836 126.109L45.6565 125.747L45.6779 125.92Z" fill="#625F6E"></path><path d="M53.5243 135.399L53.5349 139.75H53.3842L53.3735 135.399H53.5243Z" fill="#625F6E"></path><path d="M53.0189 135.367L53.0284 137.827L52.8788 137.829L52.8682 135.367H53.0189Z" fill="#625F6E"></path><path d="M34.6629 124.472H34.5122V139.75H34.6629V124.472Z" fill="#625F6E"></path><path d="M155.719 136.03L155.712 136.197L162.052 136.484L162.06 136.317L155.719 136.03Z" fill="#625F6E"></path><path d="M146.999 97.8532L152.637 96.7578L152.666 96.905L147.027 98.0016L146.999 97.8532Z" fill="#625F6E"></path><path d="M152.623 98.4229L149.471 99.0117L149.498 99.1599L152.651 98.5711L152.623 98.4229Z" fill="#625F6E"></path><path d="M155.664 98.0228L159.097 97.3843L159.124 97.5326L155.691 98.1711L155.664 98.0228Z" fill="#625F6E"></path><path d="M55.3357 98.2079L28.959 107.059L29.0066 107.201L55.3833 98.3497L55.3357 98.2079Z" fill="#625F6E"></path><path d="M26.5353 107.874L10.4829 113.26L10.5309 113.403L26.5833 108.017L26.5353 107.874Z" fill="#625F6E"></path><path d="M8.27724 114L2.12158 116.065L2.16915 116.207L8.32481 114.142L8.27724 114Z" fill="#625F6E"></path><path d="M28.978 124.491L55.3535 120.372L55.3761 120.52L29.0018 124.639L28.978 124.491Z" fill="#625F6E"></path><path d="M26.559 124.867L10.5088 127.375L10.5321 127.523L26.5823 125.016L26.559 124.867Z" fill="#625F6E"></path><path d="M8.29531 127.721L2.75488 128.587L2.77797 128.735L8.31839 127.869L8.29531 127.721Z" fill="#625F6E"></path><path d="M55.3366 76.1467L28.9595 89.7085L29.0284 89.8425L55.4056 76.2807L55.3366 76.1467Z" fill="#625F6E"></path><path d="M26.5429 90.9486L10.4893 99.2026L10.5582 99.3367L26.6118 91.0827L26.5429 90.9486Z" fill="#625F6E"></path><path d="M8.27977 100.34L1.99658 103.571L2.0655 103.705L8.34869 100.474L8.27977 100.34Z" fill="#625F6E"></path><path d="M28.9424 72.3232L55.3226 54.0405L55.4081 54.1651L29.0278 72.4466L28.9424 72.3232Z" fill="#625F6E"></path><path d="M8.25809 86.6623L1.86865 91.0898L1.95382 91.2128L8.34326 86.7852L8.25809 86.6623Z" fill="#625F6E"></path><path d="M42.7114 126.119L42.6997 126.294L45.6578 126.492L45.6695 126.317L42.7114 126.119Z" fill="#625F6E"></path><path d="M69.3551 1.98249L68.37 1.17072L10.0921 60.3447V61.3784H9.94141V60.3138L9.96396 60.2616L68.3119 1.01643L68.3594 0.967773L68.4128 1.01168L69.4512 1.86618L69.3551 1.98249Z" fill="#625F6E"></path><path d="M55.4139 32.6217L9.03845 72.8448L8.93994 72.7309L55.3154 32.5078L55.4139 32.6217Z" fill="#625F6E"></path><path d="M55.4142 34.4015L10.0036 73.1328L9.90625 73.0189L55.3157 34.2876L55.4142 34.4015Z" fill="#625F6E"></path><path d="M56.2269 30.4062H56.0762V48.3994H56.2269V30.4062Z" fill="#625F6E"></path><path d="M56.2269 52.6553H56.0762V70.9439H56.2269V52.6553Z" fill="#625F6E"></path><path d="M56.2269 75.1572H56.0762V93.2571H56.2269V75.1572Z" fill="#625F6E"></path><path d="M56.2269 97.3193H56.0762V115.544H56.2269V97.3193Z" fill="#625F6E"></path><path d="M15.5863 113.347H15.4355V123.331H15.5863V113.347Z" fill="#625F6E"></path><path d="M15.5863 99.3799H15.4355V108.26H15.5863V99.3799Z" fill="#625F6E"></path><path d="M78.7786 23.3418H78.6279V42.1882H78.7786V23.3418Z" fill="#625F6E"></path><path d="M78.7786 46.8896H78.6279V65.9936H78.7786V46.8896Z" fill="#625F6E"></path><path d="M78.7786 70.7363H78.6279V89.8866H78.7786V70.7363Z" fill="#625F6E"></path><path d="M109.116 64.6714H108.965V67.6028H109.116V64.6714Z" fill="#625F6E"></path><path d="M109.116 77.3516H108.965V99.47H109.116V77.3516Z" fill="#625F6E"></path><path d="M109.116 103.254H108.965V108.361H109.116V103.254Z" fill="#625F6E"></path><path d="M94.9842 84.5967H94.8335V94.923H94.9842V84.5967Z" fill="#625F6E"></path><path d="M94.9842 46.7173H94.8335V52.2074H94.9842V46.7173Z" fill="#625F6E"></path><path d="M34.6629 107.311H34.5122V119.564H34.6629V107.311Z" fill="#625F6E"></path><path d="M34.6629 90.1772H34.5122V101.111H34.6629V90.1772Z" fill="#625F6E"></path><path d="M34.6629 73.5278H34.5122V82.6282H34.6629V73.5278Z" fill="#625F6E"></path><path d="M40.4257 93.2411L38.6858 92.8281L38.6182 92.8127V92.7427V88.1616H38.7938V92.6727L40.4672 93.0702L40.4257 93.2411Z" fill="#625F6E"></path><path d="M55.2838 85.3635L38.6675 92.668L38.7382 92.8288L55.3545 85.5243L55.2838 85.3635Z" fill="#625F6E"></path><path d="M54.1796 64.374H54.0039V71.7441H54.1796V64.374Z" fill="#625F6E"></path><path d="M53.0599 65.0752H52.9092V72.3705H53.0599V65.0752Z" fill="#625F6E"></path><path d="M138.005 126.364L137.983 126.53L140.539 126.875L140.561 126.709L138.005 126.364Z" fill="#625F6E"></path><path d="M108.564 89.2822L117.854 93.08L117.797 93.2189L108.508 89.4223L108.564 89.2822Z" fill="#625F6E"></path><path d="M108.568 92.3794L113.352 94.1952L113.29 94.3602L108.506 92.5432L108.568 92.3794Z" fill="#625F6E"></path><path d="M108.564 90.8369L115.652 93.6307L115.597 93.7707L108.51 90.977L108.564 90.8369Z" fill="#625F6E"></path><path d="M108.558 90.0466L108.502 90.1865L116.703 93.4783L116.759 93.3384L108.558 90.0466Z" fill="#625F6E"></path><path d="M161.552 109.75H161.385V116.053H161.552V109.75Z" fill="#625F6E"></path><path d="M161.552 98.748H161.385V104.654H161.552V98.748Z" fill="#625F6E"></path><path d="M86.8621 103.17H86.7114V133.767H86.8621V103.17Z" fill="#625F6E"></path><path d="M123.762 113.437H123.594V116.414H123.762V113.437Z" fill="#625F6E"></path><path d="M123.762 99.416H123.594V104.079H123.762V99.416Z" fill="#625F6E"></path><path d="M122.493 99.6929H122.325V103.671H122.493V99.6929Z" fill="#625F6E"></path><path d="M122.493 77.4995H122.325V82.0794H122.493V77.4995Z" fill="#625F6E"></path><path d="M123.762 78.2095H123.594V87.0606H123.762V78.2095Z" fill="#625F6E"></path><path d="M121.218 114.41L123.683 114.95L123.647 115.113L121.182 114.573L121.218 114.41Z" fill="#625F6E"></path><path d="M81.6864 121.563H81.519V133.967H81.6864V121.563Z" fill="#625F6E"></path><path d="M80.8841 130.551H80.7168V133.956H80.8841V130.551Z" fill="#625F6E"></path><path d="M80.1654 130.61H79.998V134.015H80.1654V130.61Z" fill="#625F6E"></path><path d="M87.3611 103.561L87.3257 103.708L121.178 111.891L121.214 111.745L87.3611 103.561Z" fill="#625F6E"></path><path d="M40.4429 92.4422L53.9665 86.564L54.027 86.7016L40.5022 92.5799L40.4429 92.4422Z" fill="#625F6E"></path><path d="M55.4213 60.8431L37.2086 72.4845V81.2098H36.9985V72.4275V72.3717L37.0472 72.3397L55.3085 60.6675L55.4213 60.8431Z" fill="#625F6E"></path><path d="M40.535 91.9785H40.3594V98.2531H40.535V91.9785Z" fill="#625F6E"></path><path d="M40.2484 92.123H40.0977V98.3704H40.2484V92.123Z" fill="#625F6E"></path><path d="M104.155 101.952L101.719 102.489V106.511H101.51V102.404V102.32L101.592 102.302L104.111 101.748L104.155 101.952Z" fill="#625F6E"></path><path d="M77.7305 95.7015L77.6748 95.9028L101.578 102.514L101.634 102.312L77.7305 95.7015Z" fill="#625F6E"></path><path d="M103.117 134.367V135.685V135.791L103.009 135.789L101.23 135.734L101.127 135.731V135.63V134.37H101.338V135.529L102.906 135.577V134.367H103.117Z" fill="#625F6E"></path><path d="M97.1788 134.129V135.402L100.079 135.491L100.181 135.494V135.595V139.74H99.9714V135.697L97.0708 135.608L96.9688 135.605V135.504V134.129H97.1788Z" fill="#625F6E"></path><path d="M155.682 98.8045L160.258 97.9702L160.295 98.1755L155.719 99.0098L155.682 98.8045Z" fill="#625F6E"></path><path d="M162.016 99.2964L155.672 100.408L155.708 100.614L162.052 99.5021L162.016 99.2964Z" fill="#625F6E"></path><path d="M130.873 121.142H130.664V139.748H130.873V121.142Z" fill="#625F6E"></path><path d="M137.988 137.279L137.983 137.488L140.543 137.549L140.548 137.341L137.988 137.279Z" fill="#625F6E"></path><path d="M155.695 138.32L155.691 138.529L162.023 138.631L162.027 138.422L155.695 138.32Z" fill="#625F6E"></path><path d="M144.4 138.166L144.397 138.375L152.642 138.509L152.645 138.3L144.4 138.166Z" fill="#625F6E"></path><path d="M129.389 137.92L129.385 138.129L140.553 138.31L140.556 138.101L129.389 137.92Z" fill="#625F6E"></path><path d="M108.531 137.557L108.527 137.766L124.377 138.021L124.381 137.812L108.531 137.557Z" fill="#625F6E"></path><path d="M77.7065 137.089L77.7031 137.298L95.4375 137.586L95.4409 137.377L77.7065 137.089Z" fill="#625F6E"></path><path d="M48.7194 137.677L53.9473 137.716V137.924L48.7183 137.886L48.7194 137.677Z" fill="#625F6E"></path><path d="M48.4478 135.139L55.3609 134.871L55.3692 135.079L48.4549 135.348L48.4478 135.139Z" fill="#625F6E"></path><path d="M15.0306 117.333L26.5747 118.494L26.5545 118.702L15.0093 117.54L15.0306 117.333Z" fill="#625F6E"></path><path d="M84.8263 65.0435L80.8564 66.978L80.9479 67.1658L84.9178 65.2313L84.8263 65.0435Z" fill="#625F6E"></path><path d="M84.7875 60.5414L77.6455 64.2324L77.7414 64.418L84.8834 60.727L84.7875 60.5414Z" fill="#625F6E"></path><path d="M82.4735 87.8555H82.2646V91.0527H82.4735V87.8555Z" fill="#625F6E"></path><path d="M85.6454 80.9067L77.6621 83.9536L77.7366 84.1488L85.7199 81.1018L85.6454 80.9067Z" fill="#625F6E"></path><path d="M93.5095 84.1276L82.4035 87.9539H82.3358L77.6646 86.3837L77.731 86.1855L82.3678 87.745L93.4419 83.9282L93.5095 84.1276Z" fill="#625F6E"></path><path d="M77.668 97.0447L80.0701 96.3433L80.1282 96.5438L77.7261 97.2452L77.668 97.0447Z" fill="#625F6E"></path><path d="M95.3785 91.8851L90.1162 93.4209L90.1747 93.6214L95.437 92.0856L95.3785 91.8851Z" fill="#625F6E"></path><path d="M95.3774 90.8722L88.5625 92.9038L88.6222 93.104L95.4371 91.0724L95.3774 90.8722Z" fill="#625F6E"></path><path d="M95.3494 90.1832L87.4336 92.5762L87.494 92.7761L95.4099 90.3832L95.3494 90.1832Z" fill="#625F6E"></path><path d="M121.245 93.5601L108.518 96.6558L108.567 96.8587L121.295 93.7631L121.245 93.5601Z" fill="#625F6E"></path><path d="M119.099 92.725L108.51 95.377L108.561 95.5796L119.15 92.9276L119.099 92.725Z" fill="#625F6E"></path><path d="M104.157 97.9363L104.004 97.9731L103.955 97.7702L104.109 97.7334L104.157 97.9363ZM94.0149 100.403L89.6996 101.452L89.651 101.249L93.9662 100.2L94.016 100.403H94.0149ZM80.0319 103.803L77.7212 104.364L77.6714 104.161L79.9821 103.6L80.0308 103.803H80.0319Z" fill="#625F6E"></path><path d="M91.73 99.574L87.4048 100.657L87.4555 100.86L91.7808 99.7766L91.73 99.574Z" fill="#625F6E"></path><path d="M112.972 108.67L111.161 108.982L111.126 108.776L112.938 108.465L112.972 108.67Z" fill="#625F6E"></path><path d="M116.737 109.611L114.924 109.908L114.891 109.701L116.703 109.405L116.737 109.611Z" fill="#625F6E"></path><path d="M84.8549 113.511L83.4521 113.753L83.4165 113.546L84.8193 113.304L84.8549 113.511Z" fill="#625F6E"></path><path d="M83.4449 107.755L83.4023 107.96L84.8141 108.254L84.8566 108.049L83.4449 107.755Z" fill="#625F6E"></path><path d="M84.8207 113.991L83.4179 113.753L83.3301 113.737V113.65L83.3218 107.865V107.781L83.4049 107.763L84.816 107.466L84.8587 107.67L83.5307 107.949L83.539 113.561L84.8551 113.785L84.8207 113.991Z" fill="#625F6E"></path><path d="M101.603 104.149L96.1628 105.294L96.1201 105.088L101.56 103.945L101.603 104.149Z" fill="#625F6E"></path><path d="M124.412 99.3518L114.784 101.376L114.741 101.172L124.37 99.1465L124.412 99.3518Z" fill="#625F6E"></path><path d="M77.7139 113.482L84.8537 114.657L84.8205 114.864L77.6807 113.689L77.7139 113.482Z" fill="#625F6E"></path><path d="M84.8537 114.825L77.7139 115.992L77.6807 115.786L84.8205 114.618L84.8537 114.825Z" fill="#625F6E"></path><path d="M82.3537 118.538L77.7121 119.195L77.6836 118.989L82.3252 118.331L82.3537 118.538Z" fill="#625F6E"></path><path d="M82.3295 121.561L77.7093 122.123L77.6855 121.915L82.3058 121.354L82.3295 121.561Z" fill="#625F6E"></path><path d="M84.844 125.05L78.4792 125.666L78.459 125.458L84.8238 124.842L84.844 125.05Z" fill="#625F6E"></path><path d="M84.828 126.476L78.4573 127.033L78.4395 126.824L84.809 126.268L84.828 126.476Z" fill="#625F6E"></path><path d="M84.8326 129.176L78.459 129.613L78.4733 129.821L84.8469 129.384L84.8326 129.176Z" fill="#625F6E"></path><path d="M78.4805 130.558L84.831 130.164L84.8429 130.372L78.4923 130.766L78.4805 130.558Z" fill="#625F6E"></path><path d="M121.19 121.925L124.381 121.626L124.4 121.834L121.209 122.133L121.19 121.925Z" fill="#625F6E"></path><path d="M124.401 121.224L121.209 121.533L121.19 121.325L124.381 121.017L124.401 121.224Z" fill="#625F6E"></path><path d="M124.405 113.426L121.212 113.864L121.185 113.657L124.378 113.219L124.405 113.426Z" fill="#625F6E"></path><path d="M121.188 118.372L124.381 118.014L124.404 118.221L121.211 118.58L121.188 118.372Z" fill="#625F6E"></path><path d="M124.405 116.449L121.212 116.836L121.188 116.629L124.38 116.242L124.405 116.449Z" fill="#625F6E"></path><path d="M124.405 112.585L121.214 113.037L121.185 112.829L124.376 112.378L124.405 112.585Z" fill="#625F6E"></path><path d="M82.2676 136.055L82.2593 117.173V117.083L82.3483 117.07L84.8216 116.7L84.8524 116.906L82.4682 117.263L82.4753 136.055H82.2676Z" fill="#625F6E"></path><path d="M130.793 122.218L137.983 123.401L138.07 123.415V123.504V139.749H137.862V123.593L130.76 122.424L130.793 122.218Z" fill="#625F6E"></path><path d="M129.366 121.16L140.536 120.114L140.555 120.322L129.385 121.368L129.366 121.16Z" fill="#625F6E"></path><path d="M129.364 117.454L140.534 116.199L140.556 116.407L129.386 117.661L129.364 117.454Z" fill="#625F6E"></path><path d="M137.533 114.853L129.388 115.842L129.363 115.635L137.508 114.645L137.533 114.853Z" fill="#625F6E"></path><path d="M140.555 119.662L129.385 120.742L129.366 120.534L140.535 119.454L140.555 119.662Z" fill="#625F6E"></path><path d="M134.048 113.975L129.388 114.57L129.362 114.364L134.022 113.768L134.048 113.975Z" fill="#625F6E"></path><path d="M140.532 134.512L137.981 134.575L137.987 134.784L140.537 134.721L140.532 134.512Z" fill="#625F6E"></path><path d="M140.533 132.739L137.998 132.826L137.991 132.617L140.526 132.531L140.533 132.739Z" fill="#625F6E"></path><path d="M152.645 113.018L151.932 113.104L151.908 112.896L152.621 112.81L152.645 113.018Z" fill="#625F6E"></path><path d="M162.054 111.875L160.804 112.027L160.779 111.819L162.029 111.667L162.054 111.875ZM156.23 112.582L155.711 112.645L155.688 112.437L156.206 112.374L156.231 112.582H156.23Z" fill="#625F6E"></path><path d="M152.645 111.595L148.739 112.095L148.712 111.888L152.619 111.389L152.645 111.595Z" fill="#625F6E"></path><path d="M148.833 110.074L144.303 110.696L144.275 110.488L148.805 109.867L148.833 110.074Z" fill="#625F6E"></path><path d="M137.442 106.002L132.607 106.793L132.641 106.999L137.476 106.208L137.442 106.002Z" fill="#625F6E"></path><path d="M146.864 109.406L144.387 109.757L144.358 109.549L146.834 109.199L146.864 109.406Z" fill="#625F6E"></path><path d="M152.129 118.543L144.387 119.291L144.368 119.083L152.11 118.335L152.129 118.543Z" fill="#625F6E"></path><path d="M158.145 119.871L155.68 120.086L155.698 120.296L158.163 120.08L158.145 119.871Z" fill="#625F6E"></path><path d="M162.058 102.199L157.57 102.934L157.535 102.727L162.024 101.994L162.058 102.199Z" fill="#625F6E"></path><path d="M152.301 93.6879L144.34 95.3467L144.383 95.5512L152.344 93.8924L152.301 93.6879Z" fill="#625F6E"></path><path d="M150.811 93.0469L144.385 94.42L144.343 94.2159L150.767 92.8428L150.811 93.0469Z" fill="#625F6E"></path><path d="M102.79 77.1987L103.799 76.8296L103.87 77.0266L102.861 77.3945L102.79 77.1987Z" fill="#625F6E"></path><path d="M100.448 75.2634L99.4453 75.646L99.5198 75.8411L100.522 75.4586L100.448 75.2634Z" fill="#625F6E"></path><path d="M140.525 88.8719L132.191 90.8989L132.24 91.1019L140.574 89.0749L140.525 88.8719Z" fill="#625F6E"></path><path d="M140.52 87.3586L130.148 89.9561L130.199 90.1587L140.57 87.5612L140.52 87.3586Z" fill="#625F6E"></path><path d="M124.369 83.3984L119.3 84.8789L119.358 85.0794L124.428 83.5989L124.369 83.3984Z" fill="#625F6E"></path><path d="M130.29 81.6695L129.347 81.9448L129.406 82.1453L130.349 81.87L130.29 81.6695Z" fill="#625F6E"></path><path d="M117.736 83.406L116.74 83.707L116.8 83.907L117.797 83.606L117.736 83.406Z" fill="#625F6E"></path><path d="M124.365 81.3894L121.173 82.355L121.234 82.5549L124.426 81.5893L124.365 81.3894Z" fill="#625F6E"></path><path d="M170.538 118.773L180.123 117.935L175.785 116.254L165.168 117.281L165.148 117.074L175.79 116.043L175.837 116.051L180.618 117.903L180.589 118.105L170.556 118.982L170.538 118.773Z" fill="#625F6E"></path><path d="M165.688 106.53L175.787 105.1L175.906 105.083V105.203V116.148H175.696V105.324L165.717 106.737L165.688 106.53Z" fill="#625F6E"></path><path d="M54.0055 109.061L54.9419 109.689L55.3406 109.593L55.3893 109.794L54.9466 109.902L54.9015 109.913L54.8635 109.888L53.8892 109.234L54.0055 109.061Z" fill="#625F6E"></path><path d="M53.8542 139.75L53.8458 120.126H54.0547L54.063 139.75H53.8542ZM53.8447 115.802L53.8423 109.148V109.066L53.9206 109.046L55.3377 108.691L55.3887 108.894L54.05 109.23L54.0524 115.802H53.8435H53.8447Z" fill="#625F6E"></path><path d="M55.0258 109.802L55.0281 115.611H54.8193L54.8169 109.802H55.0258ZM55.0293 119.97L55.0376 139.751H54.8288L54.8205 119.97H55.0293Z" fill="#625F6E"></path><path d="M48.8012 135.26L48.8118 139.749H48.603L48.5923 135.26H48.8012Z" fill="#625F6E"></path><path d="M15.0265 129.136L15.0166 129.344L24.8726 129.812L24.8825 129.604L15.0265 129.136Z" fill="#625F6E"></path><path d="M48.4667 112.108L55.3798 113.119L55.3501 113.327L48.437 112.316L48.4667 112.108ZM77.713 116.386L82.3796 117.069L82.3487 117.275L77.6822 116.593L77.7119 116.386H77.713Z" fill="#625F6E"></path><path d="M47.4944 104.694L47.3774 104.867L48.6272 105.712L48.7442 105.539L47.4944 104.694Z" fill="#625F6E"></path><path d="M55.3943 103.766L48.7934 105.692L48.7969 112.176H48.588L48.5845 105.615V105.536L48.6604 105.514L55.3362 103.565L55.3943 103.766Z" fill="#625F6E"></path><path d="M47.3368 117.079L47.3345 104.77V104.692L47.4081 104.669L55.3347 102.273L55.3952 102.474L47.5434 104.847L47.5445 117.079H47.3368Z" fill="#625F6E"></path><path d="M47.5487 121.172H47.3398V139.751H47.5487V121.172Z" fill="#625F6E"></path><path d="M45.768 122.821H45.5591V139.75H45.768V122.821Z" fill="#625F6E"></path><path d="M48.7755 67.584L50.9616 68.4159L51.1633 68.4919L50.9782 68.6023L44.1244 72.7003L44.0829 72.7252L44.0366 72.7098L41.9015 71.9728L41.6938 71.9016L41.8814 71.7865L48.6829 67.5947L48.7268 67.5674L48.7743 67.5852L48.7755 67.584ZM50.6863 68.5346L48.7494 67.7976L42.1781 71.847L44.0591 72.4962L50.6863 68.5334V68.5346Z" fill="#625F6E"></path><path d="M55.4199 63.6873L50.9955 66.4134L54.137 67.6417L54.061 67.8364L50.7249 66.5321L50.5303 66.4549L50.7083 66.3457L55.3095 63.5093L55.4199 63.6873Z" fill="#625F6E"></path><path d="M40.5556 123.58H40.3467V139.75H40.5556V123.58Z" fill="#625F6E"></path><path d="M40.5517 105.464H40.3428V118.455H40.5517V105.464Z" fill="#625F6E"></path><path d="M52.5777 101.531L55.3856 102.112L55.3441 102.316L52.5361 101.735L52.5777 101.531Z" fill="#625F6E"></path><path d="M38.7919 98.8449L38.6753 99.0186L39.2721 99.4193L39.3887 99.2457L38.7919 98.8449Z" fill="#625F6E"></path><path d="M38.8427 106.011H38.6338V118.785H38.8427V106.011Z" fill="#625F6E"></path><path d="M38.8456 123.83H38.6367V139.75H38.8456V123.83Z" fill="#625F6E"></path><path d="M36.2636 139.75L36.2612 125.58V125.489L36.3514 125.477L55.1895 122.924L55.2168 123.132L36.4701 125.672L36.4725 139.75H36.2636Z" fill="#625F6E"></path><path d="M55.4021 92.6751L38.8402 98.996V99.5491H38.6313V98.9236V98.8524L38.699 98.8263L55.3273 92.4805L55.4021 92.6751Z" fill="#625F6E"></path><path d="M55.3894 110.681L48.557 112.294V116.88H48.3481V112.128L48.4288 112.109L55.342 110.477L55.3894 110.681ZM48.557 121.01V135.141L55.3681 135.304L55.3633 135.513L48.4502 135.348L48.3481 135.345V121.01H48.557ZM78.487 135.858L82.3761 135.952L82.3714 136.161L78.4834 136.067L78.4882 135.858H78.487Z" fill="#625F6E"></path><path d="M94.2782 134.134H94.0693V139.749H94.2782V134.134Z" fill="#625F6E"></path><path d="M89.5004 135.909H89.2915V139.749H89.5004V135.909Z" fill="#625F6E"></path><path d="M77.7075 123.537L78.4789 123.61L78.5738 123.619V123.714V139.749H78.365V123.809L77.6885 123.745L77.7075 123.537Z" fill="#625F6E"></path><path d="M77.721 103.068L84.8608 104.71L84.8145 104.913L77.6747 103.271L77.721 103.067V103.068ZM90.7936 103.78L90.8399 103.984L95.4269 102.949L95.4305 102.746L82.7376 99.4302H82.6842L77.6724 100.765L77.7258 100.967L82.7127 99.6379L94.9641 102.837L90.7948 103.777L90.7936 103.78Z" fill="#625F6E"></path><path d="M121.278 76.682L121.128 76.9561L124.32 78.6956L124.47 78.4216L121.278 76.682Z" fill="#625F6E"></path><path d="M149.224 119.418H148.99V132.343H149.224V119.418Z" fill="#625F6E"></path><path d="M167.89 134.047L164.533 133.763L164.552 133.529L167.909 133.813L167.89 134.047ZM162.03 133.552L155.697 133.017L155.716 132.783L162.049 133.318L162.03 133.552ZM152.623 132.757L149.106 132.46L144.387 132.62L144.38 132.387L149.109 132.225H149.122L152.642 132.523L152.623 132.757Z" fill="#625F6E"></path><path d="M152.606 120.351L149.092 119.535L144.388 119.975L144.366 119.742L149.091 119.3L149.128 119.302L152.658 120.122L152.606 120.35V120.351ZM155.727 120.837L162.066 122.31L162.014 122.537L155.675 121.065L155.727 120.837ZM164.564 122.89L167.915 123.668L168.005 123.69V123.784L168.017 133.932V134.046L167.903 134.048L164.545 134.131L164.541 133.897L167.783 133.817L167.772 123.875L164.512 123.118L164.564 122.89ZM144.383 134.395L152.63 134.191L152.635 134.424L144.388 134.629L144.382 134.395H144.383ZM155.705 134.115L162.039 133.958L162.045 134.192L155.711 134.348L155.706 134.115H155.705Z" fill="#625F6E"></path><path d="M95.5623 84.771H95.249V95.1674H95.5623V84.771Z" fill="#625F6E"></path><path d="M95.5623 134.252H95.249V139.749H95.5623V134.252Z" fill="#625F6E"></path><path d="M77.7529 77.7344L95.4078 84.6048L104.084 81.6888L104.184 81.9867L95.454 84.9193L95.3484 84.9169L77.6401 78.0263L77.7529 77.7344Z" fill="#625F6E"></path><path d="M77.773 52.9646L77.623 53.2397L84.5008 56.9881L84.6508 56.713L77.773 52.9646Z" fill="#625F6E"></path><path d="M77.7827 35.2812L95.4115 46.849L104.061 41.9475L104.215 42.2205L95.4815 47.1683L95.3984 47.2169L95.3189 47.1635L77.6118 35.5435L77.7827 35.2812Z" fill="#625F6E"></path><path d="M95.5623 47.0327H95.249V52.5027H95.5623V47.0327Z" fill="#625F6E"></path><path d="M10.5232 126.971L10.5078 127.246L15.013 127.497L15.0284 127.223L10.5232 126.971Z" fill="#625F6E"></path><path d="M10.5321 112.799L10.4995 113.073L15.0051 113.607L15.0377 113.333L10.5321 112.799Z" fill="#625F6E"></path><path d="M10.5404 98.6411L15.0455 99.4576L14.9968 99.7282L10.4917 98.9117L10.5404 98.6411Z" fill="#625F6E"></path><path d="M14.8823 139.749V127.358V127.239L14.9998 127.221L26.545 125.503L26.5842 125.776L15.1577 127.477V139.749H14.8823Z" fill="#625F6E"></path><path d="M14.8823 123.436V113.473V113.372L14.9785 113.341L26.5237 109.696L26.6067 109.96L15.1577 113.574V123.436H14.8823Z" fill="#625F6E"></path><path d="M14.8823 108.464V99.5927V99.5061L14.9607 99.4693L26.5059 93.8984L26.6257 94.1465L15.1577 99.6793V108.464H14.8823Z" fill="#625F6E"></path><path d="M34.2271 124.522H33.9126V139.75H34.2271V124.522Z" fill="#625F6E"></path><path d="M29.0018 123.981L34.0635 124.363L55.3417 121.198L55.3879 121.508L34.092 124.677L34.0575 124.678L28.978 124.295L29.0018 123.981Z" fill="#625F6E"></path><path d="M34.2259 107.459H33.9126V119.701H34.2259V107.459Z" fill="#625F6E"></path><path d="M29.0137 106.491L34.0564 107.296L55.318 100.586L55.4118 100.885L34.117 107.606L34.0446 107.611L28.9639 106.8L29.0137 106.491Z" fill="#625F6E"></path><path d="M55.4269 81.8906L48.5126 85.1342L48.3892 84.8707L55.3023 81.626L55.4269 81.8906Z" fill="#625F6E"></path><path d="M55.3244 87.1545L48.4113 85.1429L48.3057 85.112V85.0028V79.0332H48.5988V84.8936L55.4063 86.8732L55.3244 87.1545Z" fill="#625F6E"></path><path d="M29.0233 89.0117L34.1064 90.2496L34.0328 90.5534L28.9497 89.3155L29.0233 89.0117Z" fill="#625F6E"></path><path d="M29.0336 71.5327L34.1737 73.2168L34.0775 73.5147L28.9375 71.8306L29.0336 71.5327Z" fill="#625F6E"></path><path d="M34.1488 73.2939L44.9416 76.8318L44.8953 76.9742L34.1025 73.4375L34.1488 73.2939Z" fill="#625F6E"></path><path d="M33.9126 101.303V90.402V90.3035L34.0016 90.2608L48.3833 83.3228L48.5186 83.6052L34.2259 90.5005V101.303H33.9126Z" fill="#625F6E"></path><path d="M33.9111 82.9054V73.3469V73.2615L33.9835 73.2152L55.2795 59.3901L55.4492 59.6536L34.2256 73.4312V82.9054H33.9111Z" fill="#625F6E"></path><path d="M133.846 104.946L133.835 97.2329H134.127L134.138 104.946H133.846Z" fill="#625F6E"></path><path d="M155.751 106.085L160.846 108.193L160.938 108.231V108.328V114.027V114.159L160.807 114.173L156.668 114.638L156.636 114.347L160.645 113.896V108.425L155.641 106.354L155.751 106.085Z" fill="#625F6E"></path><path d="M144.423 101.397L152.688 104.817L152.576 105.087L144.312 101.667L144.423 101.397Z" fill="#625F6E"></path><path d="M140.49 100.084L133.967 97.3854L129.402 98.3455L129.343 98.0583L133.951 97.0898L134.037 97.0981L140.601 99.8147L140.49 100.084Z" fill="#625F6E"></path><path d="M140.498 107.305L133.98 105.095L129.398 105.884L129.348 105.596L133.967 104.801L134.038 104.807L140.592 107.027L140.498 107.305Z" fill="#625F6E"></path><path d="M144.418 108.325L144.324 108.602L152.586 111.401L152.679 111.125L144.418 108.325Z" fill="#625F6E"></path><path d="M155.742 112.155L155.647 112.433L160.74 114.158L160.834 113.881L155.742 112.155Z" fill="#625F6E"></path><path d="M170.23 139.749L170.208 123.125L164.509 121.676L164.567 121.448L170.353 122.921L170.441 122.942V123.033L170.463 139.749H170.23Z" fill="#625F6E"></path><path d="M164.576 119.022L164.512 119.247L182.339 124.345L182.403 124.121L164.576 119.022Z" fill="#625F6E"></path><path d="M164.57 116.869L182.398 122.495L182.48 122.52V122.606V124.22V124.329L182.369 124.336L167.896 125.235L167.882 125.001L182.246 124.11V122.692L164.5 117.092L164.57 116.869Z" fill="#625F6E"></path><path d="M164.57 108.103L164.476 108.317L170.28 110.853L170.374 110.638L164.57 108.103Z" fill="#625F6E"></path><path d="M155.745 116.492L155.676 116.733L162.017 118.546L162.085 118.306L155.745 116.492Z" fill="#625F6E"></path><path d="M155.732 114.064L155.657 114.303L161.998 116.304L162.074 116.065L155.732 114.064Z" fill="#625F6E"></path><path d="M162.01 121.054L155.67 119.456L155.731 119.212L162.071 120.811L162.01 121.054Z" fill="#625F6E"></path><path d="M162.031 110.153L160.781 110.312L160.813 110.561L162.063 110.401L162.031 110.153Z" fill="#625F6E"></path><path d="M155.742 104.243L155.642 104.473L161.987 107.245L162.088 107.016L155.742 104.243Z" fill="#625F6E"></path><path d="M161.995 110.059L160.744 109.559L160.837 109.327L162.086 109.826L161.995 110.059Z" fill="#625F6E"></path><path d="M155.749 95.494L155.629 95.7139L161.979 99.1743L162.099 98.9544L155.749 95.494Z" fill="#625F6E"></path><path d="M158.27 91.2172L163.105 90.1835L163.156 90.1729L163.2 90.2025L164.593 91.1413L164.649 91.1781V91.2445L164.668 134.013L164.67 139.749H164.421L164.418 134.013L164.399 91.3122L163.105 90.4399L158.322 91.4629L158.27 91.2172Z" fill="#625F6E"></path><path d="M152.596 115.849L144.337 113.488L144.412 113.227L152.669 115.588L152.596 115.849Z" fill="#625F6E"></path><path d="M144.407 110.477L144.325 110.736L152.585 113.342L152.667 113.083L144.407 110.477Z" fill="#625F6E"></path><path d="M152.599 118.692L144.343 116.61L144.409 116.347L152.666 118.428L152.599 118.692Z" fill="#625F6E"></path><path d="M144.418 99.2881L144.31 99.5371L152.576 103.149L152.685 102.9L144.418 99.2881Z" fill="#625F6E"></path><path d="M144.423 89.3093L144.294 89.5469L152.566 94.0551L152.696 93.8175L144.423 89.3093Z" fill="#625F6E"></path><path d="M153.803 139.75L153.795 120.539L153.78 84.1113H154.051L154.066 120.539L154.073 139.75H153.803Z" fill="#625F6E"></path><path d="M148.669 85.2846L153.882 83.9791L153.94 83.9648L153.991 83.9993L155.762 85.1861L155.822 85.2276V85.3L155.837 120.952L155.845 139.75H155.574L155.566 120.952L155.552 85.3724L153.89 84.258L148.736 85.5492L148.669 85.2846Z" fill="#625F6E"></path><path d="M129.419 108.938L129.339 109.219L140.511 112.414L140.591 112.133L129.419 108.938Z" fill="#625F6E"></path><path d="M129.412 105.738L129.324 106.018L140.496 109.542L140.585 109.263L129.412 105.738Z" fill="#625F6E"></path><path d="M140.51 115.655L129.338 112.839L129.41 112.555L140.581 115.371L140.51 115.655Z" fill="#625F6E"></path><path d="M129.427 92.7246L129.311 92.9922L140.485 97.8742L140.602 97.6067L129.427 92.7246Z" fill="#625F6E"></path><path d="M131.45 97.8842L129.318 97.032L129.425 96.7603L131.558 97.6124L131.45 97.8842Z" fill="#625F6E"></path><path d="M129.437 81.1279L129.297 81.3843L140.473 87.4753L140.613 87.219L129.437 81.1279Z" fill="#625F6E"></path><path d="M142.233 76.1489H141.941V139.75H142.233V76.1489Z" fill="#625F6E"></path><path d="M136.411 77.712L142.038 76.009L142.105 75.9888L142.163 76.0279L144.436 77.5637L144.5 77.6076V77.6847L144.533 139.75H144.241L144.208 77.763L142.057 76.3092L136.495 77.9921L136.411 77.712Z" fill="#625F6E"></path><path d="M108.596 83.6123L108.47 83.8994L124.327 90.8269L124.452 90.5398L108.596 83.6123Z" fill="#625F6E"></path><path d="M124.334 95.054L108.479 88.7224L108.594 88.4316L124.449 94.7632L124.334 95.054Z" fill="#625F6E"></path><path d="M126.421 65.5215H126.107V139.75H126.421V65.5215Z" fill="#625F6E"></path><path d="M120.163 67.6797L126.202 65.3749L126.278 65.3452L126.346 65.3915L129.454 67.4767L129.524 67.523V67.6073L129.535 139.749H129.223L129.211 67.6903L126.239 65.6965L120.275 67.9728L120.163 67.6797Z" fill="#625F6E"></path><path d="M108.615 60.4775L124.474 70.2698L124.549 70.3161V70.4028V139.75H124.234V70.4894L108.451 60.7434L108.615 60.4775Z" fill="#625F6E"></path><path d="M108.611 64.2675L108.452 64.5376L124.31 73.8602L124.469 73.5901L108.611 64.2675Z" fill="#625F6E"></path><path d="M108.598 79.8124L108.466 80.0952L124.322 87.4925L124.454 87.2097L108.598 79.8124Z" fill="#625F6E"></path><path d="M124.348 107.795L108.495 103.263L108.581 102.96L124.435 107.494L124.348 107.795Z" fill="#625F6E"></path><path d="M108.58 99.1493L108.485 99.4492L124.34 104.451L124.434 104.151L108.58 99.1493Z" fill="#625F6E"></path><path d="M124.353 111.594L108.5 107.597L108.575 107.293L124.429 111.289L124.353 111.594Z" fill="#625F6E"></path><path d="M129.445 73.353L140.622 80.2543L140.692 80.2982V80.3789V139.75H140.399V80.4596L129.292 73.6011L129.445 73.353Z" fill="#625F6E"></path><path d="M129.442 76.5322L140.619 83.1035L140.472 83.3552L129.294 76.7838L129.442 76.5322Z" fill="#625F6E"></path><path d="M129.432 89.5494L129.309 89.814L140.483 95.0272L140.607 94.7626L129.432 89.5494Z" fill="#625F6E"></path><path d="M144.429 82.6182L152.703 87.7274L152.769 87.7677V87.8425V134.308V139.75H152.496V134.308V87.9184L144.287 82.8484L144.429 82.6182Z" fill="#625F6E"></path><path d="M144.428 85.354L152.701 90.2187L152.565 90.4525L144.291 85.5878L144.428 85.354Z" fill="#625F6E"></path><path d="M144.422 96.5547L152.69 100.412L152.575 100.657L144.307 96.8003L144.422 96.5547Z" fill="#625F6E"></path><path d="M155.755 89.6245L162.107 93.5469L162.166 93.5837V93.6537V122.424V139.75H161.915V122.424V93.7225L155.623 89.8381L155.755 89.6245Z" fill="#625F6E"></path><path d="M155.753 92.0249L162.104 95.7586L161.977 95.9746L155.626 92.2409L155.753 92.0249Z" fill="#625F6E"></path><path d="M155.747 101.85L162.094 104.811L161.988 105.038L155.641 102.077L155.747 101.85Z" fill="#625F6E"></path><path d="M164.588 95.0884L170.392 98.6737L170.448 98.7081V98.7734L170.449 100.741V100.841L170.351 100.856L164.547 101.806L164.51 101.574L170.215 100.641V98.8387L164.465 95.2878L164.588 95.0884Z" fill="#625F6E"></path><path d="M164.582 97.2193L164.464 97.4209L170.27 100.834L170.388 100.633L164.582 97.2193Z" fill="#625F6E"></path><path d="M164.579 105.98L170.384 108.689L170.451 108.72V108.794L170.452 110.762V110.865L170.349 110.878L164.546 111.583L164.519 111.351L170.218 110.658V108.869L164.481 106.192L164.579 105.98Z" fill="#625F6E"></path><path d="M163.028 139.75L163.021 122.68L163.006 90.3076H163.256L163.271 122.68L163.278 139.75H163.028Z" fill="#625F6E"></path><path d="M55.4749 43.284L22.9351 68.7195V72.8294H22.5791V68.6341V68.5475L22.6479 68.494L55.2565 43.0039L55.4749 43.284Z" fill="#625F6E"></path><path d="M87.2738 66.5821L83.7197 68.25L83.8705 68.5712L87.4245 66.9034L87.2738 66.5821Z" fill="#625F6E"></path><path d="M87.5255 55.3452V66.6388L121.277 83.133L121.121 83.4522L87.2691 66.9094L87.1694 66.8608V66.7492V55.3452H87.5255Z" fill="#625F6E"></path><path d="M77.6133 60.4255L87.262 55.1894L87.3486 55.1431L87.4341 55.1917L121.286 74.3206L121.378 74.3716V74.4749V83.294V83.4258L121.251 83.4637L117.88 84.4678L117.779 84.1283L121.022 83.1611V74.5769L87.3462 55.549L77.7818 60.7388L77.6133 60.4255Z" fill="#625F6E"></path><path d="M77.6914 133.933L87.3413 133.56H87.3543L121.207 134.922L121.192 135.277L87.346 133.914L77.7033 134.288L77.6914 133.933Z" fill="#625F6E"></path><path d="M87.5255 103.028H87.1694V133.736H87.5255V103.028Z" fill="#625F6E"></path><path d="M95.3961 135.629L82.3701 135.95L82.3753 136.159L95.4012 135.838L95.3961 135.629Z" fill="#625F6E"></path><path d="M10.3364 139.75V127.107V126.956L10.4872 126.931L26.5375 124.353L26.7428 124.319V124.527L26.7416 139.75H26.3867L26.3879 124.736L10.6925 127.258V139.75H10.3364Z" fill="#625F6E"></path><path d="M26.3891 107.719L10.6925 113.065V124.104L26.3879 121.026V107.72H26.3891V107.719ZM10.4575 112.77L26.5102 107.302L26.7452 107.223V107.471L26.744 121.171V121.317L26.6004 121.346L10.5489 124.493L10.3364 124.535V112.81L10.4575 112.769V112.77Z" fill="#625F6E"></path><path d="M55.5435 97.6621V115.672L55.3999 115.7L29.0245 120.872L28.8132 120.914V120.698L28.812 106.647V106.519L28.9319 106.479L55.3086 97.4948L55.5435 97.4141V97.6621ZM55.1875 115.379V97.9102L29.1669 106.773V120.481L55.1875 115.379Z" fill="#625F6E"></path><path d="M28.8147 139.75L28.8135 124.137V123.987L28.963 123.963L55.3373 119.724L55.5438 119.69V119.899V139.75H55.1878V120.107L29.1671 124.289L29.1695 139.75H28.8147Z" fill="#625F6E"></path><path d="M55.5433 75.4348V93.4207L55.4281 93.4646L29.0515 103.38L28.8117 103.471V103.214L28.8105 89.1637V89.0557L28.9055 89.0058L55.2834 75.2769L55.5433 75.1416V75.4348ZM55.1872 93.1751V75.7279L29.1642 89.2717V102.957L55.1872 93.1739V93.1751Z" fill="#625F6E"></path><path d="M26.3915 90.7147L10.6937 98.8846V109.902L26.3903 104.001V90.7159H26.3915V90.7147ZM10.4326 98.6188L26.4864 90.2637L26.7463 90.1284V104.123L26.7452 104.247L26.63 104.289L10.5774 110.324L10.3364 110.414V98.6686L10.4326 98.6188Z" fill="#625F6E"></path><path d="M55.543 53.2068V71.1738L55.4516 71.2248L29.0737 85.8842L28.8103 86.0301V85.7287L28.8091 71.6793V71.5868L28.885 71.5334L55.2641 53.0596L55.5442 52.8638V53.2044L55.543 53.2068ZM55.1869 70.9661V53.5486L29.1627 71.7731V85.4296L55.1869 70.9673V70.9661Z" fill="#625F6E"></path><path d="M26.4388 86.9962V73.6233L10.6473 84.6831V95.7726L26.4388 86.9962ZM26.7023 73.3717V87.0733L26.7011 87.1505L26.6335 87.1885L10.5796 96.1108L10.3838 96.22V84.5478L10.4408 84.5087L26.4958 73.2649L26.7023 73.1201V73.3729V73.3717Z" fill="#625F6E"></path><path d="M1.32373 128.404L8.27958 127.286L8.48608 127.252V127.461V139.749H8.13004V127.669L1.37832 128.754L1.32373 128.404Z" fill="#625F6E"></path><path d="M1.29439 115.891L8.25143 113.522L8.48642 113.441V113.691V124.752V124.899L8.34163 124.926L1.52938 126.262V128.409L8.3167 128.731L8.30009 129.086L1.34305 128.756L1.17334 128.748V128.579V126.116V125.969L1.31694 125.942L8.13038 124.606V113.939L1.40833 116.228L1.29439 115.891Z" fill="#625F6E"></path><path d="M1.26947 103.389L8.22651 99.7676L8.48642 99.6323V99.9255V110.988V111.111L8.37011 111.154L1.52938 113.726V115.9L8.32501 116.583L8.29059 116.937L1.33356 116.237L1.17334 116.22V116.06V113.603V113.48L1.28846 113.437L8.13038 110.865V100.219L1.43325 103.704L1.26947 103.389Z" fill="#625F6E"></path><path d="M1.25048 90.888L8.20633 86.0161L8.48642 85.8203V86.1609V97.2231V97.3275L8.39385 97.3786L1.52938 101.193V103.394L8.33451 104.441L8.28229 104.793L1.32525 103.722L1.17334 103.699V103.546V101.09V100.985L1.26591 100.934L8.13038 97.1199V86.5027L1.45343 91.1787L1.25048 90.888Z" fill="#625F6E"></path><path d="M108.724 79.1572H108.349V108.237H108.724V79.1572Z" fill="#625F6E"></path><path d="M108.729 134.589H108.354V139.749H108.729V134.589Z" fill="#625F6E"></path><path d="M104.044 58.0453L77.6043 41.7173L77.52 41.6651V22.6003V22.249L77.8025 22.4567L104.243 41.9393L104.316 41.9927V42.0829L104.314 57.8934V58.2115L104.044 58.0442V58.0453ZM77.8749 41.4681L103.96 57.5766V42.1731L77.8749 22.9516V41.4681Z" fill="#625F6E"></path><path d="M77.52 139.75V94.0571L77.7467 94.1224L104.182 101.681L104.31 101.718V107.156H103.955V101.986L77.8761 94.5295V139.751H77.52V139.75ZM103.951 139.75H104.306V134.412H103.952V139.75H103.951Z" fill="#625F6E"></path><path d="M77.52 89.5789V70.0156L77.7692 70.1248L104.206 81.6748L104.313 81.7211V97.9209L104.312 98.163L104.081 98.0906L77.6458 89.7486L77.5212 89.7094V89.5789H77.52ZM77.8761 70.558V89.4483L103.956 97.6776V81.9537L77.8761 70.558Z" fill="#625F6E"></path><path d="M103.96 64.8314V61.9261L77.8761 46.5914V65.4604L103.957 77.6298L103.958 77.0637H104.312V77.9076V78.1865L104.06 78.069L77.6233 65.7345L77.52 65.6859V65.5731V46.2805V45.9707L77.7882 46.1285L104.227 61.6709L104.314 61.7231V61.824L104.313 64.8314H103.96Z" fill="#625F6E"></path><path d="M1.37832 90.8994L8.33536 92.3402L8.28076 92.606L1.32373 91.1653L1.37832 90.8994Z" fill="#625F6E"></path><path d="M8.19007 72.4524L55.248 31.1493L55.5435 30.8906V31.2835V48.8434V48.9324L55.4699 48.987L1.45497 88.7199L1.24609 88.4327L55.1874 48.7544V31.6751L8.42387 72.7195L8.19007 72.4524Z" fill="#625F6E"></path><path d="M1.43959 88.6306L0.113934 89.6049L0 89.4506L1.32566 88.4751L1.43959 88.6306Z" fill="#625F6E"></path><path d="M18.8146 75.8716L8.25443 72.7658L8.11914 72.7266V72.5854V63.104L8.17492 62.9711L70.8001 0.243823L70.9235 0.121582L71.0553 0.233142L108.652 31.9481L108.718 32.0038V32.0917L108.722 67.3171H108.347L108.343 32.1795L70.9449 0.631909L8.49654 63.1811V72.4453L18.9202 75.5108L18.8146 75.8716Z" fill="#625F6E"></path><path d="M71.1431 0.376953H70.7241V139.75H71.1431V0.376953Z" fill="#625F6E"></path><path d="M104.111 134.763L84.8313 134.012L84.6592 134.005V133.835V103.621V103.481L84.7969 103.449L87.3069 102.857H87.39L121.241 111.179L121.378 111.212V111.351V135.1V135.273L121.203 135.277L108.545 135.588L108.536 135.234L121.022 134.927V111.49L87.3461 103.212L85.0152 103.762V133.664L104.123 134.408L104.111 134.763Z" fill="#625F6E"></path><path d="M85.0152 56.7085V67.8158L118.901 83.8435L118.749 84.164L84.7613 68.0887L84.6592 68.0401V67.9285V56.7085H85.0152Z" fill="#625F6E"></path>', 316)
  ])]);
}
const db = /* @__PURE__ */ Ye(Cc, [["render", $c]]);
function Mc(e) {
  return {
    dropzoneClasses: i(() => [
      "flex h-full w-full flex-col items-center justify-center gap-2.5 rounded-2xl border border-dashed p-5 text-center transition-colors duration-200",
      e.isDisabled ? "cursor-not-allowed border-border-border-300 bg-background-light-100 opacity-70" : "cursor-pointer border-border-border-300 bg-background-light-100 hover:border-blue-600 hover:bg-blue-50"
    ]),
    emptyViewClasses: "flex h-full w-full flex-col items-center justify-center gap-2 rounded-2xl border border-border-border-200 bg-gray-50 text-gray-400",
    previewFrameClasses: "relative h-full w-full overflow-hidden rounded-2xl border border-border-border-200",
    errorCardClasses: "flex h-full w-full flex-col items-center justify-center gap-2.5 rounded-2xl border border-dashed border-red-500 bg-red-50 p-5 text-center",
    cropStageClasses: "mx-auto rounded-2xl border-2 border-blue-700 transition-[width,height,border-color] duration-200 ease-in-out motion-reduce:transition-none",
    cropClipClasses: "pointer-events-none absolute inset-0 overflow-hidden rounded-[14px]",
    cropImageClasses: "pointer-events-none absolute touch-none select-none",
    cropMaskRectClasses: "absolute bg-black/60",
    cropBoxClasses: "absolute cursor-move touch-none border-2 border-white focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-offset-1 focus-visible:outline-none",
    cropHandleClasses: "absolute flex h-7 w-7 -translate-x-1/2 -translate-y-1/2 items-center justify-center border-none bg-transparent p-0 focus-visible:rounded-full focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-offset-1 focus-visible:outline-none",
    cropHandleDotClasses: "h-[13px] w-[13px] rounded-full border-2 border-blue-700 bg-white shadow-sm",
    cropPillClasses: "pointer-events-none absolute rounded-md bg-black/70 px-2 py-1 type-caption whitespace-nowrap text-white",
    cropActionBarClasses: "mt-3 flex items-center justify-between gap-4"
  };
}
const Vc = {
  "image/jpeg": "jpg"
};
function Us(e, a) {
  const t = Vc[e.type] ?? e.type.split("/")[1] ?? "png";
  return new File([e], `${a}.${t}`, { type: e.type });
}
const je = 32, Sc = 400, Bc = 250, Ec = 8, Dc = 24, Fc = [
  [16, 10],
  [1, 1],
  [4, 3],
  [3, 2],
  [16, 9],
  [5, 4]
], Rc = [
  { id: "nw", corner: !0, label: "top-left corner", cursorClass: "cursor-nwse-resize" },
  { id: "n", corner: !1, label: "top edge", cursorClass: "cursor-ns-resize" },
  { id: "ne", corner: !0, label: "top-right corner", cursorClass: "cursor-nesw-resize" },
  { id: "e", corner: !1, label: "right edge", cursorClass: "cursor-ew-resize" },
  { id: "se", corner: !0, label: "bottom-right corner", cursorClass: "cursor-nwse-resize" },
  { id: "s", corner: !1, label: "bottom edge", cursorClass: "cursor-ns-resize" },
  { id: "sw", corner: !0, label: "bottom-left corner", cursorClass: "cursor-nesw-resize" },
  { id: "w", corner: !1, label: "left edge", cursorClass: "cursor-ew-resize" }
];
function Ie(e, a, t) {
  return Math.min(t, Math.max(a, e));
}
function Ic(e, a, t, s) {
  const o = Math.min(t / e, s / a);
  return { displayW: e * o, displayH: a * o };
}
function Tc(e, a, t) {
  if (!t) {
    const u = e * 0.86, b = a * 0.86;
    return { x: (e - u) / 2, y: (a - b) / 2, w: u, h: b };
  }
  const s = e / a;
  let o, d;
  return s > t ? (d = a, o = d * t) : (o = e, d = o / t), { x: (e - o) / 2, y: (a - d) / 2, w: o, h: d };
}
function Ac(e, a) {
  const t = e / a;
  for (const [s, o] of Fc)
    if (Math.abs(t - s / o) < 0.02) return `${s}:${o}`;
  return `${t.toFixed(2)}:1`;
}
function El(e, a, t, s, o, d, u) {
  const b = u ?? s.w / s.h;
  let { x: g, y: h, w: p, h: f } = s;
  switch (e) {
    case "e": {
      p = Ie(s.w + a, je, o - s.x);
      break;
    }
    case "w": {
      const y = Ie(s.x + a, 0, s.x + s.w - je);
      p = s.x + s.w - y, g = y;
      break;
    }
    case "n": {
      const y = Ie(s.y + t, 0, s.y + s.h - je);
      f = s.y + s.h - y, h = y;
      break;
    }
    case "s": {
      f = Ie(s.h + t, je, d - s.y);
      break;
    }
    case "se": {
      p = Ie(s.w + a, je, o - s.x), f = Ie(s.h + t, je, d - s.y), u && (f = Ie(p / b, je, d - s.y), p = f * b);
      break;
    }
    case "ne": {
      p = Ie(s.w + a, je, o - s.x);
      const y = Ie(s.y + t, 0, s.y + s.h - je);
      u ? (f = Ie(p / b, je, s.y + s.h), p = f * b, h = s.y + s.h - f) : (f = s.y + s.h - y, h = y);
      break;
    }
    case "sw": {
      const y = Ie(s.x + a, 0, s.x + s.w - je);
      f = Ie(s.h + t, je, d - s.y), u ? (p = Ie(f * b, je, s.x + s.w), f = p / b, g = s.x + s.w - p) : (p = s.x + s.w - y, g = y);
      break;
    }
    case "nw": {
      const y = Ie(s.x + a, 0, s.x + s.w - je), w = Ie(s.y + t, 0, s.y + s.h - je);
      p = s.x + s.w - y, f = s.y + s.h - w, u ? (p = Ie(p, je, s.x + s.w), f = Ie(p / b, je, s.y + s.h), p = f * b, g = s.x + s.w - p, h = s.y + s.h - f) : (g = y, h = w);
      break;
    }
  }
  return { x: g, y: h, w: p, h: f };
}
function Oc(e, a, t) {
  const s = A(!1), o = A(null), d = A(null), u = A(0), b = A(0), g = A(0), h = A(0), p = il({ x: 0, y: 0, w: 0, h: 0 }), f = il({ x: 0, y: 0, w: 0, h: 0 }), y = A(!1), w = A(""), S = A(null);
  let k = null;
  const x = i(
    () => e.lockAspectRatio && e.aspectRatio ? e.aspectRatio : null
  ), $ = i(() => o.value?.src ?? "");
  function D(I = f) {
    if (!p.w) return;
    const Y = u.value / p.w;
    w.value = `Crop area ${Math.round(I.w * Y)} by ${Math.round(I.h * Y)} pixels`;
  }
  function E(I) {
    f.x = I.x, f.y = I.y, f.w = I.w, f.h = I.h;
  }
  function R() {
    const I = Tc(p.w, p.h, e.aspectRatio ?? null);
    return {
      x: I.x + p.x,
      y: I.y + p.y,
      w: I.w,
      h: I.h
    };
  }
  function V(I, Y) {
    const be = a.value?.getBoundingClientRect(), J = be && be.width > 0 ? be.width : Sc, Q = be && be.height > 0 ? be.height : Bc, ue = Ic(Y.naturalWidth, Y.naturalHeight, J, Q);
    p.w = ue.displayW, p.h = ue.displayH, p.x = (J - ue.displayW) / 2, p.y = (Q - ue.displayH) / 2, E(R()), o.value = Y, d.value = I, u.value = Y.naturalWidth, b.value = Y.naturalHeight, g.value = J, h.value = Q, s.value = !0, D(), Fe(() => S.value?.focus());
  }
  function Z() {
    E(R()), D();
  }
  function G() {
    o.value && URL.revokeObjectURL(o.value.src), s.value = !1, o.value = null, d.value = null, k = null, w.value = "";
  }
  function z(I) {
    if (!k) return;
    const Y = I.clientX - k.startX, be = I.clientY - k.startY;
    if (k.mode === "move") {
      const J = k.box;
      f.x = Ie(J.x + Y, 0, g.value - J.w), f.y = Ie(J.y + be, 0, h.value - J.h);
    } else
      E(
        El(
          k.mode,
          Y,
          be,
          k.box,
          g.value,
          h.value,
          x.value
        )
      );
  }
  function U() {
    globalThis.removeEventListener("pointermove", z), globalThis.removeEventListener("pointerup", U), globalThis.removeEventListener("pointercancel", U), k = null, y.value = !1, D();
  }
  function ae(I, Y) {
    k = { mode: I, startX: Y.clientX, startY: Y.clientY, box: { ...f } }, y.value = !0, globalThis.addEventListener("pointermove", z), globalThis.addEventListener("pointerup", U), globalThis.addEventListener("pointercancel", U);
  }
  function B(I) {
    I.target.closest("[data-handle]") || (I.preventDefault(), ae("move", I));
  }
  function le(I) {
    I.stopPropagation(), I.preventDefault();
    const Y = I.currentTarget.dataset.handle;
    ae(Y, I);
  }
  function O(I) {
    const Y = I.shiftKey ? Dc : Ec;
    switch (I.key) {
      case "ArrowLeft":
        return { dx: -Y, dy: 0 };
      case "ArrowRight":
        return { dx: Y, dy: 0 };
      case "ArrowUp":
        return { dx: 0, dy: -Y };
      case "ArrowDown":
        return { dx: 0, dy: Y };
      default:
        return null;
    }
  }
  function j(I) {
    const Y = O(I);
    Y && (I.preventDefault(), f.x = Ie(f.x + Y.dx, 0, g.value - f.w), f.y = Ie(f.y + Y.dy, 0, h.value - f.h), D());
  }
  function _(I) {
    const Y = O(I);
    if (!Y) return;
    I.preventDefault();
    const be = I.currentTarget.dataset.handle;
    E(
      El(
        be,
        Y.dx,
        Y.dy,
        f,
        g.value,
        h.value,
        x.value
      )
    ), D();
  }
  const ne = i(() => {
    const I = Math.max(h.value - (f.y + f.h), 0), Y = Math.max(g.value - (f.x + f.w), 0);
    return [
      {
        id: "t",
        style: { left: "0px", top: "0px", width: `${g.value}px`, height: `${f.y}px` }
      },
      {
        id: "b",
        style: {
          left: "0px",
          top: `${f.y + f.h}px`,
          width: `${g.value}px`,
          height: `${I}px`
        }
      },
      {
        id: "l",
        style: { left: "0px", top: `${f.y}px`, width: `${f.x}px`, height: `${f.h}px` }
      },
      {
        id: "r",
        style: {
          left: `${f.x + f.w}px`,
          top: `${f.y}px`,
          width: `${Y}px`,
          height: `${f.h}px`
        }
      }
    ];
  }), P = i(() => ({
    left: `${f.x}px`,
    top: `${f.y}px`,
    width: `${f.w}px`,
    height: `${f.h}px`
  })), ce = i(() => {
    const I = !!x.value, Y = {
      nw: { x: f.x, y: f.y },
      n: { x: f.x + f.w / 2, y: f.y },
      ne: { x: f.x + f.w, y: f.y },
      e: { x: f.x + f.w, y: f.y + f.h / 2 },
      se: { x: f.x + f.w, y: f.y + f.h },
      s: { x: f.x + f.w / 2, y: f.y + f.h },
      sw: { x: f.x, y: f.y + f.h },
      w: { x: f.x, y: f.y + f.h / 2 }
    };
    return Rc.filter((be) => !I || be.corner).map((be) => ({
      ...be,
      style: { left: `${Y[be.id].x}px`, top: `${Y[be.id].y}px` }
    }));
  }), W = i(() => {
    if (!p.w) return "";
    const I = u.value / p.w, Y = Math.round(f.w * I), be = Math.round(f.h * I);
    return `${Y.toLocaleString()} × ${be.toLocaleString()} px · ${Ac(Y, be)}`;
  }), H = i(() => f.y > 28), fe = i(() => ({
    left: `${p.x}px`,
    top: `${p.y}px`,
    width: `${p.w}px`,
    height: `${p.h}px`
  }));
  function $e() {
    return new Promise((I) => {
      const Y = o.value, be = d.value;
      if (!Y || !be || !p.w) {
        G(), I(null);
        return;
      }
      const J = u.value / p.w, Q = b.value / p.h, ue = (f.x - p.x) * J, K = (f.y - p.y) * Q, ee = f.w * J, he = f.h * Q, ge = document.createElement("canvas");
      ge.width = Math.max(1, Math.round(ee)), ge.height = Math.max(1, Math.round(he));
      const N = ge.getContext("2d");
      if (!N) {
        G(), I(null);
        return;
      }
      N.fillStyle = t.value ?? "#f3f4f6", N.fillRect(0, 0, ge.width, ge.height), N.drawImage(Y, ue, K, ee, he, 0, 0, ge.width, ge.height);
      const Le = be.type && be.type.startsWith("image/") ? be.type : "image/jpeg";
      ge.toBlob(
        (Me) => {
          if (G(), !Me) {
            I(null);
            return;
          }
          const ye = be.name.replace(/\.[^./]+$/, "");
          I(Us(Me, ye));
        },
        Le,
        0.92
      );
    });
  }
  function te() {
    G();
  }
  function we() {
    globalThis.removeEventListener("pointermove", z), globalThis.removeEventListener("pointerup", U), globalThis.removeEventListener("pointercancel", U), s.value && G();
  }
  return {
    isCropping: s,
    dragging: y,
    isRatioLocked: i(() => !!x.value),
    displayW: g,
    displayH: h,
    imageRect: p,
    imageStyle: fe,
    crop: f,
    imageSrc: $,
    pendingFile: d,
    liveMsg: w,
    boxRef: S,
    maskRects: ne,
    boxStyle: P,
    handles: ce,
    dimensionLabel: W,
    pillAbove: H,
    startCrop: V,
    resetCrop: Z,
    confirmCrop: $e,
    cancelCrop: te,
    onBoxPointerDown: B,
    onHandlePointerDown: le,
    onBoxKeyDown: j,
    onHandleKeyDown: _,
    dispose: we
  };
}
const zc = 128, Oa = 245, Hc = 16, Zc = (e, a, t, s) => e === 0 || a === 0 || e === t - 1 || a === s - 1, Pc = (e, a, t) => e > Oa && a > Oa && t > Oa;
function Gs(e) {
  const a = e.naturalWidth, t = e.naturalHeight;
  if (!a || !t) return null;
  const s = Math.min(1, zc / Math.max(a, t)), o = Math.max(1, Math.round(a * s)), d = Math.max(1, Math.round(t * s)), u = document.createElement("canvas");
  u.width = o, u.height = d;
  const b = u.getContext("2d");
  if (!b) return null;
  b.drawImage(e, 0, 0, o, d);
  let g;
  try {
    g = b.getImageData(0, 0, o, d).data;
  } catch {
    return null;
  }
  let h = 0, p = 0, f = 0, y = 0;
  for (let w = 0; w < d; w++)
    for (let S = 0; S < o; S++) {
      if (!Zc(S, w, o, d)) continue;
      const k = (w * o + S) * 4, x = g[k + 3], $ = g[k], D = g[k + 1], E = g[k + 2];
      x < Hc || Pc($, D, E) || (h += $, p += D, f += E, y += 1);
    }
  return y ? `rgb(${Math.round(h / y)}, ${Math.round(p / y)}, ${Math.round(f / y)})` : null;
}
function jc() {
  const e = A(null);
  return { tint: e, compute: (s) => {
    e.value = Gs(s);
  }, reset: () => {
    e.value = null;
  } };
}
const Nc = 0.02;
function qc(e, a, t) {
  return new Promise((s) => {
    const o = a.naturalWidth, d = a.naturalHeight;
    if (!o || !d) {
      s(null);
      return;
    }
    const u = o / d;
    if (Math.abs(u - t) < Nc) {
      s(null);
      return;
    }
    let b, g, h, p;
    u > t ? (b = o, g = Math.round(o / t), h = 0, p = Math.round((g - d) / 2)) : (g = d, b = Math.round(d * t), h = Math.round((b - o) / 2), p = 0);
    const f = document.createElement("canvas");
    f.width = b, f.height = g;
    const y = f.getContext("2d");
    if (!y) {
      s(null);
      return;
    }
    y.fillStyle = Gs(a) ?? "#f3f4f6", y.fillRect(0, 0, b, g), y.drawImage(a, h, p, o, d);
    const w = e.type && e.type.startsWith("image/") ? e.type : "image/jpeg";
    f.toBlob(
      (S) => {
        if (!S) {
          s(null);
          return;
        }
        const k = e.name.replace(/\.[^./]+$/, "");
        s(Us(S, k));
      },
      w,
      0.92
    );
  });
}
const Uc = ["id", "accept", "required", "disabled"], Gc = ["data-testid"], _c = { class: "inline-flex h-12 w-12 items-center justify-center rounded-xl bg-blue-50 text-blue-600" }, Wc = { class: "text-txt-600 type-body-2 mt-0.5 block" }, Kc = ["src", "alt"], Yc = { class: "absolute inset-0 flex flex-col items-center justify-center gap-3 text-white" }, Xc = { class: "type-body-1-strong" }, Jc = { class: "absolute inset-x-0 bottom-0 h-[5px] overflow-hidden bg-white/25" }, Qc = {
  key: 0,
  class: "image-upload-indeterminate h-full bg-blue-600"
}, eu = ["src", "alt", "data-testid"], tu = {
  key: 0,
  class: "absolute top-2.5 left-2.5 flex gap-1.5"
}, au = {
  key: 1,
  class: "absolute top-2.5 right-2.5 flex gap-1.5"
}, lu = {
  key: 2,
  class: "type-body-2 absolute inset-x-0 bottom-0 flex justify-between gap-2 bg-gradient-to-t from-black/70 to-transparent px-3 pt-5 pb-2 text-white"
}, su = { class: "overflow-hidden text-ellipsis whitespace-nowrap" }, nu = {
  key: 0,
  class: "flex-none opacity-85"
}, ou = ["src"], ru = ["data-handle", "aria-label"], iu = { class: "absolute bottom-2.5 left-2.5 flex gap-1.5" }, du = { class: "inline-flex h-11 w-11 items-center justify-center rounded-xl bg-red-100 text-red-600" }, cu = {
  role: "alert",
  class: "type-body-1 max-w-[280px] text-red-700"
}, uu = {
  key: 6,
  class: "pointer-events-none absolute inset-0 flex items-center justify-center rounded-2xl border-2 border-blue-600 bg-blue-600/10"
}, fu = {
  role: "status",
  "aria-live": "polite",
  class: "sr-only"
}, bu = ["data-testid"], pu = ["src", "alt"], hu = {
  key: 0,
  class: "type-body-1 flex gap-2.5 text-white/90"
}, gu = {
  key: 0,
  class: "opacity-60"
}, mu = /* @__PURE__ */ X({
  __name: "ImageUpload",
  props: {
    id: {},
    variant: { default: "card" },
    modelValue: { default: null },
    src: {},
    class: { type: [Boolean, null, String, Object, Array] },
    frameClass: { type: [Boolean, null, String, Object, Array], default: "aspect-[16/10]" },
    isReadOnly: { type: Boolean, default: !1 },
    isDisabled: { type: Boolean, default: !1 },
    accept: { default: "image/jpeg,image/png,image/webp" },
    maxSizeMb: { default: 10 },
    isUploading: { type: Boolean, default: !1 },
    progress: { default: 0 },
    indeterminate: { type: Boolean, default: !1 },
    errorMessage: {},
    fileName: {},
    fileSize: {},
    constraintLabel: { default: "JPG, PNG or WebP · max 10 MB" },
    alt: { default: "" },
    enableCrop: { type: Boolean, default: !1 },
    aspectRatio: { default: null },
    lockAspectRatio: { type: Boolean, default: !0 },
    padToAspectRatio: { type: Boolean, default: !1 },
    isRequired: { type: Boolean, default: !1 },
    requiredMessage: {}
  },
  emits: ["update:modelValue", "select", "remove", "retry", "error", "croppingChange"],
  setup(e, { emit: a }) {
    const t = e, s = a, {
      dropzoneClasses: o,
      emptyViewClasses: d,
      previewFrameClasses: u,
      errorCardClasses: b,
      cropStageClasses: g,
      cropClipClasses: h,
      cropImageClasses: p,
      cropMaskRectClasses: f,
      cropBoxClasses: y,
      cropHandleClasses: w,
      cropHandleDotClasses: S,
      cropPillClasses: k,
      cropActionBarClasses: x
    } = Mc(t), $ = A(null), D = A(null), E = A(!1), R = A(!1), V = A(!1), Z = A(""), G = A(null), { tint: z, compute: U, reset: ae } = jc(), {
      isCropping: B,
      displayW: le,
      displayH: O,
      imageStyle: j,
      crop: _,
      imageSrc: ne,
      pendingFile: P,
      liveMsg: ce,
      boxRef: W,
      maskRects: H,
      boxStyle: fe,
      handles: $e,
      dimensionLabel: te,
      pillAbove: we,
      startCrop: I,
      resetCrop: Y,
      confirmCrop: be,
      cancelCrop: J,
      onBoxPointerDown: Q,
      onHandlePointerDown: ue,
      onBoxKeyDown: K,
      onHandleKeyDown: ee,
      dispose: he
    } = Oc(t, D, z), ge = A("");
    Se(
      () => t.modelValue,
      (pe) => {
        if (pe instanceof File) {
          const de = new FileReader(), De = () => t.modelValue === pe;
          de.addEventListener("load", (Qe) => {
            De() && (ge.value = Qe.target?.result ?? "");
          }), de.readAsDataURL(pe);
        } else
          ge.value = "";
      },
      { immediate: !0 }
    );
    const N = A(0), Le = i(() => N.value > 0);
    let Me = 0;
    const ye = i(() => B.value || Le.value);
    Se(ye, (pe) => s("croppingChange", pe));
    const Re = i(() => ge.value || t.src || ""), Zt = i(() => !!Re.value), ze = i(() => !t.isReadOnly && !t.isDisabled), at = i(() => t.enableCrop && !!G.value);
    Se(
      Re,
      (pe) => {
        if (!pe) {
          ae();
          return;
        }
        const de = new Image(), De = () => Re.value === pe;
        de.addEventListener("load", () => De() && U(de), { once: !0 }), de.addEventListener("error", () => De() && ae(), { once: !0 }), de.src = pe;
      },
      { immediate: !0 }
    );
    const Xe = i(() => ({
      backgroundColor: z.value ?? "#f3f4f6"
    })), lt = i(
      () => `${t.constraintLabel}${t.isRequired ? " (Required)" : ""}`
    ), Pe = i(() => B.value ? "cropping" : t.errorMessage ? "error" : t.isUploading ? "uploading" : Zt.value ? "uploaded" : "empty"), vt = i(() => ({
      width: `${le.value}px`,
      height: `${O.value}px`
    })), Jt = i(() => ({
      left: `${_.x}px`,
      top: we.value ? `${_.y - 28}px` : `${_.y + _.h + 8}px`
    })), yt = i(() => ({ width: `${le.value}px` })), it = i(() => t.fileName || t.modelValue?.name || ""), Pt = i(() => t.fileSize ?? t.modelValue?.size ?? 0), jt = (pe) => {
      if (!pe) return "";
      const de = pe / 1048576;
      return de >= 1 ? `${de.toFixed(1)} MB` : `${Math.max(1, Math.round(pe / 1024))} KB`;
    }, xt = i(() => jt(Pt.value)), Nt = i(() => `${Math.round(Math.min(100, Math.max(0, t.progress)))}%`), Qt = (pe) => {
      const de = t.accept?.trim();
      if (!de) return !0;
      const De = pe.type.toLowerCase(), Qe = pe.name.toLowerCase();
      return de.split(",").map((Ge) => Ge.trim().toLowerCase()).filter(Boolean).some((Ge) => Ge.endsWith("/*") ? De.startsWith(Ge.slice(0, -1)) : Ge.startsWith(".") ? Qe.endsWith(Ge) : De === Ge);
    }, Dt = () => {
      $.value && ($.value.value = "");
    }, dt = A(!1);
    let Ft;
    const wt = () => {
      dt.value = !1, globalThis.removeEventListener("focus", wt), clearTimeout(Ft);
    }, Rt = () => {
      !ze.value || dt.value || (dt.value = !0, globalThis.addEventListener("focus", wt, { once: !0 }), Ft = setTimeout(wt, 2e3), $.value?.click());
    }, qt = (pe, de, De, Qe = () => !0) => {
      Z.value && URL.revokeObjectURL(Z.value);
      const Ge = URL.createObjectURL(pe);
      Z.value = Ge;
      const ha = new Image();
      ha.addEventListener(
        "load",
        () => {
          Z.value === Ge && (Z.value = ""), de(ha);
        },
        { once: !0 }
      ), ha.addEventListener(
        "error",
        () => {
          Z.value === Ge && (Z.value = ""), URL.revokeObjectURL(Ge), Qe() && s("error", { reason: "unreadable", file: pe }), De?.();
        },
        { once: !0 }
      ), ha.src = Ge;
    }, Ve = (pe) => {
      if (!Qt(pe)) {
        s("error", { reason: "type", file: pe });
        return;
      }
      if (t.maxSizeMb && pe.size > t.maxSizeMb * 1024 * 1024) {
        s("error", { reason: "size", file: pe });
        return;
      }
      if (!t.enableCrop) {
        G.value = null, s("update:modelValue", pe), s("select", pe);
        return;
      }
      const de = ++Me;
      N.value += 1, qt(
        pe,
        (De) => {
          if (de !== Me) {
            N.value -= 1;
            return;
          }
          G.value = pe, qe(pe, De, de);
        },
        () => {
          N.value -= 1;
        },
        () => de === Me
      );
    }, qe = async (pe, de, De) => {
      try {
        const Qe = t.padToAspectRatio && t.aspectRatio ? await qc(pe, de, t.aspectRatio) : null;
        if (URL.revokeObjectURL(de.src), De !== Me) return;
        const Ge = Qe ?? pe;
        s("update:modelValue", Ge), s("select", Ge);
      } finally {
        N.value -= 1;
      }
    }, ea = () => {
      const pe = G.value;
      !at.value || !pe || qt(pe, (de) => I(pe, de));
    }, me = (pe) => {
      const de = pe.target.files?.[0];
      de && Ve(de), Dt();
    }, ve = (pe) => {
      pe.preventDefault(), !(!ze.value || Pe.value === "cropping") && (E.value || (E.value = !0));
    }, Ue = (pe) => {
      pe.preventDefault(), E.value = !1;
    }, ct = (pe) => {
      if (pe.preventDefault(), E.value = !1, !ze.value || Pe.value === "cropping") return;
      const de = pe.dataTransfer?.files?.[0];
      de && Ve(de);
    }, ke = () => {
      ze.value && (Dt(), Me += 1, G.value = null, s("update:modelValue", null), s("remove"));
    }, Ke = () => {
      s("retry"), Rt();
    }, Je = () => {
      t.isDisabled || Re.value && (R.value = !0);
    }, ta = () => {
      R.value = !1;
    }, aa = async () => {
      if (V.value) return;
      V.value = !0;
      const pe = P.value;
      try {
        const de = await be();
        de ? (G.value = pe, s("update:modelValue", de), s("select", de)) : pe && s("error", { reason: "unreadable", file: pe });
      } finally {
        V.value = !1;
      }
    }, Da = (pe) => {
      pe.key === "Escape" && (R.value ? ta() : Pe.value === "cropping" && J());
    }, pn = i(() => R.value || Pe.value === "cropping");
    return Se(pn, (pe) => {
      globalThis.window !== void 0 && (pe ? globalThis.addEventListener("keydown", Da) : globalThis.removeEventListener("keydown", Da));
    }), Mt(() => {
      globalThis.window !== void 0 && globalThis.removeEventListener("keydown", Da), Z.value && URL.revokeObjectURL(Z.value), globalThis.removeEventListener("focus", wt), clearTimeout(Ft), he();
    }), (pe, de) => (n(), c("div", {
      class: r(l(q)("w-full", t.class)),
      "data-scroll-anchor": ""
    }, [
      m("input", {
        id: e.id,
        ref_key: "fileInput",
        ref: $,
        type: "file",
        class: "hidden",
        accept: e.accept,
        required: e.isRequired,
        disabled: !ze.value,
        onChange: me
      }, null, 40, Uc),
      m("div", {
        ref_key: "stageEl",
        ref: D,
        class: r(["relative", Pe.value === "cropping" ? l(g) : ["w-full", e.frameClass]]),
        style: Ee(Pe.value === "cropping" ? { ...vt.value, ...Xe.value } : void 0),
        onDragover: ve,
        onDragleave: Ue,
        onDrop: ct
      }, [
        Pe.value === "empty" && ze.value ? (n(), c("button", {
          key: 0,
          type: "button",
          class: r(l(o)),
          "data-testid": `imageupload-${e.id}-dropzone`,
          onClick: Rt
        }, [
          T(pe.$slots, "placeholder", {}, () => [
            m("span", _c, [
              L(l(vs), { class: "h-6 w-6" })
            ])
          ], !0),
          m("span", null, [
            de[5] || (de[5] = m("span", { class: "text-txt-800 type-body-1-strong block" }, [
              ie(" Drag an image here, or "),
              m("span", { class: "text-blue-600" }, "browse")
            ], -1)),
            m("span", Wc, C(lt.value), 1)
          ])
        ], 10, Gc)) : Pe.value === "empty" && !ze.value ? (n(), c("div", {
          key: 1,
          class: r(l(d))
        }, [
          L(l(li), { class: "h-7 w-7" }),
          de[6] || (de[6] = m("span", { class: "type-body-1-strong" }, "No image added", -1))
        ], 2)) : Pe.value === "uploading" ? (n(), c("div", {
          key: 2,
          class: r([l(u), "bg-gray-900"])
        }, [
          m("img", {
            src: Re.value,
            alt: e.alt,
            class: "h-full w-full object-contain opacity-55"
          }, null, 8, Kc),
          m("div", Yc, [
            L(et, {
              size: "lg",
              color: "#ffffff"
            }),
            m("span", Xc, C(e.indeterminate ? "Uploading…" : `Uploading… ${Nt.value}`), 1)
          ]),
          m("div", Jc, [
            e.indeterminate ? (n(), c("div", Qc)) : (n(), c("div", {
              key: 1,
              class: "h-full bg-blue-600 transition-[width] duration-200",
              style: Ee({ width: Nt.value })
            }, null, 4))
          ])
        ], 2)) : Pe.value === "uploaded" ? (n(), c("div", {
          key: 3,
          class: r(l(u)),
          style: Ee(Xe.value)
        }, [
          m("img", {
            src: Re.value,
            alt: e.alt,
            class: r(["h-full w-full object-contain", e.isDisabled ? "cursor-not-allowed" : "cursor-zoom-in"]),
            "data-testid": `imageupload-${e.id}-preview`,
            onClick: Je
          }, null, 10, eu),
          e.isDisabled ? v("", !0) : (n(), c("div", tu, [
            L(Ze, {
              variant: "primary",
              severity: "neutral",
              size: "sm",
              "is-icon-only": "",
              class: "shadow-sm",
              title: "Preview",
              "aria-label": "Preview image",
              "data-testid": `imageupload-${e.id}-view`,
              onClick: Je
            }, {
              "left-icon": M(() => [
                L(l(Cs), { class: "h-[18px] w-[18px]" })
              ]),
              _: 1
            }, 8, ["data-testid"]),
            ze.value ? (n(), c(re, { key: 0 }, [
              L(Ze, {
                variant: "primary",
                severity: "neutral",
                size: "sm",
                "is-icon-only": "",
                class: "shadow-sm",
                title: "Replace",
                "aria-label": "Replace image",
                "is-loading": dt.value,
                "data-testid": `imageupload-${e.id}-replace`,
                onClick: Rt
              }, {
                "left-icon": M(() => [
                  L(l(_r), { class: "h-[18px] w-[18px]" })
                ]),
                _: 1
              }, 8, ["is-loading", "data-testid"]),
              at.value ? (n(), F(Ze, {
                key: 0,
                variant: "primary",
                severity: "neutral",
                size: "sm",
                "is-icon-only": "",
                class: "shadow-sm",
                title: "Crop",
                "aria-label": "Crop image",
                "data-testid": `imageupload-${e.id}-crop`,
                onClick: ea
              }, {
                "left-icon": M(() => [
                  L(l(ni), { class: "h-[18px] w-[18px]" })
                ]),
                _: 1
              }, 8, ["data-testid"])) : v("", !0)
            ], 64)) : v("", !0)
          ])),
          ze.value ? (n(), c("div", au, [
            L(Ze, {
              variant: "primary",
              severity: "neutral",
              size: "sm",
              "is-icon-only": "",
              class: "shadow-sm",
              title: "Remove",
              "aria-label": "Remove image",
              "data-testid": `imageupload-${e.id}-remove`,
              onClick: ke
            }, {
              "left-icon": M(() => [
                L(l(Ms), { class: "h-[18px] w-[18px] text-red-600" })
              ]),
              _: 1
            }, 8, ["data-testid"])
          ])) : v("", !0),
          it.value ? (n(), c("div", lu, [
            m("span", su, C(it.value), 1),
            xt.value ? (n(), c("span", nu, C(xt.value), 1)) : v("", !0)
          ])) : v("", !0)
        ], 6)) : Pe.value === "cropping" ? (n(), c(re, { key: 4 }, [
          m("div", {
            class: r(l(h))
          }, [
            m("img", {
              src: l(ne),
              alt: "",
              class: r(l(p)),
              style: Ee(l(j))
            }, null, 14, ou),
            (n(!0), c(re, null, xe(l(H), (De) => (n(), c("div", {
              key: De.id,
              class: r(l(f)),
              style: Ee(De.style)
            }, null, 6))), 128))
          ], 2),
          m("div", {
            ref_key: "cropBoxRef",
            ref: W,
            tabindex: "0",
            role: "group",
            "aria-label": "Crop area. Drag or press arrow keys to move. Tab to a handle to resize.",
            class: r(l(y)),
            style: Ee(l(fe)),
            onPointerdown: de[0] || (de[0] = //@ts-ignore
            (...De) => l(Q) && l(Q)(...De)),
            onKeydown: de[1] || (de[1] = //@ts-ignore
            (...De) => l(K) && l(K)(...De))
          }, [...de[7] || (de[7] = [
            m("div", { class: "absolute inset-y-0 left-1/3 w-px bg-white/35" }, null, -1),
            m("div", { class: "absolute inset-y-0 left-2/3 w-px bg-white/35" }, null, -1),
            m("div", { class: "absolute inset-x-0 top-1/3 h-px bg-white/35" }, null, -1),
            m("div", { class: "absolute inset-x-0 top-2/3 h-px bg-white/35" }, null, -1)
          ])], 38),
          (n(!0), c(re, null, xe(l($e), (De) => (n(), c("button", {
            key: De.id,
            type: "button",
            "data-handle": De.id,
            "aria-label": `Resize crop area from the ${De.label}. Use arrow keys.`,
            class: r([l(w), De.cursorClass]),
            style: Ee(De.style),
            onPointerdown: de[2] || (de[2] = //@ts-ignore
            (...Qe) => l(ue) && l(ue)(...Qe)),
            onKeydown: de[3] || (de[3] = //@ts-ignore
            (...Qe) => l(ee) && l(ee)(...Qe))
          }, [
            m("span", {
              class: r(l(S))
            }, null, 2)
          ], 46, ru))), 128)),
          m("div", {
            class: r(l(k)),
            style: Ee(Jt.value)
          }, C(l(te)), 7),
          m("div", iu, [
            L(Ze, {
              variant: "primary",
              severity: "neutral",
              size: "sm",
              "is-icon-only": "",
              class: "shadow-sm",
              title: "Reset to suggested",
              "aria-label": "Reset crop to suggested area",
              "data-testid": `imageupload-${e.id}-crop-reset`,
              onClick: l(Y)
            }, {
              "left-icon": M(() => [
                L(l(Wr), { class: "h-[18px] w-[18px]" })
              ]),
              _: 1
            }, 8, ["data-testid", "onClick"])
          ])
        ], 64)) : (n(), c("div", {
          key: 5,
          class: r(l(b))
        }, [
          m("span", du, [
            L(l(Ls), { class: "h-[22px] w-[22px]" })
          ]),
          m("span", cu, C(e.errorMessage), 1),
          ze.value ? (n(), F(Ze, {
            key: 0,
            variant: "tertiary",
            severity: "neutral",
            size: "sm",
            "data-testid": `imageupload-${e.id}-retry`,
            onClick: Ke
          }, {
            default: M(() => [...de[8] || (de[8] = [
              ie(" Try again ", -1)
            ])]),
            _: 1
          }, 8, ["data-testid"])) : v("", !0)
        ], 2)),
        E.value ? (n(), c("div", uu, [...de[9] || (de[9] = [
          m("span", { class: "type-h5 rounded-full bg-white px-3 py-1 text-blue-600 shadow-md" }, " Drop to upload ", -1)
        ])])) : v("", !0)
      ], 38),
      Pe.value === "cropping" ? (n(), c("div", {
        key: 0,
        class: "mx-auto",
        style: Ee(yt.value)
      }, [
        m("div", {
          class: r(l(x))
        }, [
          L(Ze, {
            variant: "text",
            severity: "neutral",
            size: "sm",
            "data-testid": `imageupload-${e.id}-crop-cancel`,
            onClick: l(J)
          }, {
            default: M(() => [...de[10] || (de[10] = [
              ie(" Cancel crop ", -1)
            ])]),
            _: 1
          }, 8, ["data-testid", "onClick"]),
          L(Ze, {
            variant: "tertiary",
            size: "sm",
            "is-disabled": V.value,
            "data-testid": `imageupload-${e.id}-crop-confirm`,
            onClick: aa
          }, {
            default: M(() => [...de[11] || (de[11] = [
              ie(" Confirm crop ", -1)
            ])]),
            _: 1
          }, 8, ["is-disabled", "data-testid"])
        ], 2)
      ], 4)) : v("", !0),
      e.requiredMessage ? (n(), F(Be, {
        key: 1,
        message: e.requiredMessage,
        type: "error",
        "data-testid": `imageupload-${e.id}-required-message`
      }, null, 8, ["message", "data-testid"])) : v("", !0),
      m("span", fu, C(l(ce)), 1),
      (n(), F(Wa, { to: "body" }, [
        R.value ? (n(), c("div", {
          key: 0,
          class: "fixed inset-0 z-[1000] flex items-center justify-center bg-black/80 p-10",
          "data-testid": `imageupload-${e.id}-lightbox`,
          onClick: ta
        }, [
          m("div", {
            class: "flex max-h-[88vh] max-w-[92vw] flex-col items-center gap-2.5",
            onClick: de[4] || (de[4] = Te(() => {
            }, ["stop"]))
          }, [
            m("img", {
              src: Re.value,
              alt: e.alt,
              class: "max-h-[80vh] max-w-[92vw] rounded-lg object-contain shadow-xl"
            }, null, 8, pu),
            it.value ? (n(), c("div", hu, [
              m("span", null, C(it.value), 1),
              xt.value ? (n(), c("span", gu, C(xt.value), 1)) : v("", !0)
            ])) : v("", !0)
          ]),
          m("button", {
            type: "button",
            class: "fixed top-5 right-5 flex h-10 w-10 items-center justify-center rounded-full border-none bg-white/10 text-white transition-colors hover:bg-white/25",
            title: "Close",
            "aria-label": "Close preview",
            onClick: ta
          }, [
            L(l(rt), { class: "h-[22px] w-[22px]" })
          ])
        ], 8, bu)) : v("", !0)
      ]))
    ], 2));
  }
}), cb = /* @__PURE__ */ Ye(mu, [["__scopeId", "data-v-d273fa68"]]), za = {
  success: {
    container: "bg-green-50 text-gray-900",
    icon: "text-green-600",
    spinner: "green-600",
    border: "border-green-600"
  },
  warn: {
    container: "bg-orange-50 text-gray-900",
    icon: "text-orange-600",
    spinner: "orange-600",
    border: "border-orange-600"
  },
  info: {
    container: "bg-blue-50 text-gray-900",
    icon: "text-blue-600",
    spinner: "blue-600",
    border: "border-blue-600"
  },
  error: {
    container: "bg-red-50 text-red-600",
    icon: "text-red-600",
    spinner: "red-600",
    border: "border-red-600"
  }
}, Dl = {
  sm: { container: "p-2 type-body-2 gap-2", icon: "w-4 h-4" },
  md: { container: "p-3 type-body-1 gap-3", icon: "w-5 h-5" },
  lg: { container: "p-4 type-h4 gap-4", icon: "w-6 h-6" }
};
function vu(e) {
  const a = i(() => {
    const o = "w-full rounded-lg flex items-center transition-all duration-200", d = za[e.severity || "info"], u = Dl[e.size || "md"], b = e.hasBorder ? `border ${d.border}` : "border border-transparent";
    return [o, d.container, u.container, b];
  }), t = i(() => {
    const o = za[e.severity || "info"], d = Dl[e.size || "md"];
    return [o.icon, d.icon, "shrink-0"];
  }), s = i(() => za[e.severity || "info"].spinner);
  return { containerClasses: a, iconClasses: t, spinnerColor: s };
}
const yu = ["role"], xu = { class: "flex min-w-0 flex-1 flex-col lg:flex-row lg:items-center lg:justify-between" }, wu = {
  key: 0,
  class: "flex items-center py-1"
}, Lu = {
  key: 1,
  class: "min-w-0 flex-1"
}, Cu = { class: "flex items-start gap-2" }, ku = {
  key: 0,
  class: "mt-4 flex justify-end lg:hidden"
}, ub = /* @__PURE__ */ X({
  __name: "Message",
  props: {
    severity: { default: "info" },
    size: { default: "md" },
    showIcon: { type: Boolean, default: !0 },
    message: { default: void 0 },
    isLoading: { type: Boolean, default: !1 },
    hasBorder: { type: Boolean, default: !1 }
  },
  setup(e) {
    const a = e, t = We(), s = A(!1), { containerClasses: o, iconClasses: d, spinnerColor: u } = vu(a), b = i(() => {
      switch (a.severity) {
        case "success":
          return Kr;
        case "warn":
          return Ls;
        case "error":
          return Qr;
        default:
          return el;
      }
    }), g = () => {
      s.value = !s.value;
    }, h = i(
      () => a.severity === "error" || a.severity === "warn" ? "alert" : "status"
    );
    return (p, f) => (n(), c("div", {
      class: r(l(o)),
      role: h.value
    }, [
      e.showIcon ? (n(), c("div", {
        key: 0,
        class: r(l(d))
      }, [
        T(p.$slots, "icon", {}, () => [
          (n(), F(kt(b.value)))
        ])
      ], 2)) : v("", !0),
      m("div", xu, [
        e.isLoading ? (n(), c("div", wu, [
          L(et, {
            size: "xs",
            color: l(u)
          }, null, 8, ["color"])
        ])) : (n(), c("div", Lu, [
          m("div", Cu, [
            m("div", {
              "data-testid": "message-content",
              class: r(["min-w-0 flex-1 wrap-anywhere", !s.value && "max-lg:line-clamp-1"])
            }, [
              T(p.$slots, "default", {}, () => [
                ie(C(e.message), 1)
              ])
            ], 2),
            s.value ? v("", !0) : (n(), c("button", {
              key: 0,
              type: "button",
              "aria-expanded": !1,
              "aria-label": "Show full message",
              class: "type-h6 flex h-full shrink-0 items-center whitespace-nowrap underline decoration-2 underline-offset-2 lg:hidden",
              onClick: g
            }, " Read more "))
          ]),
          s.value ? (n(), c("div", ku, [
            m("button", {
              type: "button",
              "aria-expanded": !0,
              "aria-label": "Collapse message",
              class: "type-h6 whitespace-nowrap underline decoration-2 underline-offset-2",
              onClick: g
            }, " Read less ")
          ])) : v("", !0)
        ])),
        l(t).action && !e.isLoading ? (n(), c("div", {
          key: 2,
          class: r(["lg:ml-4 lg:block lg:shrink-0", s.value ? "max-lg:mt-4" : "hidden"])
        }, [
          T(p.$slots, "action")
        ], 2)) : v("", !0)
      ])
    ], 10, yu));
  }
}), $u = ["href", "target", "rel", "aria-disabled", "tabindex", "data-testid"], Mu = {
  key: 0,
  class: "inline-flex shrink-0"
}, Vu = {
  key: 1,
  class: "truncate"
}, Su = {
  key: 2,
  class: "inline-flex shrink-0"
}, Bu = ["aria-disabled", "tabindex", "data-testid"], Eu = {
  key: 0,
  class: "inline-flex shrink-0"
}, Du = {
  key: 1,
  class: "truncate"
}, Fu = {
  key: 2,
  class: "inline-flex shrink-0"
}, fb = /* @__PURE__ */ X({
  __name: "LinkButton",
  props: {
    href: {},
    to: {},
    target: {},
    rel: { default: "noopener noreferrer" },
    variant: { default: "primary" },
    size: { default: "md" },
    severity: { default: "default" },
    isDisabled: { type: Boolean, default: !1 },
    isIconOnly: { type: Boolean, default: !1 }
  },
  emits: ["navigate"],
  setup(e, { emit: a }) {
    const t = e, s = a, { buttonClasses: o } = Vs(t), d = i(() => {
      if (t.target === "_blank" && t.href) {
        const g = t.rel ? t.rel.split(/\s+/) : [];
        return ["noopener", "noreferrer"].forEach((p) => {
          g.includes(p) || g.push(p);
        }), g.join(" ");
      }
      return t.rel;
    });
    function u(g) {
      if (t.isDisabled) {
        g.preventDefault();
        return;
      }
    }
    function b(g) {
      if (t.isDisabled || !t.to) {
        g.preventDefault();
        return;
      }
      s("navigate", t.to);
    }
    return (g, h) => e.href ? (n(), c("a", {
      key: 0,
      href: e.href,
      target: e.target,
      rel: d.value,
      class: r(l(o)),
      "aria-disabled": e.isDisabled,
      tabindex: e.isDisabled ? -1 : 0,
      "data-testid": g.$attrs["data-testid"] || "ui-link-button",
      onClick: u
    }, [
      g.$slots["left-icon"] ? (n(), c("span", Mu, [
        T(g.$slots, "left-icon")
      ])) : v("", !0),
      e.isIconOnly ? v("", !0) : (n(), c("span", Vu, [
        T(g.$slots, "default")
      ])),
      g.$slots["right-icon"] ? (n(), c("span", Su, [
        T(g.$slots, "right-icon")
      ])) : v("", !0)
    ], 10, $u)) : e.to ? (n(), c("a", {
      key: 1,
      href: "#",
      class: r(l(o)),
      "aria-disabled": e.isDisabled,
      tabindex: e.isDisabled ? -1 : 0,
      "data-testid": g.$attrs["data-testid"] || "ui-link-button",
      onClick: Te(b, ["prevent"])
    }, [
      g.$slots["left-icon"] ? (n(), c("span", Eu, [
        T(g.$slots, "left-icon")
      ])) : v("", !0),
      e.isIconOnly ? v("", !0) : (n(), c("span", Du, [
        T(g.$slots, "default")
      ])),
      g.$slots["right-icon"] ? (n(), c("span", Fu, [
        T(g.$slots, "right-icon")
      ])) : v("", !0)
    ], 10, Bu)) : v("", !0);
  }
}), bb = /* @__PURE__ */ X({
  __name: "AvatarGroup",
  props: {
    items: {},
    max: { default: 4 },
    size: { default: "md" },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e, t = i(() => a.items.length > a.max), s = i(() => t.value ? a.max - 1 : a.max), o = i(() => a.items.slice(0, s.value)), d = i(() => t.value ? a.items.slice(s.value) : []), u = i(() => d.value.length), b = i(() => d.value.map((y) => y.name).join(", ")), g = i(() => u.value > 99 ? "99+" : `+${u.value}`), h = {
      sm: "-space-x-1.5",
      md: "-space-x-2",
      lg: "-space-x-2.5"
    }, p = i(() => q(
      "absolute inset-0 flex items-center justify-center",
      "font-sans type-body-2 tracking-[-0.135px] text-white",
      "mt-[1px]"
    )), f = i(() => {
      switch (a.size) {
        case "sm":
          return "h-6 w-6";
        case "md":
          return "h-8 w-8";
        case "lg":
          return "h-10 w-10";
        default:
          return "h-8 w-8";
      }
    });
    return (y, w) => (n(), c("div", {
      "data-testid": "avatar-group",
      class: r(l(q)("flex items-center", h[a.size], a.class))
    }, [
      (n(!0), c(re, null, xe(o.value, (S) => (n(), F(ht, {
        key: S.id,
        label: S.name
      }, {
        default: M(() => [
          L(Ot, {
            src: S.src,
            label: S.name,
            size: a.size
          }, null, 8, ["src", "label", "size"])
        ]),
        _: 2
      }, 1032, ["label"]))), 128)),
      u.value > 0 ? (n(), F(ht, {
        key: 0,
        label: b.value
      }, {
        default: M(() => [
          m("div", {
            "data-testid": "avatar-group-counter-wrapper",
            class: r(
              l(q)(
                "relative flex items-center justify-center overflow-hidden rounded-full",
                "border border-white bg-blue-900",
                f.value
              )
            )
          }, [
            m("span", {
              class: r(p.value)
            }, C(g.value), 3)
          ], 2)
        ]),
        _: 1
      }, 8, ["label"])) : v("", !0)
    ], 2));
  }
}), Ru = {
  compact: {
    content: "p-1",
    // `min-h-8` rather than `h-8`: an item carrying a description is two lines and has to be able
    // to grow. A plain item still measures 32px, since the padding and one `type-body-1` line come in
    // under it — so a menu without descriptions renders exactly as it did.
    item: "min-h-8 py-1.5 px-2.5"
  },
  comfortable: {
    content: "p-1 space-y-0.5",
    item: "min-h-9 py-2 px-2.5"
  }
}, Ct = {
  content: "min-w-[220px] outline-none bg-white rounded-md z-[100] shadow-[0px_10px_38px_-10px_rgba(22,23,24,0.35),0px_10px_20px_-15px_rgba(22,23,24,0.2)]",
  item: "group type-body-1 text-gray-900 rounded-[3px] flex items-center relative select-none outline-none cursor-pointer transition-all duration-200 data-[disabled]:text-gray-300 data-[disabled]:pointer-events-none data-[highlighted]:bg-gray-50 data-[highlighted]:text-black",
  // Inherits the disabled colour through the item's `group` rather than stating its own, so a
  // disabled item dims as one thing instead of leaving its description at full strength.
  description: "mt-0.5 type-body-2 text-gray-500 group-data-[disabled]:text-gray-300",
  subTrigger: "data-[state=open]:bg-gray-100 data-[state=open]:text-black",
  separator: "h-px bg-gray-100 my-1 mx-1",
  shortcut: "ml-auto pl-5 text-gray-400 type-body-2 group-data-[highlighted]:text-black",
  chevron: "h-4 w-4 text-black opacity-50 ml-auto",
  arrow: "fill-white drop-shadow-[0_1px_2px_rgba(0,0,0,0.1)]"
};
function Iu(e = "compact") {
  const a = i(() => Ru[Ne(e)]), t = i(() => `${Ct.content} ${a.value.content}`), s = i(() => `${Ct.item} ${a.value.item}`), o = i(() => Ct.description), d = i(() => [s.value, Ct.subTrigger]), u = i(() => Ct.separator), b = i(() => Ct.shortcut), g = i(() => Ct.chevron), h = i(() => Ct.arrow);
  return {
    contentClasses: t,
    itemClasses: s,
    descriptionClasses: o,
    subTriggerClasses: d,
    separatorClasses: u,
    shortcutClasses: b,
    chevronClasses: g,
    arrowClasses: h
  };
}
const Tu = { class: "flex min-w-0 items-center gap-2" }, Au = { class: "flex min-w-0 flex-col" }, Ou = { key: 0 }, zu = { class: "flex items-center gap-2" }, Hu = { class: "flex min-w-0 flex-col" }, Zu = { key: 0 }, Pu = { class: "flex w-full items-center gap-2" }, ju = { key: 0 }, pb = /* @__PURE__ */ X({
  __name: "DropdownMenu",
  props: {
    items: {},
    size: { default: "compact" }
  },
  emits: ["select", "open-change"],
  setup(e, { emit: a }) {
    const t = e, {
      contentClasses: s,
      itemClasses: o,
      descriptionClasses: d,
      subTriggerClasses: u,
      separatorClasses: b,
      shortcutClasses: g,
      chevronClasses: h,
      arrowClasses: p
    } = Iu(() => t.size), f = a, y = i(() => {
      const S = (k) => k.filter((x) => x.visible !== !1).map((x) => ({
        ...x,
        children: x.children ? S(x.children) : void 0
      }));
      return S(t.items);
    }), w = (S) => {
      S.children || S.isLoading || (S.command && S.command(), f("select", S));
    };
    return (S, k) => (n(), F(l(bo), {
      "onUpdate:open": k[0] || (k[0] = (x) => f("open-change", x))
    }, {
      default: M(() => [
        L(l(po), { "as-child": "" }, {
          default: M(() => [
            T(S.$slots, "trigger")
          ]),
          _: 3
        }),
        L(l(ul), null, {
          default: M(() => [
            L(l(ho), {
              "collision-padding": 16,
              class: r(l(s))
            }, {
              default: M(() => [
                L(l(go), {
                  class: r(l(p)),
                  width: 12,
                  height: 6
                }, null, 8, ["class"]),
                (n(!0), c(re, null, xe(y.value, (x) => (n(), c(re, {
                  key: x.id
                }, [
                  x.type === "separator" ? (n(), F(l(mo), {
                    key: 0,
                    class: r(l(b))
                  }, null, 8, ["class"])) : x.children ? (n(), F(l(vo), { key: 1 }, {
                    default: M(() => [
                      L(l(yo), {
                        class: r(l(u)),
                        disabled: x.isLoading
                      }, {
                        default: M(() => [
                          m("div", Tu, [
                            x.isLoading ? (n(), F(et, {
                              key: 0,
                              size: "xs",
                              color: "blue-700"
                            })) : x.icon ? (n(), F(kt(x.icon), {
                              key: 1,
                              class: "h-4 w-4"
                            })) : v("", !0),
                            m("div", Au, [
                              x.label ? (n(), c("span", Ou, C(x.label), 1)) : v("", !0),
                              x.description ? (n(), c("span", {
                                key: 1,
                                class: r(l(d))
                              }, C(x.description), 3)) : v("", !0)
                            ])
                          ]),
                          L(l(ot), {
                            class: r(l(h))
                          }, null, 8, ["class"])
                        ]),
                        _: 2
                      }, 1032, ["class", "disabled"]),
                      L(l(ul), null, {
                        default: M(() => [
                          L(l(xo), {
                            "collision-padding": 16,
                            class: r(l(s))
                          }, {
                            default: M(() => [
                              (n(!0), c(re, null, xe(x.children, ($) => (n(), F(l(fl), {
                                key: $.id,
                                class: r(l(q)(l(o), $.class)),
                                disabled: $.isLoading || $.disabled,
                                onSelect: (D) => w($)
                              }, {
                                default: M(() => [
                                  m("div", zu, [
                                    $.isLoading ? (n(), F(et, {
                                      key: 0,
                                      size: "xs",
                                      color: "blue-700"
                                    })) : $.icon ? (n(), F(kt($.icon), {
                                      key: 1,
                                      class: "h-4 w-4 opacity-70"
                                    })) : v("", !0),
                                    m("div", Hu, [
                                      $.label ? (n(), c("span", Zu, C($.label), 1)) : v("", !0),
                                      $.description ? (n(), c("span", {
                                        key: 1,
                                        class: r(l(d))
                                      }, C($.description), 3)) : v("", !0)
                                    ])
                                  ]),
                                  $.shortcut && !$.isLoading ? (n(), c("div", {
                                    key: 0,
                                    class: r(l(g))
                                  }, C($.shortcut), 3)) : v("", !0)
                                ]),
                                _: 2
                              }, 1032, ["class", "disabled", "onSelect"]))), 128))
                            ]),
                            _: 2
                          }, 1032, ["class"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)) : (n(), F(l(fl), {
                    key: 2,
                    class: r(l(q)(l(o), x.class)),
                    disabled: x.disabled || x.isLoading,
                    onSelect: ($) => w(x)
                  }, {
                    default: M(() => [
                      m("div", Pu, [
                        x.isLoading ? (n(), F(et, {
                          key: 0,
                          size: "xs",
                          color: "blue-700"
                        })) : x.icon ? (n(), F(kt(x.icon), {
                          key: 1,
                          class: "h-4 w-4 opacity-70"
                        })) : v("", !0),
                        m("div", {
                          class: r(["flex min-w-0 flex-col", { "opacity-50": x.isLoading }])
                        }, [
                          x.label ? (n(), c("span", ju, C(x.label), 1)) : v("", !0),
                          x.description && !x.isLoading ? (n(), c("span", {
                            key: 1,
                            class: r(l(d))
                          }, C(x.description), 3)) : v("", !0)
                        ], 2),
                        x.shortcut && !x.isLoading ? (n(), c("div", {
                          key: 2,
                          class: r(l(g))
                        }, C(x.shortcut), 3)) : v("", !0)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["class", "disabled", "onSelect"]))
                ], 64))), 128))
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 3
    }));
  }
});
function Nu() {
  return {
    rootClasses: "w-full overflow-hidden rounded-lg border border-gray-200 bg-white",
    itemClasses: "border-b border-gray-200 last:border-b-0",
    getTriggerClasses: (g) => [
      "flex w-full items-center justify-between p-4 text-left type-body-1 transition-colors",
      "hover:bg-gray-50 focus-visible:outline-none",
      "border-b border-transparent data-[state=open]:border-gray-200",
      g ? "cursor-not-allowed opacity-50 bg-gray-50" : "cursor-pointer"
    ],
    iconClasses: "h-5 w-5 shrink-0 text-black transition-transform duration-200",
    contentClasses: "overflow-hidden type-body-1 text-gray-600 transition-all",
    innerContentClasses: "p-4",
    titleClasses: "type-h2",
    subtitleClasses: "text-txt-500 type-body-1"
  };
}
const qu = { class: "flex-1 pr-4" }, Uu = { class: "relative h-5 w-5" }, hb = /* @__PURE__ */ X({
  __name: "Accordion",
  props: {
    items: {},
    defaultValue: {},
    modelValue: {},
    type: { default: "single" },
    collapsible: { type: Boolean, default: !0 },
    unmountOnHide: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = a, {
      rootClasses: o,
      itemClasses: d,
      getTriggerClasses: u,
      iconClasses: b,
      contentClasses: g,
      innerContentClasses: h,
      titleClasses: p,
      subtitleClasses: f
    } = Nu(), y = i(() => {
      const { items: w, ...S } = t;
      return S;
    });
    return (w, S) => (n(), F(l(wo), Oe(y.value, {
      class: l(o),
      "unmount-on-hide": e.unmountOnHide,
      "onUpdate:modelValue": S[0] || (S[0] = (k) => s("update:modelValue", k))
    }), {
      default: M(() => [
        (n(!0), c(re, null, xe(e.items, (k) => (n(), F(l(Lo), {
          key: k.value,
          value: k.value,
          disabled: k.disabled,
          class: r(l(d))
        }, {
          default: M(() => [
            L(l(Co), { class: "flex" }, {
              default: M(() => [
                L(l(ko), {
                  class: r([l(u)(k.disabled), "group"])
                }, {
                  default: M(() => [
                    m("div", qu, [
                      T(w.$slots, "header", { item: k }, () => [
                        k.title ? (n(), c("p", {
                          key: 0,
                          class: r(l(p))
                        }, C(k.title), 3)) : v("", !0),
                        k.subtitle ? (n(), c("p", {
                          key: 1,
                          class: r(l(f))
                        }, C(k.subtitle), 3)) : v("", !0)
                      ])
                    ]),
                    m("div", Uu, [
                      L(l(si), {
                        class: r([
                          l(b),
                          "absolute inset-0 group-data-[state=open]:rotate-90 group-data-[state=open]:opacity-0"
                        ])
                      }, null, 8, ["class"]),
                      L(l($s), {
                        class: r([
                          l(b),
                          "absolute inset-0 -rotate-90 opacity-0 group-data-[state=open]:rotate-0 group-data-[state=open]:opacity-100"
                        ])
                      }, null, 8, ["class"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["class"])
              ]),
              _: 2
            }, 1024),
            L(l($o), {
              class: r(l(g))
            }, {
              default: M(() => [
                m("div", {
                  class: r(l(h))
                }, [
                  T(w.$slots, `content-${k.value}`, { item: k }, () => [
                    T(w.$slots, "default")
                  ])
                ], 2)
              ]),
              _: 2
            }, 1032, ["class"])
          ]),
          _: 2
        }, 1032, ["value", "disabled", "class"]))), 128))
      ]),
      _: 3
    }, 16, ["class", "unmount-on-hide"]));
  }
}), Gu = (e) => {
  const a = [
    "flex items-center gap-0.5 p-1 w-full",
    "list-none",
    "overflow-hidden"
  ].join(" "), t = i(() => {
    const g = Ne(e.size) === "sm", h = "inline-block hover:text-blue-600 transition-colors duration-150";
    return Ne(e.fluid) ? g ? `type-body-2 text-txt-800 truncate ${h}` : `type-body-1 text-txt-800 truncate ${h}` : g ? `type-body-2 text-txt-800 truncate max-w-[160px] ${h}` : `type-body-1 text-txt-800 truncate max-w-[200px] ${h}`;
  }), s = i(() => {
    const g = Ne(e.size) === "sm", h = "inline-block hover:text-blue-600 transition-colors duration-150";
    return Ne(e.fluid) ? g ? `type-body-2-strong text-blue-800 cursor-pointer truncate ${h}` : `type-body-1-strong text-blue-800 cursor-pointer truncate ${h}` : g ? `type-body-2-strong text-blue-800 cursor-pointer truncate max-w-[160px] ${h}` : `type-body-1-strong text-blue-800 cursor-pointer truncate max-w-[200px] ${h}`;
  }), o = i(
    () => e.size === "sm" ? "type-body-2 text-txt-800 cursor-pointer hover:text-blue-800 px-0.5" : "type-body-1 text-txt-800 cursor-pointer hover:text-blue-800 px-0.5"
  ), d = "h-4 w-4 shrink-0", u = i(
    () => Ne(e.size) === "sm" ? "h-[17.4px]" : "h-[18px] md:h-[21px]"
  ), b = i(
    () => Ne(e.size) === "sm" ? "h-3 block animate-pulse rounded bg-gray-100" : "h-3.5 block animate-pulse rounded bg-gray-100"
  );
  return {
    containerClasses: a,
    linkClasses: t,
    currentClasses: s,
    separatorClasses: d,
    ellipsisClasses: o,
    skeletonRowClasses: u,
    skeletonBarClasses: b
  };
}, _u = ["aria-busy"], Wu = {
  key: 0,
  class: "text-txt-700 inline-flex items-center justify-center"
}, Ku = ["role", "tabindex", "onClick", "onKeydown"], Yu = ["href"], Xu = ["onClick", "onKeydown"], Ju = {
  key: 5,
  class: "text-txt-700 inline-flex items-center justify-center",
  "aria-hidden": "true",
  "data-testid": "breadcrumb-separator"
}, gb = /* @__PURE__ */ X({
  __name: "Breadcrumb",
  props: {
    items: { default: () => [] },
    size: { default: "sm" },
    maxItems: { default: 0 },
    isLoading: { type: Boolean, default: !1 },
    skeletonItems: { default: 2 },
    fluid: { type: Boolean, default: !1 }
  },
  emits: ["item-clicked"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = A(!1), d = i(() => {
      const { items: E, maxItems: R } = t;
      if (!R || o.value || E.length <= R)
        return E;
      const V = E[0], Z = E.slice(-(R - 2));
      return [V, { id: "__ellipsis__", label: "...", isEllipsis: !0 }, ...Z];
    }), {
      containerClasses: u,
      linkClasses: b,
      currentClasses: g,
      separatorClasses: h,
      ellipsisClasses: p,
      skeletonRowClasses: f,
      skeletonBarClasses: y
    } = Gu({
      size: () => t.size,
      fluid: () => t.fluid
    }), w = (E) => E === t.skeletonItems ? "w-24" : "w-16", S = (E) => E.href ? (s("item-clicked", E), E.href) : "", k = (E) => !E.isCurrent && !E.isEllipsis && !!E.href, x = (E) => !E.isCurrent && !E.isEllipsis && E.index !== void 0, $ = (E) => E.isClickable === !0 && E.index !== void 0, D = (E) => {
      E.index !== void 0 && E.isClickable !== !1 && s("item-clicked", E);
    };
    return (E, R) => (n(), c("nav", {
      "aria-label": "Breadcrumb",
      "data-testid": "breadcrumb-nav",
      class: "w-full",
      "aria-busy": e.isLoading
    }, [
      e.isLoading ? (n(), c("ol", {
        key: 0,
        class: r(l(u)),
        "aria-hidden": "true",
        "data-testid": "breadcrumb-skeleton"
      }, [
        (n(!0), c(re, null, xe(e.skeletonItems, (V) => (n(), c("li", {
          key: `skeleton-${V}`,
          class: r(["inline-flex min-w-0 items-center gap-0.5", l(f)])
        }, [
          m("span", {
            class: r([l(y), w(V)])
          }, null, 2),
          V < e.skeletonItems ? (n(), c("span", Wu, [
            L(l(ot), {
              class: r(l(h))
            }, null, 8, ["class"])
          ])) : v("", !0)
        ], 2))), 128))
      ], 2)) : (n(), c("ol", {
        key: 1,
        class: r(l(u))
      }, [
        (n(!0), c(re, null, xe(d.value, (V, Z) => (n(), c("li", {
          key: V.id ?? `${V.label}-${Z}`,
          class: "inline-flex min-w-0 items-center gap-0.5"
        }, [
          V.isEllipsis ? (n(), c("button", {
            key: 0,
            class: r(l(p)),
            type: "button",
            "aria-label": "Show full path",
            "data-testid": "breadcrumb-ellipsis",
            onClick: R[0] || (R[0] = (G) => o.value = !0)
          }, " … ", 2)) : V.isCurrent ? (n(), c("span", {
            key: 1,
            class: r([l(g), "min-w-0 truncate"]),
            "aria-current": "page",
            "data-testid": "breadcrumb-current",
            role: $(V) ? "button" : void 0,
            tabindex: $(V) ? 0 : void 0,
            onClick: (G) => $(V) && D(V),
            onKeydown: [
              Tt(Te((G) => $(V) && D(V), ["prevent"]), ["enter"]),
              Tt(Te((G) => $(V) && D(V), ["prevent"]), ["space"])
            ]
          }, C(V.label), 43, Ku)) : k(V) ? (n(), c("a", {
            key: 2,
            href: S(V),
            class: r([
              l(b),
              "min-w-0 truncate rounded focus-visible:ring-2 focus-visible:ring-blue-800 focus-visible:ring-offset-1 focus-visible:outline"
            ]),
            "data-testid": "breadcrumb-link"
          }, C(V.label), 11, Yu)) : x(V) ? (n(), c("span", {
            key: 3,
            class: r(l(q)(l(b), "min-w-0 cursor-pointer truncate")),
            "data-testid": "breadcrumb-link",
            role: "button",
            tabindex: "0",
            onClick: (G) => D(V),
            onKeydown: [
              Tt(Te((G) => D(V), ["prevent"]), ["enter"]),
              Tt(Te((G) => D(V), ["prevent"]), ["space"])
            ]
          }, C(V.label), 43, Xu)) : (n(), c("span", {
            key: 4,
            class: r(l(b)),
            "data-testid": "breadcrumb-link"
          }, C(V.label), 3)),
          Z < d.value.length - 1 ? (n(), c("span", Ju, [
            L(l(ot), {
              class: r(l(h))
            }, null, 8, ["class"])
          ])) : v("", !0)
        ]))), 128))
      ], 2))
    ], 8, _u));
  }
}), Qu = { class: "flex items-center gap-3" }, e1 = {
  key: 0,
  class: "text-txt-500 type-body-2 max-w-2xl pt-1"
}, mb = /* @__PURE__ */ X({
  __name: "DrawerSubHeader",
  props: {
    label: {},
    description: { default: void 0 },
    labelId: { default: void 0 },
    as: { default: "p" },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e;
    return (t, s) => (n(), c("div", {
      class: r(l(q)("pb-3", a.class))
    }, [
      m("div", Qu, [
        (n(), F(kt(a.as), {
          id: a.labelId,
          class: "text-txt-700 type-h4 tracking-[0.14em] uppercase"
        }, {
          default: M(() => [
            ie(C(a.label), 1)
          ]),
          _: 1
        }, 8, ["id"])),
        s[0] || (s[0] = m("span", { class: "bg-border-border-200 h-px flex-1" }, null, -1))
      ]),
      a.description ? (n(), c("p", e1, C(a.description), 1)) : v("", !0)
    ], 2));
  }
}), t1 = (e) => {
  const a = i(() => ["sticky top-0 z-20 w-full"]), t = i(() => ["relative flex w-full bg-white"]), s = [
    "overflow-x-auto overflow-y-visible scroll-smooth overscroll-x-contain",
    "[-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
    "grow w-full"
  ].join(" "), o = i(
    () => ["relative flex border-b-2 border-gray-200 w-full"].join(" ")
  ), d = (g, h) => [
    "relative type-body-1 border-b-2 -mb-0.5",
    "py-2 px-4",
    // maxWidth (takes precedence): shrink-0 so tabs sit at their inline-style max-width and left-align
    // fit: shrink-0 plus a 120px floor. Sizing purely to content left a one-word tab far
    // narrower than its neighbours — "BOQ" came out 63px beside "Compliance" at 118px, and
    // "Users" 70px beside "Organisation settings" at 182px — which read as squashed rather
    // than as a tab bar. 120px is the width of the longest single-word label, so a bar of
    // short labels lands even. Safe here only because `shrink-0` means the floor can never
    // compress a longer label; see the default branch below for why that isn't general.
    // default: flex-1 to share the full width equally when tabs fit, with
    // min-w-max (min-width: max-content) so a tab never shrinks below its own
    // label. A fixed min like min-w-[80px] overrides the flex min-content floor
    // and lets narrow tabs shrink under their nowrap label, overlapping the text
    // and leaving nothing to scroll — which only surfaces once content crosses the
    // viewport width (a real phone, but not a wider device-simulator preview).
    e.maxWidth ? "shrink-0 min-w-[80px]" : e.fit ? "shrink-0 min-w-30" : "flex-1 min-w-max",
    // Context: the list's border is the only track. An inactive tab drawing its own grey border
    // doubled the line wherever `-mb-0.5` failed to pull it onto the track (PLE-1514).
    g ? "border-black text-txt-800" : "border-transparent text-txt-600",
    // Hover on inactive
    !g && !h ? "hover:border-gray-300 hover:text-gray-800" : "",
    // Disabled
    h ? "opacity-60 !cursor-not-allowed" : "cursor-pointer",
    // Focus
    "outline-transparent focus:outline-none focus-visible:ring-1 ring-inset focus-visible:ring-blue-800",
    // Misc
    "transition-all duration-200 select-none whitespace-nowrap text-center"
  ].filter(Boolean).join(" "), u = i(
    () => e.maxWidth ? { maxWidth: e.maxWidth } : {}
  );
  return {
    tabBarWrapperClasses: a,
    tabBarContainerClasses: t,
    scrollWrapperClasses: s,
    tabListClasses: o,
    getTabClasses: d,
    tabMaxWidthStyle: u,
    scrollButtonClasses: (g) => [
      "absolute top-0 z-20 h-full w-10 flex items-center justify-center",
      "text-gray-700 border-b-2 border-gray-200 outline-transparent cursor-pointer shrink-0",
      g === "left" ? "left-0 bg-gradient-to-r from-white from-30% via-white/80 via-70% to-transparent" : "right-0 bg-gradient-to-l from-white from-30% via-white/80 via-70% to-transparent",
      "focus-visible:outline-none disabled:opacity-40"
    ].filter(Boolean).join(" ")
  };
}, _s = () => {
  const e = A(null), a = A(0), t = A(0), s = A(!1), o = i(() => a.value > 5), d = i(() => a.value < t.value - 5), u = () => {
    e.value && (t.value = Math.max(0, e.value.scrollWidth - e.value.clientWidth), a.value = e.value.scrollLeft);
  };
  let b = null, g = null, h = null;
  const p = () => {
    b && clearTimeout(b), b = setTimeout(u, 10);
  }, f = () => {
    if (!e.value || s.value) return;
    s.value = !0;
    const S = Math.min(200, a.value);
    e.value.scrollTo({
      left: Math.max(0, a.value - S),
      behavior: "smooth"
    }), g = setTimeout(() => {
      s.value = !1;
    }, 300);
  }, y = () => {
    if (!e.value || s.value) return;
    s.value = !0;
    const S = Math.min(200, t.value - a.value);
    e.value.scrollTo({
      left: Math.min(t.value, a.value + S),
      behavior: "smooth"
    }), h = setTimeout(() => {
      s.value = !1;
    }, 300);
  }, w = async () => {
    await Fe(), e.value && (e.value.offsetWidth, u());
  };
  return Vt(() => {
    w(), window.addEventListener("resize", w);
  }), Ka(() => {
    window.removeEventListener("resize", w), b && clearTimeout(b), g && clearTimeout(g), h && clearTimeout(h);
  }), {
    tabListRef: e,
    canScrollLeft: o,
    canScrollRight: d,
    isScrolling: s,
    handleScroll: p,
    scrollLeft: f,
    scrollRight: y,
    initScrollMetrics: w
  };
}, a1 = { class: "flex w-full flex-col" }, l1 = ["role", "aria-label"], s1 = ["id", "role", "aria-selected", "aria-controls", "aria-current", "aria-disabled", "disabled", "tabindex", "data-testid", "onClick", "onKeydown"], n1 = { class: "inline-flex items-center justify-center gap-2 align-middle text-inherit" }, o1 = ["disabled"], r1 = ["disabled"], i1 = ["id", "aria-labelledby", "hidden", "data-testid"], d1 = /* @__PURE__ */ X({
  __name: "Tabs",
  props: {
    tabs: { default: () => [] },
    activeTab: { default: void 0 },
    destroyOnHide: { type: Boolean, default: !1 },
    navigation: { type: Boolean, default: !1 },
    maxWidth: { default: void 0 },
    fit: { type: Boolean, default: !1 }
  },
  emits: ["tab-change"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = A(t.tabs[0]?.id ?? ""), d = i(
      () => t.activeTab === void 0 ? o.value : t.activeTab
    );
    Se(
      () => t.activeTab,
      (U) => {
        U !== void 0 && (o.value = U);
      }
    ), Se(
      () => t.tabs,
      async (U) => {
        U.find((ae) => ae.id === d.value) || (o.value = U[0]?.id ?? ""), await Fe(), z();
      }
    );
    const u = (U) => {
      U.isDisabled || (o.value = U.id, s("tab-change", U.id));
    }, b = A([]), g = i(() => t.tabs.filter((U) => !U.isDisabled).map((U) => U.id)), h = (U, ae) => {
      if (t.navigation) return;
      const B = g.value, le = B.indexOf(ae.id);
      let O;
      switch (U.key) {
        case "ArrowRight": {
          U.preventDefault(), O = B[(le + 1) % B.length];
          break;
        }
        case "ArrowLeft": {
          U.preventDefault(), O = B[(le - 1 + B.length) % B.length];
          break;
        }
        case "Home": {
          U.preventDefault(), O = B[0];
          break;
        }
        case "End": {
          U.preventDefault(), O = B.at(-1);
          break;
        }
        case "Enter":
        case " ": {
          U.preventDefault(), u(ae);
          return;
        }
        default:
          return;
      }
      if (O) {
        const j = t.tabs.findIndex((_) => _.id === O);
        b.value[j]?.focus();
      }
    }, {
      tabBarWrapperClasses: p,
      tabBarContainerClasses: f,
      scrollWrapperClasses: y,
      tabListClasses: w,
      getTabClasses: S,
      tabMaxWidthStyle: k,
      scrollButtonClasses: x
    } = t1({ maxWidth: t.maxWidth, fit: t.fit }), {
      tabListRef: $,
      canScrollLeft: D,
      canScrollRight: E,
      isScrolling: R,
      handleScroll: V,
      scrollLeft: Z,
      scrollRight: G,
      initScrollMetrics: z
    } = _s();
    return (U, ae) => (n(), c("div", a1, [
      m("div", {
        class: r(l(p)),
        "data-testid": "tabs-wrapper"
      }, [
        m("div", {
          class: r(l(f))
        }, [
          m("div", {
            ref_key: "tabListRef",
            ref: $,
            class: r(l(y)),
            onScroll: ae[0] || (ae[0] = //@ts-ignore
            (...B) => l(V) && l(V)(...B))
          }, [
            m("div", {
              role: e.navigation ? void 0 : "tablist",
              class: r(l(w)),
              "aria-label": e.navigation ? void 0 : "Tabs",
              "data-testid": "tabs-list"
            }, [
              (n(!0), c(re, null, xe(e.tabs, (B, le) => (n(), c("button", {
                id: `tab-${B.id}`,
                key: B.id,
                ref_for: !0,
                ref: (O) => {
                  O && (b.value[le] = O);
                },
                role: e.navigation ? void 0 : "tab",
                "aria-selected": e.navigation ? void 0 : d.value === B.id,
                "aria-controls": e.navigation ? void 0 : `tabpanel-${B.id}`,
                "aria-current": e.navigation && d.value === B.id ? "true" : void 0,
                "aria-disabled": B.isDisabled ? "true" : void 0,
                disabled: B.isDisabled,
                tabindex: e.navigation ? void 0 : d.value === B.id ? 0 : -1,
                class: r(l(S)(d.value === B.id, !!B.isDisabled)),
                style: Ee(l(k)),
                "data-testid": `tab-${B.id}`,
                onClick: (O) => u(B),
                onKeydown: (O) => h(O, B)
              }, [
                m("span", n1, [
                  ie(C(B.label) + " ", 1),
                  B.icon ? (n(), F(kt(B.icon), {
                    key: 0,
                    class: "order-first h-5 w-5 shrink-0"
                  })) : v("", !0),
                  L(Rr, {
                    value: B.badge,
                    tone: B.badgeTone,
                    "data-testid": `tab-badge-${B.id}`
                  }, null, 8, ["value", "tone", "data-testid"])
                ])
              ], 46, s1))), 128))
            ], 10, l1)
          ], 34),
          L(_t, { name: "tabs-fade" }, {
            default: M(() => [
              l(D) ? (n(), c("button", {
                key: 0,
                class: r(l(x)("left")),
                disabled: l(R),
                "aria-label": "Scroll tabs left",
                "data-testid": "tabs-scroll-left",
                onClick: ae[1] || (ae[1] = Te(
                  //@ts-ignore
                  (...B) => l(Z) && l(Z)(...B),
                  ["stop"]
                ))
              }, [
                L(l(Wt), { class: "h-4 w-4 text-gray-600" })
              ], 10, o1)) : v("", !0)
            ]),
            _: 1
          }),
          L(_t, { name: "tabs-fade" }, {
            default: M(() => [
              l(E) ? (n(), c("button", {
                key: 0,
                class: r(l(x)("right")),
                disabled: l(R),
                "aria-label": "Scroll tabs right",
                "data-testid": "tabs-scroll-right",
                onClick: ae[2] || (ae[2] = Te(
                  //@ts-ignore
                  (...B) => l(G) && l(G)(...B),
                  ["stop"]
                ))
              }, [
                L(l(ot), { class: "h-4 w-4 text-gray-600" })
              ], 10, r1)) : v("", !0)
            ]),
            _: 1
          })
        ], 2)
      ], 2),
      (n(!0), c(re, null, xe(e.navigation ? [] : e.tabs, (B) => (n(), c(re, {
        key: B.id
      }, [
        !e.destroyOnHide || d.value === B.id ? (n(), c("div", {
          key: 0,
          id: `tabpanel-${B.id}`,
          role: "tabpanel",
          "aria-labelledby": `tab-${B.id}`,
          hidden: !e.destroyOnHide && d.value !== B.id ? !0 : void 0,
          "data-testid": `tabpanel-${B.id}`
        }, [
          T(U.$slots, B.id, {}, void 0, !0)
        ], 8, i1)) : v("", !0)
      ], 64))), 128))
    ]));
  }
}), vb = /* @__PURE__ */ Ye(d1, [["__scopeId", "data-v-47e37683"]]), Fl = "outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700", Ws = (e) => e.isCurrent ? "type-h5 text-txt-800" : e.disabled ? "type-body-1-strong text-txt-500" : "type-body-1-strong text-txt-700", c1 = (e) => {
  const a = "relative z-10 inline-flex size-10 shrink-0 items-center justify-center rounded-full type-h5 tabular-nums transition-all duration-200";
  if (e.isCurrent || e.done) return `${a} bg-blue-700 text-white border-none`;
  const t = e.disabled ? "text-txt-500" : "text-txt-700", s = e.disabled ? "" : "group-hover:ring-4 group-hover:ring-blue-50";
  return `${a} bg-white border-2 border-border-border-200 ${t} ${s}`.trim();
}, u1 = (e) => `block ${Ws(e)}`, f1 = (e) => {
  const a = "inline-flex size-5 shrink-0 items-center justify-center rounded-full type-caption tabular-nums transition-all duration-200";
  return e.isCurrent ? `${a} bg-blue-700 text-white border-none` : e.done ? `${a} bg-green-100 text-green-700 border-none` : `${a} bg-transparent text-txt-500 border-[1.5px] border-border-border-200`;
}, b1 = (e) => `block truncate ${Ws(e)}`, p1 = (e) => {
  const a = e.done || e.isCurrent ? "bg-blue-700" : "bg-border-border-200", t = e.disabled ? "" : "group-hover:opacity-70";
  return `block h-1.5 rounded-full transition-all duration-200 ${a} ${t}`.trim();
}, h1 = (e) => {
  const a = i(() => e.variant !== "minimal" && e.navigable), t = i(() => Math.max(e.maxReached ?? e.current, e.current)), s = (U) => {
    const ae = U < e.current, B = U === e.current, le = e.forwardLocked ? U <= t.value : !0, O = !a.value || !le && !B;
    return { done: ae, isCurrent: B, disabled: O };
  }, o = i(() => e.steps.map((U, ae) => s(ae))), d = i(
    () => ({
      gridTemplateColumns: `repeat(${Math.max(e.steps.length, 1)}, minmax(0, 1fr))`
    })
  ), u = (U) => U.disabled ? a.value ? "cursor-not-allowed" : "cursor-default" : "cursor-pointer", b = "grid list-none p-0 m-0", g = "relative text-center", h = (U) => [
    "absolute top-5 -mt-px h-0.5 left-[calc(50%+20px)] right-[calc(-50%+20px)]",
    "transition-colors duration-200",
    U < t.value ? "bg-blue-700" : "bg-border-border-200"
  ].join(" "), p = (U) => [
    "group flex w-full flex-col items-center gap-2 px-1 pb-1 bg-transparent border-none rounded-md",
    u(U),
    Fl
  ].join(" "), f = "block type-caption text-txt-500 mt-px", y = "grid list-none p-0 m-0 gap-2", w = "min-w-0", S = (U) => [
    "group block w-full text-left bg-transparent border-none p-0 rounded-md",
    u(U),
    Fl
  ].join(" "), k = "flex items-center gap-[7px] mb-2", x = "min-w-0 flex-1", $ = "block truncate type-caption text-txt-500 mt-px", D = "flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1 mb-2.5", E = "type-h5 text-txt-800", R = "type-body-2-strong text-txt-500 ml-2", V = "type-body-2 text-txt-500 whitespace-nowrap", Z = "h-2 rounded-full bg-border-border-200 overflow-hidden", G = "h-full rounded-full bg-blue-700 transition-[width] duration-300", z = i(
    () => ({
      width: e.steps.length > 1 ? `${Math.min(Math.max(e.current / (e.steps.length - 1), 0), 1) * 100}%` : "100%"
    })
  );
  return {
    isNavigable: a,
    maxIndex: t,
    stepStates: o,
    gridColumnsStyle: d,
    railListClasses: b,
    railItemClasses: g,
    railConnectorClasses: h,
    railButtonClasses: p,
    railDotClasses: c1,
    railLabelClasses: u1,
    railHintClasses: f,
    segmentsListClasses: y,
    segmentsItemClasses: w,
    segmentsButtonClasses: S,
    segmentsBadgeClasses: f1,
    segmentsLabelClasses: b1,
    segmentsRowClasses: k,
    segmentsTextClasses: x,
    segmentsHintClasses: $,
    segmentsTrackClasses: p1,
    minimalHeaderClasses: D,
    minimalTitleClasses: E,
    minimalCountClasses: R,
    minimalNextClasses: V,
    minimalTrackClasses: Z,
    minimalFillClasses: G,
    minimalFillStyle: z
  };
}, g1 = ["data-variant"], m1 = ["onFocusin"], v1 = ["disabled", "aria-current", "aria-describedby", "onClick"], y1 = ["onFocusin"], x1 = ["disabled", "aria-current", "aria-describedby", "onClick"], w1 = { key: 2 }, L1 = ["id"], C1 = {
  key: 4,
  role: "status",
  "aria-live": "polite",
  class: "sr-only"
}, yb = /* @__PURE__ */ X({
  __name: "Stepper",
  props: {
    variant: { default: "rail" },
    steps: { default: () => [] },
    current: { default: 0 },
    maxReached: {},
    navigable: { type: Boolean, default: !0 },
    forwardLocked: { type: Boolean, default: !0 },
    lockedTooltip: { default: "Complete earlier steps first" },
    goBackTooltip: {},
    stepCountLabel: {},
    nextStepLabel: {},
    finalStepLabel: { default: "Final step" },
    showNextStep: { type: Boolean, default: !0 }
  },
  emits: ["update:current", "step-change"],
  setup(e, { emit: a }) {
    const t = e, s = a, {
      isNavigable: o,
      stepStates: d,
      gridColumnsStyle: u,
      railListClasses: b,
      railItemClasses: g,
      railConnectorClasses: h,
      railButtonClasses: p,
      railDotClasses: f,
      railLabelClasses: y,
      railHintClasses: w,
      segmentsListClasses: S,
      segmentsItemClasses: k,
      segmentsButtonClasses: x,
      segmentsBadgeClasses: $,
      segmentsLabelClasses: D,
      segmentsRowClasses: E,
      segmentsTextClasses: R,
      segmentsHintClasses: V,
      segmentsTrackClasses: Z,
      minimalHeaderClasses: G,
      minimalTitleClasses: z,
      minimalCountClasses: U,
      minimalNextClasses: ae,
      minimalTrackClasses: B,
      minimalFillClasses: le,
      minimalFillStyle: O
    } = h1(t), j = (N) => t.goBackTooltip?.(N) ?? `Go back to ${N}`, _ = (N, Le) => t.stepCountLabel?.(N, Le) ?? `Step ${N} of ${Le}`, ne = (N) => t.nextStepLabel?.(N) ?? `Next: ${N}`, P = A(null), ce = Ga(), W = `${ce}-locked`, H = `${ce}-step`, fe = i(
      () => Math.min(Math.max(t.current, 0), Math.max(t.steps.length - 1, 0))
    ), $e = i(
      () => _(fe.value + 1, t.steps.length)
    ), te = i(() => t.steps[fe.value]?.label ?? ""), we = i(() => {
      const N = t.steps[fe.value + 1]?.label;
      return N ? ne(N) : t.finalStepLabel;
    }), I = (N) => o.value && d.value[N].disabled, Y = i(() => t.steps.some((N, Le) => I(Le))), be = (N) => {
      const Le = t.steps[N]?.label ?? "";
      return I(N) ? t.lockedTooltip : o.value && d.value[N].done ? j(Le) : t.variant === "segments" ? Le : void 0;
    }, J = (N) => {
      if (I(N)) return W;
      const Le = be(N);
      return Le && Le !== t.steps[N]?.label ? Q(N) : void 0;
    }, Q = (N) => `${H}-${N}`, ue = A(null), K = (N, Le) => {
      Le.target?.matches(":focus-visible") && (ue.value = N);
    }, ee = (N) => ue.value === N && be(N) ? !0 : void 0, he = (N) => {
      d.value[N].disabled || (s("update:current", N), s("step-change", N));
    }, ge = (N) => {
      if (N.key !== "ArrowLeft" && N.key !== "ArrowRight") return;
      N.preventDefault();
      const Le = Array.from(
        P.value?.querySelectorAll("[data-stepper-trigger]:not([disabled])") ?? []
      ), Me = Le.indexOf(N.currentTarget);
      if (Me === -1) return;
      Le[Me + (N.key === "ArrowRight" ? 1 : -1)]?.focus();
    };
    return (N, Le) => e.steps.length > 0 ? (n(), c("div", {
      key: 0,
      "data-variant": e.variant,
      "data-testid": "stepper"
    }, [
      e.variant === "rail" ? (n(), c("ol", {
        key: 0,
        ref_key: "listRef",
        ref: P,
        class: r(l(b)),
        style: Ee(l(u))
      }, [
        (n(!0), c(re, null, xe(e.steps, (Me, ye) => (n(), c("li", {
          key: ye,
          class: r(l(g))
        }, [
          ye < e.steps.length - 1 ? (n(), c("span", {
            key: 0,
            "aria-hidden": "true",
            class: r(l(h)(ye))
          }, null, 2)) : v("", !0),
          L(ht, {
            position: "bottom",
            label: be(ye),
            "is-open": ee(ye)
          }, {
            default: M(() => [
              m("span", {
                "data-testid": "stepper-step-tooltip-host",
                class: "block w-full",
                onFocusin: (Re) => K(ye, Re),
                onFocusout: Le[0] || (Le[0] = (Re) => ue.value = null),
                onKeydown: Le[1] || (Le[1] = Tt((Re) => ue.value = null, ["esc"]))
              }, [
                m("button", {
                  type: "button",
                  "data-stepper-trigger": "",
                  "data-testid": "stepper-step",
                  disabled: l(d)[ye].disabled,
                  "aria-current": l(d)[ye].isCurrent ? "step" : void 0,
                  "aria-describedby": J(ye),
                  class: r(l(p)(l(d)[ye])),
                  onClick: (Re) => he(ye),
                  onKeydown: ge
                }, [
                  m("span", {
                    class: r(l(f)(l(d)[ye]))
                  }, [
                    l(d)[ye].done ? (n(), F(l($t), {
                      key: 0,
                      class: "size-5",
                      "aria-hidden": "true"
                    })) : (n(), c(re, { key: 1 }, [
                      ie(C(ye + 1), 1)
                    ], 64))
                  ], 2),
                  m("span", null, [
                    m("span", {
                      class: r(l(y)(l(d)[ye]))
                    }, C(Me.label), 3),
                    Me.hint ? (n(), c("span", {
                      key: 0,
                      class: r(l(w))
                    }, C(Me.hint), 3)) : v("", !0)
                  ])
                ], 42, v1)
              ], 40, m1)
            ]),
            _: 2
          }, 1032, ["label", "is-open"])
        ], 2))), 128))
      ], 6)) : e.variant === "segments" ? (n(), c("ol", {
        key: 1,
        ref_key: "listRef",
        ref: P,
        class: r(l(S)),
        style: Ee(l(u))
      }, [
        (n(!0), c(re, null, xe(e.steps, (Me, ye) => (n(), c("li", {
          key: ye,
          class: r(l(k))
        }, [
          L(ht, {
            position: "bottom",
            label: be(ye),
            "is-open": ee(ye)
          }, {
            default: M(() => [
              m("span", {
                "data-testid": "stepper-step-tooltip-host",
                class: "block w-full",
                onFocusin: (Re) => K(ye, Re),
                onFocusout: Le[2] || (Le[2] = (Re) => ue.value = null),
                onKeydown: Le[3] || (Le[3] = Tt((Re) => ue.value = null, ["esc"]))
              }, [
                m("button", {
                  type: "button",
                  "data-stepper-trigger": "",
                  "data-testid": "stepper-step",
                  disabled: l(d)[ye].disabled,
                  "aria-current": l(d)[ye].isCurrent ? "step" : void 0,
                  "aria-describedby": J(ye),
                  class: r(l(x)(l(d)[ye])),
                  onClick: (Re) => he(ye),
                  onKeydown: ge
                }, [
                  m("span", {
                    class: r(l(E))
                  }, [
                    m("span", {
                      class: r(l($)(l(d)[ye]))
                    }, [
                      l(d)[ye].done ? (n(), F(l($t), {
                        key: 0,
                        class: "size-3",
                        "aria-hidden": "true"
                      })) : (n(), c(re, { key: 1 }, [
                        ie(C(ye + 1), 1)
                      ], 64))
                    ], 2),
                    m("span", {
                      class: r(l(R))
                    }, [
                      m("span", {
                        class: r(l(D)(l(d)[ye]))
                      }, C(Me.label), 3),
                      Me.hint ? (n(), c("span", {
                        key: 0,
                        class: r(l(V))
                      }, C(Me.hint), 3)) : v("", !0)
                    ], 2)
                  ], 2),
                  m("span", {
                    class: r(l(Z)(l(d)[ye]))
                  }, null, 2)
                ], 42, x1)
              ], 40, y1)
            ]),
            _: 2
          }, 1032, ["label", "is-open"])
        ], 2))), 128))
      ], 6)) : (n(), c("div", w1, [
        m("div", {
          class: r(l(G))
        }, [
          m("span", {
            class: r(l(z)),
            "data-testid": "stepper-title"
          }, [
            ie(C(te.value) + " ", 1),
            m("span", {
              class: r(l(U)),
              "data-testid": "stepper-count"
            }, C($e.value), 3)
          ], 2),
          e.showNextStep ? (n(), c("span", {
            key: 0,
            class: r(l(ae)),
            "data-testid": "stepper-next"
          }, C(we.value), 3)) : v("", !0)
        ], 2),
        m("div", {
          class: r(l(B))
        }, [
          m("div", {
            "data-testid": "stepper-fill",
            class: r(l(le)),
            style: Ee(l(O))
          }, null, 6)
        ], 2)
      ])),
      Y.value ? (n(), c("span", {
        key: 3,
        id: W,
        class: "sr-only"
      }, C(e.lockedTooltip), 1)) : v("", !0),
      (n(!0), c(re, null, xe(e.steps, (Me, ye) => (n(), c(re, {
        key: `description-${ye}`
      }, [
        e.variant !== "minimal" && J(ye) === Q(ye) ? (n(), c("span", {
          key: 0,
          id: Q(ye),
          class: "sr-only"
        }, C(be(ye)), 9, L1)) : v("", !0)
      ], 64))), 128)),
      e.variant !== "minimal" ? (n(), c("span", C1, C($e.value), 1)) : v("", !0)
    ], 8, g1)) : v("", !0);
  }
}), k1 = { class: "flex w-full flex-col" }, xb = /* @__PURE__ */ X({
  __name: "TextField",
  props: {
    errorMessage: {},
    infoMessage: {},
    warnMessage: {},
    id: {},
    modelValue: {},
    class: { type: [Boolean, null, String, Object, Array] },
    placeholder: {},
    label: {},
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: {},
    ariaLabel: {},
    isDisabled: { type: Boolean },
    isReadOnly: { type: Boolean },
    isClearable: { type: Boolean },
    isCopyable: { type: Boolean },
    isLoading: { type: Boolean },
    variant: {},
    isInvalid: { type: Boolean },
    isRequired: { type: Boolean },
    type: {},
    inputMode: {},
    maxLength: {},
    size: {}
  },
  emits: ["update:modelValue", "blur", "focus", "clear"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = i(() => t.isInvalid || !!t.errorMessage), d = i(
      () => !!(t.errorMessage || t.warnMessage || t.infoMessage)
    ), u = i(() => `${t.id}-message`), b = i(() => {
      const h = [t.ariaDescribedby, d.value ? u.value : void 0].filter(
        Boolean
      );
      return h.length > 0 ? h.join(" ") : void 0;
    }), g = i(() => {
      const { errorMessage: h, warnMessage: p, infoMessage: f, ...y } = t;
      return y;
    });
    return (h, p) => (n(), c("div", k1, [
      L(Ba, Oe(g.value, {
        "is-invalid": o.value,
        "aria-describedby": b.value,
        "onUpdate:modelValue": p[0] || (p[0] = (f) => s("update:modelValue", f)),
        onBlur: p[1] || (p[1] = (f) => s("blur", f)),
        onFocus: p[2] || (p[2] = (f) => s("focus", f)),
        onClear: p[3] || (p[3] = (f) => s("clear"))
      }), tt({ _: 2 }, [
        xe(h.$slots, (f, y) => ({
          name: y,
          fn: M((w) => [
            T(h.$slots, y, ca(ua(w || {})))
          ])
        }))
      ]), 1040, ["is-invalid", "aria-describedby"]),
      e.errorMessage ? (n(), F(Be, {
        key: 0,
        id: u.value,
        message: e.errorMessage,
        type: "error",
        class: r(e.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : e.warnMessage ? (n(), F(Be, {
        key: 1,
        id: u.value,
        message: e.warnMessage,
        type: "warn",
        class: r(e.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : e.infoMessage ? (n(), F(Be, {
        key: 2,
        id: u.value,
        message: e.infoMessage,
        type: "info",
        class: r(e.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : v("", !0)
    ]));
  }
}), $1 = { class: "flex w-full flex-col" }, wb = /* @__PURE__ */ X({
  __name: "SelectField",
  props: {
    errorMessage: {},
    infoMessage: {},
    warnMessage: {},
    messageClass: { type: [Boolean, null, String, Object, Array] },
    id: {},
    modelValue: {},
    options: {},
    class: { type: [Boolean, null, String, Object, Array] },
    placeholder: {},
    label: {},
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: {},
    ariaLabel: {},
    name: {},
    isDisabled: { type: Boolean },
    isReadOnly: { type: Boolean },
    isClearable: { type: Boolean },
    isInvalid: { type: Boolean },
    isRequired: { type: Boolean },
    variant: {},
    size: {},
    showSelectedAvatar: { type: Boolean, default: !0 },
    menuMaxRows: {},
    menuTitle: {},
    menuDescription: {},
    isSearchable: { type: Boolean },
    searchPlaceholder: {},
    menuWidth: {},
    noMatchesText: {}
  },
  emits: ["update:modelValue", "change", "blur", "focus", "clear"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = i(() => t.isInvalid || !!t.errorMessage), d = i(
      () => !!(t.errorMessage || t.warnMessage || t.infoMessage)
    ), u = i(() => `${t.id}-message`), b = i(() => {
      const h = [t.ariaDescribedby, d.value ? u.value : void 0].filter(
        Boolean
      );
      return h.length > 0 ? h.join(" ") : void 0;
    }), g = i(() => {
      const { errorMessage: h, warnMessage: p, infoMessage: f, messageClass: y, ...w } = t;
      return w;
    });
    return (h, p) => (n(), c("div", $1, [
      L(Ai, Oe(g.value, {
        "is-invalid": o.value,
        "aria-describedby": b.value,
        "onUpdate:modelValue": p[0] || (p[0] = (f) => s("update:modelValue", f)),
        onChange: p[1] || (p[1] = (f) => s("change", f)),
        onBlur: p[2] || (p[2] = (f) => s("blur", f)),
        onFocus: p[3] || (p[3] = (f) => s("focus", f)),
        onClear: p[4] || (p[4] = (f) => s("clear"))
      }), tt({ _: 2 }, [
        xe(h.$slots, (f, y) => ({
          name: y,
          fn: M((w) => [
            T(h.$slots, y, ca(ua(w || {})))
          ])
        }))
      ]), 1040, ["is-invalid", "aria-describedby"]),
      e.errorMessage ? (n(), F(Be, {
        key: 0,
        id: u.value,
        message: e.errorMessage,
        type: "error",
        class: r([e.isReadOnly ? "pl-0" : "pl-2", e.messageClass])
      }, null, 8, ["id", "message", "class"])) : e.warnMessage ? (n(), F(Be, {
        key: 1,
        id: u.value,
        message: e.warnMessage,
        type: "warn",
        class: r([e.isReadOnly ? "pl-0" : "pl-2", e.messageClass])
      }, null, 8, ["id", "message", "class"])) : e.infoMessage ? (n(), F(Be, {
        key: 2,
        id: u.value,
        message: e.infoMessage,
        type: "info",
        class: r([e.isReadOnly ? "pl-0" : "pl-2", e.messageClass])
      }, null, 8, ["id", "message", "class"])) : v("", !0)
    ]));
  }
}), M1 = { class: "flex w-full flex-col" }, Lb = /* @__PURE__ */ X({
  __name: "DatePickerField",
  props: {
    errorMessage: {},
    infoMessage: {},
    warnMessage: {},
    id: {},
    modelValue: {},
    class: { type: [Boolean, null, String, Object, Array] },
    placeholder: {},
    label: {},
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: {},
    ariaLabel: {},
    name: {},
    isDisabled: { type: Boolean },
    isReadOnly: { type: Boolean },
    isClearable: { type: Boolean },
    showTodayButton: { type: Boolean },
    isInvalid: { type: Boolean },
    isRequired: { type: Boolean },
    variant: {},
    size: {},
    minDate: {},
    maxDate: {},
    locale: {},
    formatOptions: {},
    weekStartsOn: {}
  },
  emits: ["update:modelValue", "change", "blur", "focus", "clear"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = i(() => t.isInvalid || !!t.errorMessage), d = i(
      () => !!(t.errorMessage || t.warnMessage || t.infoMessage)
    ), u = i(() => `${t.id}-message`), b = i(() => {
      const h = [t.ariaDescribedby, d.value ? u.value : void 0].filter(
        Boolean
      );
      return h.length > 0 ? h.join(" ") : void 0;
    }), g = i(() => {
      const { errorMessage: h, warnMessage: p, infoMessage: f, ...y } = t;
      return y;
    });
    return (h, p) => (n(), c("div", M1, [
      L(Ud, Oe(g.value, {
        "is-invalid": o.value,
        "aria-describedby": b.value,
        "onUpdate:modelValue": p[0] || (p[0] = (f) => s("update:modelValue", f)),
        onChange: p[1] || (p[1] = (f) => s("change", f)),
        onBlur: p[2] || (p[2] = (f) => s("blur", f)),
        onFocus: p[3] || (p[3] = (f) => s("focus", f)),
        onClear: p[4] || (p[4] = (f) => s("clear"))
      }), null, 16, ["is-invalid", "aria-describedby"]),
      e.errorMessage ? (n(), F(Be, {
        key: 0,
        id: u.value,
        message: e.errorMessage,
        type: "error",
        class: r(e.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : e.warnMessage ? (n(), F(Be, {
        key: 1,
        id: u.value,
        message: e.warnMessage,
        type: "warn",
        class: r(e.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : e.infoMessage ? (n(), F(Be, {
        key: 2,
        id: u.value,
        message: e.infoMessage,
        type: "info",
        class: r(e.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : v("", !0)
    ]));
  }
}), V1 = { class: "flex w-full flex-col" }, Cb = /* @__PURE__ */ X({
  __name: "DateRangePickerField",
  props: {
    errorMessage: {},
    infoMessage: {},
    warnMessage: {},
    id: {},
    modelValue: {},
    class: { type: [Boolean, null, String, Object, Array] },
    placeholder: {},
    label: {},
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: {},
    ariaLabel: {},
    name: {},
    isDisabled: { type: Boolean },
    isReadOnly: { type: Boolean },
    isClearable: { type: Boolean },
    isInvalid: { type: Boolean },
    isRequired: { type: Boolean },
    variant: {},
    size: {},
    minDate: {},
    maxDate: {},
    locale: {},
    formatOptions: {},
    weekStartsOn: {},
    numberOfMonths: {}
  },
  emits: ["update:modelValue", "change", "blur", "focus", "clear"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = i(() => t.isInvalid || !!t.errorMessage), d = i(
      () => !!(t.errorMessage || t.warnMessage || t.infoMessage)
    ), u = i(() => `${t.id}-message`), b = i(() => {
      const h = [t.ariaDescribedby, d.value ? u.value : void 0].filter(
        Boolean
      );
      return h.length > 0 ? h.join(" ") : void 0;
    }), g = i(() => {
      const { errorMessage: h, warnMessage: p, infoMessage: f, ...y } = t;
      return y;
    });
    return (h, p) => (n(), c("div", V1, [
      L(fc, Oe(g.value, {
        "is-invalid": o.value,
        "aria-describedby": b.value,
        "onUpdate:modelValue": p[0] || (p[0] = (f) => s("update:modelValue", f)),
        onChange: p[1] || (p[1] = (f) => s("change", f)),
        onBlur: p[2] || (p[2] = (f) => s("blur", f)),
        onFocus: p[3] || (p[3] = (f) => s("focus", f)),
        onClear: p[4] || (p[4] = (f) => s("clear"))
      }), null, 16, ["is-invalid", "aria-describedby"]),
      e.errorMessage ? (n(), F(Be, {
        key: 0,
        id: u.value,
        message: e.errorMessage,
        type: "error",
        class: r(e.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : e.warnMessage ? (n(), F(Be, {
        key: 1,
        id: u.value,
        message: e.warnMessage,
        type: "warn",
        class: r(e.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : e.infoMessage ? (n(), F(Be, {
        key: 2,
        id: u.value,
        message: e.infoMessage,
        type: "info",
        class: r(e.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : v("", !0)
    ]));
  }
}), S1 = { class: "flex w-full flex-col" }, B1 = {
  key: 0,
  class: "flex items-start"
}, kb = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "TextAreaField",
  props: {
    errorMessage: {},
    infoMessage: {},
    warnMessage: {},
    showCharCount: { type: Boolean },
    id: {},
    modelValue: {},
    class: { type: [Boolean, null, String, Object, Array] },
    placeholder: {},
    label: {},
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: {},
    isDisabled: { type: Boolean },
    isReadOnly: { type: Boolean },
    isInvalid: { type: Boolean },
    isRequired: { type: Boolean },
    size: {},
    rows: {},
    autoResize: { type: Boolean },
    isResizable: { type: Boolean },
    maxlength: {}
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = i(() => t.isInvalid || !!t.errorMessage), d = i(
      () => !!(t.errorMessage || t.warnMessage || t.infoMessage)
    ), u = i(() => `${t.id}-message`), b = i(
      () => t.showCharCount && !t.isReadOnly && typeof t.maxlength == "number" && t.maxlength > 0
    ), g = i(() => String(t.modelValue ?? "").length), h = i(() => [
      "mt-1 ml-auto shrink-0 pr-2 type-body-2",
      t.maxlength !== void 0 && g.value >= t.maxlength ? "text-red-600" : "text-txt-500"
    ]), p = i(() => {
      const y = [t.ariaDescribedby, d.value ? u.value : void 0].filter(
        Boolean
      );
      return y.length > 0 ? y.join(" ") : void 0;
    }), f = i(() => {
      const { errorMessage: y, infoMessage: w, showCharCount: S, ...k } = t;
      return k;
    });
    return (y, w) => (n(), c("div", S1, [
      L(ld, Oe({ ...f.value, ...y.$attrs }, {
        "is-invalid": o.value,
        "aria-describedby": p.value,
        "onUpdate:modelValue": w[0] || (w[0] = (S) => s("update:modelValue", S)),
        onBlur: w[1] || (w[1] = (S) => s("blur", S)),
        onFocus: w[2] || (w[2] = (S) => s("focus", S))
      }), null, 16, ["is-invalid", "aria-describedby"]),
      d.value || b.value ? (n(), c("div", B1, [
        e.errorMessage ? (n(), F(Be, {
          key: 0,
          id: u.value,
          message: e.errorMessage,
          type: "error",
          class: r(e.isReadOnly ? "pl-0" : "pl-2")
        }, null, 8, ["id", "message", "class"])) : e.warnMessage ? (n(), F(Be, {
          key: 1,
          id: u.value,
          message: e.warnMessage,
          type: "warn",
          class: r(e.isReadOnly ? "pl-0" : "pl-2")
        }, null, 8, ["id", "message", "class"])) : e.infoMessage ? (n(), F(Be, {
          key: 2,
          id: u.value,
          message: e.infoMessage,
          type: "info",
          class: r(e.isReadOnly ? "pl-0" : "pl-2")
        }, null, 8, ["id", "message", "class"])) : v("", !0),
        b.value ? (n(), c("span", {
          key: 3,
          class: r(h.value),
          "aria-hidden": "true"
        }, C(g.value) + " / " + C(e.maxlength), 3)) : v("", !0)
      ])) : v("", !0)
    ]));
  }
}), E1 = { class: "flex w-full flex-col" }, $b = /* @__PURE__ */ X({
  __name: "AutoCompleteField",
  props: {
    errorMessage: {},
    infoMessage: {},
    warnMessage: {},
    messageClass: { type: [Boolean, null, String, Object, Array] },
    id: {},
    modelValue: {},
    options: {},
    class: { type: [Boolean, null, String, Object, Array] },
    placeholder: {},
    label: {},
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: {},
    ariaLabel: {},
    name: {},
    isDisabled: { type: Boolean },
    isReadOnly: { type: Boolean },
    isClearable: { type: Boolean },
    isInvalid: { type: Boolean },
    isRequired: { type: Boolean },
    isLoading: { type: Boolean },
    ignoreFilter: { type: Boolean },
    emptyMessage: {},
    loadingMessage: {},
    size: {},
    variant: {}
  },
  emits: ["update:modelValue", "change", "update:query", "blur", "focus", "clear"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = i(() => t.isInvalid || !!t.errorMessage), d = i(
      () => !!(t.errorMessage || t.warnMessage || t.infoMessage)
    ), u = i(() => `${t.id}-message`), b = i(() => {
      const h = [t.ariaDescribedby, d.value ? u.value : void 0].filter(
        Boolean
      );
      return h.length > 0 ? h.join(" ") : void 0;
    }), g = i(() => {
      const { errorMessage: h, warnMessage: p, infoMessage: f, messageClass: y, ...w } = t;
      return w;
    });
    return (h, p) => (n(), c("div", E1, [
      L(Pi, Oe(g.value, {
        "is-invalid": o.value,
        "aria-describedby": b.value,
        "onUpdate:modelValue": p[0] || (p[0] = (f) => s("update:modelValue", f)),
        onChange: p[1] || (p[1] = (f) => s("change", f)),
        "onUpdate:query": p[2] || (p[2] = (f) => s("update:query", f)),
        onBlur: p[3] || (p[3] = (f) => s("blur", f)),
        onFocus: p[4] || (p[4] = (f) => s("focus", f)),
        onClear: p[5] || (p[5] = (f) => s("clear"))
      }), tt({ _: 2 }, [
        xe(h.$slots, (f, y) => ({
          name: y,
          fn: M((w) => [
            T(h.$slots, y, ca(ua(w || {})))
          ])
        }))
      ]), 1040, ["is-invalid", "aria-describedby"]),
      e.errorMessage ? (n(), F(Be, {
        key: 0,
        id: u.value,
        message: e.errorMessage,
        type: "error",
        class: r([e.isReadOnly ? "pl-0" : "pl-2", e.messageClass])
      }, null, 8, ["id", "message", "class"])) : e.warnMessage ? (n(), F(Be, {
        key: 1,
        id: u.value,
        message: e.warnMessage,
        type: "warn",
        class: r([e.isReadOnly ? "pl-0" : "pl-2", e.messageClass])
      }, null, 8, ["id", "message", "class"])) : e.infoMessage ? (n(), F(Be, {
        key: 2,
        id: u.value,
        message: e.infoMessage,
        type: "info",
        class: r([e.isReadOnly ? "pl-0" : "pl-2", e.messageClass])
      }, null, 8, ["id", "message", "class"])) : v("", !0)
    ]));
  }
}), D1 = { class: "flex w-full flex-col" }, Mb = /* @__PURE__ */ X({
  __name: "ComboboxField",
  props: {
    errorMessage: {},
    infoMessage: {},
    warnMessage: {},
    id: {},
    modelValue: {},
    suggestions: {},
    filter: { type: [Boolean, Function], default: !0 },
    class: { type: [Boolean, null, String, Object, Array] },
    placeholder: {},
    label: {},
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: {},
    ariaLabel: {},
    name: {},
    type: {},
    inputMode: {},
    isDisabled: { type: Boolean },
    isReadOnly: { type: Boolean },
    isClearable: { type: Boolean },
    isInvalid: { type: Boolean },
    isRequired: { type: Boolean },
    isLoading: { type: Boolean },
    variant: {},
    size: {},
    showSelectedAvatar: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "select", "blur", "focus", "clear"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = i(() => t.isInvalid || !!t.errorMessage), d = i(
      () => !!(t.errorMessage || t.warnMessage || t.infoMessage)
    ), u = i(() => `${t.id}-message`), b = i(() => {
      const h = [t.ariaDescribedby, d.value ? u.value : void 0].filter(
        Boolean
      );
      return h.length > 0 ? h.join(" ") : void 0;
    }), g = i(() => {
      const { errorMessage: h, warnMessage: p, infoMessage: f, ...y } = t;
      return y;
    });
    return (h, p) => (n(), c("div", D1, [
      L(Ji, Oe(g.value, {
        "is-invalid": o.value,
        "aria-describedby": b.value,
        "onUpdate:modelValue": p[0] || (p[0] = (f) => s("update:modelValue", f)),
        onSelect: p[1] || (p[1] = (f) => s("select", f)),
        onBlur: p[2] || (p[2] = (f) => s("blur", f)),
        onFocus: p[3] || (p[3] = (f) => s("focus", f)),
        onClear: p[4] || (p[4] = (f) => s("clear"))
      }), tt({ _: 2 }, [
        xe(h.$slots, (f, y) => ({
          name: y,
          fn: M((w) => [
            T(h.$slots, y, ca(ua(w || {})))
          ])
        }))
      ]), 1040, ["is-invalid", "aria-describedby"]),
      e.errorMessage ? (n(), F(Be, {
        key: 0,
        id: u.value,
        message: e.errorMessage,
        type: "error",
        class: r(e.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : e.warnMessage ? (n(), F(Be, {
        key: 1,
        id: u.value,
        message: e.warnMessage,
        type: "warn",
        class: r(e.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : e.infoMessage ? (n(), F(Be, {
        key: 2,
        id: u.value,
        message: e.infoMessage,
        type: "info",
        class: r(e.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : v("", !0)
    ]));
  }
}), F1 = { class: "flex w-full flex-col" }, Vb = /* @__PURE__ */ X({
  __name: "NumberField",
  props: {
    errorMessage: {},
    infoMessage: {},
    warnMessage: {},
    messageClass: { type: [Boolean, null, String, Object, Array] },
    id: {},
    modelValue: {},
    label: {},
    floatLabel: { type: Boolean, default: !0 },
    placeholder: {},
    class: { type: [Boolean, null, String, Object, Array] },
    ariaDescribedby: {},
    ariaLabel: {},
    variant: {},
    size: {},
    isDisabled: { type: Boolean },
    isReadOnly: { type: Boolean },
    isInvalid: { type: Boolean },
    isRequired: { type: Boolean },
    isClearable: { type: Boolean },
    mode: {},
    locale: {},
    currency: {},
    min: {},
    max: {},
    minFractionDigits: {},
    maxFractionDigits: {},
    useGrouping: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "blur", "focus", "clear"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = i(() => t.isInvalid || !!t.errorMessage), d = i(
      () => !!(t.errorMessage || t.warnMessage || t.infoMessage)
    ), u = i(() => `${t.id}-message`), b = i(() => {
      const h = [t.ariaDescribedby, d.value ? u.value : void 0].filter(
        Boolean
      );
      return h.length > 0 ? h.join(" ") : void 0;
    }), g = i(() => {
      const { errorMessage: h, warnMessage: p, infoMessage: f, messageClass: y, ...w } = t;
      return w;
    });
    return (h, p) => (n(), c("div", F1, [
      L(bc, Oe(g.value, {
        "is-invalid": o.value,
        "aria-describedby": b.value,
        "onUpdate:modelValue": p[0] || (p[0] = (f) => s("update:modelValue", f)),
        onBlur: p[1] || (p[1] = (f) => s("blur", f)),
        onFocus: p[2] || (p[2] = (f) => s("focus", f)),
        onClear: p[3] || (p[3] = (f) => s("clear"))
      }), tt({ _: 2 }, [
        xe(h.$slots, (f, y) => ({
          name: y,
          fn: M((w) => [
            T(h.$slots, y, ca(ua(w || {})))
          ])
        }))
      ]), 1040, ["is-invalid", "aria-describedby"]),
      e.errorMessage ? (n(), F(Be, {
        key: 0,
        id: u.value,
        message: e.errorMessage,
        type: "error",
        class: r([e.isReadOnly ? "pl-0" : "pl-2", e.messageClass])
      }, null, 8, ["id", "message", "class"])) : e.warnMessage ? (n(), F(Be, {
        key: 1,
        id: u.value,
        message: e.warnMessage,
        type: "warn",
        class: r([e.isReadOnly ? "pl-0" : "pl-2", e.messageClass])
      }, null, 8, ["id", "message", "class"])) : e.infoMessage ? (n(), F(Be, {
        key: 2,
        id: u.value,
        message: e.infoMessage,
        type: "info",
        class: r([e.isReadOnly ? "pl-0" : "pl-2", e.messageClass])
      }, null, 8, ["id", "message", "class"])) : v("", !0)
    ]));
  }
}), R1 = { class: "flex w-full flex-col" }, Sb = /* @__PURE__ */ X({
  __name: "PhoneNumberField",
  props: {
    errorMessage: {},
    infoMessage: {},
    warnMessage: {},
    id: {},
    modelValue: {},
    countryCode: {},
    countries: {},
    class: { type: [Boolean, null, String, Object, Array] },
    placeholder: {},
    label: {},
    floatLabel: { type: Boolean, default: !0 },
    ariaDescribedby: {},
    ariaLabel: {},
    name: {},
    isDisabled: { type: Boolean },
    isReadOnly: { type: Boolean },
    isInvalid: { type: Boolean },
    isRequired: { type: Boolean },
    noCountryCode: { type: Boolean },
    maxLength: {},
    stripLeadingZero: { type: Boolean },
    groupSizes: {},
    size: {},
    searchPlaceholder: {},
    emptyMessage: {}
  },
  emits: ["update:modelValue", "update:countryCode", "blur", "focus"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = i(() => t.isInvalid || !!t.errorMessage), d = i(
      () => !!(t.errorMessage || t.warnMessage || t.infoMessage)
    ), u = i(() => `${t.id}-message`), b = i(() => {
      const h = [t.ariaDescribedby, d.value ? u.value : void 0].filter(
        Boolean
      );
      return h.length > 0 ? h.join(" ") : void 0;
    }), g = i(() => {
      const { errorMessage: h, warnMessage: p, infoMessage: f, ...y } = t;
      return y;
    });
    return (h, p) => (n(), c("div", R1, [
      L(yc, Oe(g.value, {
        "is-invalid": o.value,
        "aria-describedby": b.value,
        "onUpdate:modelValue": p[0] || (p[0] = (f) => s("update:modelValue", f)),
        "onUpdate:countryCode": p[1] || (p[1] = (f) => s("update:countryCode", f)),
        onBlur: p[2] || (p[2] = (f) => s("blur", f)),
        onFocus: p[3] || (p[3] = (f) => s("focus", f))
      }), null, 16, ["is-invalid", "aria-describedby"]),
      e.errorMessage ? (n(), F(Be, {
        key: 0,
        id: u.value,
        message: e.errorMessage,
        type: "error",
        class: r(e.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : e.warnMessage ? (n(), F(Be, {
        key: 1,
        id: u.value,
        message: e.warnMessage,
        type: "warn",
        class: r(e.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : e.infoMessage ? (n(), F(Be, {
        key: 2,
        id: u.value,
        message: e.infoMessage,
        type: "info",
        class: r(e.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : v("", !0)
    ]));
  }
}), I1 = (e) => [
  "flex h-8 w-8 shrink-0 items-center justify-center rounded-md",
  e ? "bg-red-50 text-red-600" : "bg-blue-50 text-blue-700"
].join(" ");
function T1() {
  return {
    wrapperClasses: "w-full min-w-0",
    frameClasses: "flex w-full flex-col overflow-hidden rounded-lg border border-border-border-200 bg-white",
    headerClasses: "flex items-center justify-between gap-4 p-4",
    titleClasses: "type-h4 text-txt-800",
    countPillClasses: "rounded-full bg-blue-50 px-2 py-0.5 type-body-2 tabular-nums",
    constraintClasses: "type-body-1 text-txt-600",
    emptyMessageClasses: "border-t border-border-border-200 px-4 py-6 text-center type-body-1 text-txt-600",
    rowClasses: "flex items-center gap-3 border-t border-border-border-200 px-4 py-3 transition-colors duration-200 ease-in-out hover:bg-background-light-100",
    badgeClasses: I1,
    fileNameClasses: "truncate type-body-1 text-txt-800",
    descriptionClasses: "truncate type-body-2 text-txt-600",
    reasonClasses: "truncate type-body-2 text-red-600",
    sizeClasses: "shrink-0 type-body-1 text-txt-700 tabular-nums",
    progressTrackClasses: "mt-1.5 h-1 w-full overflow-hidden rounded-full bg-gray-50",
    progressFillClasses: "h-full rounded-full bg-blue-700 transition-[width] duration-200 ease-in-out motion-reduce:transition-none"
  };
}
const A1 = ["id", "accept", "multiple", "disabled", "aria-describedby"], O1 = { class: "flex min-w-0 flex-col gap-1" }, z1 = { class: "flex items-center gap-2" }, H1 = ["for"], Z1 = { class: "flex min-w-0 flex-1 flex-col gap-0.5" }, P1 = ["aria-label", "aria-valuenow"], Bb = /* @__PURE__ */ X({
  __name: "DocumentUpload",
  props: {
    id: {},
    modelValue: { default: () => [] },
    label: { default: "Documents" },
    multiple: { type: Boolean, default: !0 },
    accept: {},
    maxSizeMb: { default: 10 },
    constraintLabel: {},
    emptyMessage: { default: "No documents yet. Upload a file to get started." },
    uploadLabel: { default: "Upload" },
    typeErrorMessage: { default: "This file type is not supported." },
    sizeErrorMessage: {},
    canUpload: { type: Boolean, default: !0 },
    canDownload: { type: Boolean, default: !0 },
    canDelete: { type: Boolean, default: !0 },
    errorMessage: {},
    infoMessage: {},
    warnMessage: {},
    class: { type: [Boolean, null, String, Object, Array] }
  },
  emits: ["update:modelValue", "upload", "remove", "download"],
  setup(e, { emit: a }) {
    const t = e, s = a, {
      wrapperClasses: o,
      frameClasses: d,
      headerClasses: u,
      titleClasses: b,
      countPillClasses: g,
      constraintClasses: h,
      emptyMessageClasses: p,
      rowClasses: f,
      badgeClasses: y,
      fileNameClasses: w,
      descriptionClasses: S,
      reasonClasses: k,
      sizeClasses: x,
      progressTrackClasses: $,
      progressFillClasses: D
    } = T1(), E = A([]), R = A(null);
    let V = 0;
    const Z = i(() => `${t.id}-message`), G = i(
      () => !!t.errorMessage || !!t.warnMessage || !!t.infoMessage
    ), z = i(() => t.errorMessage || t.warnMessage || t.infoMessage), U = i(() => t.errorMessage ? "error" : t.warnMessage ? "warn" : "info"), ae = i(
      () => t.sizeErrorMessage ?? `This file is larger than the ${t.maxSizeMb} MB limit.`
    ), B = (W) => {
      if (!W) return "";
      const H = W / 1048576;
      return H >= 1 ? `${H.toFixed(1)} MB` : `${Math.max(1, Math.round(W / 1024))} KB`;
    }, le = i(() => [
      ...t.modelValue.map((W) => ({
        key: W.id,
        name: W.name,
        description: W.description ?? "",
        sizeLabel: B(W.size ?? W.file?.size ?? 0),
        isUploading: !!W.isUploading,
        progress: Math.round(Math.min(100, Math.max(0, W.progress ?? 0))),
        canDownload: t.canDownload && !W.isUploading && !W.file,
        canRemove: t.canDelete,
        item: W
      })),
      ...E.value.map((W) => ({
        key: W.key,
        name: W.name,
        description: "",
        sizeLabel: B(W.size),
        isUploading: !1,
        progress: 0,
        canDownload: !1,
        // Dismissing a rejection clears an error rather than deleting a document, so it stays
        // available even without delete rights — otherwise the row is stuck on screen.
        canRemove: !0,
        reason: W.reason === "type" ? t.typeErrorMessage : ae.value
      }))
    ]), O = (W) => {
      const H = t.accept?.trim();
      if (!H) return !0;
      const fe = W.type.toLowerCase(), $e = W.name.toLowerCase();
      return H.split(",").map((te) => te.trim().toLowerCase()).filter(Boolean).some((te) => te.endsWith("/*") ? fe.startsWith(te.slice(0, -1)) : te.startsWith(".") ? $e.endsWith(te) : fe === te);
    }, j = (W) => {
      if (!O(W)) return "type";
      if (t.maxSizeMb && W.size > t.maxSizeMb * 1024 * 1024) return "size";
    }, _ = () => {
      t.canUpload && R.value?.click();
    }, ne = (W) => {
      const H = W.target, fe = Array.from(H.files ?? []);
      if (H.value = "", !t.canUpload || fe.length === 0) return;
      const $e = [], te = [];
      for (const I of fe) {
        const Y = j(I);
        if (Y) {
          V += 1, te.push({
            key: `${t.id}-rejected-${V}`,
            name: I.name,
            size: I.size,
            reason: Y
          });
          continue;
        }
        $e.push(I);
      }
      if (E.value = te, $e.length === 0) return;
      const we = $e.map((I) => (V += 1, {
        id: `${t.id}-local-${V}`,
        name: I.name,
        size: I.size,
        file: I
      }));
      s("update:modelValue", t.multiple ? [...t.modelValue, ...we] : we), s("upload", $e);
    }, P = (W) => {
      if (!W.item) {
        E.value = E.value.filter((H) => H.key !== W.key);
        return;
      }
      t.canDelete && (s(
        "update:modelValue",
        t.modelValue.filter((H) => H.id !== W.item?.id)
      ), s("remove", W.item));
    }, ce = (W) => {
      !W.item || !W.canDownload || s("download", W.item);
    };
    return (W, H) => (n(), c("div", {
      class: r(l(q)(l(o), t.class))
    }, [
      m("input", {
        id: t.id,
        ref_key: "fileInput",
        ref: R,
        type: "file",
        class: "hidden",
        accept: t.accept,
        multiple: t.multiple,
        disabled: !t.canUpload,
        "aria-describedby": G.value ? Z.value : void 0,
        onChange: ne
      }, null, 40, A1),
      m("div", {
        class: r(l(d))
      }, [
        m("div", {
          class: r(l(u))
        }, [
          m("div", O1, [
            m("div", z1, [
              m("label", {
                for: t.id,
                class: r(l(b))
              }, C(t.label), 11, H1),
              t.modelValue.length > 0 ? (n(), F(Sa, {
                key: 0,
                color: "blue",
                size: "sm",
                label: String(t.modelValue.length),
                class: r(l(g)),
                "data-testid": "document-upload-count"
              }, null, 8, ["label", "class"])) : v("", !0)
            ]),
            t.constraintLabel ? (n(), c("p", {
              key: 0,
              class: r(l(h))
            }, C(t.constraintLabel), 3)) : v("", !0)
          ]),
          t.canUpload ? (n(), F(Ze, {
            key: 0,
            variant: "tertiary",
            size: "sm",
            type: "button",
            class: "shrink-0",
            "data-testid": "document-upload-button",
            onClick: _
          }, {
            "left-icon": M(() => [
              L(l(vs), { class: "h-4 w-4" })
            ]),
            default: M(() => [
              ie(" " + C(t.uploadLabel), 1)
            ]),
            _: 1
          })) : v("", !0)
        ], 2),
        le.value.length === 0 ? (n(), c("p", {
          key: 0,
          class: r(l(p)),
          "data-testid": "document-upload-empty"
        }, C(t.emptyMessage), 3)) : v("", !0),
        (n(!0), c(re, null, xe(le.value, (fe) => (n(), c("div", {
          key: fe.key,
          class: r(l(f)),
          "data-testid": "document-upload-row"
        }, [
          m("span", {
            class: r(l(y)(!!fe.reason))
          }, [
            L(l(ai), { class: "h-4 w-4" })
          ], 2),
          m("div", Z1, [
            m("span", {
              class: r(l(w))
            }, C(fe.name), 3),
            fe.reason ? (n(), c("p", {
              key: 0,
              class: r(l(k)),
              role: "alert"
            }, C(fe.reason), 3)) : fe.description ? (n(), c("p", {
              key: 1,
              class: r(l(S))
            }, C(fe.description), 3)) : v("", !0),
            fe.isUploading ? (n(), c("div", {
              key: 2,
              class: r(l($)),
              role: "progressbar",
              "aria-label": `Uploading ${fe.name}`,
              "aria-valuemin": "0",
              "aria-valuemax": "100",
              "aria-valuenow": fe.progress
            }, [
              m("div", {
                class: r(l(D)),
                style: Ee({ width: `${fe.progress}%` })
              }, null, 6)
            ], 10, P1)) : v("", !0)
          ]),
          fe.sizeLabel ? (n(), c("span", {
            key: 0,
            class: r(l(x))
          }, C(fe.sizeLabel), 3)) : v("", !0),
          fe.canDownload ? (n(), F(Ze, {
            key: 1,
            variant: "tertiary",
            severity: "neutral",
            size: "sm",
            type: "button",
            "is-icon-only": "",
            "aria-label": `Download ${fe.name}`,
            onClick: ($e) => ce(fe)
          }, {
            "left-icon": M(() => [
              L(l(Ur), { class: "h-4 w-4" })
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"])) : v("", !0),
          fe.canRemove ? (n(), F(Ze, {
            key: 2,
            variant: "tertiary",
            severity: "danger",
            size: "sm",
            type: "button",
            "is-icon-only": "",
            "aria-label": `Remove ${fe.name}`,
            onClick: ($e) => P(fe)
          }, {
            "left-icon": M(() => [
              L(l(Ms), { class: "h-4 w-4" })
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"])) : v("", !0)
        ], 2))), 128))
      ], 2),
      L(Be, {
        id: Z.value,
        message: z.value,
        type: U.value,
        class: "pl-2"
      }, null, 8, ["id", "message", "type"])
    ], 2));
  }
}), j1 = "flex min-w-0 items-center gap-2 overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden", Ks = "inline-flex h-8 shrink-0 items-center gap-1.5 rounded-lg border px-3 type-body-2-strong whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-1", N1 = `${Ks} border-blue-800 bg-blue-50 text-blue-800`, q1 = `${Ks} border-gray-200 bg-white text-txt-700 hover:border-gray-300`, U1 = "tabular-nums", Ys = "absolute top-1/2 z-10 flex size-7 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border border-gray-200 bg-white text-gray-600 shadow-sm hover:border-blue-800 hover:bg-blue-50 hover:text-blue-800", G1 = `${Ys} left-0`, _1 = `${Ys} right-0`, W1 = ["aria-label"], K1 = ["aria-pressed", "data-testid", "onClick"], Y1 = ["disabled"], X1 = ["disabled"], J1 = "4rem", Eb = /* @__PURE__ */ X({
  __name: "FilterChipGroup",
  props: {
    modelValue: {},
    options: {},
    ariaLabel: {},
    testIdPrefix: { default: "filter-chip" },
    isScrollable: { type: Boolean, default: !1 },
    class: { type: [Boolean, null, String, Object, Array], default: void 0 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = (R) => {
      R !== t.modelValue && (s("update:modelValue", R), s("change", R));
    }, d = A(null), u = (R) => d.value === R ? !0 : void 0, b = (R, V) => {
      o(R), V && (d.value = d.value === R ? null : R);
    }, g = () => {
      d.value = null;
    }, {
      tabListRef: h,
      canScrollLeft: p,
      canScrollRight: f,
      isScrolling: y,
      handleScroll: w,
      scrollLeft: S,
      scrollRight: k,
      initScrollMetrics: x
    } = _s();
    Se(() => t.options, x, { deep: !0 });
    const $ = i(
      () => t.isScrollable ? ms(p.value, f.value, J1) : void 0
    ), D = i(
      () => t.isScrollable ? q("relative min-w-0", t.class) : "contents"
    ), E = i(() => q(j1, !t.isScrollable && t.class));
    return (R, V) => (n(), c("div", {
      class: r(D.value)
    }, [
      m("div", {
        ref_key: "rowRef",
        ref: h,
        role: "group",
        "aria-label": t.ariaLabel,
        class: r(E.value),
        style: Ee($.value),
        "data-testid": "filter-chip-group",
        onScroll: V[0] || (V[0] = //@ts-ignore
        (...Z) => l(w) && l(w)(...Z))
      }, [
        (n(!0), c(re, null, xe(t.options, (Z) => (n(), F(ht, {
          key: Z.value,
          position: "bottom",
          label: Z.tooltip,
          "is-disabled": !Z.tooltip,
          "is-open": u(Z.value)
        }, {
          default: M(() => [
            m("button", {
              type: "button",
              class: r(Z.value === t.modelValue ? l(N1) : l(q1)),
              "aria-pressed": Z.value === t.modelValue,
              "data-testid": `${t.testIdPrefix}-${Z.value}`,
              onClick: (G) => b(Z.value, !!Z.tooltip),
              onBlur: g,
              onKeydown: Tt(g, ["esc"])
            }, [
              ie(C(Z.label) + " ", 1),
              Z.count !== void 0 ? (n(), c("span", {
                key: 0,
                class: r(l(U1))
              }, C(Z.count), 3)) : v("", !0)
            ], 42, K1)
          ]),
          _: 2
        }, 1032, ["label", "is-disabled", "is-open"]))), 128))
      ], 46, W1),
      t.isScrollable ? (n(), c(re, { key: 0 }, [
        l(p) ? (n(), c("button", {
          key: 0,
          type: "button",
          tabindex: "-1",
          "aria-hidden": "true",
          class: r(l(G1)),
          disabled: l(y),
          "data-testid": "filter-chip-scroll-left",
          onMousedown: V[1] || (V[1] = Te(() => {
          }, ["prevent"])),
          onClick: V[2] || (V[2] = //@ts-ignore
          (...Z) => l(S) && l(S)(...Z))
        }, [
          L(l(Wt), { class: "size-4" })
        ], 42, Y1)) : v("", !0),
        l(f) ? (n(), c("button", {
          key: 1,
          type: "button",
          tabindex: "-1",
          "aria-hidden": "true",
          class: r(l(_1)),
          disabled: l(y),
          "data-testid": "filter-chip-scroll-right",
          onMousedown: V[3] || (V[3] = Te(() => {
          }, ["prevent"])),
          onClick: V[4] || (V[4] = //@ts-ignore
          (...Z) => l(k) && l(k)(...Z))
        }, [
          L(l(ot), { class: "size-4" })
        ], 42, X1)) : v("", !0)
      ], 64)) : v("", !0)
    ], 2));
  }
}), Q1 = {
  amber: {
    root: "bg-amber-50 border-amber-200",
    label: "text-amber-700",
    count: "bg-amber-600 text-white",
    track: "bg-amber-600",
    ring: "focus-visible:ring-amber-600"
  },
  neutral: {
    root: "bg-neutral-100 border-neutral-400",
    label: "text-neutral-800",
    count: "bg-neutral-600 text-white",
    track: "bg-neutral-600",
    ring: "focus-visible:ring-neutral-500"
  }
}, Ha = {
  label: "text-[#46464c]",
  count: "bg-neutral-200 text-neutral-600",
  track: "bg-neutral-300"
};
function e0(e) {
  const a = i(() => !!e.modelValue), t = i(() => Q1[e.severity ?? "amber"]), s = i(() => [
    "inline-flex h-8 items-center gap-2.5 rounded-lg border px-3 type-body-1 whitespace-nowrap transition-colors",
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1",
    t.value.ring,
    e.disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer",
    a.value ? t.value.root : `border-neutral-300 ${e.transparent ? "bg-transparent" : "bg-white"}`
  ]), o = i(() => ["font-medium", a.value ? t.value.label : Ha.label]), d = i(() => [
    // Context: count badges sit outside the ramp for the same reason the Button badges do —
    // a small semibold numeral centred in a fixed-height pill, where type is a layout
    // constraint rather than a typographic choice. A ramp token carries its own line-height,
    // which an 18px pill cannot absorb.
    // eslint-disable-next-line no-restricted-syntax -- documented badge exception
    "inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full px-1 text-[11px] leading-none font-semibold",
    a.value ? t.value.count : Ha.count
  ]), u = i(() => [
    "relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors",
    a.value ? t.value.track : Ha.track
  ]), b = i(() => [
    "absolute top-[3px] left-[3px] block h-3.5 w-3.5 rounded-full bg-white transition-transform",
    "translate-x-0 data-[state=checked]:translate-x-4"
  ]);
  return { rootClasses: s, labelClasses: o, countClasses: d, trackClasses: u, thumbClasses: b };
}
const Db = /* @__PURE__ */ X({
  __name: "FilterToggle",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: {},
    count: { default: void 0 },
    severity: { default: "amber" },
    disabled: { type: Boolean, default: !1 },
    transparent: { type: Boolean, default: !0 },
    id: { default: void 0 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = i({
      get: () => t.modelValue,
      set: (p) => {
        s("update:modelValue", p), s("change", p);
      }
    }), { rootClasses: d, labelClasses: u, countClasses: b, trackClasses: g, thumbClasses: h } = e0(t);
    return (p, f) => (n(), F(l(Zl), {
      id: e.id,
      modelValue: o.value,
      "onUpdate:modelValue": f[0] || (f[0] = (y) => o.value = y),
      disabled: e.disabled,
      "aria-label": e.label,
      "data-testid": `filter-toggle-${e.id ?? "default"}`,
      class: r(l(d))
    }, {
      default: M(() => [
        m("span", {
          class: r(l(u))
        }, C(e.label), 3),
        e.count !== void 0 ? (n(), c("span", {
          key: 0,
          "data-testid": "filter-toggle-count",
          class: r(l(b))
        }, C(e.count), 3)) : v("", !0),
        m("span", {
          class: r(l(g))
        }, [
          L(l(Pl), {
            class: r(l(h))
          }, null, 8, ["class"])
        ], 2)
      ]),
      _: 1
    }, 8, ["id", "modelValue", "disabled", "aria-label", "data-testid", "class"]));
  }
}), t0 = {
  equal: "relative inline-flex w-full items-stretch bg-gray-100 p-0.5",
  fit: "relative inline-flex w-fit items-stretch bg-gray-100 p-0.5"
}, a0 = {
  pill: "rounded-full",
  rounded: "rounded-md"
}, Xs = {
  pill: "rounded-full",
  rounded: "rounded"
}, l0 = (e, a) => q(
  // will-change-transform: keeps the slide compositor-driven so it stays smooth under a heavy
  // sibling re-render.
  "absolute inset-y-0.5 left-0.5 bg-white shadow-sm duration-300 ease-in-out will-change-transform motion-reduce:transition-none",
  Xs[a],
  // Context: in `fit` the first placement is a measurement, not a move — sliding in from the
  // track's left edge on mount would read as a selection change that never happened.
  e ? "transition-[transform,width]" : "transition-none"
), s0 = {
  equal: "flex-1",
  fit: "flex-none"
}, n0 = (e, a, t) => q(
  "group relative z-10 flex items-center justify-center gap-1.5 px-3 py-1 type-body-1-strong whitespace-nowrap text-gray-500 transition-colors",
  Xs[t],
  s0[a],
  "focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 focus-visible:outline-none",
  "data-[state=checked]:font-semibold data-[state=checked]:text-blue-700",
  e ? "cursor-not-allowed opacity-60" : "cursor-pointer"
), o0 = {
  neutral: "inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-gray-200 px-1 pt-px text-[10px] leading-none font-semibold text-gray-500 group-data-[state=checked]:bg-blue-50 group-data-[state=checked]:text-blue-700",
  warn: "inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-orange-100 px-1 pt-px text-[10px] leading-none font-semibold text-orange-700"
}, r0 = () => ({
  trackClasses: (e, a) => q(t0[e], a0[a]),
  thumbClasses: l0,
  optionClasses: n0,
  badgeClasses: (e = "neutral") => o0[e]
}), i0 = ["data-testid"], Rl = 2, Fb = /* @__PURE__ */ X({
  __name: "SegmentedToggle",
  props: {
    options: {},
    optionWidth: { default: "equal" },
    shape: { default: "pill" },
    modelValue: {},
    id: { default: void 0 },
    name: { default: void 0 },
    "aria-label": {},
    isDisabled: { type: Boolean, default: !1 },
    class: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = i(() => t.ariaLabel), o = a, { trackClasses: d, thumbClasses: u, optionClasses: b, badgeClasses: g } = r0(), h = i(
      () => t.options.findIndex((V) => V.value === t.modelValue)
    ), p = i(() => b(t.isDisabled, t.optionWidth, t.shape)), f = [], y = (V, Z) => {
      const G = V && "$el" in V ? V.$el : V;
      f[Z] = G instanceof HTMLElement ? G : void 0;
    }, w = A(null), S = () => {
      const V = f[h.value];
      w.value = V ? { left: V.offsetLeft - Rl, width: V.offsetWidth } : null;
    }, k = i(() => h.value === -1 ? null : t.optionWidth === "equal" ? {
      width: `calc((100% - ${Rl * 2}px) / ${t.options.length})`,
      transform: `translateX(${h.value * 100}%)`
    } : w.value ? {
      width: `${w.value.width}px`,
      transform: `translateX(${w.value.left}px)`
    } : null), x = A(t.optionWidth === "equal");
    let $ = null;
    const D = () => {
      if ($) {
        $.disconnect(), f.length = t.options.length;
        for (const V of f) V && $.observe(V, { box: "border-box" });
      }
    };
    Vt(() => {
      t.optionWidth === "fit" && (S(), requestAnimationFrame(() => x.value = !0), typeof ResizeObserver < "u" && ($ = new ResizeObserver(S), D()));
    }), Se(
      () => [t.modelValue, t.options],
      () => {
        t.optionWidth === "fit" && Fe(() => {
          D(), S();
        });
      },
      { deep: !0 }
    ), Mt(() => {
      $?.disconnect(), $ = null;
    });
    const E = (V) => V.count === void 0 ? V.label : `${V.label}, ${V.count}`, R = (V) => o("update:modelValue", V);
    return (V, Z) => (n(), F(l(Xl), {
      id: t.id,
      "model-value": t.modelValue,
      name: t.name,
      disabled: t.isDisabled,
      orientation: "horizontal",
      "aria-label": s.value,
      "data-testid": "segmented-toggle-root",
      class: r(l(q)(l(d)(t.optionWidth, t.shape), t.class)),
      "onUpdate:modelValue": R
    }, {
      default: M(() => [
        k.value ? (n(), c("span", {
          key: 0,
          "aria-hidden": "true",
          "data-testid": "segmented-toggle-thumb",
          class: r(l(u)(x.value, t.shape)),
          style: Ee(k.value)
        }, null, 6)) : v("", !0),
        (n(!0), c(re, null, xe(t.options, (G, z) => (n(), F(l(Hl), {
          key: G.value,
          ref_for: !0,
          ref: (U) => y(U, z),
          value: G.value,
          disabled: t.isDisabled,
          "aria-label": E(G),
          class: r(p.value),
          "data-testid": `segmented-toggle-option-${G.value}`
        }, {
          default: M(() => [
            ie(C(G.label) + " ", 1),
            G.count !== void 0 ? (n(), c("span", {
              key: 0,
              class: r(l(g)(G.countTone)),
              "data-testid": `segmented-toggle-count-${G.value}`
            }, C(G.count), 11, i0)) : v("", !0)
          ]),
          _: 2
        }, 1032, ["value", "disabled", "aria-label", "class", "data-testid"]))), 128))
      ]),
      _: 1
    }, 8, ["id", "model-value", "name", "disabled", "aria-label", "class"]));
  }
});
function d0() {
  return { rootClasses: "relative flex flex-col gap-2", listClasses: "flex flex-col gap-3 outline-none", groupClasses: "flex flex-col gap-0.5", groupLabelClasses: "type-column-header text-txt-500 px-4 pt-1 pb-0.5", itemClasses: (u) => [
    u ? "type-body-1-strong" : "type-body-1",
    "text-txt-800 flex w-full cursor-pointer items-center gap-3 rounded-lg px-4 py-2.5",
    "outline-none transition-colors select-none",
    "hover:bg-background-light-200 data-[highlighted]:bg-background-light-200",
    "data-[state=checked]:bg-blue-50 data-[state=checked]:text-blue-800",
    // The selected option's blue would otherwise hide where keyboard focus is.
    "focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-600"
  ].join(" "), emptyClasses: "type-body-2 text-txt-500 px-4 py-2.5" };
}
const c0 = ["for"], u0 = ["id", "aria-label"], Rb = /* @__PURE__ */ X({
  __name: "SelectableList",
  props: {
    id: {},
    options: {},
    groups: {},
    modelValue: { default: void 0 },
    "aria-label": {},
    filterPlaceholder: { default: void 0 },
    filterLabel: { default: void 0 },
    emptyMessage: { default: void 0 },
    class: { type: [Boolean, null, String, Object, Array], default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = a, { rootClasses: o, listClasses: d, groupClasses: u, groupLabelClasses: b, itemClasses: g, emptyClasses: h } = d0(), p = i(() => t.ariaLabel), f = i(() => `${t.id}-filter`), y = A(""), w = i(() => {
      const D = y.value.trim().toLocaleLowerCase(), E = (V) => !D || V.label.toLocaleLowerCase().includes(D);
      return (t.groups ?? [{ options: t.options ?? [] }]).map((V) => ({ label: V.label, options: V.options.filter(E) })).filter((V) => V.options.length > 0);
    }), S = (D) => {
      typeof D == "string" && s("update:modelValue", D);
    }, k = A();
    let x;
    Se(
      () => t.modelValue,
      async () => {
        const D = document.activeElement;
        D && k.value?.contains(D) || (x = D, await Fe(), await Fe(), await Fe(), x = void 0);
      },
      { immediate: !0 }
    );
    const $ = (D) => {
      if (x === void 0) return;
      const E = x;
      x = void 0, E instanceof HTMLElement && E !== document.body ? E.focus({ preventScroll: !0 }) : D.target instanceof HTMLElement && D.target.blur();
    };
    return (D, E) => (n(), c("div", {
      class: r(l(q)(l(o), t.class)),
      "data-testid": "selectable-list"
    }, [
      t.filterPlaceholder ? (n(), c(re, { key: 0 }, [
        m("label", {
          for: f.value,
          class: "sr-only"
        }, C(t.filterLabel ?? t.filterPlaceholder), 9, c0),
        L(Ba, {
          id: f.value,
          modelValue: y.value,
          "onUpdate:modelValue": E[0] || (E[0] = (R) => y.value = R),
          placeholder: t.filterPlaceholder,
          variant: "outlined",
          size: "md",
          "is-clearable": "",
          "data-testid": "selectable-list-filter"
        }, null, 8, ["id", "modelValue", "placeholder"])
      ], 64)) : v("", !0),
      L(l(Mo), {
        "model-value": t.modelValue,
        "selection-behavior": "replace",
        "onUpdate:modelValue": S
      }, {
        default: M(() => [
          L(l(Vo), { "as-child": "" }, {
            default: M(() => [
              _a(m("div", {
                id: `${t.id}-list`,
                ref_key: "listRef",
                ref: k,
                "aria-label": p.value,
                class: r(l(d)),
                onFocusin: $
              }, [
                (n(!0), c(re, null, xe(w.value, (R, V) => (n(), F(kt(R.label ? l(So) : "div"), {
                  key: R.label ?? V,
                  class: r(l(u)),
                  "data-testid": "selectable-list-group"
                }, {
                  default: M(() => [
                    R.label ? (n(), F(l(Bo), {
                      key: 0,
                      class: r(l(b))
                    }, {
                      default: M(() => [
                        ie(C(R.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["class"])) : v("", !0),
                    (n(!0), c(re, null, xe(R.options, (Z) => (n(), F(l(Eo), {
                      key: Z.value,
                      value: Z.value,
                      class: r(l(g)(Z.value === t.modelValue)),
                      "data-testid": "selectable-list-item"
                    }, {
                      default: M(() => [
                        T(D.$slots, "item", {
                          option: Z,
                          isSelected: Z.value === t.modelValue
                        }, () => [
                          ie(C(Z.label), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["value", "class"]))), 128))
                  ]),
                  _: 2
                }, 1032, ["class"]))), 128))
              ], 42, u0), [
                [xn, w.value.length > 0]
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["model-value"]),
      w.value.length === 0 && t.emptyMessage ? (n(), c("p", {
        key: 1,
        role: "status",
        class: r(l(h)),
        "data-testid": "selectable-list-empty"
      }, C(t.emptyMessage), 3)) : v("", !0)
    ], 2));
  }
}), f0 = { class: "relative" }, Ib = /* @__PURE__ */ X({
  __name: "PasswordInput",
  props: {
    id: {},
    modelValue: { default: "" },
    placeholder: { default: "" },
    isRequired: { type: Boolean, default: !1 },
    isDisabled: { type: Boolean, default: !1 },
    isInvalid: { type: Boolean, default: !1 },
    variant: { default: "filled" },
    showToggle: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = A(!1), d = i(() => o.value ? "text" : "password"), u = i(() => t.placeholder?.trim() || void 0), b = () => {
      t.isDisabled || (o.value = !o.value);
    };
    return (g, h) => (n(), c("div", f0, [
      L(Ba, {
        id: e.id,
        "model-value": e.modelValue,
        type: d.value,
        placeholder: u.value,
        class: r(["w-full"]),
        "is-disabled": e.isDisabled,
        "is-invalid": e.isInvalid,
        "is-required": e.isRequired,
        variant: e.variant,
        "data-cy": `password-${e.id}`,
        "onUpdate:modelValue": h[0] || (h[0] = (p) => s("update:modelValue", p)),
        onBlur: h[1] || (h[1] = (p) => s("blur", p)),
        onFocus: h[2] || (h[2] = (p) => s("focus", p))
      }, tt({ _: 2 }, [
        e.showToggle ? {
          name: "suffix",
          fn: M(() => [
            L(Ze, {
              type: "button",
              variant: "primary",
              severity: "neutral",
              size: "sm",
              "is-disabled": e.isDisabled,
              "is-icon-only": "",
              "aria-label": o.value ? "Hide password" : "Show password",
              class: "absolute right-2",
              onClick: b
            }, {
              default: M(() => [
                o.value ? (n(), F(l(ei), {
                  key: 0,
                  class: "h-4 w-4 text-gray-500"
                })) : (n(), F(l(Cs), {
                  key: 1,
                  class: "h-4 w-4 text-gray-500"
                }))
              ]),
              _: 1
            }, 8, ["is-disabled", "aria-label"])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "model-value", "type", "placeholder", "is-disabled", "is-invalid", "is-required", "variant", "data-cy"])
    ]));
  }
}), b0 = "flex w-full items-center rounded-lg border border-transparent bg-white", Js = (e) => [
  b0,
  e ? "py-3" : "py-1"
], Qs = "px-0 type-body-1 text-black", en = "flex min-w-0 flex-col gap-0.5", tn = "px-0 type-body-2 text-gray-500", an = "px-0 type-body-1 text-gray-400", ln = [
  "pointer-events-none absolute -top-2 z-10 rounded type-field-label",
  gt,
  mt
], p0 = ["id"], h0 = ["data-testid"], g0 = ["id", "data-testid"], m0 = ["id"], v0 = ["for"], y0 = { class: "grid min-w-0 flex-1 gap-1.5 leading-none" }, x0 = { class: "type-body-1 text-gray-900" }, w0 = ["id"], L0 = ["id"], Tb = /* @__PURE__ */ X({
  __name: "CheckboxField",
  props: {
    id: {},
    label: {},
    description: {},
    error: {},
    hasPadding: { type: Boolean, default: !1 },
    hasBorder: { type: Boolean, default: !1 },
    isRounded: { type: Boolean, default: !1 },
    hasFillOnSelect: { type: Boolean, default: !1 },
    requiredLabel: { default: "Required" },
    isReadOnly: { type: Boolean, default: !1 },
    checkedLabel: { default: "Yes" },
    uncheckedLabel: { default: "No" },
    class: { type: [Boolean, null, String, Object, Array] },
    modelValue: { type: Boolean },
    name: {},
    required: { type: Boolean },
    value: {},
    disabled: { type: Boolean },
    "aria-describedby": {},
    "aria-invalid": { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, s = We(), o = a, d = i({
      get: () => t.modelValue,
      set: (k) => o("update:modelValue", k)
    }), u = i(() => !!(t.error || s.error)), b = i(() => !!(t.description || s.description) || u.value), g = i(() => [
      t.description || s.description ? `${t.id}-desc` : void 0,
      u.value ? `${t.id}-error` : void 0
    ].filter(Boolean).join(" ")), h = i(() => !!(t.label || s.label)), p = i(
      () => (t.modelValue ? t.checkedLabel : t.uncheckedLabel)?.trim() || ka
    ), f = i(() => !!(t.description || s.description)), y = i(
      () => p.value === ka ? an : Qs
    ), w = i(
      () => q(ln, u.value ? "text-red-600" : "")
    ), S = i(() => Js(h.value));
    return (k, x) => t.isReadOnly ? (n(), c("div", {
      key: 0,
      class: r(l(q)("relative w-full", t.class))
    }, [
      h.value ? (n(), c("span", {
        key: 0,
        id: `${t.id}-label`,
        class: r(w.value)
      }, [
        T(k.$slots, "label", {}, () => [
          ie(C(t.label), 1)
        ])
      ], 10, p0)) : v("", !0),
      m("div", {
        class: r(S.value),
        "data-testid": `checkbox-field-${t.id}-read-only`
      }, [
        m("div", {
          class: r(l(en))
        }, [
          m("p", {
            class: r(y.value)
          }, C(p.value), 3),
          f.value ? (n(), c("p", {
            key: 0,
            id: `${t.id}-desc`,
            class: r(l(tn)),
            "data-testid": `checkbox-field-${t.id}-read-only-description`
          }, [
            T(k.$slots, "description", {}, () => [
              ie(C(t.description), 1)
            ])
          ], 10, g0)) : v("", !0)
        ], 2)
      ], 10, h0),
      u.value ? (n(), c("div", {
        key: 1,
        id: `${t.id}-error`,
        class: "type-field-help text-red-600"
      }, [
        T(k.$slots, "error", {}, () => [
          ie(C(t.error), 1)
        ])
      ], 8, m0)) : v("", !0)
    ], 2)) : (n(), c("label", {
      key: 1,
      for: t.id,
      class: r(
        l(q)(
          "flex gap-3",
          t.disabled ? "cursor-not-allowed" : "cursor-pointer",
          b.value ? "items-start" : "items-center",
          {
            "p-4": t.hasPadding,
            "rounded-md": t.isRounded,
            "border border-gray-200": t.hasBorder
          },
          // No hover feedback when disabled — the row isn't interactive.
          t.hasFillOnSelect && !t.disabled ? "hover:bg-blue-50" : "",
          // Fill-on-select wins over the base border colour (tailwind-merge keeps the later one).
          t.hasFillOnSelect && t.modelValue ? ["bg-blue-50", t.hasBorder && "border-blue-500"] : "",
          // Inherited from CheckboxProps, so it is a declared prop here and no longer falls through to
          // this root on its own — it lands on the row, not on the box inside it.
          t.class
        )
      )
    }, [
      L(Bs, {
        id: t.id,
        modelValue: d.value,
        "onUpdate:modelValue": x[0] || (x[0] = ($) => d.value = $),
        name: t.name,
        required: t.required,
        value: t.value,
        disabled: t.disabled,
        "aria-describedby": g.value,
        "aria-invalid": u.value,
        class: r({ "mt-0.5": b.value })
      }, null, 8, ["id", "modelValue", "name", "required", "value", "disabled", "aria-describedby", "aria-invalid", "class"]),
      m("div", y0, [
        m("span", x0, [
          T(k.$slots, "label", {}, () => [
            ie(C(t.label), 1)
          ])
        ]),
        t.description || k.$slots.description ? (n(), c("div", {
          key: 0,
          id: `${t.id}-desc`,
          class: "type-body-2 text-gray-500"
        }, [
          T(k.$slots, "description", {}, () => [
            ie(C(t.description), 1)
          ])
        ], 8, w0)) : v("", !0),
        u.value ? (n(), c("div", {
          key: 1,
          id: `${t.id}-error`,
          class: "type-field-help text-red-600"
        }, [
          T(k.$slots, "error", {}, () => [
            ie(C(t.error), 1)
          ])
        ], 8, L0)) : v("", !0)
      ]),
      t.required ? (n(), F(Sa, {
        key: 0,
        color: "blue",
        size: "sm",
        class: "shrink-0",
        label: t.requiredLabel
      }, tt({ _: 2 }, [
        k.$slots.required ? {
          name: "label",
          fn: M(() => [
            T(k.$slots, "required")
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["label"])) : v("", !0)
    ], 10, v0));
  }
}), C0 = ["id"], k0 = ["aria-labelledby", "aria-describedby", "data-testid"], $0 = ["data-testid"], M0 = {
  key: 1,
  class: "mb-2 flex flex-col gap-1"
}, V0 = ["id"], S0 = ["id"], B0 = ["for"], E0 = { class: "grid min-w-0 flex-1 gap-1.5 leading-none" }, D0 = { class: "type-body-1 text-gray-900" }, F0 = {
  key: 0,
  class: "type-body-2 text-gray-500"
}, Ab = /* @__PURE__ */ X({
  __name: "RadioGroupField",
  props: {
    id: {},
    options: {},
    modelValue: {},
    defaultValue: {},
    name: {},
    label: {},
    description: {},
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    isReadOnly: { type: Boolean, default: !1 },
    layout: { default: "vertical" },
    hasPadding: { type: Boolean, default: !1 },
    hasBorder: { type: Boolean, default: !1 },
    isRounded: { type: Boolean, default: !1 },
    hasFillOnSelect: { type: Boolean, default: !1 },
    isInvalid: { type: Boolean, default: !1 },
    errorMessage: {},
    infoMessage: {},
    warnMessage: {},
    optionClass: { type: [Boolean, null, String, Object, Array] },
    ariaLabelledby: {},
    ariaDescribedby: {}
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = We(), d = i(() => `${t.id}-label`), u = i(() => `${t.id}-message`), b = i(() => `${t.id}-description`), g = i(
      () => !!(t.label || o.label || t.description || o.description)
    ), h = i(() => !!(t.label || o.label)), p = i(
      () => !t.isReadOnly && !!(t.description || o.description)
    ), f = i(() => t.ariaLabelledby ? t.ariaLabelledby : h.value ? d.value : void 0), y = i(() => t.isInvalid || !!t.errorMessage), w = i(
      () => !!(t.errorMessage || t.warnMessage || t.infoMessage)
    ), S = i(() => {
      const j = [
        t.ariaDescribedby,
        p.value ? b.value : void 0,
        w.value ? u.value : void 0
      ].filter(Boolean);
      return j.length > 0 ? j.join(" ") : void 0;
    }), k = i(() => {
      const j = /* @__PURE__ */ new Set();
      return t.options.map((_, ne) => {
        const P = String(_.value).trim().replaceAll(/\s+/g, "-");
        return j.has(P) ? String(ne) : (j.add(P), P);
      });
    }), x = (j) => `${t.id}-${k.value[j]}`, $ = (j) => t.modelValue === j.value, D = (j) => t.disabled || !!j.disabled, E = (j) => {
      s("update:modelValue", j), s("change", j);
    }, R = i(() => t.modelValue !== void 0 && t.modelValue !== ""), V = i(
      () => t.options.find((j) => j.value === t.modelValue)
    ), Z = i(() => R.value ? V.value?.label ?? String(t.modelValue) : ka), G = i(() => V.value?.description), z = i(
      () => !!V.value && !!(G.value || o["option-description"])
    ), U = i(
      () => q(ln, y.value ? "text-red-600" : "")
    ), ae = i(() => Js(h.value)), B = A(!1), le = () => {
      B.value || t.defaultValue === void 0 || R.value || t.isReadOnly || t.options.some((j) => j.value === t.defaultValue) && (B.value = !0, s("update:modelValue", t.defaultValue));
    };
    Vt(le), Se(
      [
        () => t.defaultValue,
        () => t.options.map((j) => j.value),
        () => t.isReadOnly
      ],
      le
    );
    const O = (j) => {
      const _ = $(j), ne = D(j), P = !!(j.description || o["option-description"]);
      return q(
        "flex gap-3",
        ne ? "cursor-not-allowed" : "cursor-pointer",
        P ? "items-start" : "items-center",
        {
          "p-4": t.hasPadding,
          "rounded-md": t.isRounded,
          "border border-gray-200": t.hasBorder
        },
        // No hover feedback when disabled — the row isn't interactive.
        t.hasFillOnSelect && !ne ? "hover:bg-blue-50" : "",
        // Fill-on-select wins over the base border colour (tailwind-merge keeps the later one).
        t.hasFillOnSelect && _ ? ["bg-blue-50", t.hasBorder && "border-blue-500"] : "",
        // Invalid is applied last so a red border wins over both the base and selected colours —
        // the whole group is in error, so every row reads as such.
        y.value && t.hasBorder ? "border-red-500" : "",
        t.optionClass
      );
    };
    return (j, _) => (n(), c("div", {
      class: r(l(q)("flex w-full flex-col", t.isReadOnly ? "relative" : ""))
    }, [
      t.isReadOnly ? (n(), c(re, { key: 0 }, [
        h.value ? (n(), c("span", {
          key: 0,
          id: d.value,
          class: r(U.value)
        }, [
          T(j.$slots, "label", {}, () => [
            ie(C(t.label), 1)
          ])
        ], 10, C0)) : v("", !0),
        m("div", {
          role: "group",
          "aria-labelledby": f.value,
          "aria-describedby": S.value,
          class: r(ae.value),
          "data-testid": `radio-group-${t.id}-read-only`
        }, [
          m("div", {
            class: r(l(en))
          }, [
            m("p", {
              class: r(R.value ? l(Qs) : l(an))
            }, [
              V.value ? T(j.$slots, "option-label", {
                option: V.value,
                checked: !0
              }, () => [
                ie(C(Z.value), 1)
              ], void 0, 0) : (n(), c(re, { key: 1 }, [
                ie(C(Z.value), 1)
              ], 64))
            ], 2),
            z.value ? (n(), c("p", {
              key: 0,
              class: r(l(tn)),
              "data-testid": `radio-group-${t.id}-read-only-description`
            }, [
              T(j.$slots, "option-description", {
                option: V.value,
                checked: !0
              }, () => [
                ie(C(G.value), 1)
              ])
            ], 10, $0)) : v("", !0)
          ], 2)
        ], 10, k0)
      ], 64)) : v("", !0),
      g.value && !t.isReadOnly ? (n(), c("div", M0, [
        h.value ? (n(), c("span", {
          key: 0,
          id: d.value,
          class: "text-txt-800 type-body-1"
        }, [
          T(j.$slots, "label", {}, () => [
            ie(C(t.label), 1)
          ])
        ], 8, V0)) : v("", !0),
        p.value ? (n(), c("p", {
          key: 1,
          id: b.value,
          class: "text-txt-600 type-body-2"
        }, [
          T(j.$slots, "description", {}, () => [
            ie(C(t.description), 1)
          ])
        ], 8, S0)) : v("", !0)
      ])) : v("", !0),
      t.isReadOnly ? v("", !0) : (n(), F(l(Xl), {
        key: 2,
        "model-value": t.modelValue,
        name: t.name,
        disabled: t.disabled,
        required: t.required,
        orientation: t.layout === "horizontal" ? "horizontal" : "vertical",
        "aria-labelledby": f.value,
        "aria-describedby": S.value,
        "aria-invalid": y.value || void 0,
        "aria-required": t.required || void 0,
        "data-testid": "radio-group-root",
        class: r(l(q)("flex gap-3", t.layout === "horizontal" ? "flex-row flex-wrap" : "flex-col")),
        "onUpdate:modelValue": E
      }, {
        default: M(() => [
          (n(!0), c(re, null, xe(t.options, (ne, P) => (n(), c("label", {
            key: String(ne.value),
            for: x(P),
            class: r(O(ne))
          }, [
            L(Ci, {
              id: x(P),
              value: ne.value,
              disabled: D(ne),
              class: r({ "mt-0.5": !!(ne.description || j.$slots["option-description"]) })
            }, null, 8, ["id", "value", "disabled", "class"]),
            m("div", E0, [
              m("span", D0, [
                T(j.$slots, "option-label", {
                  option: ne,
                  checked: $(ne)
                }, () => [
                  ie(C(ne.label), 1)
                ])
              ]),
              ne.description || j.$slots["option-description"] ? (n(), c("div", F0, [
                T(j.$slots, "option-description", {
                  option: ne,
                  checked: $(ne)
                }, () => [
                  ie(C(ne.description), 1)
                ])
              ])) : v("", !0)
            ])
          ], 10, B0))), 128))
        ]),
        _: 3
      }, 8, ["model-value", "name", "disabled", "required", "orientation", "aria-labelledby", "aria-describedby", "aria-invalid", "aria-required", "class"])),
      t.errorMessage ? (n(), F(Be, {
        key: 3,
        id: u.value,
        message: t.errorMessage,
        type: "error",
        class: r(t.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : t.warnMessage ? (n(), F(Be, {
        key: 4,
        id: u.value,
        message: t.warnMessage,
        type: "warn",
        class: r(t.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : t.infoMessage ? (n(), F(Be, {
        key: 5,
        id: u.value,
        message: t.infoMessage,
        type: "info",
        class: r(t.isReadOnly ? "pl-0" : "pl-2")
      }, null, 8, ["id", "message", "class"])) : v("", !0)
    ], 2));
  }
}), R0 = {
  class: "flex items-center gap-2",
  "data-testid": "action-stamp"
}, Ob = /* @__PURE__ */ X({
  __name: "ActionStamp",
  props: {
    action: {},
    name: {},
    date: { default: void 0 },
    tone: { default: "neutral" }
  },
  setup(e) {
    const a = e, t = i(
      () => a.tone === "amber" ? { avatar: "bg-amber-600", label: "text-amber-700", name: "text-amber-800" } : { avatar: "", label: "text-gray-600", name: "text-gray-800" }
    );
    return (s, o) => (n(), c("div", R0, [
      L(Ot, {
        size: "sm",
        label: e.name,
        class: r(t.value.avatar)
      }, null, 8, ["label", "class"]),
      m("span", {
        class: r(["type-body-2", t.value.label])
      }, [
        ie(C(e.action) + " ", 1),
        m("span", {
          class: r(["font-semibold", t.value.name])
        }, C(e.name), 3),
        e.date ? (n(), c(re, { key: 0 }, [
          ie(" · " + C(e.date), 1)
        ], 64)) : v("", !0)
      ], 2)
    ]));
  }
}), sn = /* @__PURE__ */ Symbol("StatCardVariant"), I0 = (e) => {
  ba(sn, e);
}, T0 = () => fa(
  sn,
  i(() => "cards")
), nn = /* @__PURE__ */ Symbol("StatCardNarrowLayout"), A0 = (e) => {
  ba(nn, e);
}, O0 = () => fa(
  nn,
  i(() => "scroll")
), z0 = {
  strip: "w-full overflow-hidden rounded-lg border border-border-border-200 bg-white",
  cards: "w-full"
}, H0 = "w-full overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden", Z0 = {
  strip: "grid grid-flow-col",
  cards: "grid grid-flow-col gap-4"
}, P0 = "@container", j0 = "@max-[560px]:grid-flow-row @max-[560px]:grid-cols-2 @max-[560px]:[&>*:last-child:nth-child(odd)]:col-span-2", N0 = "@max-[560px]:[&>*:nth-child(odd)]:border-l-0 @max-[560px]:[&>*:nth-child(n+3)]:border-t", q0 = {
  strip: "flex min-w-0 items-center justify-between gap-3 border-l border-border-border-100 px-5 py-3.5 first:border-l-0",
  cards: "flex min-w-0 items-center justify-between gap-3 rounded-lg border border-border-border-200 bg-white px-4 py-3"
}, U0 = "cursor-pointer text-left transition-colors duration-150 focus-visible:ring-2 focus-visible:outline-none", G0 = {
  gray: "hover:bg-gray-50",
  blue: "hover:bg-blue-50",
  green: "hover:bg-green-50",
  orange: "hover:bg-orange-50",
  red: "hover:bg-red-50",
  purple: "hover:bg-purple-50"
}, _0 = {
  gray: "bg-gray-50",
  blue: "bg-blue-50",
  green: "bg-green-50",
  orange: "bg-orange-50",
  red: "bg-red-50",
  purple: "bg-purple-50"
}, W0 = {
  gray: "border-gray-600",
  blue: "border-blue-600",
  green: "border-green-600",
  orange: "border-orange-600",
  red: "border-red-600",
  purple: "border-purple-600"
}, K0 = {
  gray: "shadow-[inset_0_-2px_0_0_var(--color-gray-600)]",
  blue: "shadow-[inset_0_-2px_0_0_var(--color-blue-600)]",
  green: "shadow-[inset_0_-2px_0_0_var(--color-green-600)]",
  orange: "shadow-[inset_0_-2px_0_0_var(--color-orange-600)]",
  red: "shadow-[inset_0_-2px_0_0_var(--color-red-600)]",
  purple: "shadow-[inset_0_-2px_0_0_var(--color-purple-600)]"
}, Y0 = {
  gray: "focus-visible:ring-gray-600",
  blue: "focus-visible:ring-blue-600",
  green: "focus-visible:ring-green-600",
  orange: "focus-visible:ring-orange-600",
  red: "focus-visible:ring-red-600",
  purple: "focus-visible:ring-purple-600"
}, X0 = "flex min-w-0 items-center gap-3", J0 = "[&>svg]:size-[15px]", Q0 = "flex min-w-0 flex-col gap-px", ef = "flex min-w-0 items-center gap-1", tf = "inline-flex shrink-0 cursor-help items-center text-gray-400 hover:text-gray-600", af = "h-3.5 w-3.5", lf = "type-form-sub-header text-txt-500 ", sf = "type-h2 whitespace-nowrap text-txt-800", nf = {
  gray: "type-h2 whitespace-nowrap text-gray-600",
  blue: "type-h2 whitespace-nowrap text-blue-600",
  green: "type-h2 whitespace-nowrap text-green-600",
  orange: "type-h2 whitespace-nowrap text-orange-700",
  red: "type-h2 whitespace-nowrap text-red-600",
  purple: "type-h2 whitespace-nowrap text-purple-600"
}, of = "type-h2 whitespace-nowrap text-txt-700", rf = "type-caption whitespace-nowrap text-txt-500", df = "@max-[560px]:whitespace-normal", cf = "h-6 w-24 animate-pulse rounded bg-gray-100", uf = "h-3.5 w-16 animate-pulse rounded bg-gray-100", ff = "flex shrink-0 items-center", bf = ["aria-label"], zb = /* @__PURE__ */ X({
  __name: "StatCard",
  props: {
    value: {},
    label: {},
    footnote: {},
    tooltip: {},
    tooltipAriaLabel: {},
    color: {},
    clickable: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    href: {},
    unavailable: { type: Boolean, default: !1 },
    unavailableLabel: { default: "unavailable" },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = We(), d = T0(), u = O0(), b = i(() => !!t.href), g = i(() => !b.value && (!!t.tooltip || !!o.tooltip)), h = i(() => !!t.label || g.value), p = i(() => t.color ?? "gray"), f = i(() => t.color ?? "blue"), y = i(() => t.clickable && !t.loading && !b.value), w = i(() => t.selected && !b.value), S = i(() => t.unavailable ? of : b.value ? nf[f.value] : sf), k = i(
      () => q(rf, u.value === "two-up" && df)
    ), x = i(
      () => q(
        q0[d.value],
        (y.value || b.value) && [
          U0,
          G0[f.value],
          Y0[f.value]
        ],
        // Independent of `clickable`: a card can be shown as chosen without the user
        // being the one who chooses it.
        w.value && [
          _0[f.value],
          d.value === "cards" ? W0[f.value] : K0[f.value]
        ],
        t.class
      )
    ), $ = (E) => {
      !y.value && !b.value || s("click", E);
    }, D = (E) => {
      !y.value || E.key !== "Enter" && E.key !== " " || (E.preventDefault(), $(E));
    };
    return (E, R) => (n(), F(kt(b.value ? "a" : "div"), {
      "data-testid": "stat-card",
      href: t.href,
      class: r(x.value),
      role: y.value ? "button" : void 0,
      tabindex: y.value ? 0 : void 0,
      "aria-pressed": y.value ? t.selected : void 0,
      "aria-busy": t.loading ? "true" : void 0,
      "data-selected": w.value ? "true" : void 0,
      "data-loading": t.loading ? "true" : void 0,
      "data-unavailable": t.unavailable && !t.loading ? "true" : void 0,
      onClick: $,
      onKeydown: D
    }, {
      default: M(() => [
        m("div", {
          class: r(l(X0))
        }, [
          E.$slots.icon ? (n(), F(qs, {
            key: 0,
            color: p.value,
            size: "2xs",
            class: r(l(J0))
          }, {
            default: M(() => [
              T(E.$slots, "icon")
            ]),
            _: 3
          }, 8, ["color", "class"])) : v("", !0),
          m("div", {
            class: r(l(Q0))
          }, [
            h.value ? (n(), c("div", {
              key: 0,
              class: r(l(ef))
            }, [
              t.label ? (n(), c("span", {
                key: 0,
                "data-testid": "stat-card-label",
                class: r(l(lf))
              }, C(t.label), 3)) : v("", !0),
              g.value ? (n(), F(ht, {
                key: 1,
                label: t.tooltip,
                position: "top"
              }, tt({
                default: M(() => [
                  m("button", {
                    type: "button",
                    "data-testid": "stat-card-tooltip-trigger",
                    class: r(l(tf)),
                    "aria-label": t.tooltipAriaLabel ?? t.tooltip ?? "More information",
                    onClick: R[0] || (R[0] = Te(() => {
                    }, ["stop"]))
                  }, [
                    L(l(el), {
                      class: r(l(af))
                    }, null, 8, ["class"])
                  ], 10, bf)
                ]),
                _: 2
              }, [
                l(o).tooltip ? {
                  name: "label",
                  fn: M(() => [
                    T(E.$slots, "tooltip")
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["label"])) : v("", !0)
            ], 2)) : v("", !0),
            t.loading ? (n(), c("div", {
              key: 1,
              "data-testid": "stat-card-value-skeleton",
              class: r(l(cf)),
              "aria-hidden": "true"
            }, null, 2)) : (n(), c("div", {
              key: 2,
              "data-testid": "stat-card-value",
              class: r(S.value)
            }, C(t.unavailable ? t.unavailableLabel : t.value), 3)),
            t.footnote || l(o).footnote ? (n(), c(re, { key: 3 }, [
              t.loading ? (n(), c("div", {
                key: 0,
                "data-testid": "stat-card-footnote-skeleton",
                class: r(l(uf)),
                "aria-hidden": "true"
              }, null, 2)) : (n(), c("div", {
                key: 1,
                "data-testid": "stat-card-footnote",
                class: r(k.value)
              }, [
                T(E.$slots, "footnote", {}, () => [
                  ie(C(t.footnote), 1)
                ])
              ], 2))
            ], 64)) : v("", !0)
          ], 2)
        ], 2),
        E.$slots.action ? (n(), c("div", {
          key: 0,
          class: r(l(ff))
        }, [
          T(E.$slots, "action")
        ], 2)) : v("", !0)
      ]),
      _: 3
    }, 40, ["href", "class", "role", "tabindex", "aria-pressed", "aria-busy", "data-selected", "data-loading", "data-unavailable"]));
  }
}), pf = ["data-variant", "data-narrow-layout"], hf = ["tabindex", "data-overflowing", "data-fade-left", "data-fade-right"], gf = "2rem", Hb = /* @__PURE__ */ X({
  __name: "StatCardGroup",
  props: {
    variant: { default: "strip" },
    minCellWidth: { default: "max-content" },
    narrowLayout: { default: "scroll" },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e, t = i(() => a.narrowLayout === "two-up"), s = i(
      () => q(
        z0[a.variant],
        t.value && P0,
        a.class
      )
    ), o = i(
      () => q(
        Z0[a.variant],
        t.value && [
          j0,
          a.variant === "strip" && N0
        ]
      )
    );
    I0(i(() => a.variant)), A0(i(() => a.narrowLayout));
    const d = i(() => ({
      gridAutoColumns: `minmax(${a.minCellWidth}, 1fr)`
    })), u = A(null), b = A(!1), g = A(!1), h = A(!1);
    let p;
    const f = () => {
      const w = u.value;
      w && (h.value = w.scrollWidth - w.clientWidth > 1, b.value = w.scrollLeft > 1, g.value = Math.ceil(w.scrollLeft + w.clientWidth) < w.scrollWidth);
    };
    Vt(() => {
      if (f(), typeof ResizeObserver > "u" || !u.value) return;
      p = new ResizeObserver(f), p.observe(u.value);
      const w = u.value.firstElementChild;
      w && p.observe(w);
    }), Mt(() => {
      p?.disconnect();
    });
    const y = i(
      () => ms(b.value, g.value, gf)
    );
    return (w, S) => (n(), c("div", {
      "data-testid": "stat-card-group",
      "data-variant": a.variant,
      "data-narrow-layout": t.value ? "two-up" : void 0,
      class: r(s.value)
    }, [
      m("div", {
        ref_key: "scroller",
        ref: u,
        "data-testid": "stat-card-group-scroll",
        class: r(l(H0)),
        style: Ee(y.value),
        tabindex: h.value ? 0 : void 0,
        "data-overflowing": h.value ? "true" : void 0,
        "data-fade-left": b.value ? "true" : void 0,
        "data-fade-right": g.value ? "true" : void 0,
        onScroll: f
      }, [
        m("div", {
          "data-testid": "stat-card-group-track",
          class: r(o.value),
          style: Ee(d.value)
        }, [
          T(w.$slots, "default")
        ], 6)
      ], 46, hf)
    ], 10, pf));
  }
}), Zb = /* @__PURE__ */ X({
  __name: "ExpandableAvatar",
  props: {
    label: { default: void 0 },
    src: { default: void 0 },
    size: { default: "sm" },
    expansionDirection: { default: "right" },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e, t = i(() => !a.src && !a.label);
    return (s, o) => t.value ? v("", !0) : (n(), c("div", {
      key: 0,
      "data-testid": "expandable-avatar",
      class: r(
        l(q)(
          "group flex w-fit items-center",
          e.expansionDirection === "left" ? "flex-row-reverse" : "",
          a.class
        )
      )
    }, [
      L(Ot, {
        label: e.label,
        src: e.src,
        size: e.size,
        class: "shrink-0"
      }, null, 8, ["label", "src", "size"]),
      m("span", {
        "data-testid": "expandable-avatar-label",
        class: r(
          l(q)(
            "text-txt-800 type-body-1 block max-w-0 overflow-hidden whitespace-nowrap transition-all duration-500 ease-in-out group-hover:max-w-xs",
            e.expansionDirection === "left" ? "group-hover:pr-3 group-hover:pl-1" : "group-hover:pl-3"
          )
        )
      }, C(e.label), 3)
    ], 2));
  }
}), mf = { class: "flex min-w-0 items-start gap-2" }, vf = { class: "min-w-0 flex-1" }, yf = ["aria-expanded"], xf = ["aria-label"], Pb = /* @__PURE__ */ X({
  __name: "ExpandableText",
  props: {
    text: {},
    copyable: { type: Boolean, default: !1 },
    lines: { default: 1 }
  },
  setup(e) {
    const a = e, t = {
      1: "truncate",
      2: "line-clamp-2 wrap-anywhere",
      3: "line-clamp-3 wrap-anywhere",
      4: "line-clamp-4 wrap-anywhere"
    }, s = i(() => t[a.lines]), o = A(!1), d = A(!1), u = A(null);
    let b;
    const g = () => {
      const k = u.value;
      !k || o.value || (d.value = a.lines === 1 ? k.scrollWidth > k.clientWidth : k.scrollHeight > k.clientHeight + 1);
    }, h = async () => {
      await Fe(), g();
    };
    Vt(() => {
      h(), u.value && "ResizeObserver" in globalThis && (b = new ResizeObserver(() => g()), b.observe(u.value));
    }), Se(
      () => a.text,
      () => {
        h();
      }
    ), Se(o, (k) => {
      k || h();
    }), wn(() => {
      h();
    });
    const p = i(() => d.value), f = () => {
      o.value = !o.value;
    }, y = A(!1);
    let w;
    const S = async () => {
      await Qa(a.text) && (y.value = !0, clearTimeout(w), w = setTimeout(() => {
        y.value = !1;
      }, 1e3));
    };
    return Mt(() => {
      b?.disconnect(), clearTimeout(w);
    }), (k, x) => (n(), c("div", mf, [
      m("div", vf, [
        m("div", {
          ref_key: "textRef",
          ref: u,
          "data-testid": "expandable-text-content",
          class: r(o.value ? "wrap-anywhere" : s.value)
        }, [
          T(k.$slots, "default", {}, () => [
            ie(C(e.text), 1)
          ])
        ], 2),
        p.value ? (n(), c("button", {
          key: 0,
          type: "button",
          "data-testid": "expandable-text-toggle",
          "aria-expanded": o.value,
          class: "type-h6 mt-0.5 whitespace-nowrap underline decoration-2 underline-offset-2",
          onClick: f
        }, C(o.value ? "Read less" : "Read more"), 9, yf)) : v("", !0)
      ]),
      e.copyable ? (n(), c("button", {
        key: 0,
        type: "button",
        "data-testid": "expandable-text-copy",
        "aria-label": y.value ? "Copied" : "Copy description",
        class: "text-txt-700 shrink-0 transition-colors hover:text-black",
        onClick: S
      }, [
        y.value ? (n(), F(l(xs), {
          key: 0,
          class: "h-4 w-4 text-green-600"
        })) : (n(), F(l(ws), {
          key: 1,
          class: "h-4 w-4"
        }))
      ], 8, xf)) : v("", !0)
    ]));
  }
}), wf = { class: "flex min-w-0 items-start gap-3" }, Lf = { class: "min-w-0 flex-1" }, Cf = ["id"], kf = ["id"], $f = { class: "select-all" }, Mf = ["id"], Vf = ["aria-hidden"], Sf = {
  key: 0,
  class: "sr-only select-none"
}, Bf = ["id"], Ef = ["aria-label", "aria-describedby"], Df = {
  role: "status",
  class: "sr-only",
  "data-testid": "copyable-value-announcement"
}, jb = /* @__PURE__ */ X({
  __name: "CopyableValueCell",
  props: {
    id: {},
    label: {},
    value: {},
    description: { default: void 0 },
    readAsCharacters: { type: Boolean, default: !1 },
    isSensitive: { type: Boolean, default: !1 },
    isCopyDisabled: { type: Boolean, default: !1 },
    copyLabel: { default: void 0 },
    hideLabel: { type: Boolean, default: !1 }
  },
  setup(e) {
    const a = e, t = i(() => [...a.value].join(" ")), s = i(() => `Copied ${a.copyLabel ?? a.label}`), o = i(
      () => u.value ? s.value : `Copy ${a.copyLabel ?? a.label}`
    ), d = i(() => `${a.id}-spelled`), u = A(!1);
    let b;
    const g = async () => {
      await Qa(a.value) && (u.value = !0, clearTimeout(b), b = setTimeout(() => {
        u.value = !1;
      }, 1e3));
    };
    return Mt(() => clearTimeout(b)), (h, p) => (n(), c("div", wf, [
      m("div", Lf, [
        m("p", {
          id: `${e.id}-label`,
          class: r(l(q)("text-txt-700 type-body-2-strong", e.hideLabel && "sr-only"))
        }, C(e.label), 11, Cf),
        m("p", {
          id: `${e.id}-value`,
          "data-testid": "copyable-value",
          class: r(l(q)("type-body-1-strong wrap-anywhere text-black", e.isSensitive && "sentry-mask"))
        }, [
          h.$slots.value ? (n(), c(re, { key: 0 }, [
            m("span", $f, [
              T(h.$slots, "value", {
                value: e.value,
                describedBy: e.readAsCharacters ? d.value : void 0
              })
            ]),
            e.readAsCharacters ? (n(), c("span", {
              key: 0,
              id: d.value,
              class: "sr-only select-none",
              "aria-hidden": "true"
            }, C(t.value), 9, Mf)) : v("", !0)
          ], 64)) : (n(), c(re, { key: 1 }, [
            m("span", {
              class: "select-all",
              "aria-hidden": e.readAsCharacters ? "true" : void 0
            }, C(e.value), 9, Vf),
            e.readAsCharacters ? (n(), c("span", Sf, C(t.value), 1)) : v("", !0)
          ], 64))
        ], 10, kf),
        e.description ? (n(), c("p", {
          key: 0,
          id: `${e.id}-description`,
          class: "text-txt-700 type-field-help mt-1"
        }, C(e.description), 9, Bf)) : v("", !0)
      ]),
      e.isCopyDisabled ? v("", !0) : (n(), c("button", {
        key: 0,
        type: "button",
        "data-testid": "copyable-value-copy",
        "aria-label": o.value,
        "aria-describedby": e.description ? `${e.id}-description` : void 0,
        class: "text-txt-700 shrink-0 rounded transition-colors hover:text-black focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 focus-visible:outline-none max-md:-m-3 max-md:p-3",
        onClick: Te(g, ["stop"])
      }, [
        u.value ? (n(), F(l(xs), {
          key: 0,
          class: "h-5 w-5 text-green-600"
        })) : (n(), F(l(ws), {
          key: 1,
          class: "h-5 w-5"
        }))
      ], 8, Ef)),
      m("span", Df, C(u.value ? s.value : ""), 1)
    ]));
  }
}), Ae = {
  wrapper: "flex flex-wrap items-center justify-end gap-2",
  triggerBase: "inline-flex items-center gap-1 rounded-lg border px-2.5 py-1.5 type-body-1-strong transition-all focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:outline-none",
  triggerOpen: "border-blue-600 bg-blue-50 text-txt-700",
  triggerClosed: "border-border-border-300 bg-white text-txt-600",
  triggerDisabled: "cursor-not-allowed opacity-50",
  triggerEnabled: "cursor-pointer hover:border-border-border-400",
  chevron: "h-4 w-4 transition-transform ml-1",
  contentBase: "z-50 overflow-hidden rounded-xl border border-border-border-200 bg-white shadow-lg",
  /**
   * 340px is sized for a label over a description. A menu of bare labels does not need it, so it
   * sizes to its own content instead — floored so the footer never wraps, and capped at the
   * original width so it can never be wider than it is today.
   */
  contentWidthWithDescriptions: "w-[340px]",
  contentWidthBare: "w-max min-w-56 max-w-[340px]",
  list: "max-h-80 overflow-y-auto py-1",
  optionBase: "flex items-start gap-3 px-3.5 py-2.5 hover:bg-gray-50",
  groupHeading: "px-3.5 pt-3 pb-1 type-caption uppercase text-gray-500",
  optionInteractive: "cursor-pointer",
  optionStatic: "cursor-not-allowed",
  optionHeader: "flex items-center gap-2",
  /**
   * Two option treatments, chosen by whether the menu's options carry descriptions.
   *
   * A label sitting above a description IS a heading, and semibold is doing real work there —
   * every role picker in the app reads that way. A menu of bare labels is a plain option list,
   * and heading weight on it reads as emphasis with nothing to be emphatic about; it also puts
   * the control out of step with `Select`, whose options are `type-body-1 text-txt-700` and go
   * medium only once chosen. Derived from the options rather than taken as a prop so a caller
   * cannot get it wrong, and per MENU rather than per option so one dropdown never mixes both.
   */
  optionLabelHeading: "type-h5 text-txt-800",
  optionLabelPlain: "type-body-1 text-txt-700",
  optionLabelPlainChecked: "type-body-1-strong text-black",
  lockBadge: "inline-flex items-center gap-1 type-caption text-gray-400",
  description: "mt-0.5 type-body-2 text-txt-600",
  dot: "h-2 w-2 shrink-0 rounded-full",
  /**
   * `gap-6` is load-bearing, not decoration: on a content-sized menu (`contentWidthBare`) the
   * footer is usually the widest row, so `justify-between` has no slack to distribute and the
   * hint ends up touching the count. The gap is part of the intrinsic width, so it reserves the
   * space instead of hoping for it.
   */
  footer: "flex items-center justify-between gap-6 border-t border-border-border-200 px-3.5 py-2 type-body-2 text-gray-400",
  /**
   * The search row, as `Select` draws it (`useSelectStyles`): above the scrolling list, so the
   * box stays put while the options scroll under it. Copied rather than imported, since
   * `Select`'s are built inside its composable from its own props.
   */
  searchRow: "flex items-center gap-2 border-b border-border-border-200 px-3 py-2",
  searchIcon: "h-4 w-4 shrink-0 text-gray-400",
  searchInput: "w-full min-w-0 border-none bg-transparent p-0 type-body-1 text-txt-700 outline-none ring-0 placeholder:text-gray-400 focus:ring-0 focus:outline-none",
  /** `Select`'s empty and no-matches line, inset to this menu's option padding. */
  noMatches: "px-3.5 py-2.5 type-body-1 text-gray-400",
  countBase: "font-semibold tabular-nums",
  countActive: "text-blue-600",
  countEmpty: "text-gray-400"
}, Ff = {
  white: "bg-gray-300",
  gray: "bg-gray-500",
  blue: "bg-blue-600",
  green: "bg-green-600",
  orange: "bg-orange-600",
  red: "bg-red-600",
  violet: "bg-violet-700",
  pink: "bg-pink-700"
};
function Rf() {
  return {
    styles: Ae,
    triggerClasses: (b, g) => q(
      Ae.triggerBase,
      b ? Ae.triggerOpen : Ae.triggerClosed,
      g ? Ae.triggerDisabled : Ae.triggerEnabled
    ),
    contentClasses: (b) => q(
      Ae.contentBase,
      b ? Ae.contentWidthWithDescriptions : Ae.contentWidthBare
    ),
    chevronClasses: (b) => q(Ae.chevron, b && "rotate-180"),
    optionClasses: (b) => q(
      Ae.optionBase,
      b ? Ae.optionInteractive : Ae.optionStatic
    ),
    optionLabelClasses: (b, g) => b ? Ae.optionLabelHeading : g ? Ae.optionLabelPlainChecked : Ae.optionLabelPlain,
    dotClass: (b) => q(Ae.dot, Ff[b ?? "gray"]),
    countClasses: (b) => q(
      Ae.countBase,
      b ? Ae.countActive : Ae.countEmpty
    )
  };
}
const If = ["placeholder", "aria-label", "aria-describedby"], Tf = ["data-testid"], Af = ["for", "data-testid"], Of = { class: "min-w-0 flex-1" }, Nb = /* @__PURE__ */ X({
  __name: "MultiSelectCheckboxDropdown",
  props: /* @__PURE__ */ ia({
    options: {},
    modelValue: {},
    lockedValues: { default: () => [] },
    disabled: { type: Boolean, default: !1 },
    triggerLabel: { default: "Manage" },
    minOne: { type: Boolean, default: !1 },
    hidePills: { type: Boolean, default: !1 },
    lockedLabel: { default: "Always on" },
    selectHint: { default: "Select one or more options" },
    isSearchable: { type: Boolean, default: !1 },
    searchPlaceholder: { default: "Search" },
    noMatchesText: { default: "No matches" },
    emptyText: {}
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ ia(["update:modelValue", "add", "remove"], ["update:open"]),
  setup(e, { emit: a }) {
    const t = e, s = a, {
      styles: o,
      contentClasses: d,
      chevronClasses: u,
      optionClasses: b,
      optionLabelClasses: g,
      dotClass: h,
      countClasses: p
    } = Rf(), f = Ga(), y = `${f}-empty`, w = Ya(e, "open"), S = i(() => new Set(t.lockedValues)), k = i(() => t.options.some((O) => !!O.description)), x = i(() => /* @__PURE__ */ new Set([...t.modelValue, ...t.lockedValues])), $ = i(
      () => t.options.filter((O) => x.value.has(O.value))
    ), D = A(""), E = A(null), R = i(() => {
      const O = t.isSearchable ? D.value.trim().toLowerCase() : "";
      return O ? t.options.filter((j) => j.label.toLowerCase().includes(O)) : t.options;
    }), V = i(
      () => t.isSearchable && D.value.trim() !== "" && R.value.length === 0
    ), Z = i(
      () => !!t.emptyText && t.options.length === 0 && !V.value
    );
    Se(w, (O) => {
      t.isSearchable && !O && (D.value = "");
    }), Se(E, (O) => {
      O && requestAnimationFrame(() => O.focus());
    });
    const G = () => {
      D.value = "", E.value?.focus();
    }, z = (O) => {
      const j = R.value[O]?.group;
      return !!j && j !== R.value[O - 1]?.group;
    }, U = (O) => x.value.has(O.value), ae = (O) => S.value.has(O.value), B = (O) => t.minOne && t.modelValue.includes(O.value) && t.modelValue.length === 1, le = (O) => {
      if (!(t.disabled || ae(O)))
        if (t.modelValue.includes(O.value)) {
          if (B(O)) return;
          s("remove", O.value), s(
            "update:modelValue",
            t.modelValue.filter((j) => j !== O.value)
          );
        } else
          s("add", O.value), s("update:modelValue", [...t.modelValue, O.value]);
    };
    return (O, j) => (n(), c("div", {
      class: r(l(o).wrapper),
      "data-testid": "multiselect"
    }, [
      t.hidePills ? v("", !0) : (n(!0), c(re, { key: 0 }, xe($.value, (_) => (n(), F(Sa, {
        key: _.value,
        color: _.color,
        label: _.label,
        size: "sm",
        "data-testid": `multiselect-pill-${_.value}`
      }, null, 8, ["color", "label", "data-testid"]))), 128)),
      L(l(Jl), {
        open: w.value,
        "onUpdate:open": j[1] || (j[1] = (_) => w.value = _)
      }, {
        default: M(() => [
          L(l(Ql), { "as-child": "" }, {
            default: M(() => [
              T(O.$slots, "trigger", {
                open: w.value,
                disabled: t.disabled
              }, () => [
                L(Ze, {
                  "data-testid": "multiselect-trigger",
                  "data-cy": "multiselect-trigger",
                  size: "sm",
                  variant: "tertiary",
                  disabled: t.disabled
                }, {
                  "left-icon": M(() => [
                    ie(C(t.triggerLabel) + " ", 1),
                    L(l(pa), {
                      class: r(l(u)(w.value))
                    }, null, 8, ["class"])
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 3
          }),
          L(l(es), null, {
            default: M(() => [
              L(l(ts), {
                align: "end",
                "side-offset": 6,
                "data-testid": "multiselect-content",
                class: r(l(d)(k.value))
              }, {
                default: M(() => [
                  t.isSearchable ? (n(), c("div", {
                    key: 0,
                    class: r(l(o).searchRow)
                  }, [
                    L(l(ks), {
                      class: r(l(o).searchIcon)
                    }, null, 8, ["class"]),
                    _a(m("input", {
                      ref_key: "searchInput",
                      ref: E,
                      "onUpdate:modelValue": j[0] || (j[0] = (_) => D.value = _),
                      type: "text",
                      autocomplete: "off",
                      class: r(l(o).searchInput),
                      placeholder: t.searchPlaceholder,
                      "aria-label": t.searchPlaceholder,
                      "aria-describedby": Z.value ? y : void 0,
                      "data-testid": "multiselect-search"
                    }, null, 10, If), [
                      [Tl, D.value]
                    ]),
                    D.value ? (n(), c("button", {
                      key: 0,
                      type: "button",
                      class: r(l(tl)),
                      "aria-label": "Clear search",
                      "data-testid": "multiselect-search-clear",
                      onClick: G
                    }, [
                      L(l(rt), { class: "h-4 w-4" })
                    ], 2)) : v("", !0)
                  ], 2)) : v("", !0),
                  m("div", {
                    class: r(l(o).list)
                  }, [
                    V.value ? (n(), c("div", {
                      key: 0,
                      class: r(l(o).noMatches),
                      "data-testid": "multiselect-no-matches"
                    }, [
                      T(O.$slots, "no-match", {
                        query: D.value.trim()
                      }, () => [
                        ie(C(t.noMatchesText), 1)
                      ])
                    ], 2)) : v("", !0),
                    Z.value ? (n(), c("div", {
                      key: 1,
                      id: y,
                      class: r(l(o).noMatches),
                      "data-testid": "multiselect-empty"
                    }, C(t.emptyText), 3)) : v("", !0),
                    (n(!0), c(re, null, xe(R.value, (_, ne) => (n(), c(re, {
                      key: _.value
                    }, [
                      z(ne) ? (n(), c("div", {
                        key: 0,
                        class: r(l(o).groupHeading),
                        "data-testid": `multiselect-group-${_.group}`
                      }, [
                        T(O.$slots, "group-heading", {
                          group: _.group
                        }, () => [
                          ie(C(_.group), 1)
                        ])
                      ], 10, Tf)) : v("", !0),
                      m("label", {
                        for: `${l(f)}-${_.value}`,
                        "data-testid": `multiselect-option-${_.value}`,
                        class: r(l(b)(!ae(_) && !t.disabled))
                      }, [
                        L(Bs, {
                          id: `${l(f)}-${_.value}`,
                          "model-value": U(_),
                          disabled: t.disabled || ae(_),
                          class: "mt-0.5",
                          "aria-label": _.label,
                          "onUpdate:modelValue": (P) => le(_)
                        }, null, 8, ["id", "model-value", "disabled", "aria-label", "onUpdate:modelValue"]),
                        m("div", Of, [
                          m("div", {
                            class: r(l(o).optionHeader)
                          }, [
                            m("span", {
                              class: r(l(g)(k.value, U(_)))
                            }, C(_.label), 3),
                            ae(_) ? (n(), c("span", {
                              key: 0,
                              class: r(l(o).lockBadge)
                            }, [
                              L(l(ti), { class: "h-3 w-3" }),
                              ie(" " + C(t.lockedLabel), 1)
                            ], 2)) : _.color ? (n(), c("span", {
                              key: 1,
                              class: r(l(h)(_.color))
                            }, null, 2)) : v("", !0)
                          ], 2),
                          _.description ? (n(), c("p", {
                            key: 0,
                            class: r(l(o).description)
                          }, C(_.description), 3)) : v("", !0)
                        ])
                      ], 10, Af)
                    ], 64))), 128))
                  ], 2),
                  T(O.$slots, "after-options", {
                    query: D.value.trim()
                  }),
                  m("div", {
                    class: r(l(o).footer)
                  }, [
                    m("span", null, C(t.selectHint), 1),
                    m("span", {
                      class: r(l(p)(x.value.size > 0)),
                      "data-testid": "multiselect-count"
                    }, C(x.value.size) + " selected ", 3)
                  ], 2)
                ]),
                _: 3
              }, 8, ["class"])
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["open"])
    ], 2));
  }
}), Il = 1e4, na = {
  content: "overflow-y-auto rounded-xl border border-border-border-200 bg-white shadow-lg outline-none",
  // The content takes focus itself when nothing inside it can, so a keyboard user needs to see it.
  focusRing: "focus-visible:ring-2 focus-visible:ring-blue-800 focus-visible:ring-offset-1",
  // reka measures what the viewport leaves on the open side, so a tall panel scrolls instead of
  // running off the screen.
  maxHeight: "max-h-[var(--reka-popover-content-available-height)]",
  widthFixed: "max-w-[var(--reka-popover-content-available-width)]",
  widthAuto: "w-max max-w-[min(var(--container-sm),var(--reka-popover-content-available-width))]"
};
function zf(e, a) {
  const t = i(
    () => q(
      na.content,
      na.focusRing,
      na.maxHeight,
      Ne(e) === void 0 ? na.widthAuto : na.widthFixed,
      Ne(a)
    )
  ), s = i(() => {
    const o = Ne(e);
    return o === void 0 ? { zIndex: Il } : { zIndex: Il, width: `${o}px` };
  });
  return { contentClasses: t, contentStyle: s };
}
const Hf = ["tabindex"], qb = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "Popover",
  props: {
    open: { type: Boolean, default: void 0 },
    align: { default: "center" },
    side: { default: "bottom" },
    sideOffset: { default: 6 },
    width: { default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    class: { type: [Boolean, null, String, Object, Array], default: void 0 }
  },
  emits: ["update:open"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = We(), { contentClasses: d, contentStyle: u } = zf(
      () => t.width,
      () => t.class
    ), b = A(!1), g = i({
      get: () => t.open ?? b.value,
      set: (x) => {
        b.value = x, s("update:open", x);
      }
    }), h = () => {
      g.value = !1;
    }, p = i(() => t.ariaLabelledby ? { "aria-labelledby": t.ariaLabelledby } : t.ariaLabel ? { "aria-label": t.ariaLabel, "aria-labelledby": void 0 } : o.trigger ? {} : { "aria-labelledby": void 0 }), f = Al(null), y = A(), w = A(!1), S = () => {
      f.value = document.activeElement instanceof HTMLElement ? document.activeElement : null, w.value = !1, Fe(() => {
        const x = y.value;
        !x || x.contains(document.activeElement) || (w.value = !0, x.focus({ preventScroll: !0 }));
      });
    }, k = () => {
      o.trigger || f.value?.focus(), f.value = null;
    };
    return (x, $) => (n(), F(l(Jl), {
      open: g.value,
      "onUpdate:open": $[0] || ($[0] = (D) => g.value = D),
      modal: ""
    }, {
      default: M(() => [
        l(o).anchor ? (n(), F(l(Do), {
          key: 0,
          "as-child": ""
        }, {
          default: M(() => [
            T(x.$slots, "anchor")
          ]),
          _: 3
        })) : v("", !0),
        l(o).trigger ? (n(), F(l(Ql), {
          key: 1,
          "as-child": ""
        }, {
          default: M(() => [
            T(x.$slots, "trigger")
          ]),
          _: 3
        })) : v("", !0),
        L(l(es), null, {
          default: M(() => [
            L(l(ts), {
              "as-child": "",
              align: t.align,
              side: t.side,
              "side-offset": t.sideOffset,
              "collision-padding": 16,
              onOpenAutoFocus: S,
              onCloseAutoFocus: k
            }, {
              default: M(() => [
                m("div", Oe({
                  ref_key: "contentElement",
                  ref: y
                }, { ...x.$attrs, ...p.value }, {
                  tabindex: w.value ? 0 : -1,
                  class: l(d),
                  style: l(u)
                }), [
                  T(x.$slots, "default", { close: h })
                ], 16, Hf)
              ]),
              _: 3
            }, 8, ["align", "side", "side-offset"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), Ub = /* @__PURE__ */ X({
  __name: "Card",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e;
    return (t, s) => (n(), c("div", {
      "data-testid": "card-container",
      class: r(
        l(q)(
          "border-border-border-200 flex w-full overflow-hidden rounded-2xl border-2 bg-white",
          a.class
        )
      )
    }, [
      T(t.$slots, "default")
    ], 2));
  }
}), Zf = ["data-testid"], Pf = { key: 0 }, jf = { class: "flex min-w-0 flex-1 flex-col" }, Nf = { class: "flex items-center gap-1.5" }, qf = {
  key: 2,
  class: "text-gray-400"
}, Uf = {
  key: 0,
  class: "h-3 w-20 animate-pulse rounded bg-gray-200"
}, Gf = { key: 1 }, Gb = /* @__PURE__ */ X({
  __name: "CardItem",
  props: {
    size: { default: "md" },
    label: {},
    value: {},
    subtext: {},
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    const a = e, t = We(), s = i(() => {
      const o = a.label ? a.label.toLowerCase().replaceAll(/\s+/g, "-") : "unknown";
      return a.loading ? `card-item-${o}-skeleton` : `card-item-${o}`;
    });
    return (o, d) => (n(), c("div", {
      "data-testid": s.value,
      class: r(
        l(q)("group relative flex min-w-0 flex-1 items-center", {
          "gap-4 p-5": a.size === "lg",
          "gap-3 p-4": a.size === "md",
          "gap-3 p-3": a.size === "sm"
        })
      )
    }, [
      d[0] || (d[0] = m("div", { class: "absolute top-1/2 right-0 h-1/2 w-px -translate-y-1/2 bg-gray-200 group-last:hidden" }, null, -1)),
      l(t).icon ? (n(), c("div", Pf, [
        a.loading ? (n(), c("div", {
          key: 0,
          class: r(
            l(q)("shrink-0 animate-pulse rounded-lg bg-gray-200", {
              "h-12 w-12": a.size === "lg",
              "h-10 w-10": a.size === "md",
              "h-8 w-8": a.size === "sm"
            })
          )
        }, null, 2)) : T(o.$slots, "icon", {}, void 0, void 0, 1)
      ])) : v("", !0),
      m("div", jf, [
        m("div", Nf, [
          a.loading ? (n(), c("div", {
            key: 0,
            class: r(
              l(q)("mb-1 animate-pulse rounded bg-gray-200", {
                "h-4 w-20": a.size === "lg",
                "h-3 w-16": a.size === "md",
                "h-2.5 w-14": a.size === "sm"
              })
            )
          }, null, 2)) : (n(), c("span", {
            key: 1,
            class: r(l(q)("type-column-header truncate text-gray-500"))
          }, [
            T(o.$slots, "label", {}, () => [
              ie(C(a.label), 1)
            ])
          ], 2)),
          !a.loading && l(t).tooltip ? (n(), c("div", qf, [
            T(o.$slots, "tooltip")
          ])) : v("", !0)
        ]),
        m("div", {
          "data-testid": "item-value",
          class: r(
            l(q)("truncate text-gray-900", {
              "type-h1": a.size === "lg",
              "type-h2": a.size === "md",
              "type-h3": a.size === "sm"
            })
          )
        }, [
          a.loading ? (n(), c("div", {
            key: 0,
            class: r(
              l(q)("mb-1 animate-pulse rounded bg-gray-200", {
                "h-8 w-32": a.size === "lg",
                "h-7 w-24": a.size === "md",
                "h-6 w-20": a.size === "sm"
              })
            )
          }, null, 2)) : T(o.$slots, "value", {}, () => [
            ie(C(a.value), 1)
          ], void 0, 1)
        ], 2),
        a.subtext || l(t).subtext ? (n(), c("div", {
          key: 0,
          class: r(
            l(q)("line-clamp-2 text-gray-500", {
              "type-body-1": a.size === "lg",
              "type-body-2": a.size === "md" || a.size === "sm"
            })
          )
        }, [
          a.loading ? (n(), c("div", Uf)) : T(o.$slots, "subtext", {}, () => [
            ie(C(a.subtext), 1)
          ], void 0, 1)
        ], 2)) : v("", !0),
        !a.loading && l(t).action ? (n(), c("div", Gf, [
          T(o.$slots, "action")
        ])) : v("", !0)
      ])
    ], 10, Zf));
  }
}), _f = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  '[tabindex]:not([tabindex="-1"])'
].join(", "), Wf = () => {
  const e = A(null);
  let a = null;
  const t = (d) => {
    if (d.key !== "Tab" || !e.value) return;
    const u = Array.from(
      e.value.querySelectorAll(_f)
    ).filter((h) => !h.closest("[disabled]"));
    if (!u.length) return;
    const b = u[0], g = u[u.length - 1];
    d.shiftKey ? document.activeElement === b && (d.preventDefault(), g.focus()) : document.activeElement === g && (d.preventDefault(), b.focus());
  }, s = () => {
    a = document.activeElement, requestAnimationFrame(() => {
      e.value?.focus();
    }), document.addEventListener("keydown", t);
  }, o = () => {
    document.removeEventListener("keydown", t), a?.focus(), a = null;
  };
  return Ka(() => {
    document.removeEventListener("keydown", t);
  }), {
    drawerRef: e,
    onOpen: s,
    onClose: o
  };
}, Kf = (e) => {
  const a = i(() => {
    switch (Ne(e.size)) {
      case "sm":
        return "w-full lg:w-[480px]";
      case "md":
        return "w-full lg:w-[640px]";
      case "lg":
        return "w-full lg:w-[860px]";
      case "xl":
        return "w-full lg:w-[1100px]";
      case "2xl":
        return "w-full lg:w-[1400px]";
      // A short last step, where the rest of the scale climbs by about a third: `2xl` already fills
      // a laptop, so the room this adds is for a wide desktop's data-dense drawer, not another tier.
      case "3xl":
        return "w-full lg:w-[1550px]";
      default:
        return "w-full lg:w-[1100px]";
    }
  }), t = ["fixed inset-0 z-50", "bg-black/50", "backdrop-blur-sm"].join(" "), s = [
    "fixed inset-0 z-50",
    "flex items-stretch justify-end",
    // Pointer events only on the backdrop area (drawer panel handles its own)
    "pointer-events-none"
  ].join(" "), o = i(
    () => [
      "relative flex flex-col",
      a.value,
      "h-full",
      // Rounded left only, and only from lg: a full-screen panel has no left edge showing
      "lg:rounded-l-lg overflow-hidden",
      "bg-white shadow-2xl",
      // Re-enable pointer events on the panel
      "pointer-events-auto"
    ].join(" ")
  ), d = [
    "flex flex-col gap-0.5",
    "px-6 py-4",
    "border-b border-gray-200",
    "shrink-0"
  ].join(" "), u = "type-h3 text-txt-800", b = "type-body-1 text-txt-600", g = [
    "flex items-center justify-center",
    "w-8 h-8 -ml-1",
    "rounded-md text-txt-600",
    "hover:bg-gray-100 hover:text-txt-800",
    "transition-colors duration-150",
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-800 focus-visible:ring-offset-1"
  ].join(" "), h = "flex-1 overflow-y-auto bg-gray-50", p = ["shrink-0", "px-4 py-2", "border-t border-gray-200"].join(" ");
  return {
    overlayClasses: t,
    containerClasses: s,
    panelClasses: o,
    defaultHeaderClasses: d,
    titleClasses: u,
    subtitleClasses: b,
    closeButtonClasses: g,
    contentClasses: h,
    footerClasses: p
  };
}, Yf = ["aria-label", "data-testid"], Xf = { class: "flex items-center gap-3" }, Jf = { class: "flex min-w-0 flex-col gap-0.5" }, _b = /* @__PURE__ */ X({
  __name: "Drawer",
  props: {
    show: { type: Boolean, default: !1 },
    title: { default: void 0 },
    subtitle: { default: void 0 },
    size: { default: "xl" },
    dataTestId: {}
  },
  emits: ["close", "hide"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = We(), {
      overlayClasses: d,
      containerClasses: u,
      panelClasses: b,
      defaultHeaderClasses: g,
      titleClasses: h,
      subtitleClasses: p,
      closeButtonClasses: f,
      contentClasses: y,
      footerClasses: w
    } = Kf({
      size: () => t.size ?? "xl"
    }), { drawerRef: S, onOpen: k, onClose: x } = Wf();
    Se(
      () => t.show,
      (R) => {
        R ? (k(), document.body.style.overflow = "hidden") : (x(), document.body.style.overflow = "");
      },
      { immediate: !0 }
    ), Ka(() => {
      t.show && (document.body.style.overflow = "");
    });
    const $ = () => s("close"), D = () => s("hide"), E = (R) => {
      R.key === "Escape" && D();
    };
    return (R, V) => (n(), F(Wa, { to: "body" }, [
      L(_t, {
        "enter-active-class": "transition-opacity duration-300 ease-out",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition-opacity duration-200 ease-in",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: M(() => [
          e.show ? (n(), c("div", {
            key: 0,
            class: r(l(d)),
            "aria-hidden": "true",
            "data-testid": "drawer-overlay",
            onClick: D
          }, null, 2)) : v("", !0)
        ]),
        _: 1
      }),
      m("div", {
        class: r(l(u)),
        onKeydown: E
      }, [
        L(_t, {
          appear: "",
          "enter-active-class": "transition-transform duration-300 ease-out",
          "enter-from-class": "translate-x-full",
          "enter-to-class": "translate-x-0",
          "leave-active-class": "transition-transform duration-200 ease-in",
          "leave-from-class": "translate-x-0",
          "leave-to-class": "translate-x-full"
        }, {
          default: M(() => [
            e.show ? (n(), c("dialog", {
              key: 0,
              ref_key: "drawerRef",
              ref: S,
              class: r(l(b)),
              "aria-modal": "true",
              tabindex: "-1",
              "aria-label": e.title ?? "Drawer",
              "data-testid": e.dataTestId ?? "drawer-panel"
            }, [
              T(R.$slots, "header", {}, () => [
                m("div", {
                  class: r(l(g)),
                  "data-testid": "drawer-default-header"
                }, [
                  m("div", Xf, [
                    L(Ze, {
                      class: r(l(f)),
                      isIconOnly: "",
                      size: "sm",
                      variant: "primary",
                      severity: "neutral",
                      "aria-label": "Close",
                      "data-testid": "drawer-close-button",
                      onClick: $
                    }, {
                      "left-icon": M(() => [
                        L(l(rt), { class: "h-5 w-5" })
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    m("div", Jf, [
                      e.subtitle ? (n(), c("span", {
                        key: 0,
                        class: r(l(p)),
                        "data-testid": "drawer-subtitle"
                      }, C(e.subtitle), 3)) : v("", !0),
                      e.title ? (n(), c("span", {
                        key: 1,
                        class: r(l(h)),
                        "data-testid": "drawer-title"
                      }, C(e.title), 3)) : v("", !0)
                    ])
                  ])
                ], 2)
              ]),
              m("div", {
                class: r(l(y)),
                "data-testid": "drawer-content"
              }, [
                T(R.$slots, "default")
              ], 2),
              l(o).footer ? (n(), c("div", {
                key: 0,
                class: r(l(w)),
                "data-testid": "drawer-footer"
              }, [
                T(R.$slots, "footer")
              ], 2)) : v("", !0)
            ], 10, Yf)) : v("", !0)
          ]),
          _: 3
        })
      ], 34)
    ]));
  }
}), Qf = 9999, e2 = 10002, t2 = (e) => {
  const a = i(() => {
    switch (Ne(e.size)) {
      case "sm":
        return "sm:max-w-md";
      case "md":
        return "sm:max-w-lg";
      case "lg":
        return "sm:max-w-2xl";
      case "xl":
        return "sm:max-w-4xl";
      case "2xl":
        return "sm:max-w-6xl";
      default:
        return "sm:max-w-lg";
    }
  }), t = i(() => Ne(e.elevated) ? e2 : Qf), s = i(() => ({ zIndex: t.value })), o = i(() => ({ zIndex: t.value })), d = [
    "fixed inset-0",
    "bg-black/50 backdrop-blur-sm",
    "data-[state=open]:animate-in data-[state=closed]:animate-out",
    "data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0"
  ].join(" "), u = i(
    () => [
      "fixed left-1/2 top-1/2",
      "-translate-x-1/2 -translate-y-1/2",
      "flex flex-col",
      "w-[calc(100%-2rem)]",
      a.value,
      // Grow with content, but never taller than 80% of the viewport
      "max-h-[95vh]",
      "rounded-lg bg-white shadow-2xl",
      "focus:outline-none",
      "data-[state=open]:animate-in data-[state=closed]:animate-out",
      "data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0",
      "data-[state=open]:zoom-in-95 data-[state=closed]:zoom-out-95"
    ].join(" ")
  ), b = [
    "flex items-center justify-between gap-3",
    "p-4 2xl:pt-10",
    "border-b border-gray-200",
    "shrink-0"
  ].join(" "), g = "type-h3 text-txt-800", h = [
    "flex items-center justify-center",
    "w-8 h-8",
    "rounded-md text-txt-600",
    "hover:bg-gray-100 hover:text-txt-800",
    "transition-colors duration-150",
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-800 focus-visible:ring-offset-1"
  ].join(" "), p = "flex-1 min-h-24 overflow-y-auto p-4", f = ["shrink-0", "px-4 py-2", "border-t border-gray-200"].join(" ");
  return {
    overlayStyles: s,
    panelStyles: o,
    overlayClasses: d,
    panelClasses: u,
    headerClasses: b,
    titleClasses: g,
    closeButtonClasses: h,
    contentClasses: p,
    footerClasses: f
  };
}, a2 = /* @__PURE__ */ X({
  __name: "Dialog",
  props: /* @__PURE__ */ ia({
    title: {},
    size: { default: "md" },
    hideCloseButton: { type: Boolean, default: !1 },
    elevated: { type: Boolean, default: !1 },
    contentClass: { type: [Boolean, null, String, Object, Array] },
    dataTestId: { default: void 0 },
    externalContentSelector: { default: void 0 },
    initialFocus: { default: void 0 }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(e) {
    const a = e, t = Ya(e, "open"), s = We(), {
      overlayStyles: o,
      panelStyles: d,
      overlayClasses: u,
      panelClasses: b,
      headerClasses: g,
      titleClasses: h,
      closeButtonClasses: p,
      contentClasses: f,
      footerClasses: y
    } = t2({
      size: () => a.size ?? "md",
      elevated: () => a.elevated
    }), w = (x) => {
      a.hideCloseButton && x.preventDefault();
    }, S = (x) => {
      if (!a.initialFocus || !(x.target instanceof Element)) return;
      const $ = x.target.querySelector(a.initialFocus);
      $?.focus(), $ && document.activeElement === $ && x.preventDefault();
    }, k = (x) => {
      if (a.hideCloseButton) {
        x.preventDefault();
        return;
      }
      const $ = x.target;
      a.externalContentSelector && $ instanceof Element && $.closest(a.externalContentSelector) && x.preventDefault();
    };
    return (x, $) => (n(), F(l(Fo), {
      open: t.value,
      "onUpdate:open": $[0] || ($[0] = (D) => t.value = D)
    }, {
      default: M(() => [
        l(s).trigger ? (n(), F(l(Ro), {
          key: 0,
          "as-child": ""
        }, {
          default: M(() => [
            T(x.$slots, "trigger")
          ]),
          _: 3
        })) : v("", !0),
        L(l(Io), null, {
          default: M(() => [
            L(l(To), {
              class: r(l(u)),
              style: Ee(l(o)),
              "data-testid": "dialog-overlay"
            }, null, 8, ["class", "style"]),
            L(l(Ao), {
              class: r(l(b)),
              style: Ee(l(d)),
              "data-testid": e.dataTestId ?? "dialog-panel",
              onOpenAutoFocus: S,
              onEscapeKeyDown: w,
              onInteractOutside: k
            }, {
              default: M(() => [
                m("div", {
                  class: r(l(g)),
                  "data-testid": "dialog-header"
                }, [
                  L(l(Oo), {
                    class: r(l(h)),
                    "data-testid": "dialog-title"
                  }, {
                    default: M(() => [
                      ie(C(e.title), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  e.hideCloseButton ? v("", !0) : (n(), F(l(zo), {
                    key: 0,
                    "as-child": ""
                  }, {
                    default: M(() => [
                      L(Ze, {
                        class: r(l(p)),
                        "is-icon-only": "",
                        size: "sm",
                        variant: "primary",
                        severity: "neutral",
                        "aria-label": "Close",
                        "data-testid": "dialog-close-button"
                      }, {
                        "left-icon": M(() => [
                          L(l(rt), { class: "h-5 w-5" })
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    _: 1
                  }))
                ], 2),
                L(l(Ho), {
                  as: "div",
                  class: r(l(q)(l(f), a.contentClass)),
                  "data-testid": "dialog-content"
                }, {
                  default: M(() => [
                    T(x.$slots, "default")
                  ]),
                  _: 3
                }, 8, ["class"]),
                l(s).footer ? (n(), c("div", {
                  key: 0,
                  class: r(l(y)),
                  "data-testid": "dialog-footer"
                }, [
                  T(x.$slots, "footer")
                ], 2)) : v("", !0)
              ]),
              _: 3
            }, 8, ["class", "style", "data-testid"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), l2 = { class: "flex justify-end gap-3" }, Wb = /* @__PURE__ */ X({
  __name: "ConfirmationDialog",
  props: /* @__PURE__ */ ia({
    title: {},
    size: { default: "sm" },
    confirmLabel: { default: "Confirm" },
    cancelLabel: { default: "Cancel" },
    confirmSeverity: { default: "default" },
    confirmLoading: { type: Boolean, default: !1 },
    confirmDisabled: { type: Boolean, default: !1 },
    cancelLoading: { type: Boolean, default: !1 },
    cancelDisabled: { type: Boolean, default: !1 },
    hideCloseButton: { type: Boolean, default: !1 },
    dataTestId: { default: void 0 },
    initialFocus: { default: void 0 }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ ia(["confirm", "cancel"], ["update:open"]),
  setup(e, { emit: a }) {
    const t = e, s = Ya(e, "open"), o = a, d = i(() => t.cancelDisabled || t.confirmLoading), u = () => o("confirm"), b = () => {
      o("cancel"), s.value = !1;
    }, g = (h) => {
      if (h) {
        s.value = !0;
        return;
      }
      t.confirmLoading || b();
    };
    return (h, p) => (n(), F(a2, {
      open: s.value,
      title: e.title,
      size: e.size,
      "hide-close-button": e.hideCloseButton,
      "data-test-id": e.dataTestId,
      "initial-focus": e.initialFocus,
      "onUpdate:open": g
    }, tt({
      footer: M(() => [
        m("div", l2, [
          L(Ze, {
            variant: "tertiary",
            "is-loading": e.cancelLoading,
            "is-disabled": d.value,
            "data-testid": "confirmation-cancel-button",
            onClick: b
          }, {
            default: M(() => [
              ie(C(e.cancelLabel), 1)
            ]),
            _: 1
          }, 8, ["is-loading", "is-disabled"]),
          L(Ze, {
            variant: e.confirmSeverity === "default" ? "brand" : "primary",
            severity: e.confirmSeverity,
            "is-loading": e.confirmLoading,
            "is-disabled": e.confirmDisabled,
            "data-testid": "confirmation-confirm-button",
            onClick: u
          }, {
            default: M(() => [
              ie(C(e.confirmLabel), 1)
            ]),
            _: 1
          }, 8, ["variant", "severity", "is-loading", "is-disabled"])
        ])
      ]),
      default: M(() => [
        T(h.$slots, "default")
      ]),
      _: 2
    }, [
      h.$slots.trigger ? {
        name: "trigger",
        fn: M(() => [
          T(h.$slots, "trigger")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["open", "title", "size", "hide-close-button", "data-test-id", "initial-focus"]));
  }
}), s2 = { class: "flex items-center justify-between py-2 sm:py-4" }, n2 = { class: "flex items-center gap-4" }, o2 = { class: "flex flex-col" }, r2 = {
  key: 0,
  class: "text-txt-600 type-body-1 line-clamp-1"
}, i2 = { class: "inline-flex items-center" }, d2 = { class: "type-h2 line-clamp-1" }, Kb = /* @__PURE__ */ X({
  __name: "PageHeader",
  props: {
    title: { default: "Lorem Ipsum Dolar" },
    subtitle: {},
    hasBackButton: { type: Boolean, default: !0 },
    tag: {}
  },
  emits: ["back-clicked"],
  setup(e, { emit: a }) {
    const t = e, s = a;
    return (o, d) => (n(), c("div", s2, [
      m("div", n2, [
        e.hasBackButton ? (n(), F(Ze, {
          key: 0,
          "is-icon-only": "",
          size: "sm",
          variant: "tertiary",
          "aria-label": "Close",
          "data-testid": "drawer-close-button",
          onClick: d[0] || (d[0] = (u) => s("back-clicked"))
        }, {
          "left-icon": M(() => [
            L(l(Gr), { class: "h-5 w-5" })
          ]),
          _: 1
        })) : v("", !0),
        m("div", o2, [
          e.subtitle ? (n(), c("p", r2, C(e.subtitle), 1)) : v("", !0),
          m("div", i2, [
            m("h1", d2, C(e.title), 1),
            t.tag ? (n(), F(Sa, Oe({ key: 0 }, t.tag, { class: "ml-2" }), null, 16)) : v("", !0)
          ])
        ])
      ]),
      T(o.$slots, "content-right")
    ]));
  }
}), on = {
  left: "text-left",
  center: "text-center",
  right: "text-right"
}, c2 = {
  default: "px-4 py-3",
  compact: "px-4 py-2"
}, u2 = {
  default: "px-4 py-3",
  compact: "px-4 py-2"
}, f2 = "flex w-full flex-col overflow-hidden rounded-lg border border-gray-200 bg-white", b2 = "w-full min-h-0 flex-1 overflow-x-auto focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-600", p2 = "flex w-full items-center justify-between gap-3 border-b border-gray-200 px-4 py-3", h2 = "flex w-full items-center justify-between gap-3 border-t border-gray-200 px-4 py-2.5", g2 = "w-full caption-bottom border-collapse type-body-1", m2 = "border-b border-gray-200 bg-background-light-300", v2 = "type-form-sub-header whitespace-nowrap text-gray-800", y2 = "border-t border-gray-200 bg-background-light-300", x2 = {
  left: "table-pinned-left z-[2] bg-background-light-300",
  right: "table-pinned-right z-[2] bg-background-light-300"
}, w2 = {
  left: "table-pinned-left z-[2] bg-inherit",
  right: "table-pinned-right z-[2] bg-inherit"
}, L2 = {
  left: { position: "sticky", left: 0 },
  right: { position: "sticky", right: 0 }
}, ol = (e) => e === !0 ? "right" : e || void 0, rn = (e) => {
  const a = ol(e);
  return a ? L2[a] : void 0;
}, C2 = "sticky top-0 z-[3] bg-background-light-300", k2 = "group inline-flex cursor-pointer items-center gap-1 select-none", Za = "h-3.5 w-3.5", $2 = "text-gray-500", M2 = "text-gray-300", V2 = [
  "flex h-4 w-4 shrink-0 items-center justify-center rounded-[3px] border transition-colors",
  "border-gray-300 bg-white",
  "data-[state=checked]:border-blue-600 data-[state=checked]:bg-blue-600",
  "data-[state=indeterminate]:border-blue-600 data-[state=indeterminate]:bg-blue-600",
  "cursor-pointer hover:border-blue-500",
  "focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-1 focus-visible:outline-none",
  // A 16px box is a 16px target, which is under the 24px a pointer wants. The pseudo-element grows
  // the hit area to 24px without costing any layout, so the box stays the size of the text beside it
  // while still being comfortable to hit — and the row's own padding keeps the overhang clear of the
  // neighbouring cell.
  "relative before:absolute before:-inset-1 before:content-['']",
  "disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-50"
], S2 = "flex h-full w-full items-center justify-center", B2 = "h-3 w-3 stroke-[3] text-white", E2 = "text-gray-400";
function D2(e, a, t) {
  return i(() => {
    const s = a?.value ?? !1, o = ol(e.pinned);
    return [
      c2[t?.value ?? "compact"],
      v2,
      on[e.align ?? "left"],
      o ? x2[o] : "",
      s ? C2 : "",
      // The pinned corner overlaps both the sticky header row and the pinned
      // column, so it must out-rank both (their z-indexes are 3 and 2). `cn()`
      // merges last-wins, so this overrides the z-index set above.
      o && s ? "z-[4]" : ""
    ];
  });
}
function F2(e, a) {
  return i(() => {
    const t = ol(e.pinned);
    return [
      u2[a?.value ?? "compact"],
      "align-middle type-body-1 text-gray-700",
      on[e.align ?? "left"],
      t ? w2[t] : ""
    ];
  });
}
const R2 = "[&>*:first-child]:relative [&>*:first-child]:before:absolute [&>*:first-child]:before:inset-y-0 [&>*:first-child]:before:left-0 [&>*:first-child]:before:w-[3px] [&>*:first-child]:before:content-['']", I2 = "relative after:pointer-events-none after:absolute after:inset-x-0 after:top-0 after:-bottom-px last:after:bottom-0 after:z-[2] after:border after:content-['']", T2 = "px-4 py-1.5 text-left type-caption ", ra = {
  info: {
    edge: "[&>*:first-child]:before:bg-blue-500",
    outline: "after:border-blue-500",
    fill: "bg-blue-50",
    banner: "bg-blue-600 text-white"
  },
  // The lightest of the four. White on `orange-500` measures 2.9:1, under the 4.5:1 text this size
  // wants — a deliberate call: the alternatives were an orange dark enough to carry white (rust, at
  // 700) or dark text on the light orange, and the brand orange with white won. The banner repeats
  // what the row already says rather than being the only place it's said, which is what makes that
  // survivable. Don't copy the pairing into anything load-bearing.
  warn: {
    edge: "[&>*:first-child]:before:bg-orange-500",
    outline: "after:border-orange-500",
    fill: "bg-orange-50",
    banner: "bg-orange-500 text-white"
  },
  error: {
    edge: "[&>*:first-child]:before:bg-red-500",
    outline: "after:border-red-500",
    fill: "bg-red-50",
    banner: "bg-red-600 text-white"
  },
  // The mark sits on 500 with `info` and `error`, chosen for an even set rather than from the
  // numbers: this theme's green ramp runs lighter than its blue and red, so `green-500` measures
  // 2.28:1 against white where `blue-500` is 3.68 — the faintest of the four, and under the 3:1 a
  // mark this size wants. A deliberate trade of that for a set that reads as one scale.
  //
  // The banner is the exception and stays two steps back, where every other severity is one: it is
  // the only severity surface carrying text, and white needs 4.5:1, which this ramp does not reach
  // until 700 (`green-600` is 3.30). Lightening it to sit beside the mark would have put the one
  // part of the row that *says why* below the threshold — the mark can trade contrast for the set,
  // a sentence in white cannot.
  success: {
    edge: "[&>*:first-child]:before:bg-green-500",
    outline: "after:border-green-500",
    fill: "bg-green-50",
    banner: "bg-green-700 text-white"
  },
  // Several rungs lighter than the other four throughout: neutral marks a row without ranking it,
  // and grey at their weight would read as a fifth alarm rather than the absence of one. Light
  // enough to sit under the content, dark enough to still draw the line it's drawing.
  neutral: {
    // The edge stays a step darker than the outline: it's 3px of colour doing the marking on its
    // own, where the outline is a rule the eye reads as part of the table's own furniture.
    edge: "[&>*:first-child]:before:bg-gray-300",
    // `gray-200` — the same rule the header sits on and the table is framed in.
    outline: "after:border-gray-200",
    fill: "bg-gray-50",
    // `text-gray-800`, not the `text-gray-700` the cells use: this theme's grey scale runs lighter
    // than Tailwind's stock one (`gray-700` is #747184), which left the strip at 3.91:1. 5.13:1 here.
    banner: "bg-gray-100 text-gray-800"
  }
};
function rl(e) {
  return e.severity ? new Set(
    Array.isArray(e.severityStyle) ? e.severityStyle : [e.severityStyle ?? "edge"]
  ) : /* @__PURE__ */ new Set();
}
function A2(e) {
  return i(() => {
    const a = e.severity;
    if (!(!a || !rl(e).has("banner")))
      return [T2, ra[a].banner];
  });
}
function O2(e) {
  return i(() => {
    const a = e.severity;
    if (!(!a || !rl(e).has("banner")))
      return [
        ra[a].banner,
        "[&>td]:bg-inherit [&>td]:py-1.5 [&>td]:text-[11px] [&>td]:font-medium [&>td]:text-inherit"
      ];
  });
}
function z2(e, a = !1) {
  return i(() => {
    const t = e.severity, s = rl(e), o = t !== void 0 && s.has("fill") && !e.selected, d = a ? "" : e.selected ? "bg-blue-50" : o && t ? ra[t].fill : "bg-white";
    return [
      // `last:border-b-0`, not `border-0`: the latter drops every border on the last row, which
      // took the severity edge with it — reading as "the edge only shows when a row follows".
      "border-b border-gray-100 transition-colors last:border-b-0",
      t && s.has("edge") ? [R2, ra[t].edge] : "",
      t && s.has("outline") ? [I2, ra[t].outline] : "",
      // Solid, not an alpha wash: a pinned cell inherits this colour and paints it again over the
      // row's own, so a translucent one would darken exactly the columns it should match.
      //
      // A selected row keeps its own fill: severity says what kind of row it is, selection says
      // which one you're on, and the latter is the more immediate fact.
      d,
      { "cursor-pointer hover:bg-gray-50": e.clickable }
    ];
  });
}
const dn = /* @__PURE__ */ Symbol("TableStickyHeader"), H2 = (e) => {
  ba(dn, e);
}, Z2 = () => fa(
  dn,
  i(() => !1)
), cn = /* @__PURE__ */ Symbol("TableDensity"), P2 = (e) => {
  ba(cn, e);
}, un = () => fa(
  cn,
  i(() => "default")
), fn = /* @__PURE__ */ Symbol("TableBandRow"), bn = () => {
  ba(fn, !0);
}, j2 = () => fa(fn, !1), N2 = {
  "data-testid": "table-skeleton",
  class: "flex h-full w-full flex-col overflow-hidden",
  "aria-hidden": "true"
}, q2 = {
  key: 0,
  class: "flex shrink-0 items-center gap-4 border-b border-gray-200 px-4 py-3"
}, U2 = /* @__PURE__ */ X({
  __name: "TableSkeleton",
  props: {
    columns: { default: 5 },
    rows: { default: 16 },
    showHeader: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (a, t) => (n(), c("div", N2, [
      e.showHeader ? (n(), c("div", q2, [
        (n(!0), c(re, null, xe(e.columns, (s) => (n(), c("div", {
          key: `h-${s}`,
          class: "h-3 flex-1 animate-pulse rounded bg-gray-100"
        }))), 128))
      ])) : v("", !0),
      (n(!0), c(re, null, xe(e.rows, (s) => (n(), c("div", {
        key: `r-${s}`,
        class: "flex flex-1 items-center gap-4 border-b border-gray-100 px-4 py-4 last:border-0"
      }, [
        (n(!0), c(re, null, xe(e.columns, (o) => (n(), c("div", {
          key: `c-${s}-${o}`,
          class: "h-4 flex-1 animate-pulse rounded bg-gray-100"
        }))), 128))
      ]))), 128))
    ]));
  }
}), G2 = ["data-overflowing", "tabindex"], _2 = {
  key: "loading",
  class: "h-full"
}, W2 = {
  key: "empty",
  class: "h-full"
}, Yb = /* @__PURE__ */ X({
  __name: "Table",
  props: {
    density: {},
    class: { type: [Boolean, null, String, Object, Array] },
    tableStyle: { type: [Boolean, null, String, Object, Array] },
    stickyHeader: { type: Boolean },
    loading: { type: Boolean },
    empty: { type: Boolean },
    loadingDelay: { default: 200 },
    loadingMinDuration: { default: 400 }
  },
  setup(e) {
    const a = e, t = A(!1);
    let s, o, d = 0;
    Se(
      () => a.loading,
      (x) => {
        if (clearTimeout(s), clearTimeout(o), x) {
          if (t.value) return;
          s = setTimeout(() => {
            t.value = !0, d = Date.now();
          }, a.loadingDelay);
          return;
        }
        if (!t.value) return;
        const $ = Math.max(0, a.loadingMinDuration - (Date.now() - d));
        o = setTimeout(() => {
          t.value = !1;
        }, $);
      },
      { immediate: !0 }
    );
    const u = i(() => !a.loading && a.empty), b = i(() => !t.value && !u.value), g = i(() => q(f2, a.stickyHeader && "h-full")), h = i(
      () => q(b2, a.stickyHeader && "overflow-y-auto")
    );
    H2(i(() => !!a.stickyHeader)), P2(i(() => a.density ?? "compact"));
    const p = A(null), f = A(!1), y = A(!1);
    let w;
    const S = () => {
      const x = p.value;
      x && (f.value = x.scrollWidth - x.clientWidth > 1, y.value = f.value || x.scrollHeight - x.clientHeight > 1);
    }, k = () => {
      const x = p.value?.querySelector("table");
      x && w && w.observe(x);
    };
    return Vt(() => {
      S(), !(typeof ResizeObserver > "u" || !p.value) && (w = new ResizeObserver(S), w.observe(p.value), k());
    }), Se(b, async (x) => {
      x && (await Fe(), S(), k());
    }), Mt(() => {
      w?.disconnect(), clearTimeout(s), clearTimeout(o);
    }), (x, $) => (n(), c("div", {
      class: r(g.value)
    }, [
      x.$slots.header ? (n(), c("div", {
        key: 0,
        "data-testid": "table-header-band",
        class: r(l(p2))
      }, [
        T(x.$slots, "header")
      ], 2)) : v("", !0),
      m("div", {
        ref_key: "container",
        ref: p,
        "data-testid": "table-container",
        "data-overflowing": f.value ? "true" : void 0,
        tabindex: y.value ? 0 : void 0,
        class: r(h.value)
      }, [
        L(_t, {
          name: "boq-table-fade",
          mode: "out-in"
        }, {
          default: M(() => [
            t.value ? (n(), c("div", _2, [
              T(x.$slots, "loading", {}, () => [
                L(U2)
              ])
            ])) : u.value ? (n(), c("div", W2, [
              T(x.$slots, "empty")
            ])) : (n(), c("table", {
              key: "table",
              "data-testid": "table",
              class: r(l(q)(l(g2), a.class)),
              style: Ee(a.tableStyle)
            }, [
              T(x.$slots, "default")
            ], 6))
          ]),
          _: 3
        })
      ], 10, G2),
      x.$slots.footer ? (n(), c("div", {
        key: 1,
        "data-testid": "table-footer-band",
        class: r(l(h2))
      }, [
        T(x.$slots, "footer")
      ], 2)) : v("", !0)
    ], 2));
  }
}), Xb = /* @__PURE__ */ X({
  __name: "TableHeader",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e;
    return bn(), (t, s) => (n(), c("thead", {
      "data-testid": "table-header",
      class: r(l(q)(l(m2), a.class))
    }, [
      T(t.$slots, "default")
    ], 2));
  }
}), Jb = /* @__PURE__ */ X({
  __name: "TableBody",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e;
    return (t, s) => (n(), c("tbody", {
      "data-testid": "table-body",
      class: r(l(q)(a.class))
    }, [
      T(t.$slots, "default")
    ], 2));
  }
}), Qb = /* @__PURE__ */ X({
  __name: "TableFooter",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e;
    return bn(), (t, s) => (n(), c("tfoot", {
      "data-testid": "table-footer",
      class: r(l(q)(l(y2), a.class))
    }, [
      T(t.$slots, "default")
    ], 2));
  }
}), K2 = ["colspan"], ep = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "TableRow",
  props: {
    clickable: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    severity: {},
    severityStyle: {},
    bannerColspan: { default: 1 },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e, t = We(), s = z2(a, j2()), o = A2(a), d = O2(a), u = i(() => !!t["banner-cells"]);
    return (b, g) => (n(), c(re, null, [
      l(o) ? (n(), c("tr", {
        key: 0,
        "data-testid": "table-row-banner",
        class: r(u.value ? l(q)(l(d)) : void 0)
      }, [
        u.value ? T(b.$slots, "banner-cells", {}, void 0, void 0, 0) : (n(), c("td", {
          key: 1,
          colspan: a.bannerColspan,
          class: r(l(q)(l(o)))
        }, [
          T(b.$slots, "banner")
        ], 10, K2))
      ], 2)) : v("", !0),
      m("tr", Oe({ "data-testid": "table-row" }, b.$attrs, {
        class: l(q)(l(s), a.class)
      }), [
        T(b.$slots, "default")
      ], 16)
    ], 64));
  }
}), tp = /* @__PURE__ */ X({
  __name: "TableHead",
  props: {
    align: { default: "left" },
    pinned: { type: [Boolean, String], default: !1 },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e, t = Z2(), s = un(), o = D2(a, t, s);
    return (d, u) => (n(), c("th", {
      "data-testid": "table-head",
      scope: "col",
      class: r(l(q)(l(o), a.class)),
      style: Ee(l(rn)(a.pinned))
    }, [
      T(d.$slots, "default")
    ], 6));
  }
}), ap = /* @__PURE__ */ X({
  __name: "TableCell",
  props: {
    align: { default: "left" },
    pinned: { type: [Boolean, String], default: !1 },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e, t = un(), s = F2(a, t);
    return (o, d) => (n(), c("td", {
      "data-testid": "table-cell",
      class: r(l(q)(l(s), a.class)),
      style: Ee(l(rn)(a.pinned))
    }, [
      T(o.$slots, "default")
    ], 6));
  }
}), Y2 = ["data-testid"], X2 = {
  key: 1,
  "data-testid": "table-sort-static"
}, J2 = {
  class: "relative ml-0.5 cursor-help leading-none text-red-600",
  "data-testid": "table-header-required"
}, Q2 = { class: "sr-only" }, eb = ["aria-label"], lp = /* @__PURE__ */ X({
  __name: "SortableHeader",
  props: {
    label: {},
    sortable: { type: Boolean, default: !0 },
    sortDirection: { type: [String, Boolean], default: !1 },
    isRequired: { type: Boolean },
    requiredLabel: { default: "Required" },
    requiredDescription: { default: "required" },
    tooltip: {},
    tooltipAriaLabel: {},
    class: { type: [Boolean, null, String, Object, Array] }
  },
  emits: ["sort"],
  setup(e) {
    const a = e, t = We();
    return (s, o) => (n(), c("span", {
      class: r(l(q)("inline-flex items-center gap-1", a.class))
    }, [
      a.sortable ? (n(), c("button", {
        key: 0,
        type: "button",
        "data-testid": "table-sort-button",
        class: r(l(k2)),
        onClick: o[0] || (o[0] = (d) => s.$emit("sort", d))
      }, [
        T(s.$slots, "default", {}, () => [
          ie(C(a.label), 1)
        ]),
        m("span", {
          class: r(l($2)),
          "data-testid": `table-sort-${a.sortDirection || "none"}`
        }, [
          a.sortDirection === "asc" ? (n(), F(l(Xr), {
            key: 0,
            class: r(l(Za))
          }, null, 8, ["class"])) : a.sortDirection === "desc" ? (n(), F(l(pa), {
            key: 1,
            class: r(l(Za))
          }, null, 8, ["class"])) : (n(), F(l(Yr), {
            key: 2,
            class: r(l(q)(l(Za), l(M2)))
          }, null, 8, ["class"]))
        ], 10, Y2)
      ], 2)) : (n(), c("span", X2, [
        T(s.$slots, "default", {}, () => [
          ie(C(a.label), 1)
        ])
      ])),
      a.isRequired ? (n(), F(ht, {
        key: 2,
        label: a.requiredLabel,
        position: "top"
      }, {
        default: M(() => [
          m("span", J2, [
            o[2] || (o[2] = m("span", {
              "aria-hidden": "true",
              class: "text-base leading-none font-normal"
            }, "*", -1)),
            m("span", Q2, C(a.requiredDescription), 1)
          ])
        ]),
        _: 1
      }, 8, ["label"])) : v("", !0),
      a.tooltip || l(t).tooltip ? (n(), F(ht, {
        key: 3,
        label: a.tooltip,
        position: "top"
      }, tt({
        default: M(() => [
          m("button", {
            type: "button",
            "data-testid": "table-header-tooltip-trigger",
            class: "inline-flex shrink-0 cursor-help items-center text-gray-400 hover:text-gray-600",
            "aria-label": a.tooltipAriaLabel ?? a.tooltip ?? "More information",
            onClick: o[1] || (o[1] = Te(() => {
            }, ["stop"]))
          }, [
            L(l(el), { class: "h-4 w-4" })
          ], 8, eb)
        ]),
        _: 2
      }, [
        l(t).tooltip ? {
          name: "label",
          fn: M(() => [
            T(s.$slots, "tooltip")
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["label"])) : v("", !0)
    ], 2));
  }
}), sp = /* @__PURE__ */ X({
  __name: "TableResizeHandle",
  props: {
    resizing: { type: Boolean, default: !1 },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e;
    return (t, s) => (n(), c("span", {
      "data-testid": "table-column-resize-handle",
      class: r(
        l(q)(
          "group/resize absolute top-0 right-0 flex h-full w-3 cursor-col-resize touch-none items-center justify-center select-none",
          a.class
        )
      )
    }, [
      m("span", {
        class: r(["h-3.5 w-px rounded-full bg-gray-300 transition-colors group-hover/resize:bg-gray-500", { "!bg-blue-500": a.resizing }])
      }, null, 2)
    ], 2));
  }
}), tb = ["aria-expanded", "aria-label", "aria-controls", "disabled"], np = /* @__PURE__ */ X({
  __name: "TableExpander",
  props: {
    expanded: { type: Boolean, default: !1 },
    expandLabel: {},
    collapseLabel: {},
    controls: {},
    disabled: { type: Boolean, default: !1 },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  emits: ["toggle"],
  setup(e) {
    const a = e, t = i(() => a.expanded ? a.collapseLabel : a.expandLabel);
    return (s, o) => (n(), c("button", {
      type: "button",
      "aria-expanded": a.expanded,
      "aria-label": t.value,
      "aria-controls": a.controls,
      disabled: a.disabled,
      "data-testid": "table-expander",
      class: r(
        l(q)(
          "flex h-5 w-5 shrink-0 items-center justify-center rounded text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent",
          a.class
        )
      ),
      onClick: o[0] || (o[0] = (d) => s.$emit("toggle", d))
    }, [
      L(l(ot), {
        "aria-hidden": "true",
        class: r(["h-4 w-4 transition-transform duration-200 ease-in-out", a.expanded ? "rotate-90" : ""])
      }, null, 8, ["class"])
    ], 10, tb));
  }
}), op = /* @__PURE__ */ X({
  __name: "TableSelect",
  props: {
    selected: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    label: {},
    disabled: { type: Boolean, default: !1 },
    class: { type: [Boolean, null, String, Object, Array] }
  },
  emits: ["toggle"],
  setup(e, { emit: a }) {
    const t = e, s = a, o = i(
      () => t.indeterminate ? "indeterminate" : t.selected
    ), d = (b) => {
      b.stopPropagation(), s("toggle", b);
    }, u = i(
      () => q(B2, t.disabled && E2)
    );
    return (b, g) => (n(), F(l(Ol), {
      "data-testid": "table-select",
      "model-value": o.value,
      disabled: t.disabled,
      "aria-label": t.label,
      class: r(l(q)(l(V2), t.class)),
      onClick: d
    }, {
      default: M(() => [
        L(l(zl), {
          class: r(l(S2))
        }, {
          default: M(() => [
            t.indeterminate ? (n(), F(l($s), {
              key: 0,
              "aria-hidden": "true",
              class: r(u.value)
            }, null, 8, ["class"])) : (n(), F(l($t), {
              key: 1,
              "aria-hidden": "true",
              class: r(u.value)
            }, null, 8, ["class"]))
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["model-value", "disabled", "aria-label", "class"]));
  }
});
function rp(e) {
  const a = A(null);
  return { anchorId: a, resolve: (o, d, u) => {
    const b = !d;
    if (!u?.shiftKey || a.value === null || a.value === o)
      return a.value = o, { ids: [o], selected: b };
    const g = Ne(e), h = g.indexOf(a.value), p = g.indexOf(o);
    return h === -1 || p === -1 ? (a.value = o, { ids: [o], selected: b }) : {
      ids: g.slice(Math.min(h, p), Math.max(h, p) + 1),
      selected: b
    };
  }, clearAnchor: () => {
    a.value = null;
  } };
}
export {
  hb as Accordion,
  Ob as ActionStamp,
  Pi as AutoComplete,
  $b as AutoCompleteField,
  Ot as Avatar,
  bb as AvatarGroup,
  Rr as Badge,
  gb as Breadcrumb,
  Ze as Button,
  Ub as Card,
  Gb as CardItem,
  Bs as Checkbox,
  Tb as CheckboxField,
  Mb as ComboboxField,
  Ji as ComboboxInput,
  Wb as ConfirmationDialog,
  jb as CopyableValueCell,
  Bl as DEFAULT_DIALING_CODE,
  Ud as DatePicker,
  Lb as DatePickerField,
  fc as DateRangePicker,
  Cb as DateRangePickerField,
  db as DefaultImage,
  a2 as Dialog,
  Bb as DocumentUpload,
  _b as Drawer,
  mb as DrawerSubHeader,
  pb as DropdownMenu,
  ib as EmptyState,
  Zb as ExpandableAvatar,
  Pb as ExpandableText,
  Eb as FilterChipGroup,
  Db as FilterToggle,
  qs as IconWrapper,
  cb as ImageUpload,
  Be as InputMessage,
  nb as Label,
  fb as LinkButton,
  ub as Message,
  Nb as MultiSelectCheckboxDropdown,
  Vb as NumberField,
  bc as NumberInput,
  Kb as PageHeader,
  Ib as PasswordInput,
  Sb as PhoneNumberField,
  yc as PhoneNumberInput,
  qb as Popover,
  ob as ProgressBar,
  Ci as Radio,
  Ab as RadioGroupField,
  Fb as SegmentedToggle,
  Ai as Select,
  wb as SelectField,
  Rb as SelectableList,
  lp as SortableHeader,
  et as Spinner,
  zb as StatCard,
  Hb as StatCardGroup,
  yb as Stepper,
  rb as Switch,
  Yb as Table,
  Jb as TableBody,
  ap as TableCell,
  np as TableExpander,
  Qb as TableFooter,
  tp as TableHead,
  Xb as TableHeader,
  sp as TableResizeHandle,
  ep as TableRow,
  op as TableSelect,
  U2 as TableSkeleton,
  vb as Tabs,
  Sa as Tag,
  ld as TextArea,
  kb as TextAreaField,
  xb as TextField,
  Ba as TextInput,
  sb as TextLink,
  ht as Tooltip,
  q as cn,
  Qa as copyToClipboard,
  hc as countryDialingCodes,
  ms as edgeFadeMask,
  xi as progressBarFillClasses,
  m2 as tableHeaderClasses,
  v2 as tableHeaderLabelClasses,
  jc as useImageTint,
  rp as useTableRangeSelection
};
